

//------------------------------------------
/**
 * Swiper 8.3.2
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2022 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: July 26, 2022
 */

 !function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).Swiper=t()}(this,(function(){"use strict";function e(e){return null!==e&&"object"==typeof e&&"constructor"in e&&e.constructor===Object}function t(s,a){void 0===s&&(s={}),void 0===a&&(a={}),Object.keys(a).forEach((i=>{void 0===s[i]?s[i]=a[i]:e(a[i])&&e(s[i])&&Object.keys(a[i]).length>0&&t(s[i],a[i])}))}const s={body:{},addEventListener(){},removeEventListener(){},activeElement:{blur(){},nodeName:""},querySelector:()=>null,querySelectorAll:()=>[],getElementById:()=>null,createEvent:()=>({initEvent(){}}),createElement:()=>({children:[],childNodes:[],style:{},setAttribute(){},getElementsByTagName:()=>[]}),createElementNS:()=>({}),importNode:()=>null,location:{hash:"",host:"",hostname:"",href:"",origin:"",pathname:"",protocol:"",search:""}};function a(){const e="undefined"!=typeof document?document:{};return t(e,s),e}const i={document:s,navigator:{userAgent:""},location:{hash:"",host:"",hostname:"",href:"",origin:"",pathname:"",protocol:"",search:""},history:{replaceState(){},pushState(){},go(){},back(){}},CustomEvent:function(){return this},addEventListener(){},removeEventListener(){},getComputedStyle:()=>({getPropertyValue:()=>""}),Image(){},Date(){},screen:{},setTimeout(){},clearTimeout(){},matchMedia:()=>({}),requestAnimationFrame:e=>"undefined"==typeof setTimeout?(e(),null):setTimeout(e,0),cancelAnimationFrame(e){"undefined"!=typeof setTimeout&&clearTimeout(e)}};function r(){const e="undefined"!=typeof window?window:{};return t(e,i),e}class n extends Array{constructor(e){"number"==typeof e?super(e):(super(...e||[]),function(e){const t=e.__proto__;Object.defineProperty(e,"__proto__",{get:()=>t,set(e){t.__proto__=e}})}(this))}}function l(e){void 0===e&&(e=[]);const t=[];return e.forEach((e=>{Array.isArray(e)?t.push(...l(e)):t.push(e)})),t}function o(e,t){return Array.prototype.filter.call(e,t)}function d(e,t){const s=r(),i=a();let l=[];if(!t&&e instanceof n)return e;if(!e)return new n(l);if("string"==typeof e){const s=e.trim();if(s.indexOf("<")>=0&&s.indexOf(">")>=0){let e="div";0===s.indexOf("<li")&&(e="ul"),0===s.indexOf("<tr")&&(e="tbody"),0!==s.indexOf("<td")&&0!==s.indexOf("<th")||(e="tr"),0===s.indexOf("<tbody")&&(e="table"),0===s.indexOf("<option")&&(e="select");const t=i.createElement(e);t.innerHTML=s;for(let e=0;e<t.childNodes.length;e+=1)l.push(t.childNodes[e])}else l=function(e,t){if("string"!=typeof e)return[e];const s=[],a=t.querySelectorAll(e);for(let e=0;e<a.length;e+=1)s.push(a[e]);return s}(e.trim(),t||i)}else if(e.nodeType||e===s||e===i)l.push(e);else if(Array.isArray(e)){if(e instanceof n)return e;l=e}return new n(function(e){const t=[];for(let s=0;s<e.length;s+=1)-1===t.indexOf(e[s])&&t.push(e[s]);return t}(l))}d.fn=n.prototype;const c={addClass:function(){for(var e=arguments.length,t=new Array(e),s=0;s<e;s++)t[s]=arguments[s];const a=l(t.map((e=>e.split(" "))));return this.forEach((e=>{e.classList.add(...a)})),this},removeClass:function(){for(var e=arguments.length,t=new Array(e),s=0;s<e;s++)t[s]=arguments[s];const a=l(t.map((e=>e.split(" "))));return this.forEach((e=>{e.classList.remove(...a)})),this},hasClass:function(){for(var e=arguments.length,t=new Array(e),s=0;s<e;s++)t[s]=arguments[s];const a=l(t.map((e=>e.split(" "))));return o(this,(e=>a.filter((t=>e.classList.contains(t))).length>0)).length>0},toggleClass:function(){for(var e=arguments.length,t=new Array(e),s=0;s<e;s++)t[s]=arguments[s];const a=l(t.map((e=>e.split(" "))));this.forEach((e=>{a.forEach((t=>{e.classList.toggle(t)}))}))},attr:function(e,t){if(1===arguments.length&&"string"==typeof e)return this[0]?this[0].getAttribute(e):void 0;for(let s=0;s<this.length;s+=1)if(2===arguments.length)this[s].setAttribute(e,t);else for(const t in e)this[s][t]=e[t],this[s].setAttribute(t,e[t]);return this},removeAttr:function(e){for(let t=0;t<this.length;t+=1)this[t].removeAttribute(e);return this},transform:function(e){for(let t=0;t<this.length;t+=1)this[t].style.transform=e;return this},transition:function(e){for(let t=0;t<this.length;t+=1)this[t].style.transitionDuration="string"!=typeof e?`${e}ms`:e;return this},on:function(){for(var e=arguments.length,t=new Array(e),s=0;s<e;s++)t[s]=arguments[s];let[a,i,r,n]=t;function l(e){const t=e.target;if(!t)return;const s=e.target.dom7EventData||[];if(s.indexOf(e)<0&&s.unshift(e),d(t).is(i))r.apply(t,s);else{const e=d(t).parents();for(let t=0;t<e.length;t+=1)d(e[t]).is(i)&&r.apply(e[t],s)}}function o(e){const t=e&&e.target&&e.target.dom7EventData||[];t.indexOf(e)<0&&t.unshift(e),r.apply(this,t)}"function"==typeof t[1]&&([a,r,n]=t,i=void 0),n||(n=!1);const c=a.split(" ");let p;for(let e=0;e<this.length;e+=1){const t=this[e];if(i)for(p=0;p<c.length;p+=1){const e=c[p];t.dom7LiveListeners||(t.dom7LiveListeners={}),t.dom7LiveListeners[e]||(t.dom7LiveListeners[e]=[]),t.dom7LiveListeners[e].push({listener:r,proxyListener:l}),t.addEventListener(e,l,n)}else for(p=0;p<c.length;p+=1){const e=c[p];t.dom7Listeners||(t.dom7Listeners={}),t.dom7Listeners[e]||(t.dom7Listeners[e]=[]),t.dom7Listeners[e].push({listener:r,proxyListener:o}),t.addEventListener(e,o,n)}}return this},off:function(){for(var e=arguments.length,t=new Array(e),s=0;s<e;s++)t[s]=arguments[s];let[a,i,r,n]=t;"function"==typeof t[1]&&([a,r,n]=t,i=void 0),n||(n=!1);const l=a.split(" ");for(let e=0;e<l.length;e+=1){const t=l[e];for(let e=0;e<this.length;e+=1){const s=this[e];let a;if(!i&&s.dom7Listeners?a=s.dom7Listeners[t]:i&&s.dom7LiveListeners&&(a=s.dom7LiveListeners[t]),a&&a.length)for(let e=a.length-1;e>=0;e-=1){const i=a[e];r&&i.listener===r||r&&i.listener&&i.listener.dom7proxy&&i.listener.dom7proxy===r?(s.removeEventListener(t,i.proxyListener,n),a.splice(e,1)):r||(s.removeEventListener(t,i.proxyListener,n),a.splice(e,1))}}}return this},trigger:function(){const e=r();for(var t=arguments.length,s=new Array(t),a=0;a<t;a++)s[a]=arguments[a];const i=s[0].split(" "),n=s[1];for(let t=0;t<i.length;t+=1){const a=i[t];for(let t=0;t<this.length;t+=1){const i=this[t];if(e.CustomEvent){const t=new e.CustomEvent(a,{detail:n,bubbles:!0,cancelable:!0});i.dom7EventData=s.filter(((e,t)=>t>0)),i.dispatchEvent(t),i.dom7EventData=[],delete i.dom7EventData}}}return this},transitionEnd:function(e){const t=this;return e&&t.on("transitionend",(function s(a){a.target===this&&(e.call(this,a),t.off("transitionend",s))})),this},outerWidth:function(e){if(this.length>0){if(e){const e=this.styles();return this[0].offsetWidth+parseFloat(e.getPropertyValue("margin-right"))+parseFloat(e.getPropertyValue("margin-left"))}return this[0].offsetWidth}return null},outerHeight:function(e){if(this.length>0){if(e){const e=this.styles();return this[0].offsetHeight+parseFloat(e.getPropertyValue("margin-top"))+parseFloat(e.getPropertyValue("margin-bottom"))}return this[0].offsetHeight}return null},styles:function(){const e=r();return this[0]?e.getComputedStyle(this[0],null):{}},offset:function(){if(this.length>0){const e=r(),t=a(),s=this[0],i=s.getBoundingClientRect(),n=t.body,l=s.clientTop||n.clientTop||0,o=s.clientLeft||n.clientLeft||0,d=s===e?e.scrollY:s.scrollTop,c=s===e?e.scrollX:s.scrollLeft;return{top:i.top+d-l,left:i.left+c-o}}return null},css:function(e,t){const s=r();let a;if(1===arguments.length){if("string"!=typeof e){for(a=0;a<this.length;a+=1)for(const t in e)this[a].style[t]=e[t];return this}if(this[0])return s.getComputedStyle(this[0],null).getPropertyValue(e)}if(2===arguments.length&&"string"==typeof e){for(a=0;a<this.length;a+=1)this[a].style[e]=t;return this}return this},each:function(e){return e?(this.forEach(((t,s)=>{e.apply(t,[t,s])})),this):this},html:function(e){if(void 0===e)return this[0]?this[0].innerHTML:null;for(let t=0;t<this.length;t+=1)this[t].innerHTML=e;return this},text:function(e){if(void 0===e)return this[0]?this[0].textContent.trim():null;for(let t=0;t<this.length;t+=1)this[t].textContent=e;return this},is:function(e){const t=r(),s=a(),i=this[0];let l,o;if(!i||void 0===e)return!1;if("string"==typeof e){if(i.matches)return i.matches(e);if(i.webkitMatchesSelector)return i.webkitMatchesSelector(e);if(i.msMatchesSelector)return i.msMatchesSelector(e);for(l=d(e),o=0;o<l.length;o+=1)if(l[o]===i)return!0;return!1}if(e===s)return i===s;if(e===t)return i===t;if(e.nodeType||e instanceof n){for(l=e.nodeType?[e]:e,o=0;o<l.length;o+=1)if(l[o]===i)return!0;return!1}return!1},index:function(){let e,t=this[0];if(t){for(e=0;null!==(t=t.previousSibling);)1===t.nodeType&&(e+=1);return e}},eq:function(e){if(void 0===e)return this;const t=this.length;if(e>t-1)return d([]);if(e<0){const s=t+e;return d(s<0?[]:[this[s]])}return d([this[e]])},append:function(){let e;const t=a();for(let s=0;s<arguments.length;s+=1){e=s<0||arguments.length<=s?void 0:arguments[s];for(let s=0;s<this.length;s+=1)if("string"==typeof e){const a=t.createElement("div");for(a.innerHTML=e;a.firstChild;)this[s].appendChild(a.firstChild)}else if(e instanceof n)for(let t=0;t<e.length;t+=1)this[s].appendChild(e[t]);else this[s].appendChild(e)}return this},prepend:function(e){const t=a();let s,i;for(s=0;s<this.length;s+=1)if("string"==typeof e){const a=t.createElement("div");for(a.innerHTML=e,i=a.childNodes.length-1;i>=0;i-=1)this[s].insertBefore(a.childNodes[i],this[s].childNodes[0])}else if(e instanceof n)for(i=0;i<e.length;i+=1)this[s].insertBefore(e[i],this[s].childNodes[0]);else this[s].insertBefore(e,this[s].childNodes[0]);return this},next:function(e){return this.length>0?e?this[0].nextElementSibling&&d(this[0].nextElementSibling).is(e)?d([this[0].nextElementSibling]):d([]):this[0].nextElementSibling?d([this[0].nextElementSibling]):d([]):d([])},nextAll:function(e){const t=[];let s=this[0];if(!s)return d([]);for(;s.nextElementSibling;){const a=s.nextElementSibling;e?d(a).is(e)&&t.push(a):t.push(a),s=a}return d(t)},prev:function(e){if(this.length>0){const t=this[0];return e?t.previousElementSibling&&d(t.previousElementSibling).is(e)?d([t.previousElementSibling]):d([]):t.previousElementSibling?d([t.previousElementSibling]):d([])}return d([])},prevAll:function(e){const t=[];let s=this[0];if(!s)return d([]);for(;s.previousElementSibling;){const a=s.previousElementSibling;e?d(a).is(e)&&t.push(a):t.push(a),s=a}return d(t)},parent:function(e){const t=[];for(let s=0;s<this.length;s+=1)null!==this[s].parentNode&&(e?d(this[s].parentNode).is(e)&&t.push(this[s].parentNode):t.push(this[s].parentNode));return d(t)},parents:function(e){const t=[];for(let s=0;s<this.length;s+=1){let a=this[s].parentNode;for(;a;)e?d(a).is(e)&&t.push(a):t.push(a),a=a.parentNode}return d(t)},closest:function(e){let t=this;return void 0===e?d([]):(t.is(e)||(t=t.parents(e).eq(0)),t)},find:function(e){const t=[];for(let s=0;s<this.length;s+=1){const a=this[s].querySelectorAll(e);for(let e=0;e<a.length;e+=1)t.push(a[e])}return d(t)},children:function(e){const t=[];for(let s=0;s<this.length;s+=1){const a=this[s].children;for(let s=0;s<a.length;s+=1)e&&!d(a[s]).is(e)||t.push(a[s])}return d(t)},filter:function(e){return d(o(this,e))},remove:function(){for(let e=0;e<this.length;e+=1)this[e].parentNode&&this[e].parentNode.removeChild(this[e]);return this}};function p(e,t){return void 0===t&&(t=0),setTimeout(e,t)}function u(){return Date.now()}function h(e,t){void 0===t&&(t="x");const s=r();let a,i,n;const l=function(e){const t=r();let s;return t.getComputedStyle&&(s=t.getComputedStyle(e,null)),!s&&e.currentStyle&&(s=e.currentStyle),s||(s=e.style),s}(e);return s.WebKitCSSMatrix?(i=l.transform||l.webkitTransform,i.split(",").length>6&&(i=i.split(", ").map((e=>e.replace(",","."))).join(", ")),n=new s.WebKitCSSMatrix("none"===i?"":i)):(n=l.MozTransform||l.OTransform||l.MsTransform||l.msTransform||l.transform||l.getPropertyValue("transform").replace("translate(","matrix(1, 0, 0, 1,"),a=n.toString().split(",")),"x"===t&&(i=s.WebKitCSSMatrix?n.m41:16===a.length?parseFloat(a[12]):parseFloat(a[4])),"y"===t&&(i=s.WebKitCSSMatrix?n.m42:16===a.length?parseFloat(a[13]):parseFloat(a[5])),i||0}function m(e){return"object"==typeof e&&null!==e&&e.constructor&&"Object"===Object.prototype.toString.call(e).slice(8,-1)}function f(e){return"undefined"!=typeof window&&void 0!==window.HTMLElement?e instanceof HTMLElement:e&&(1===e.nodeType||11===e.nodeType)}function g(){const e=Object(arguments.length<=0?void 0:arguments[0]),t=["__proto__","constructor","prototype"];for(let s=1;s<arguments.length;s+=1){const a=s<0||arguments.length<=s?void 0:arguments[s];if(null!=a&&!f(a)){const s=Object.keys(Object(a)).filter((e=>t.indexOf(e)<0));for(let t=0,i=s.length;t<i;t+=1){const i=s[t],r=Object.getOwnPropertyDescriptor(a,i);void 0!==r&&r.enumerable&&(m(e[i])&&m(a[i])?a[i].__swiper__?e[i]=a[i]:g(e[i],a[i]):!m(e[i])&&m(a[i])?(e[i]={},a[i].__swiper__?e[i]=a[i]:g(e[i],a[i])):e[i]=a[i])}}}return e}function v(e,t,s){e.style.setProperty(t,s)}function w(e){let{swiper:t,targetPosition:s,side:a}=e;const i=r(),n=-t.translate;let l,o=null;const d=t.params.speed;t.wrapperEl.style.scrollSnapType="none",i.cancelAnimationFrame(t.cssModeFrameID);const c=s>n?"next":"prev",p=(e,t)=>"next"===c&&e>=t||"prev"===c&&e<=t,u=()=>{l=(new Date).getTime(),null===o&&(o=l);const e=Math.max(Math.min((l-o)/d,1),0),r=.5-Math.cos(e*Math.PI)/2;let c=n+r*(s-n);if(p(c,s)&&(c=s),t.wrapperEl.scrollTo({[a]:c}),p(c,s))return t.wrapperEl.style.overflow="hidden",t.wrapperEl.style.scrollSnapType="",setTimeout((()=>{t.wrapperEl.style.overflow="",t.wrapperEl.scrollTo({[a]:c})})),void i.cancelAnimationFrame(t.cssModeFrameID);t.cssModeFrameID=i.requestAnimationFrame(u)};u()}let b,x,y;function E(){return b||(b=function(){const e=r(),t=a();return{smoothScroll:t.documentElement&&"scrollBehavior"in t.documentElement.style,touch:!!("ontouchstart"in e||e.DocumentTouch&&t instanceof e.DocumentTouch),passiveListener:function(){let t=!1;try{const s=Object.defineProperty({},"passive",{get(){t=!0}});e.addEventListener("testPassiveListener",null,s)}catch(e){}return t}(),gestures:"ongesturestart"in e}}()),b}function C(e){return void 0===e&&(e={}),x||(x=function(e){let{userAgent:t}=void 0===e?{}:e;const s=E(),a=r(),i=a.navigator.platform,n=t||a.navigator.userAgent,l={ios:!1,android:!1},o=a.screen.width,d=a.screen.height,c=n.match(/(Android);?[\s\/]+([\d.]+)?/);let p=n.match(/(iPad).*OS\s([\d_]+)/);const u=n.match(/(iPod)(.*OS\s([\d_]+))?/),h=!p&&n.match(/(iPhone\sOS|iOS)\s([\d_]+)/),m="Win32"===i;let f="MacIntel"===i;return!p&&f&&s.touch&&["1024x1366","1366x1024","834x1194","1194x834","834x1112","1112x834","768x1024","1024x768","820x1180","1180x820","810x1080","1080x810"].indexOf(`${o}x${d}`)>=0&&(p=n.match(/(Version)\/([\d.]+)/),p||(p=[0,1,"13_0_0"]),f=!1),c&&!m&&(l.os="android",l.android=!0),(p||h||u)&&(l.os="ios",l.ios=!0),l}(e)),x}function T(){return y||(y=function(){const e=r();return{isSafari:function(){const t=e.navigator.userAgent.toLowerCase();return t.indexOf("safari")>=0&&t.indexOf("chrome")<0&&t.indexOf("android")<0}(),isWebView:/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent)}}()),y}Object.keys(c).forEach((e=>{Object.defineProperty(d.fn,e,{value:c[e],writable:!0})}));var $={on(e,t,s){const a=this;if(!a.eventsListeners||a.destroyed)return a;if("function"!=typeof t)return a;const i=s?"unshift":"push";return e.split(" ").forEach((e=>{a.eventsListeners[e]||(a.eventsListeners[e]=[]),a.eventsListeners[e][i](t)})),a},once(e,t,s){const a=this;if(!a.eventsListeners||a.destroyed)return a;if("function"!=typeof t)return a;function i(){a.off(e,i),i.__emitterProxy&&delete i.__emitterProxy;for(var s=arguments.length,r=new Array(s),n=0;n<s;n++)r[n]=arguments[n];t.apply(a,r)}return i.__emitterProxy=t,a.on(e,i,s)},onAny(e,t){const s=this;if(!s.eventsListeners||s.destroyed)return s;if("function"!=typeof e)return s;const a=t?"unshift":"push";return s.eventsAnyListeners.indexOf(e)<0&&s.eventsAnyListeners[a](e),s},offAny(e){const t=this;if(!t.eventsListeners||t.destroyed)return t;if(!t.eventsAnyListeners)return t;const s=t.eventsAnyListeners.indexOf(e);return s>=0&&t.eventsAnyListeners.splice(s,1),t},off(e,t){const s=this;return!s.eventsListeners||s.destroyed?s:s.eventsListeners?(e.split(" ").forEach((e=>{void 0===t?s.eventsListeners[e]=[]:s.eventsListeners[e]&&s.eventsListeners[e].forEach(((a,i)=>{(a===t||a.__emitterProxy&&a.__emitterProxy===t)&&s.eventsListeners[e].splice(i,1)}))})),s):s},emit(){const e=this;if(!e.eventsListeners||e.destroyed)return e;if(!e.eventsListeners)return e;let t,s,a;for(var i=arguments.length,r=new Array(i),n=0;n<i;n++)r[n]=arguments[n];"string"==typeof r[0]||Array.isArray(r[0])?(t=r[0],s=r.slice(1,r.length),a=e):(t=r[0].events,s=r[0].data,a=r[0].context||e),s.unshift(a);return(Array.isArray(t)?t:t.split(" ")).forEach((t=>{e.eventsAnyListeners&&e.eventsAnyListeners.length&&e.eventsAnyListeners.forEach((e=>{e.apply(a,[t,...s])})),e.eventsListeners&&e.eventsListeners[t]&&e.eventsListeners[t].forEach((e=>{e.apply(a,s)}))})),e}};var S={updateSize:function(){const e=this;let t,s;const a=e.$el;t=void 0!==e.params.width&&null!==e.params.width?e.params.width:a[0].clientWidth,s=void 0!==e.params.height&&null!==e.params.height?e.params.height:a[0].clientHeight,0===t&&e.isHorizontal()||0===s&&e.isVertical()||(t=t-parseInt(a.css("padding-left")||0,10)-parseInt(a.css("padding-right")||0,10),s=s-parseInt(a.css("padding-top")||0,10)-parseInt(a.css("padding-bottom")||0,10),Number.isNaN(t)&&(t=0),Number.isNaN(s)&&(s=0),Object.assign(e,{width:t,height:s,size:e.isHorizontal()?t:s}))},updateSlides:function(){const e=this;function t(t){return e.isHorizontal()?t:{width:"height","margin-top":"margin-left","margin-bottom ":"margin-right","margin-left":"margin-top","margin-right":"margin-bottom","padding-left":"padding-top","padding-right":"padding-bottom",marginRight:"marginBottom"}[t]}function s(e,s){return parseFloat(e.getPropertyValue(t(s))||0)}const a=e.params,{$wrapperEl:i,size:r,rtlTranslate:n,wrongRTL:l}=e,o=e.virtual&&a.virtual.enabled,d=o?e.virtual.slides.length:e.slides.length,c=i.children(`.${e.params.slideClass}`),p=o?e.virtual.slides.length:c.length;let u=[];const h=[],m=[];let f=a.slidesOffsetBefore;"function"==typeof f&&(f=a.slidesOffsetBefore.call(e));let g=a.slidesOffsetAfter;"function"==typeof g&&(g=a.slidesOffsetAfter.call(e));const w=e.snapGrid.length,b=e.slidesGrid.length;let x=a.spaceBetween,y=-f,E=0,C=0;if(void 0===r)return;"string"==typeof x&&x.indexOf("%")>=0&&(x=parseFloat(x.replace("%",""))/100*r),e.virtualSize=-x,n?c.css({marginLeft:"",marginBottom:"",marginTop:""}):c.css({marginRight:"",marginBottom:"",marginTop:""}),a.centeredSlides&&a.cssMode&&(v(e.wrapperEl,"--swiper-centered-offset-before",""),v(e.wrapperEl,"--swiper-centered-offset-after",""));const T=a.grid&&a.grid.rows>1&&e.grid;let $;T&&e.grid.initSlides(p);const S="auto"===a.slidesPerView&&a.breakpoints&&Object.keys(a.breakpoints).filter((e=>void 0!==a.breakpoints[e].slidesPerView)).length>0;for(let i=0;i<p;i+=1){$=0;const n=c.eq(i);if(T&&e.grid.updateSlide(i,n,p,t),"none"!==n.css("display")){if("auto"===a.slidesPerView){S&&(c[i].style[t("width")]="");const r=getComputedStyle(n[0]),l=n[0].style.transform,o=n[0].style.webkitTransform;if(l&&(n[0].style.transform="none"),o&&(n[0].style.webkitTransform="none"),a.roundLengths)$=e.isHorizontal()?n.outerWidth(!0):n.outerHeight(!0);else{const e=s(r,"width"),t=s(r,"padding-left"),a=s(r,"padding-right"),i=s(r,"margin-left"),l=s(r,"margin-right"),o=r.getPropertyValue("box-sizing");if(o&&"border-box"===o)$=e+i+l;else{const{clientWidth:s,offsetWidth:r}=n[0];$=e+t+a+i+l+(r-s)}}l&&(n[0].style.transform=l),o&&(n[0].style.webkitTransform=o),a.roundLengths&&($=Math.floor($))}else $=(r-(a.slidesPerView-1)*x)/a.slidesPerView,a.roundLengths&&($=Math.floor($)),c[i]&&(c[i].style[t("width")]=`${$}px`);c[i]&&(c[i].swiperSlideSize=$),m.push($),a.centeredSlides?(y=y+$/2+E/2+x,0===E&&0!==i&&(y=y-r/2-x),0===i&&(y=y-r/2-x),Math.abs(y)<.001&&(y=0),a.roundLengths&&(y=Math.floor(y)),C%a.slidesPerGroup==0&&u.push(y),h.push(y)):(a.roundLengths&&(y=Math.floor(y)),(C-Math.min(e.params.slidesPerGroupSkip,C))%e.params.slidesPerGroup==0&&u.push(y),h.push(y),y=y+$+x),e.virtualSize+=$+x,E=$,C+=1}}if(e.virtualSize=Math.max(e.virtualSize,r)+g,n&&l&&("slide"===a.effect||"coverflow"===a.effect)&&i.css({width:`${e.virtualSize+a.spaceBetween}px`}),a.setWrapperSize&&i.css({[t("width")]:`${e.virtualSize+a.spaceBetween}px`}),T&&e.grid.updateWrapperSize($,u,t),!a.centeredSlides){const t=[];for(let s=0;s<u.length;s+=1){let i=u[s];a.roundLengths&&(i=Math.floor(i)),u[s]<=e.virtualSize-r&&t.push(i)}u=t,Math.floor(e.virtualSize-r)-Math.floor(u[u.length-1])>1&&u.push(e.virtualSize-r)}if(0===u.length&&(u=[0]),0!==a.spaceBetween){const s=e.isHorizontal()&&n?"marginLeft":t("marginRight");c.filter(((e,t)=>!a.cssMode||t!==c.length-1)).css({[s]:`${x}px`})}if(a.centeredSlides&&a.centeredSlidesBounds){let e=0;m.forEach((t=>{e+=t+(a.spaceBetween?a.spaceBetween:0)})),e-=a.spaceBetween;const t=e-r;u=u.map((e=>e<0?-f:e>t?t+g:e))}if(a.centerInsufficientSlides){let e=0;if(m.forEach((t=>{e+=t+(a.spaceBetween?a.spaceBetween:0)})),e-=a.spaceBetween,e<r){const t=(r-e)/2;u.forEach(((e,s)=>{u[s]=e-t})),h.forEach(((e,s)=>{h[s]=e+t}))}}if(Object.assign(e,{slides:c,snapGrid:u,slidesGrid:h,slidesSizesGrid:m}),a.centeredSlides&&a.cssMode&&!a.centeredSlidesBounds){v(e.wrapperEl,"--swiper-centered-offset-before",-u[0]+"px"),v(e.wrapperEl,"--swiper-centered-offset-after",e.size/2-m[m.length-1]/2+"px");const t=-e.snapGrid[0],s=-e.slidesGrid[0];e.snapGrid=e.snapGrid.map((e=>e+t)),e.slidesGrid=e.slidesGrid.map((e=>e+s))}if(p!==d&&e.emit("slidesLengthChange"),u.length!==w&&(e.params.watchOverflow&&e.checkOverflow(),e.emit("snapGridLengthChange")),h.length!==b&&e.emit("slidesGridLengthChange"),a.watchSlidesProgress&&e.updateSlidesOffset(),!(o||a.cssMode||"slide"!==a.effect&&"fade"!==a.effect)){const t=`${a.containerModifierClass}backface-hidden`,s=e.$el.hasClass(t);p<=a.maxBackfaceHiddenSlides?s||e.$el.addClass(t):s&&e.$el.removeClass(t)}},updateAutoHeight:function(e){const t=this,s=[],a=t.virtual&&t.params.virtual.enabled;let i,r=0;"number"==typeof e?t.setTransition(e):!0===e&&t.setTransition(t.params.speed);const n=e=>a?t.slides.filter((t=>parseInt(t.getAttribute("data-swiper-slide-index"),10)===e))[0]:t.slides.eq(e)[0];if("auto"!==t.params.slidesPerView&&t.params.slidesPerView>1)if(t.params.centeredSlides)(t.visibleSlides||d([])).each((e=>{s.push(e)}));else for(i=0;i<Math.ceil(t.params.slidesPerView);i+=1){const e=t.activeIndex+i;if(e>t.slides.length&&!a)break;s.push(n(e))}else s.push(n(t.activeIndex));for(i=0;i<s.length;i+=1)if(void 0!==s[i]){const e=s[i].offsetHeight;r=e>r?e:r}(r||0===r)&&t.$wrapperEl.css("height",`${r}px`)},updateSlidesOffset:function(){const e=this,t=e.slides;for(let s=0;s<t.length;s+=1)t[s].swiperSlideOffset=e.isHorizontal()?t[s].offsetLeft:t[s].offsetTop},updateSlidesProgress:function(e){void 0===e&&(e=this&&this.translate||0);const t=this,s=t.params,{slides:a,rtlTranslate:i,snapGrid:r}=t;if(0===a.length)return;void 0===a[0].swiperSlideOffset&&t.updateSlidesOffset();let n=-e;i&&(n=e),a.removeClass(s.slideVisibleClass),t.visibleSlidesIndexes=[],t.visibleSlides=[];for(let e=0;e<a.length;e+=1){const l=a[e];let o=l.swiperSlideOffset;s.cssMode&&s.centeredSlides&&(o-=a[0].swiperSlideOffset);const d=(n+(s.centeredSlides?t.minTranslate():0)-o)/(l.swiperSlideSize+s.spaceBetween),c=(n-r[0]+(s.centeredSlides?t.minTranslate():0)-o)/(l.swiperSlideSize+s.spaceBetween),p=-(n-o),u=p+t.slidesSizesGrid[e];(p>=0&&p<t.size-1||u>1&&u<=t.size||p<=0&&u>=t.size)&&(t.visibleSlides.push(l),t.visibleSlidesIndexes.push(e),a.eq(e).addClass(s.slideVisibleClass)),l.progress=i?-d:d,l.originalProgress=i?-c:c}t.visibleSlides=d(t.visibleSlides)},updateProgress:function(e){const t=this;if(void 0===e){const s=t.rtlTranslate?-1:1;e=t&&t.translate&&t.translate*s||0}const s=t.params,a=t.maxTranslate()-t.minTranslate();let{progress:i,isBeginning:r,isEnd:n}=t;const l=r,o=n;0===a?(i=0,r=!0,n=!0):(i=(e-t.minTranslate())/a,r=i<=0,n=i>=1),Object.assign(t,{progress:i,isBeginning:r,isEnd:n}),(s.watchSlidesProgress||s.centeredSlides&&s.autoHeight)&&t.updateSlidesProgress(e),r&&!l&&t.emit("reachBeginning toEdge"),n&&!o&&t.emit("reachEnd toEdge"),(l&&!r||o&&!n)&&t.emit("fromEdge"),t.emit("progress",i)},updateSlidesClasses:function(){const e=this,{slides:t,params:s,$wrapperEl:a,activeIndex:i,realIndex:r}=e,n=e.virtual&&s.virtual.enabled;let l;t.removeClass(`${s.slideActiveClass} ${s.slideNextClass} ${s.slidePrevClass} ${s.slideDuplicateActiveClass} ${s.slideDuplicateNextClass} ${s.slideDuplicatePrevClass}`),l=n?e.$wrapperEl.find(`.${s.slideClass}[data-swiper-slide-index="${i}"]`):t.eq(i),l.addClass(s.slideActiveClass),s.loop&&(l.hasClass(s.slideDuplicateClass)?a.children(`.${s.slideClass}:not(.${s.slideDuplicateClass})[data-swiper-slide-index="${r}"]`).addClass(s.slideDuplicateActiveClass):a.children(`.${s.slideClass}.${s.slideDuplicateClass}[data-swiper-slide-index="${r}"]`).addClass(s.slideDuplicateActiveClass));let o=l.nextAll(`.${s.slideClass}`).eq(0).addClass(s.slideNextClass);s.loop&&0===o.length&&(o=t.eq(0),o.addClass(s.slideNextClass));let d=l.prevAll(`.${s.slideClass}`).eq(0).addClass(s.slidePrevClass);s.loop&&0===d.length&&(d=t.eq(-1),d.addClass(s.slidePrevClass)),s.loop&&(o.hasClass(s.slideDuplicateClass)?a.children(`.${s.slideClass}:not(.${s.slideDuplicateClass})[data-swiper-slide-index="${o.attr("data-swiper-slide-index")}"]`).addClass(s.slideDuplicateNextClass):a.children(`.${s.slideClass}.${s.slideDuplicateClass}[data-swiper-slide-index="${o.attr("data-swiper-slide-index")}"]`).addClass(s.slideDuplicateNextClass),d.hasClass(s.slideDuplicateClass)?a.children(`.${s.slideClass}:not(.${s.slideDuplicateClass})[data-swiper-slide-index="${d.attr("data-swiper-slide-index")}"]`).addClass(s.slideDuplicatePrevClass):a.children(`.${s.slideClass}.${s.slideDuplicateClass}[data-swiper-slide-index="${d.attr("data-swiper-slide-index")}"]`).addClass(s.slideDuplicatePrevClass)),e.emitSlidesClasses()},updateActiveIndex:function(e){const t=this,s=t.rtlTranslate?t.translate:-t.translate,{slidesGrid:a,snapGrid:i,params:r,activeIndex:n,realIndex:l,snapIndex:o}=t;let d,c=e;if(void 0===c){for(let e=0;e<a.length;e+=1)void 0!==a[e+1]?s>=a[e]&&s<a[e+1]-(a[e+1]-a[e])/2?c=e:s>=a[e]&&s<a[e+1]&&(c=e+1):s>=a[e]&&(c=e);r.normalizeSlideIndex&&(c<0||void 0===c)&&(c=0)}if(i.indexOf(s)>=0)d=i.indexOf(s);else{const e=Math.min(r.slidesPerGroupSkip,c);d=e+Math.floor((c-e)/r.slidesPerGroup)}if(d>=i.length&&(d=i.length-1),c===n)return void(d!==o&&(t.snapIndex=d,t.emit("snapIndexChange")));const p=parseInt(t.slides.eq(c).attr("data-swiper-slide-index")||c,10);Object.assign(t,{snapIndex:d,realIndex:p,previousIndex:n,activeIndex:c}),t.emit("activeIndexChange"),t.emit("snapIndexChange"),l!==p&&t.emit("realIndexChange"),(t.initialized||t.params.runCallbacksOnInit)&&t.emit("slideChange")},updateClickedSlide:function(e){const t=this,s=t.params,a=d(e).closest(`.${s.slideClass}`)[0];let i,r=!1;if(a)for(let e=0;e<t.slides.length;e+=1)if(t.slides[e]===a){r=!0,i=e;break}if(!a||!r)return t.clickedSlide=void 0,void(t.clickedIndex=void 0);t.clickedSlide=a,t.virtual&&t.params.virtual.enabled?t.clickedIndex=parseInt(d(a).attr("data-swiper-slide-index"),10):t.clickedIndex=i,s.slideToClickedSlide&&void 0!==t.clickedIndex&&t.clickedIndex!==t.activeIndex&&t.slideToClickedSlide()}};var M={getTranslate:function(e){void 0===e&&(e=this.isHorizontal()?"x":"y");const{params:t,rtlTranslate:s,translate:a,$wrapperEl:i}=this;if(t.virtualTranslate)return s?-a:a;if(t.cssMode)return a;let r=h(i[0],e);return s&&(r=-r),r||0},setTranslate:function(e,t){const s=this,{rtlTranslate:a,params:i,$wrapperEl:r,wrapperEl:n,progress:l}=s;let o,d=0,c=0;s.isHorizontal()?d=a?-e:e:c=e,i.roundLengths&&(d=Math.floor(d),c=Math.floor(c)),i.cssMode?n[s.isHorizontal()?"scrollLeft":"scrollTop"]=s.isHorizontal()?-d:-c:i.virtualTranslate||r.transform(`translate3d(${d}px, ${c}px, 0px)`),s.previousTranslate=s.translate,s.translate=s.isHorizontal()?d:c;const p=s.maxTranslate()-s.minTranslate();o=0===p?0:(e-s.minTranslate())/p,o!==l&&s.updateProgress(e),s.emit("setTranslate",s.translate,t)},minTranslate:function(){return-this.snapGrid[0]},maxTranslate:function(){return-this.snapGrid[this.snapGrid.length-1]},translateTo:function(e,t,s,a,i){void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===s&&(s=!0),void 0===a&&(a=!0);const r=this,{params:n,wrapperEl:l}=r;if(r.animating&&n.preventInteractionOnTransition)return!1;const o=r.minTranslate(),d=r.maxTranslate();let c;if(c=a&&e>o?o:a&&e<d?d:e,r.updateProgress(c),n.cssMode){const e=r.isHorizontal();if(0===t)l[e?"scrollLeft":"scrollTop"]=-c;else{if(!r.support.smoothScroll)return w({swiper:r,targetPosition:-c,side:e?"left":"top"}),!0;l.scrollTo({[e?"left":"top"]:-c,behavior:"smooth"})}return!0}return 0===t?(r.setTransition(0),r.setTranslate(c),s&&(r.emit("beforeTransitionStart",t,i),r.emit("transitionEnd"))):(r.setTransition(t),r.setTranslate(c),s&&(r.emit("beforeTransitionStart",t,i),r.emit("transitionStart")),r.animating||(r.animating=!0,r.onTranslateToWrapperTransitionEnd||(r.onTranslateToWrapperTransitionEnd=function(e){r&&!r.destroyed&&e.target===this&&(r.$wrapperEl[0].removeEventListener("transitionend",r.onTranslateToWrapperTransitionEnd),r.$wrapperEl[0].removeEventListener("webkitTransitionEnd",r.onTranslateToWrapperTransitionEnd),r.onTranslateToWrapperTransitionEnd=null,delete r.onTranslateToWrapperTransitionEnd,s&&r.emit("transitionEnd"))}),r.$wrapperEl[0].addEventListener("transitionend",r.onTranslateToWrapperTransitionEnd),r.$wrapperEl[0].addEventListener("webkitTransitionEnd",r.onTranslateToWrapperTransitionEnd))),!0}};function P(e){let{swiper:t,runCallbacks:s,direction:a,step:i}=e;const{activeIndex:r,previousIndex:n}=t;let l=a;if(l||(l=r>n?"next":r<n?"prev":"reset"),t.emit(`transition${i}`),s&&r!==n){if("reset"===l)return void t.emit(`slideResetTransition${i}`);t.emit(`slideChangeTransition${i}`),"next"===l?t.emit(`slideNextTransition${i}`):t.emit(`slidePrevTransition${i}`)}}var k={slideTo:function(e,t,s,a,i){if(void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===s&&(s=!0),"number"!=typeof e&&"string"!=typeof e)throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof e}] given.`);if("string"==typeof e){const t=parseInt(e,10);if(!isFinite(t))throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${e}] given.`);e=t}const r=this;let n=e;n<0&&(n=0);const{params:l,snapGrid:o,slidesGrid:d,previousIndex:c,activeIndex:p,rtlTranslate:u,wrapperEl:h,enabled:m}=r;if(r.animating&&l.preventInteractionOnTransition||!m&&!a&&!i)return!1;const f=Math.min(r.params.slidesPerGroupSkip,n);let g=f+Math.floor((n-f)/r.params.slidesPerGroup);g>=o.length&&(g=o.length-1),(p||l.initialSlide||0)===(c||0)&&s&&r.emit("beforeSlideChangeStart");const v=-o[g];if(r.updateProgress(v),l.normalizeSlideIndex)for(let e=0;e<d.length;e+=1){const t=-Math.floor(100*v),s=Math.floor(100*d[e]),a=Math.floor(100*d[e+1]);void 0!==d[e+1]?t>=s&&t<a-(a-s)/2?n=e:t>=s&&t<a&&(n=e+1):t>=s&&(n=e)}if(r.initialized&&n!==p){if(!r.allowSlideNext&&v<r.translate&&v<r.minTranslate())return!1;if(!r.allowSlidePrev&&v>r.translate&&v>r.maxTranslate()&&(p||0)!==n)return!1}let b;if(b=n>p?"next":n<p?"prev":"reset",u&&-v===r.translate||!u&&v===r.translate)return r.updateActiveIndex(n),l.autoHeight&&r.updateAutoHeight(),r.updateSlidesClasses(),"slide"!==l.effect&&r.setTranslate(v),"reset"!==b&&(r.transitionStart(s,b),r.transitionEnd(s,b)),!1;if(l.cssMode){const e=r.isHorizontal(),s=u?v:-v;if(0===t){const t=r.virtual&&r.params.virtual.enabled;t&&(r.wrapperEl.style.scrollSnapType="none",r._immediateVirtual=!0),h[e?"scrollLeft":"scrollTop"]=s,t&&requestAnimationFrame((()=>{r.wrapperEl.style.scrollSnapType="",r._swiperImmediateVirtual=!1}))}else{if(!r.support.smoothScroll)return w({swiper:r,targetPosition:s,side:e?"left":"top"}),!0;h.scrollTo({[e?"left":"top"]:s,behavior:"smooth"})}return!0}return r.setTransition(t),r.setTranslate(v),r.updateActiveIndex(n),r.updateSlidesClasses(),r.emit("beforeTransitionStart",t,a),r.transitionStart(s,b),0===t?r.transitionEnd(s,b):r.animating||(r.animating=!0,r.onSlideToWrapperTransitionEnd||(r.onSlideToWrapperTransitionEnd=function(e){r&&!r.destroyed&&e.target===this&&(r.$wrapperEl[0].removeEventListener("transitionend",r.onSlideToWrapperTransitionEnd),r.$wrapperEl[0].removeEventListener("webkitTransitionEnd",r.onSlideToWrapperTransitionEnd),r.onSlideToWrapperTransitionEnd=null,delete r.onSlideToWrapperTransitionEnd,r.transitionEnd(s,b))}),r.$wrapperEl[0].addEventListener("transitionend",r.onSlideToWrapperTransitionEnd),r.$wrapperEl[0].addEventListener("webkitTransitionEnd",r.onSlideToWrapperTransitionEnd)),!0},slideToLoop:function(e,t,s,a){if(void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===s&&(s=!0),"string"==typeof e){const t=parseInt(e,10);if(!isFinite(t))throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${e}] given.`);e=t}const i=this;let r=e;return i.params.loop&&(r+=i.loopedSlides),i.slideTo(r,t,s,a)},slideNext:function(e,t,s){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0);const a=this,{animating:i,enabled:r,params:n}=a;if(!r)return a;let l=n.slidesPerGroup;"auto"===n.slidesPerView&&1===n.slidesPerGroup&&n.slidesPerGroupAuto&&(l=Math.max(a.slidesPerViewDynamic("current",!0),1));const o=a.activeIndex<n.slidesPerGroupSkip?1:l;if(n.loop){if(i&&n.loopPreventsSlide)return!1;a.loopFix(),a._clientLeft=a.$wrapperEl[0].clientLeft}return n.rewind&&a.isEnd?a.slideTo(0,e,t,s):a.slideTo(a.activeIndex+o,e,t,s)},slidePrev:function(e,t,s){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0);const a=this,{params:i,animating:r,snapGrid:n,slidesGrid:l,rtlTranslate:o,enabled:d}=a;if(!d)return a;if(i.loop){if(r&&i.loopPreventsSlide)return!1;a.loopFix(),a._clientLeft=a.$wrapperEl[0].clientLeft}function c(e){return e<0?-Math.floor(Math.abs(e)):Math.floor(e)}const p=c(o?a.translate:-a.translate),u=n.map((e=>c(e)));let h=n[u.indexOf(p)-1];if(void 0===h&&i.cssMode){let e;n.forEach(((t,s)=>{p>=t&&(e=s)})),void 0!==e&&(h=n[e>0?e-1:e])}let m=0;if(void 0!==h&&(m=l.indexOf(h),m<0&&(m=a.activeIndex-1),"auto"===i.slidesPerView&&1===i.slidesPerGroup&&i.slidesPerGroupAuto&&(m=m-a.slidesPerViewDynamic("previous",!0)+1,m=Math.max(m,0))),i.rewind&&a.isBeginning){const i=a.params.virtual&&a.params.virtual.enabled&&a.virtual?a.virtual.slides.length-1:a.slides.length-1;return a.slideTo(i,e,t,s)}return a.slideTo(m,e,t,s)},slideReset:function(e,t,s){return void 0===e&&(e=this.params.speed),void 0===t&&(t=!0),this.slideTo(this.activeIndex,e,t,s)},slideToClosest:function(e,t,s,a){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0),void 0===a&&(a=.5);const i=this;let r=i.activeIndex;const n=Math.min(i.params.slidesPerGroupSkip,r),l=n+Math.floor((r-n)/i.params.slidesPerGroup),o=i.rtlTranslate?i.translate:-i.translate;if(o>=i.snapGrid[l]){const e=i.snapGrid[l];o-e>(i.snapGrid[l+1]-e)*a&&(r+=i.params.slidesPerGroup)}else{const e=i.snapGrid[l-1];o-e<=(i.snapGrid[l]-e)*a&&(r-=i.params.slidesPerGroup)}return r=Math.max(r,0),r=Math.min(r,i.slidesGrid.length-1),i.slideTo(r,e,t,s)},slideToClickedSlide:function(){const e=this,{params:t,$wrapperEl:s}=e,a="auto"===t.slidesPerView?e.slidesPerViewDynamic():t.slidesPerView;let i,r=e.clickedIndex;if(t.loop){if(e.animating)return;i=parseInt(d(e.clickedSlide).attr("data-swiper-slide-index"),10),t.centeredSlides?r<e.loopedSlides-a/2||r>e.slides.length-e.loopedSlides+a/2?(e.loopFix(),r=s.children(`.${t.slideClass}[data-swiper-slide-index="${i}"]:not(.${t.slideDuplicateClass})`).eq(0).index(),p((()=>{e.slideTo(r)}))):e.slideTo(r):r>e.slides.length-a?(e.loopFix(),r=s.children(`.${t.slideClass}[data-swiper-slide-index="${i}"]:not(.${t.slideDuplicateClass})`).eq(0).index(),p((()=>{e.slideTo(r)}))):e.slideTo(r)}else e.slideTo(r)}};var z={loopCreate:function(){const e=this,t=a(),{params:s,$wrapperEl:i}=e,r=i.children().length>0?d(i.children()[0].parentNode):i;r.children(`.${s.slideClass}.${s.slideDuplicateClass}`).remove();let n=r.children(`.${s.slideClass}`);if(s.loopFillGroupWithBlank){const e=s.slidesPerGroup-n.length%s.slidesPerGroup;if(e!==s.slidesPerGroup){for(let a=0;a<e;a+=1){const e=d(t.createElement("div")).addClass(`${s.slideClass} ${s.slideBlankClass}`);r.append(e)}n=r.children(`.${s.slideClass}`)}}"auto"!==s.slidesPerView||s.loopedSlides||(s.loopedSlides=n.length),e.loopedSlides=Math.ceil(parseFloat(s.loopedSlides||s.slidesPerView,10)),e.loopedSlides+=s.loopAdditionalSlides,e.loopedSlides>n.length&&e.params.loopedSlidesLimit&&(e.loopedSlides=n.length);const l=[],o=[];n.each(((e,t)=>{d(e).attr("data-swiper-slide-index",t)}));for(let t=0;t<e.loopedSlides;t+=1){const e=t-Math.floor(t/n.length)*n.length;o.push(n.eq(e)[0]),l.unshift(n.eq(n.length-e-1)[0])}for(let e=0;e<o.length;e+=1)r.append(d(o[e].cloneNode(!0)).addClass(s.slideDuplicateClass));for(let e=l.length-1;e>=0;e-=1)r.prepend(d(l[e].cloneNode(!0)).addClass(s.slideDuplicateClass))},loopFix:function(){const e=this;e.emit("beforeLoopFix");const{activeIndex:t,slides:s,loopedSlides:a,allowSlidePrev:i,allowSlideNext:r,snapGrid:n,rtlTranslate:l}=e;let o;e.allowSlidePrev=!0,e.allowSlideNext=!0;const d=-n[t]-e.getTranslate();if(t<a){o=s.length-3*a+t,o+=a;e.slideTo(o,0,!1,!0)&&0!==d&&e.setTranslate((l?-e.translate:e.translate)-d)}else if(t>=s.length-a){o=-s.length+t+a,o+=a;e.slideTo(o,0,!1,!0)&&0!==d&&e.setTranslate((l?-e.translate:e.translate)-d)}e.allowSlidePrev=i,e.allowSlideNext=r,e.emit("loopFix")},loopDestroy:function(){const{$wrapperEl:e,params:t,slides:s}=this;e.children(`.${t.slideClass}.${t.slideDuplicateClass},.${t.slideClass}.${t.slideBlankClass}`).remove(),s.removeAttr("data-swiper-slide-index")}};function L(e){const t=this,s=a(),i=r(),n=t.touchEventsData,{params:l,touches:o,enabled:c}=t;if(!c)return;if(t.animating&&l.preventInteractionOnTransition)return;!t.animating&&l.cssMode&&l.loop&&t.loopFix();let p=e;p.originalEvent&&(p=p.originalEvent);let h=d(p.target);if("wrapper"===l.touchEventsTarget&&!h.closest(t.wrapperEl).length)return;if(n.isTouchEvent="touchstart"===p.type,!n.isTouchEvent&&"which"in p&&3===p.which)return;if(!n.isTouchEvent&&"button"in p&&p.button>0)return;if(n.isTouched&&n.isMoved)return;!!l.noSwipingClass&&""!==l.noSwipingClass&&p.target&&p.target.shadowRoot&&e.path&&e.path[0]&&(h=d(e.path[0]));const m=l.noSwipingSelector?l.noSwipingSelector:`.${l.noSwipingClass}`,f=!(!p.target||!p.target.shadowRoot);if(l.noSwiping&&(f?function(e,t){return void 0===t&&(t=this),function t(s){if(!s||s===a()||s===r())return null;s.assignedSlot&&(s=s.assignedSlot);const i=s.closest(e);return i||s.getRootNode?i||t(s.getRootNode().host):null}(t)}(m,h[0]):h.closest(m)[0]))return void(t.allowClick=!0);if(l.swipeHandler&&!h.closest(l.swipeHandler)[0])return;o.currentX="touchstart"===p.type?p.targetTouches[0].pageX:p.pageX,o.currentY="touchstart"===p.type?p.targetTouches[0].pageY:p.pageY;const g=o.currentX,v=o.currentY,w=l.edgeSwipeDetection||l.iOSEdgeSwipeDetection,b=l.edgeSwipeThreshold||l.iOSEdgeSwipeThreshold;if(w&&(g<=b||g>=i.innerWidth-b)){if("prevent"!==w)return;e.preventDefault()}if(Object.assign(n,{isTouched:!0,isMoved:!1,allowTouchCallbacks:!0,isScrolling:void 0,startMoving:void 0}),o.startX=g,o.startY=v,n.touchStartTime=u(),t.allowClick=!0,t.updateSize(),t.swipeDirection=void 0,l.threshold>0&&(n.allowThresholdMove=!1),"touchstart"!==p.type){let e=!0;h.is(n.focusableElements)&&(e=!1,"SELECT"===h[0].nodeName&&(n.isTouched=!1)),s.activeElement&&d(s.activeElement).is(n.focusableElements)&&s.activeElement!==h[0]&&s.activeElement.blur();const a=e&&t.allowTouchMove&&l.touchStartPreventDefault;!l.touchStartForcePreventDefault&&!a||h[0].isContentEditable||p.preventDefault()}t.params.freeMode&&t.params.freeMode.enabled&&t.freeMode&&t.animating&&!l.cssMode&&t.freeMode.onTouchStart(),t.emit("touchStart",p)}function O(e){const t=a(),s=this,i=s.touchEventsData,{params:r,touches:n,rtlTranslate:l,enabled:o}=s;if(!o)return;let c=e;if(c.originalEvent&&(c=c.originalEvent),!i.isTouched)return void(i.startMoving&&i.isScrolling&&s.emit("touchMoveOpposite",c));if(i.isTouchEvent&&"touchmove"!==c.type)return;const p="touchmove"===c.type&&c.targetTouches&&(c.targetTouches[0]||c.changedTouches[0]),h="touchmove"===c.type?p.pageX:c.pageX,m="touchmove"===c.type?p.pageY:c.pageY;if(c.preventedByNestedSwiper)return n.startX=h,void(n.startY=m);if(!s.allowTouchMove)return d(c.target).is(i.focusableElements)||(s.allowClick=!1),void(i.isTouched&&(Object.assign(n,{startX:h,startY:m,currentX:h,currentY:m}),i.touchStartTime=u()));if(i.isTouchEvent&&r.touchReleaseOnEdges&&!r.loop)if(s.isVertical()){if(m<n.startY&&s.translate<=s.maxTranslate()||m>n.startY&&s.translate>=s.minTranslate())return i.isTouched=!1,void(i.isMoved=!1)}else if(h<n.startX&&s.translate<=s.maxTranslate()||h>n.startX&&s.translate>=s.minTranslate())return;if(i.isTouchEvent&&t.activeElement&&c.target===t.activeElement&&d(c.target).is(i.focusableElements))return i.isMoved=!0,void(s.allowClick=!1);if(i.allowTouchCallbacks&&s.emit("touchMove",c),c.targetTouches&&c.targetTouches.length>1)return;n.currentX=h,n.currentY=m;const f=n.currentX-n.startX,g=n.currentY-n.startY;if(s.params.threshold&&Math.sqrt(f**2+g**2)<s.params.threshold)return;if(void 0===i.isScrolling){let e;s.isHorizontal()&&n.currentY===n.startY||s.isVertical()&&n.currentX===n.startX?i.isScrolling=!1:f*f+g*g>=25&&(e=180*Math.atan2(Math.abs(g),Math.abs(f))/Math.PI,i.isScrolling=s.isHorizontal()?e>r.touchAngle:90-e>r.touchAngle)}if(i.isScrolling&&s.emit("touchMoveOpposite",c),void 0===i.startMoving&&(n.currentX===n.startX&&n.currentY===n.startY||(i.startMoving=!0)),i.isScrolling)return void(i.isTouched=!1);if(!i.startMoving)return;s.allowClick=!1,!r.cssMode&&c.cancelable&&c.preventDefault(),r.touchMoveStopPropagation&&!r.nested&&c.stopPropagation(),i.isMoved||(r.loop&&!r.cssMode&&s.loopFix(),i.startTranslate=s.getTranslate(),s.setTransition(0),s.animating&&s.$wrapperEl.trigger("webkitTransitionEnd transitionend"),i.allowMomentumBounce=!1,!r.grabCursor||!0!==s.allowSlideNext&&!0!==s.allowSlidePrev||s.setGrabCursor(!0),s.emit("sliderFirstMove",c)),s.emit("sliderMove",c),i.isMoved=!0;let v=s.isHorizontal()?f:g;n.diff=v,v*=r.touchRatio,l&&(v=-v),s.swipeDirection=v>0?"prev":"next",i.currentTranslate=v+i.startTranslate;let w=!0,b=r.resistanceRatio;if(r.touchReleaseOnEdges&&(b=0),v>0&&i.currentTranslate>s.minTranslate()?(w=!1,r.resistance&&(i.currentTranslate=s.minTranslate()-1+(-s.minTranslate()+i.startTranslate+v)**b)):v<0&&i.currentTranslate<s.maxTranslate()&&(w=!1,r.resistance&&(i.currentTranslate=s.maxTranslate()+1-(s.maxTranslate()-i.startTranslate-v)**b)),w&&(c.preventedByNestedSwiper=!0),!s.allowSlideNext&&"next"===s.swipeDirection&&i.currentTranslate<i.startTranslate&&(i.currentTranslate=i.startTranslate),!s.allowSlidePrev&&"prev"===s.swipeDirection&&i.currentTranslate>i.startTranslate&&(i.currentTranslate=i.startTranslate),s.allowSlidePrev||s.allowSlideNext||(i.currentTranslate=i.startTranslate),r.threshold>0){if(!(Math.abs(v)>r.threshold||i.allowThresholdMove))return void(i.currentTranslate=i.startTranslate);if(!i.allowThresholdMove)return i.allowThresholdMove=!0,n.startX=n.currentX,n.startY=n.currentY,i.currentTranslate=i.startTranslate,void(n.diff=s.isHorizontal()?n.currentX-n.startX:n.currentY-n.startY)}r.followFinger&&!r.cssMode&&((r.freeMode&&r.freeMode.enabled&&s.freeMode||r.watchSlidesProgress)&&(s.updateActiveIndex(),s.updateSlidesClasses()),s.params.freeMode&&r.freeMode.enabled&&s.freeMode&&s.freeMode.onTouchMove(),s.updateProgress(i.currentTranslate),s.setTranslate(i.currentTranslate))}function I(e){const t=this,s=t.touchEventsData,{params:a,touches:i,rtlTranslate:r,slidesGrid:n,enabled:l}=t;if(!l)return;let o=e;if(o.originalEvent&&(o=o.originalEvent),s.allowTouchCallbacks&&t.emit("touchEnd",o),s.allowTouchCallbacks=!1,!s.isTouched)return s.isMoved&&a.grabCursor&&t.setGrabCursor(!1),s.isMoved=!1,void(s.startMoving=!1);a.grabCursor&&s.isMoved&&s.isTouched&&(!0===t.allowSlideNext||!0===t.allowSlidePrev)&&t.setGrabCursor(!1);const d=u(),c=d-s.touchStartTime;if(t.allowClick){const e=o.path||o.composedPath&&o.composedPath();t.updateClickedSlide(e&&e[0]||o.target),t.emit("tap click",o),c<300&&d-s.lastClickTime<300&&t.emit("doubleTap doubleClick",o)}if(s.lastClickTime=u(),p((()=>{t.destroyed||(t.allowClick=!0)})),!s.isTouched||!s.isMoved||!t.swipeDirection||0===i.diff||s.currentTranslate===s.startTranslate)return s.isTouched=!1,s.isMoved=!1,void(s.startMoving=!1);let h;if(s.isTouched=!1,s.isMoved=!1,s.startMoving=!1,h=a.followFinger?r?t.translate:-t.translate:-s.currentTranslate,a.cssMode)return;if(t.params.freeMode&&a.freeMode.enabled)return void t.freeMode.onTouchEnd({currentPos:h});let m=0,f=t.slidesSizesGrid[0];for(let e=0;e<n.length;e+=e<a.slidesPerGroupSkip?1:a.slidesPerGroup){const t=e<a.slidesPerGroupSkip-1?1:a.slidesPerGroup;void 0!==n[e+t]?h>=n[e]&&h<n[e+t]&&(m=e,f=n[e+t]-n[e]):h>=n[e]&&(m=e,f=n[n.length-1]-n[n.length-2])}let g=null,v=null;a.rewind&&(t.isBeginning?v=t.params.virtual&&t.params.virtual.enabled&&t.virtual?t.virtual.slides.length-1:t.slides.length-1:t.isEnd&&(g=0));const w=(h-n[m])/f,b=m<a.slidesPerGroupSkip-1?1:a.slidesPerGroup;if(c>a.longSwipesMs){if(!a.longSwipes)return void t.slideTo(t.activeIndex);"next"===t.swipeDirection&&(w>=a.longSwipesRatio?t.slideTo(a.rewind&&t.isEnd?g:m+b):t.slideTo(m)),"prev"===t.swipeDirection&&(w>1-a.longSwipesRatio?t.slideTo(m+b):null!==v&&w<0&&Math.abs(w)>a.longSwipesRatio?t.slideTo(v):t.slideTo(m))}else{if(!a.shortSwipes)return void t.slideTo(t.activeIndex);t.navigation&&(o.target===t.navigation.nextEl||o.target===t.navigation.prevEl)?o.target===t.navigation.nextEl?t.slideTo(m+b):t.slideTo(m):("next"===t.swipeDirection&&t.slideTo(null!==g?g:m+b),"prev"===t.swipeDirection&&t.slideTo(null!==v?v:m))}}function A(){const e=this,{params:t,el:s}=e;if(s&&0===s.offsetWidth)return;t.breakpoints&&e.setBreakpoint();const{allowSlideNext:a,allowSlidePrev:i,snapGrid:r}=e;e.allowSlideNext=!0,e.allowSlidePrev=!0,e.updateSize(),e.updateSlides(),e.updateSlidesClasses(),("auto"===t.slidesPerView||t.slidesPerView>1)&&e.isEnd&&!e.isBeginning&&!e.params.centeredSlides?e.slideTo(e.slides.length-1,0,!1,!0):e.slideTo(e.activeIndex,0,!1,!0),e.autoplay&&e.autoplay.running&&e.autoplay.paused&&e.autoplay.run(),e.allowSlidePrev=i,e.allowSlideNext=a,e.params.watchOverflow&&r!==e.snapGrid&&e.checkOverflow()}function D(e){const t=this;t.enabled&&(t.allowClick||(t.params.preventClicks&&e.preventDefault(),t.params.preventClicksPropagation&&t.animating&&(e.stopPropagation(),e.stopImmediatePropagation())))}function G(){const e=this,{wrapperEl:t,rtlTranslate:s,enabled:a}=e;if(!a)return;let i;e.previousTranslate=e.translate,e.isHorizontal()?e.translate=-t.scrollLeft:e.translate=-t.scrollTop,0===e.translate&&(e.translate=0),e.updateActiveIndex(),e.updateSlidesClasses();const r=e.maxTranslate()-e.minTranslate();i=0===r?0:(e.translate-e.minTranslate())/r,i!==e.progress&&e.updateProgress(s?-e.translate:e.translate),e.emit("setTranslate",e.translate,!1)}let N=!1;function B(){}const H=(e,t)=>{const s=a(),{params:i,touchEvents:r,el:n,wrapperEl:l,device:o,support:d}=e,c=!!i.nested,p="on"===t?"addEventListener":"removeEventListener",u=t;if(d.touch){const t=!("touchstart"!==r.start||!d.passiveListener||!i.passiveListeners)&&{passive:!0,capture:!1};n[p](r.start,e.onTouchStart,t),n[p](r.move,e.onTouchMove,d.passiveListener?{passive:!1,capture:c}:c),n[p](r.end,e.onTouchEnd,t),r.cancel&&n[p](r.cancel,e.onTouchEnd,t)}else n[p](r.start,e.onTouchStart,!1),s[p](r.move,e.onTouchMove,c),s[p](r.end,e.onTouchEnd,!1);(i.preventClicks||i.preventClicksPropagation)&&n[p]("click",e.onClick,!0),i.cssMode&&l[p]("scroll",e.onScroll),i.updateOnWindowResize?e[u](o.ios||o.android?"resize orientationchange observerUpdate":"resize observerUpdate",A,!0):e[u]("observerUpdate",A,!0)};var X={attachEvents:function(){const e=this,t=a(),{params:s,support:i}=e;e.onTouchStart=L.bind(e),e.onTouchMove=O.bind(e),e.onTouchEnd=I.bind(e),s.cssMode&&(e.onScroll=G.bind(e)),e.onClick=D.bind(e),i.touch&&!N&&(t.addEventListener("touchstart",B),N=!0),H(e,"on")},detachEvents:function(){H(this,"off")}};const Y=(e,t)=>e.grid&&t.grid&&t.grid.rows>1;var R={addClasses:function(){const e=this,{classNames:t,params:s,rtl:a,$el:i,device:r,support:n}=e,l=function(e,t){const s=[];return e.forEach((e=>{"object"==typeof e?Object.keys(e).forEach((a=>{e[a]&&s.push(t+a)})):"string"==typeof e&&s.push(t+e)})),s}(["initialized",s.direction,{"pointer-events":!n.touch},{"free-mode":e.params.freeMode&&s.freeMode.enabled},{autoheight:s.autoHeight},{rtl:a},{grid:s.grid&&s.grid.rows>1},{"grid-column":s.grid&&s.grid.rows>1&&"column"===s.grid.fill},{android:r.android},{ios:r.ios},{"css-mode":s.cssMode},{centered:s.cssMode&&s.centeredSlides},{"watch-progress":s.watchSlidesProgress}],s.containerModifierClass);t.push(...l),i.addClass([...t].join(" ")),e.emitContainerClasses()},removeClasses:function(){const{$el:e,classNames:t}=this;e.removeClass(t.join(" ")),this.emitContainerClasses()}};var W={init:!0,direction:"horizontal",touchEventsTarget:"wrapper",initialSlide:0,speed:300,cssMode:!1,updateOnWindowResize:!0,resizeObserver:!0,nested:!1,createElements:!1,enabled:!0,focusableElements:"input, select, option, textarea, button, video, label",width:null,height:null,preventInteractionOnTransition:!1,userAgent:null,url:null,edgeSwipeDetection:!1,edgeSwipeThreshold:20,autoHeight:!1,setWrapperSize:!1,virtualTranslate:!1,effect:"slide",breakpoints:void 0,breakpointsBase:"window",spaceBetween:0,slidesPerView:1,slidesPerGroup:1,slidesPerGroupSkip:0,slidesPerGroupAuto:!1,centeredSlides:!1,centeredSlidesBounds:!1,slidesOffsetBefore:0,slidesOffsetAfter:0,normalizeSlideIndex:!0,centerInsufficientSlides:!1,watchOverflow:!0,roundLengths:!1,touchRatio:1,touchAngle:45,simulateTouch:!0,shortSwipes:!0,longSwipes:!0,longSwipesRatio:.5,longSwipesMs:300,followFinger:!0,allowTouchMove:!0,threshold:0,touchMoveStopPropagation:!1,touchStartPreventDefault:!0,touchStartForcePreventDefault:!1,touchReleaseOnEdges:!1,uniqueNavElements:!0,resistance:!0,resistanceRatio:.85,watchSlidesProgress:!1,grabCursor:!1,preventClicks:!0,preventClicksPropagation:!0,slideToClickedSlide:!1,preloadImages:!0,updateOnImagesReady:!0,loop:!1,loopAdditionalSlides:0,loopedSlides:null,loopedSlidesLimit:!0,loopFillGroupWithBlank:!1,loopPreventsSlide:!0,rewind:!1,allowSlidePrev:!0,allowSlideNext:!0,swipeHandler:null,noSwiping:!0,noSwipingClass:"swiper-no-swiping",noSwipingSelector:null,passiveListeners:!0,maxBackfaceHiddenSlides:10,containerModifierClass:"swiper-",slideClass:"swiper-slide",slideBlankClass:"swiper-slide-invisible-blank",slideActiveClass:"swiper-slide-active",slideDuplicateActiveClass:"swiper-slide-duplicate-active",slideVisibleClass:"swiper-slide-visible",slideDuplicateClass:"swiper-slide-duplicate",slideNextClass:"swiper-slide-next",slideDuplicateNextClass:"swiper-slide-duplicate-next",slidePrevClass:"swiper-slide-prev",slideDuplicatePrevClass:"swiper-slide-duplicate-prev",wrapperClass:"swiper-wrapper",runCallbacksOnInit:!0,_emitClasses:!1};function j(e,t){return function(s){void 0===s&&(s={});const a=Object.keys(s)[0],i=s[a];"object"==typeof i&&null!==i?(["navigation","pagination","scrollbar"].indexOf(a)>=0&&!0===e[a]&&(e[a]={auto:!0}),a in e&&"enabled"in i?(!0===e[a]&&(e[a]={enabled:!0}),"object"!=typeof e[a]||"enabled"in e[a]||(e[a].enabled=!0),e[a]||(e[a]={enabled:!1}),g(t,s)):g(t,s)):g(t,s)}}const q={eventsEmitter:$,update:S,translate:M,transition:{setTransition:function(e,t){const s=this;s.params.cssMode||s.$wrapperEl.transition(e),s.emit("setTransition",e,t)},transitionStart:function(e,t){void 0===e&&(e=!0);const s=this,{params:a}=s;a.cssMode||(a.autoHeight&&s.updateAutoHeight(),P({swiper:s,runCallbacks:e,direction:t,step:"Start"}))},transitionEnd:function(e,t){void 0===e&&(e=!0);const s=this,{params:a}=s;s.animating=!1,a.cssMode||(s.setTransition(0),P({swiper:s,runCallbacks:e,direction:t,step:"End"}))}},slide:k,loop:z,grabCursor:{setGrabCursor:function(e){const t=this;if(t.support.touch||!t.params.simulateTouch||t.params.watchOverflow&&t.isLocked||t.params.cssMode)return;const s="container"===t.params.touchEventsTarget?t.el:t.wrapperEl;s.style.cursor="move",s.style.cursor=e?"grabbing":"grab"},unsetGrabCursor:function(){const e=this;e.support.touch||e.params.watchOverflow&&e.isLocked||e.params.cssMode||(e["container"===e.params.touchEventsTarget?"el":"wrapperEl"].style.cursor="")}},events:X,breakpoints:{setBreakpoint:function(){const e=this,{activeIndex:t,initialized:s,loopedSlides:a=0,params:i,$el:r}=e,n=i.breakpoints;if(!n||n&&0===Object.keys(n).length)return;const l=e.getBreakpoint(n,e.params.breakpointsBase,e.el);if(!l||e.currentBreakpoint===l)return;const o=(l in n?n[l]:void 0)||e.originalParams,d=Y(e,i),c=Y(e,o),p=i.enabled;d&&!c?(r.removeClass(`${i.containerModifierClass}grid ${i.containerModifierClass}grid-column`),e.emitContainerClasses()):!d&&c&&(r.addClass(`${i.containerModifierClass}grid`),(o.grid.fill&&"column"===o.grid.fill||!o.grid.fill&&"column"===i.grid.fill)&&r.addClass(`${i.containerModifierClass}grid-column`),e.emitContainerClasses()),["navigation","pagination","scrollbar"].forEach((t=>{const s=i[t]&&i[t].enabled,a=o[t]&&o[t].enabled;s&&!a&&e[t].disable(),!s&&a&&e[t].enable()}));const u=o.direction&&o.direction!==i.direction,h=i.loop&&(o.slidesPerView!==i.slidesPerView||u);u&&s&&e.changeDirection(),g(e.params,o);const m=e.params.enabled;Object.assign(e,{allowTouchMove:e.params.allowTouchMove,allowSlideNext:e.params.allowSlideNext,allowSlidePrev:e.params.allowSlidePrev}),p&&!m?e.disable():!p&&m&&e.enable(),e.currentBreakpoint=l,e.emit("_beforeBreakpoint",o),h&&s&&(e.loopDestroy(),e.loopCreate(),e.updateSlides(),e.slideTo(t-a+e.loopedSlides,0,!1)),e.emit("breakpoint",o)},getBreakpoint:function(e,t,s){if(void 0===t&&(t="window"),!e||"container"===t&&!s)return;let a=!1;const i=r(),n="window"===t?i.innerHeight:s.clientHeight,l=Object.keys(e).map((e=>{if("string"==typeof e&&0===e.indexOf("@")){const t=parseFloat(e.substr(1));return{value:n*t,point:e}}return{value:e,point:e}}));l.sort(((e,t)=>parseInt(e.value,10)-parseInt(t.value,10)));for(let e=0;e<l.length;e+=1){const{point:r,value:n}=l[e];"window"===t?i.matchMedia(`(min-width: ${n}px)`).matches&&(a=r):n<=s.clientWidth&&(a=r)}return a||"max"}},checkOverflow:{checkOverflow:function(){const e=this,{isLocked:t,params:s}=e,{slidesOffsetBefore:a}=s;if(a){const t=e.slides.length-1,s=e.slidesGrid[t]+e.slidesSizesGrid[t]+2*a;e.isLocked=e.size>s}else e.isLocked=1===e.snapGrid.length;!0===s.allowSlideNext&&(e.allowSlideNext=!e.isLocked),!0===s.allowSlidePrev&&(e.allowSlidePrev=!e.isLocked),t&&t!==e.isLocked&&(e.isEnd=!1),t!==e.isLocked&&e.emit(e.isLocked?"lock":"unlock")}},classes:R,images:{loadImage:function(e,t,s,a,i,n){const l=r();let o;function c(){n&&n()}d(e).parent("picture")[0]||e.complete&&i?c():t?(o=new l.Image,o.onload=c,o.onerror=c,a&&(o.sizes=a),s&&(o.srcset=s),t&&(o.src=t)):c()},preloadImages:function(){const e=this;function t(){null!=e&&e&&!e.destroyed&&(void 0!==e.imagesLoaded&&(e.imagesLoaded+=1),e.imagesLoaded===e.imagesToLoad.length&&(e.params.updateOnImagesReady&&e.update(),e.emit("imagesReady")))}e.imagesToLoad=e.$el.find("img");for(let s=0;s<e.imagesToLoad.length;s+=1){const a=e.imagesToLoad[s];e.loadImage(a,a.currentSrc||a.getAttribute("src"),a.srcset||a.getAttribute("srcset"),a.sizes||a.getAttribute("sizes"),!0,t)}}}},_={};class V{constructor(){let e,t;for(var s=arguments.length,a=new Array(s),i=0;i<s;i++)a[i]=arguments[i];if(1===a.length&&a[0].constructor&&"Object"===Object.prototype.toString.call(a[0]).slice(8,-1)?t=a[0]:[e,t]=a,t||(t={}),t=g({},t),e&&!t.el&&(t.el=e),t.el&&d(t.el).length>1){const e=[];return d(t.el).each((s=>{const a=g({},t,{el:s});e.push(new V(a))})),e}const r=this;r.__swiper__=!0,r.support=E(),r.device=C({userAgent:t.userAgent}),r.browser=T(),r.eventsListeners={},r.eventsAnyListeners=[],r.modules=[...r.__modules__],t.modules&&Array.isArray(t.modules)&&r.modules.push(...t.modules);const n={};r.modules.forEach((e=>{e({swiper:r,extendParams:j(t,n),on:r.on.bind(r),once:r.once.bind(r),off:r.off.bind(r),emit:r.emit.bind(r)})}));const l=g({},W,n);return r.params=g({},l,_,t),r.originalParams=g({},r.params),r.passedParams=g({},t),r.params&&r.params.on&&Object.keys(r.params.on).forEach((e=>{r.on(e,r.params.on[e])})),r.params&&r.params.onAny&&r.onAny(r.params.onAny),r.$=d,Object.assign(r,{enabled:r.params.enabled,el:e,classNames:[],slides:d(),slidesGrid:[],snapGrid:[],slidesSizesGrid:[],isHorizontal:()=>"horizontal"===r.params.direction,isVertical:()=>"vertical"===r.params.direction,activeIndex:0,realIndex:0,isBeginning:!0,isEnd:!1,translate:0,previousTranslate:0,progress:0,velocity:0,animating:!1,allowSlideNext:r.params.allowSlideNext,allowSlidePrev:r.params.allowSlidePrev,touchEvents:function(){const e=["touchstart","touchmove","touchend","touchcancel"],t=["pointerdown","pointermove","pointerup"];return r.touchEventsTouch={start:e[0],move:e[1],end:e[2],cancel:e[3]},r.touchEventsDesktop={start:t[0],move:t[1],end:t[2]},r.support.touch||!r.params.simulateTouch?r.touchEventsTouch:r.touchEventsDesktop}(),touchEventsData:{isTouched:void 0,isMoved:void 0,allowTouchCallbacks:void 0,touchStartTime:void 0,isScrolling:void 0,currentTranslate:void 0,startTranslate:void 0,allowThresholdMove:void 0,focusableElements:r.params.focusableElements,lastClickTime:u(),clickTimeout:void 0,velocities:[],allowMomentumBounce:void 0,isTouchEvent:void 0,startMoving:void 0},allowClick:!0,allowTouchMove:r.params.allowTouchMove,touches:{startX:0,startY:0,currentX:0,currentY:0,diff:0},imagesToLoad:[],imagesLoaded:0}),r.emit("_swiper"),r.params.init&&r.init(),r}enable(){const e=this;e.enabled||(e.enabled=!0,e.params.grabCursor&&e.setGrabCursor(),e.emit("enable"))}disable(){const e=this;e.enabled&&(e.enabled=!1,e.params.grabCursor&&e.unsetGrabCursor(),e.emit("disable"))}setProgress(e,t){const s=this;e=Math.min(Math.max(e,0),1);const a=s.minTranslate(),i=(s.maxTranslate()-a)*e+a;s.translateTo(i,void 0===t?0:t),s.updateActiveIndex(),s.updateSlidesClasses()}emitContainerClasses(){const e=this;if(!e.params._emitClasses||!e.el)return;const t=e.el.className.split(" ").filter((t=>0===t.indexOf("swiper")||0===t.indexOf(e.params.containerModifierClass)));e.emit("_containerClasses",t.join(" "))}getSlideClasses(e){const t=this;return t.destroyed?"":e.className.split(" ").filter((e=>0===e.indexOf("swiper-slide")||0===e.indexOf(t.params.slideClass))).join(" ")}emitSlidesClasses(){const e=this;if(!e.params._emitClasses||!e.el)return;const t=[];e.slides.each((s=>{const a=e.getSlideClasses(s);t.push({slideEl:s,classNames:a}),e.emit("_slideClass",s,a)})),e.emit("_slideClasses",t)}slidesPerViewDynamic(e,t){void 0===e&&(e="current"),void 0===t&&(t=!1);const{params:s,slides:a,slidesGrid:i,slidesSizesGrid:r,size:n,activeIndex:l}=this;let o=1;if(s.centeredSlides){let e,t=a[l].swiperSlideSize;for(let s=l+1;s<a.length;s+=1)a[s]&&!e&&(t+=a[s].swiperSlideSize,o+=1,t>n&&(e=!0));for(let s=l-1;s>=0;s-=1)a[s]&&!e&&(t+=a[s].swiperSlideSize,o+=1,t>n&&(e=!0))}else if("current"===e)for(let e=l+1;e<a.length;e+=1){(t?i[e]+r[e]-i[l]<n:i[e]-i[l]<n)&&(o+=1)}else for(let e=l-1;e>=0;e-=1){i[l]-i[e]<n&&(o+=1)}return o}update(){const e=this;if(!e||e.destroyed)return;const{snapGrid:t,params:s}=e;function a(){const t=e.rtlTranslate?-1*e.translate:e.translate,s=Math.min(Math.max(t,e.maxTranslate()),e.minTranslate());e.setTranslate(s),e.updateActiveIndex(),e.updateSlidesClasses()}let i;s.breakpoints&&e.setBreakpoint(),e.updateSize(),e.updateSlides(),e.updateProgress(),e.updateSlidesClasses(),e.params.freeMode&&e.params.freeMode.enabled?(a(),e.params.autoHeight&&e.updateAutoHeight()):(i=("auto"===e.params.slidesPerView||e.params.slidesPerView>1)&&e.isEnd&&!e.params.centeredSlides?e.slideTo(e.slides.length-1,0,!1,!0):e.slideTo(e.activeIndex,0,!1,!0),i||a()),s.watchOverflow&&t!==e.snapGrid&&e.checkOverflow(),e.emit("update")}changeDirection(e,t){void 0===t&&(t=!0);const s=this,a=s.params.direction;return e||(e="horizontal"===a?"vertical":"horizontal"),e===a||"horizontal"!==e&&"vertical"!==e||(s.$el.removeClass(`${s.params.containerModifierClass}${a}`).addClass(`${s.params.containerModifierClass}${e}`),s.emitContainerClasses(),s.params.direction=e,s.slides.each((t=>{"vertical"===e?t.style.width="":t.style.height=""})),s.emit("changeDirection"),t&&s.update()),s}changeLanguageDirection(e){const t=this;t.rtl&&"rtl"===e||!t.rtl&&"ltr"===e||(t.rtl="rtl"===e,t.rtlTranslate="horizontal"===t.params.direction&&t.rtl,t.rtl?(t.$el.addClass(`${t.params.containerModifierClass}rtl`),t.el.dir="rtl"):(t.$el.removeClass(`${t.params.containerModifierClass}rtl`),t.el.dir="ltr"),t.update())}mount(e){const t=this;if(t.mounted)return!0;const s=d(e||t.params.el);if(!(e=s[0]))return!1;e.swiper=t;const i=()=>`.${(t.params.wrapperClass||"").trim().split(" ").join(".")}`;let r=(()=>{if(e&&e.shadowRoot&&e.shadowRoot.querySelector){const t=d(e.shadowRoot.querySelector(i()));return t.children=e=>s.children(e),t}return s.children?s.children(i()):d(s).children(i())})();if(0===r.length&&t.params.createElements){const e=a().createElement("div");r=d(e),e.className=t.params.wrapperClass,s.append(e),s.children(`.${t.params.slideClass}`).each((e=>{r.append(e)}))}return Object.assign(t,{$el:s,el:e,$wrapperEl:r,wrapperEl:r[0],mounted:!0,rtl:"rtl"===e.dir.toLowerCase()||"rtl"===s.css("direction"),rtlTranslate:"horizontal"===t.params.direction&&("rtl"===e.dir.toLowerCase()||"rtl"===s.css("direction")),wrongRTL:"-webkit-box"===r.css("display")}),!0}init(e){const t=this;if(t.initialized)return t;return!1===t.mount(e)||(t.emit("beforeInit"),t.params.breakpoints&&t.setBreakpoint(),t.addClasses(),t.params.loop&&t.loopCreate(),t.updateSize(),t.updateSlides(),t.params.watchOverflow&&t.checkOverflow(),t.params.grabCursor&&t.enabled&&t.setGrabCursor(),t.params.preloadImages&&t.preloadImages(),t.params.loop?t.slideTo(t.params.initialSlide+t.loopedSlides,0,t.params.runCallbacksOnInit,!1,!0):t.slideTo(t.params.initialSlide,0,t.params.runCallbacksOnInit,!1,!0),t.attachEvents(),t.initialized=!0,t.emit("init"),t.emit("afterInit")),t}destroy(e,t){void 0===e&&(e=!0),void 0===t&&(t=!0);const s=this,{params:a,$el:i,$wrapperEl:r,slides:n}=s;return void 0===s.params||s.destroyed||(s.emit("beforeDestroy"),s.initialized=!1,s.detachEvents(),a.loop&&s.loopDestroy(),t&&(s.removeClasses(),i.removeAttr("style"),r.removeAttr("style"),n&&n.length&&n.removeClass([a.slideVisibleClass,a.slideActiveClass,a.slideNextClass,a.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index")),s.emit("destroy"),Object.keys(s.eventsListeners).forEach((e=>{s.off(e)})),!1!==e&&(s.$el[0].swiper=null,function(e){const t=e;Object.keys(t).forEach((e=>{try{t[e]=null}catch(e){}try{delete t[e]}catch(e){}}))}(s)),s.destroyed=!0),null}static extendDefaults(e){g(_,e)}static get extendedDefaults(){return _}static get defaults(){return W}static installModule(e){V.prototype.__modules__||(V.prototype.__modules__=[]);const t=V.prototype.__modules__;"function"==typeof e&&t.indexOf(e)<0&&t.push(e)}static use(e){return Array.isArray(e)?(e.forEach((e=>V.installModule(e))),V):(V.installModule(e),V)}}function F(e,t,s,i){const r=a();return e.params.createElements&&Object.keys(i).forEach((a=>{if(!s[a]&&!0===s.auto){let n=e.$el.children(`.${i[a]}`)[0];n||(n=r.createElement("div"),n.className=i[a],e.$el.append(n)),s[a]=n,t[a]=n}})),s}function U(e){return void 0===e&&(e=""),`.${e.trim().replace(/([\.:!\/])/g,"\\$1").replace(/ /g,".")}`}function K(e){const t=this,{$wrapperEl:s,params:a}=t;if(a.loop&&t.loopDestroy(),"object"==typeof e&&"length"in e)for(let t=0;t<e.length;t+=1)e[t]&&s.append(e[t]);else s.append(e);a.loop&&t.loopCreate(),a.observer||t.update()}function Z(e){const t=this,{params:s,$wrapperEl:a,activeIndex:i}=t;s.loop&&t.loopDestroy();let r=i+1;if("object"==typeof e&&"length"in e){for(let t=0;t<e.length;t+=1)e[t]&&a.prepend(e[t]);r=i+e.length}else a.prepend(e);s.loop&&t.loopCreate(),s.observer||t.update(),t.slideTo(r,0,!1)}function Q(e,t){const s=this,{$wrapperEl:a,params:i,activeIndex:r}=s;let n=r;i.loop&&(n-=s.loopedSlides,s.loopDestroy(),s.slides=a.children(`.${i.slideClass}`));const l=s.slides.length;if(e<=0)return void s.prependSlide(t);if(e>=l)return void s.appendSlide(t);let o=n>e?n+1:n;const d=[];for(let t=l-1;t>=e;t-=1){const e=s.slides.eq(t);e.remove(),d.unshift(e)}if("object"==typeof t&&"length"in t){for(let e=0;e<t.length;e+=1)t[e]&&a.append(t[e]);o=n>e?n+t.length:n}else a.append(t);for(let e=0;e<d.length;e+=1)a.append(d[e]);i.loop&&s.loopCreate(),i.observer||s.update(),i.loop?s.slideTo(o+s.loopedSlides,0,!1):s.slideTo(o,0,!1)}function J(e){const t=this,{params:s,$wrapperEl:a,activeIndex:i}=t;let r=i;s.loop&&(r-=t.loopedSlides,t.loopDestroy(),t.slides=a.children(`.${s.slideClass}`));let n,l=r;if("object"==typeof e&&"length"in e){for(let s=0;s<e.length;s+=1)n=e[s],t.slides[n]&&t.slides.eq(n).remove(),n<l&&(l-=1);l=Math.max(l,0)}else n=e,t.slides[n]&&t.slides.eq(n).remove(),n<l&&(l-=1),l=Math.max(l,0);s.loop&&t.loopCreate(),s.observer||t.update(),s.loop?t.slideTo(l+t.loopedSlides,0,!1):t.slideTo(l,0,!1)}function ee(){const e=this,t=[];for(let s=0;s<e.slides.length;s+=1)t.push(s);e.removeSlide(t)}function te(e){const{effect:t,swiper:s,on:a,setTranslate:i,setTransition:r,overwriteParams:n,perspective:l,recreateShadows:o,getEffectParams:d}=e;let c;a("beforeInit",(()=>{if(s.params.effect!==t)return;s.classNames.push(`${s.params.containerModifierClass}${t}`),l&&l()&&s.classNames.push(`${s.params.containerModifierClass}3d`);const e=n?n():{};Object.assign(s.params,e),Object.assign(s.originalParams,e)})),a("setTranslate",(()=>{s.params.effect===t&&i()})),a("setTransition",((e,a)=>{s.params.effect===t&&r(a)})),a("transitionEnd",(()=>{if(s.params.effect===t&&o){if(!d||!d().slideShadows)return;s.slides.each((e=>{s.$(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").remove()})),o()}})),a("virtualUpdate",(()=>{s.params.effect===t&&(s.slides.length||(c=!0),requestAnimationFrame((()=>{c&&s.slides&&s.slides.length&&(i(),c=!1)})))}))}function se(e,t){return e.transformEl?t.find(e.transformEl).css({"backface-visibility":"hidden","-webkit-backface-visibility":"hidden"}):t}function ae(e){let{swiper:t,duration:s,transformEl:a,allSlides:i}=e;const{slides:r,activeIndex:n,$wrapperEl:l}=t;if(t.params.virtualTranslate&&0!==s){let e,s=!1;e=i?a?r.find(a):r:a?r.eq(n).find(a):r.eq(n),e.transitionEnd((()=>{if(s)return;if(!t||t.destroyed)return;s=!0,t.animating=!1;const e=["webkitTransitionEnd","transitionend"];for(let t=0;t<e.length;t+=1)l.trigger(e[t])}))}}function ie(e,t,s){const a="swiper-slide-shadow"+(s?`-${s}`:""),i=e.transformEl?t.find(e.transformEl):t;let r=i.children(`.${a}`);return r.length||(r=d(`<div class="swiper-slide-shadow${s?`-${s}`:""}"></div>`),i.append(r)),r}Object.keys(q).forEach((e=>{Object.keys(q[e]).forEach((t=>{V.prototype[t]=q[e][t]}))})),V.use([function(e){let{swiper:t,on:s,emit:a}=e;const i=r();let n=null,l=null;const o=()=>{t&&!t.destroyed&&t.initialized&&(a("beforeResize"),a("resize"))},d=()=>{t&&!t.destroyed&&t.initialized&&a("orientationchange")};s("init",(()=>{t.params.resizeObserver&&void 0!==i.ResizeObserver?t&&!t.destroyed&&t.initialized&&(n=new ResizeObserver((e=>{l=i.requestAnimationFrame((()=>{const{width:s,height:a}=t;let i=s,r=a;e.forEach((e=>{let{contentBoxSize:s,contentRect:a,target:n}=e;n&&n!==t.el||(i=a?a.width:(s[0]||s).inlineSize,r=a?a.height:(s[0]||s).blockSize)})),i===s&&r===a||o()}))})),n.observe(t.el)):(i.addEventListener("resize",o),i.addEventListener("orientationchange",d))})),s("destroy",(()=>{l&&i.cancelAnimationFrame(l),n&&n.unobserve&&t.el&&(n.unobserve(t.el),n=null),i.removeEventListener("resize",o),i.removeEventListener("orientationchange",d)}))},function(e){let{swiper:t,extendParams:s,on:a,emit:i}=e;const n=[],l=r(),o=function(e,t){void 0===t&&(t={});const s=new(l.MutationObserver||l.WebkitMutationObserver)((e=>{if(1===e.length)return void i("observerUpdate",e[0]);const t=function(){i("observerUpdate",e[0])};l.requestAnimationFrame?l.requestAnimationFrame(t):l.setTimeout(t,0)}));s.observe(e,{attributes:void 0===t.attributes||t.attributes,childList:void 0===t.childList||t.childList,characterData:void 0===t.characterData||t.characterData}),n.push(s)};s({observer:!1,observeParents:!1,observeSlideChildren:!1}),a("init",(()=>{if(t.params.observer){if(t.params.observeParents){const e=t.$el.parents();for(let t=0;t<e.length;t+=1)o(e[t])}o(t.$el[0],{childList:t.params.observeSlideChildren}),o(t.$wrapperEl[0],{attributes:!1})}})),a("destroy",(()=>{n.forEach((e=>{e.disconnect()})),n.splice(0,n.length)}))}]);const re=[function(e){let t,{swiper:s,extendParams:a,on:i,emit:r}=e;function n(e,t){const a=s.params.virtual;if(a.cache&&s.virtual.cache[t])return s.virtual.cache[t];const i=a.renderSlide?d(a.renderSlide.call(s,e,t)):d(`<div class="${s.params.slideClass}" data-swiper-slide-index="${t}">${e}</div>`);return i.attr("data-swiper-slide-index")||i.attr("data-swiper-slide-index",t),a.cache&&(s.virtual.cache[t]=i),i}function l(e){const{slidesPerView:t,slidesPerGroup:a,centeredSlides:i}=s.params,{addSlidesBefore:l,addSlidesAfter:o}=s.params.virtual,{from:d,to:c,slides:p,slidesGrid:u,offset:h}=s.virtual;s.params.cssMode||s.updateActiveIndex();const m=s.activeIndex||0;let f,g,v;f=s.rtlTranslate?"right":s.isHorizontal()?"left":"top",i?(g=Math.floor(t/2)+a+o,v=Math.floor(t/2)+a+l):(g=t+(a-1)+o,v=a+l);const w=Math.max((m||0)-v,0),b=Math.min((m||0)+g,p.length-1),x=(s.slidesGrid[w]||0)-(s.slidesGrid[0]||0);function y(){s.updateSlides(),s.updateProgress(),s.updateSlidesClasses(),s.lazy&&s.params.lazy.enabled&&s.lazy.load(),r("virtualUpdate")}if(Object.assign(s.virtual,{from:w,to:b,offset:x,slidesGrid:s.slidesGrid}),d===w&&c===b&&!e)return s.slidesGrid!==u&&x!==h&&s.slides.css(f,`${x}px`),s.updateProgress(),void r("virtualUpdate");if(s.params.virtual.renderExternal)return s.params.virtual.renderExternal.call(s,{offset:x,from:w,to:b,slides:function(){const e=[];for(let t=w;t<=b;t+=1)e.push(p[t]);return e}()}),void(s.params.virtual.renderExternalUpdate?y():r("virtualUpdate"));const E=[],C=[];if(e)s.$wrapperEl.find(`.${s.params.slideClass}`).remove();else for(let e=d;e<=c;e+=1)(e<w||e>b)&&s.$wrapperEl.find(`.${s.params.slideClass}[data-swiper-slide-index="${e}"]`).remove();for(let t=0;t<p.length;t+=1)t>=w&&t<=b&&(void 0===c||e?C.push(t):(t>c&&C.push(t),t<d&&E.push(t)));C.forEach((e=>{s.$wrapperEl.append(n(p[e],e))})),E.sort(((e,t)=>t-e)).forEach((e=>{s.$wrapperEl.prepend(n(p[e],e))})),s.$wrapperEl.children(".swiper-slide").css(f,`${x}px`),y()}a({virtual:{enabled:!1,slides:[],cache:!0,renderSlide:null,renderExternal:null,renderExternalUpdate:!0,addSlidesBefore:0,addSlidesAfter:0}}),s.virtual={cache:{},from:void 0,to:void 0,slides:[],offset:0,slidesGrid:[]},i("beforeInit",(()=>{s.params.virtual.enabled&&(s.virtual.slides=s.params.virtual.slides,s.classNames.push(`${s.params.containerModifierClass}virtual`),s.params.watchSlidesProgress=!0,s.originalParams.watchSlidesProgress=!0,s.params.initialSlide||l())})),i("setTranslate",(()=>{s.params.virtual.enabled&&(s.params.cssMode&&!s._immediateVirtual?(clearTimeout(t),t=setTimeout((()=>{l()}),100)):l())})),i("init update resize",(()=>{s.params.virtual.enabled&&s.params.cssMode&&v(s.wrapperEl,"--swiper-virtual-size",`${s.virtualSize}px`)})),Object.assign(s.virtual,{appendSlide:function(e){if("object"==typeof e&&"length"in e)for(let t=0;t<e.length;t+=1)e[t]&&s.virtual.slides.push(e[t]);else s.virtual.slides.push(e);l(!0)},prependSlide:function(e){const t=s.activeIndex;let a=t+1,i=1;if(Array.isArray(e)){for(let t=0;t<e.length;t+=1)e[t]&&s.virtual.slides.unshift(e[t]);a=t+e.length,i=e.length}else s.virtual.slides.unshift(e);if(s.params.virtual.cache){const e=s.virtual.cache,t={};Object.keys(e).forEach((s=>{const a=e[s],r=a.attr("data-swiper-slide-index");r&&a.attr("data-swiper-slide-index",parseInt(r,10)+i),t[parseInt(s,10)+i]=a})),s.virtual.cache=t}l(!0),s.slideTo(a,0)},removeSlide:function(e){if(null==e)return;let t=s.activeIndex;if(Array.isArray(e))for(let a=e.length-1;a>=0;a-=1)s.virtual.slides.splice(e[a],1),s.params.virtual.cache&&delete s.virtual.cache[e[a]],e[a]<t&&(t-=1),t=Math.max(t,0);else s.virtual.slides.splice(e,1),s.params.virtual.cache&&delete s.virtual.cache[e],e<t&&(t-=1),t=Math.max(t,0);l(!0),s.slideTo(t,0)},removeAllSlides:function(){s.virtual.slides=[],s.params.virtual.cache&&(s.virtual.cache={}),l(!0),s.slideTo(0,0)},update:l})},function(e){let{swiper:t,extendParams:s,on:i,emit:n}=e;const l=a(),o=r();function c(e){if(!t.enabled)return;const{rtlTranslate:s}=t;let a=e;a.originalEvent&&(a=a.originalEvent);const i=a.keyCode||a.charCode,r=t.params.keyboard.pageUpDown,d=r&&33===i,c=r&&34===i,p=37===i,u=39===i,h=38===i,m=40===i;if(!t.allowSlideNext&&(t.isHorizontal()&&u||t.isVertical()&&m||c))return!1;if(!t.allowSlidePrev&&(t.isHorizontal()&&p||t.isVertical()&&h||d))return!1;if(!(a.shiftKey||a.altKey||a.ctrlKey||a.metaKey||l.activeElement&&l.activeElement.nodeName&&("input"===l.activeElement.nodeName.toLowerCase()||"textarea"===l.activeElement.nodeName.toLowerCase()))){if(t.params.keyboard.onlyInViewport&&(d||c||p||u||h||m)){let e=!1;if(t.$el.parents(`.${t.params.slideClass}`).length>0&&0===t.$el.parents(`.${t.params.slideActiveClass}`).length)return;const a=t.$el,i=a[0].clientWidth,r=a[0].clientHeight,n=o.innerWidth,l=o.innerHeight,d=t.$el.offset();s&&(d.left-=t.$el[0].scrollLeft);const c=[[d.left,d.top],[d.left+i,d.top],[d.left,d.top+r],[d.left+i,d.top+r]];for(let t=0;t<c.length;t+=1){const s=c[t];if(s[0]>=0&&s[0]<=n&&s[1]>=0&&s[1]<=l){if(0===s[0]&&0===s[1])continue;e=!0}}if(!e)return}t.isHorizontal()?((d||c||p||u)&&(a.preventDefault?a.preventDefault():a.returnValue=!1),((c||u)&&!s||(d||p)&&s)&&t.slideNext(),((d||p)&&!s||(c||u)&&s)&&t.slidePrev()):((d||c||h||m)&&(a.preventDefault?a.preventDefault():a.returnValue=!1),(c||m)&&t.slideNext(),(d||h)&&t.slidePrev()),n("keyPress",i)}}function p(){t.keyboard.enabled||(d(l).on("keydown",c),t.keyboard.enabled=!0)}function u(){t.keyboard.enabled&&(d(l).off("keydown",c),t.keyboard.enabled=!1)}t.keyboard={enabled:!1},s({keyboard:{enabled:!1,onlyInViewport:!0,pageUpDown:!0}}),i("init",(()=>{t.params.keyboard.enabled&&p()})),i("destroy",(()=>{t.keyboard.enabled&&u()})),Object.assign(t.keyboard,{enable:p,disable:u})},function(e){let{swiper:t,extendParams:s,on:a,emit:i}=e;const n=r();let l;s({mousewheel:{enabled:!1,releaseOnEdges:!1,invert:!1,forceToAxis:!1,sensitivity:1,eventsTarget:"container",thresholdDelta:null,thresholdTime:null}}),t.mousewheel={enabled:!1};let o,c=u();const h=[];function m(){t.enabled&&(t.mouseEntered=!0)}function f(){t.enabled&&(t.mouseEntered=!1)}function g(e){return!(t.params.mousewheel.thresholdDelta&&e.delta<t.params.mousewheel.thresholdDelta)&&(!(t.params.mousewheel.thresholdTime&&u()-c<t.params.mousewheel.thresholdTime)&&(e.delta>=6&&u()-c<60||(e.direction<0?t.isEnd&&!t.params.loop||t.animating||(t.slideNext(),i("scroll",e.raw)):t.isBeginning&&!t.params.loop||t.animating||(t.slidePrev(),i("scroll",e.raw)),c=(new n.Date).getTime(),!1)))}function v(e){let s=e,a=!0;if(!t.enabled)return;const r=t.params.mousewheel;t.params.cssMode&&s.preventDefault();let n=t.$el;if("container"!==t.params.mousewheel.eventsTarget&&(n=d(t.params.mousewheel.eventsTarget)),!t.mouseEntered&&!n[0].contains(s.target)&&!r.releaseOnEdges)return!0;s.originalEvent&&(s=s.originalEvent);let c=0;const m=t.rtlTranslate?-1:1,f=function(e){let t=0,s=0,a=0,i=0;return"detail"in e&&(s=e.detail),"wheelDelta"in e&&(s=-e.wheelDelta/120),"wheelDeltaY"in e&&(s=-e.wheelDeltaY/120),"wheelDeltaX"in e&&(t=-e.wheelDeltaX/120),"axis"in e&&e.axis===e.HORIZONTAL_AXIS&&(t=s,s=0),a=10*t,i=10*s,"deltaY"in e&&(i=e.deltaY),"deltaX"in e&&(a=e.deltaX),e.shiftKey&&!a&&(a=i,i=0),(a||i)&&e.deltaMode&&(1===e.deltaMode?(a*=40,i*=40):(a*=800,i*=800)),a&&!t&&(t=a<1?-1:1),i&&!s&&(s=i<1?-1:1),{spinX:t,spinY:s,pixelX:a,pixelY:i}}(s);if(r.forceToAxis)if(t.isHorizontal()){if(!(Math.abs(f.pixelX)>Math.abs(f.pixelY)))return!0;c=-f.pixelX*m}else{if(!(Math.abs(f.pixelY)>Math.abs(f.pixelX)))return!0;c=-f.pixelY}else c=Math.abs(f.pixelX)>Math.abs(f.pixelY)?-f.pixelX*m:-f.pixelY;if(0===c)return!0;r.invert&&(c=-c);let v=t.getTranslate()+c*r.sensitivity;if(v>=t.minTranslate()&&(v=t.minTranslate()),v<=t.maxTranslate()&&(v=t.maxTranslate()),a=!!t.params.loop||!(v===t.minTranslate()||v===t.maxTranslate()),a&&t.params.nested&&s.stopPropagation(),t.params.freeMode&&t.params.freeMode.enabled){const e={time:u(),delta:Math.abs(c),direction:Math.sign(c)},a=o&&e.time<o.time+500&&e.delta<=o.delta&&e.direction===o.direction;if(!a){o=void 0,t.params.loop&&t.loopFix();let n=t.getTranslate()+c*r.sensitivity;const d=t.isBeginning,u=t.isEnd;if(n>=t.minTranslate()&&(n=t.minTranslate()),n<=t.maxTranslate()&&(n=t.maxTranslate()),t.setTransition(0),t.setTranslate(n),t.updateProgress(),t.updateActiveIndex(),t.updateSlidesClasses(),(!d&&t.isBeginning||!u&&t.isEnd)&&t.updateSlidesClasses(),t.params.freeMode.sticky){clearTimeout(l),l=void 0,h.length>=15&&h.shift();const s=h.length?h[h.length-1]:void 0,a=h[0];if(h.push(e),s&&(e.delta>s.delta||e.direction!==s.direction))h.splice(0);else if(h.length>=15&&e.time-a.time<500&&a.delta-e.delta>=1&&e.delta<=6){const s=c>0?.8:.2;o=e,h.splice(0),l=p((()=>{t.slideToClosest(t.params.speed,!0,void 0,s)}),0)}l||(l=p((()=>{o=e,h.splice(0),t.slideToClosest(t.params.speed,!0,void 0,.5)}),500))}if(a||i("scroll",s),t.params.autoplay&&t.params.autoplayDisableOnInteraction&&t.autoplay.stop(),n===t.minTranslate()||n===t.maxTranslate())return!0}}else{const s={time:u(),delta:Math.abs(c),direction:Math.sign(c),raw:e};h.length>=2&&h.shift();const a=h.length?h[h.length-1]:void 0;if(h.push(s),a?(s.direction!==a.direction||s.delta>a.delta||s.time>a.time+150)&&g(s):g(s),function(e){const s=t.params.mousewheel;if(e.direction<0){if(t.isEnd&&!t.params.loop&&s.releaseOnEdges)return!0}else if(t.isBeginning&&!t.params.loop&&s.releaseOnEdges)return!0;return!1}(s))return!0}return s.preventDefault?s.preventDefault():s.returnValue=!1,!1}function w(e){let s=t.$el;"container"!==t.params.mousewheel.eventsTarget&&(s=d(t.params.mousewheel.eventsTarget)),s[e]("mouseenter",m),s[e]("mouseleave",f),s[e]("wheel",v)}function b(){return t.params.cssMode?(t.wrapperEl.removeEventListener("wheel",v),!0):!t.mousewheel.enabled&&(w("on"),t.mousewheel.enabled=!0,!0)}function x(){return t.params.cssMode?(t.wrapperEl.addEventListener(event,v),!0):!!t.mousewheel.enabled&&(w("off"),t.mousewheel.enabled=!1,!0)}a("init",(()=>{!t.params.mousewheel.enabled&&t.params.cssMode&&x(),t.params.mousewheel.enabled&&b()})),a("destroy",(()=>{t.params.cssMode&&b(),t.mousewheel.enabled&&x()})),Object.assign(t.mousewheel,{enable:b,disable:x})},function(e){let{swiper:t,extendParams:s,on:a,emit:i}=e;function r(e){let s;return e&&(s=d(e),t.params.uniqueNavElements&&"string"==typeof e&&s.length>1&&1===t.$el.find(e).length&&(s=t.$el.find(e))),s}function n(e,s){const a=t.params.navigation;e&&e.length>0&&(e[s?"addClass":"removeClass"](a.disabledClass),e[0]&&"BUTTON"===e[0].tagName&&(e[0].disabled=s),t.params.watchOverflow&&t.enabled&&e[t.isLocked?"addClass":"removeClass"](a.lockClass))}function l(){if(t.params.loop)return;const{$nextEl:e,$prevEl:s}=t.navigation;n(s,t.isBeginning&&!t.params.rewind),n(e,t.isEnd&&!t.params.rewind)}function o(e){e.preventDefault(),(!t.isBeginning||t.params.loop||t.params.rewind)&&(t.slidePrev(),i("navigationPrev"))}function c(e){e.preventDefault(),(!t.isEnd||t.params.loop||t.params.rewind)&&(t.slideNext(),i("navigationNext"))}function p(){const e=t.params.navigation;if(t.params.navigation=F(t,t.originalParams.navigation,t.params.navigation,{nextEl:"swiper-button-next",prevEl:"swiper-button-prev"}),!e.nextEl&&!e.prevEl)return;const s=r(e.nextEl),a=r(e.prevEl);s&&s.length>0&&s.on("click",c),a&&a.length>0&&a.on("click",o),Object.assign(t.navigation,{$nextEl:s,nextEl:s&&s[0],$prevEl:a,prevEl:a&&a[0]}),t.enabled||(s&&s.addClass(e.lockClass),a&&a.addClass(e.lockClass))}function u(){const{$nextEl:e,$prevEl:s}=t.navigation;e&&e.length&&(e.off("click",c),e.removeClass(t.params.navigation.disabledClass)),s&&s.length&&(s.off("click",o),s.removeClass(t.params.navigation.disabledClass))}s({navigation:{nextEl:null,prevEl:null,hideOnClick:!1,disabledClass:"swiper-button-disabled",hiddenClass:"swiper-button-hidden",lockClass:"swiper-button-lock",navigationDisabledClass:"swiper-navigation-disabled"}}),t.navigation={nextEl:null,$nextEl:null,prevEl:null,$prevEl:null},a("init",(()=>{!1===t.params.navigation.enabled?h():(p(),l())})),a("toEdge fromEdge lock unlock",(()=>{l()})),a("destroy",(()=>{u()})),a("enable disable",(()=>{const{$nextEl:e,$prevEl:s}=t.navigation;e&&e[t.enabled?"removeClass":"addClass"](t.params.navigation.lockClass),s&&s[t.enabled?"removeClass":"addClass"](t.params.navigation.lockClass)})),a("click",((e,s)=>{const{$nextEl:a,$prevEl:r}=t.navigation,n=s.target;if(t.params.navigation.hideOnClick&&!d(n).is(r)&&!d(n).is(a)){if(t.pagination&&t.params.pagination&&t.params.pagination.clickable&&(t.pagination.el===n||t.pagination.el.contains(n)))return;let e;a?e=a.hasClass(t.params.navigation.hiddenClass):r&&(e=r.hasClass(t.params.navigation.hiddenClass)),i(!0===e?"navigationShow":"navigationHide"),a&&a.toggleClass(t.params.navigation.hiddenClass),r&&r.toggleClass(t.params.navigation.hiddenClass)}}));const h=()=>{t.$el.addClass(t.params.navigation.navigationDisabledClass),u()};Object.assign(t.navigation,{enable:()=>{t.$el.removeClass(t.params.navigation.navigationDisabledClass),p(),l()},disable:h,update:l,init:p,destroy:u})},function(e){let{swiper:t,extendParams:s,on:a,emit:i}=e;const r="swiper-pagination";let n;s({pagination:{el:null,bulletElement:"span",clickable:!1,hideOnClick:!1,renderBullet:null,renderProgressbar:null,renderFraction:null,renderCustom:null,progressbarOpposite:!1,type:"bullets",dynamicBullets:!1,dynamicMainBullets:1,formatFractionCurrent:e=>e,formatFractionTotal:e=>e,bulletClass:`${r}-bullet`,bulletActiveClass:`${r}-bullet-active`,modifierClass:`${r}-`,currentClass:`${r}-current`,totalClass:`${r}-total`,hiddenClass:`${r}-hidden`,progressbarFillClass:`${r}-progressbar-fill`,progressbarOppositeClass:`${r}-progressbar-opposite`,clickableClass:`${r}-clickable`,lockClass:`${r}-lock`,horizontalClass:`${r}-horizontal`,verticalClass:`${r}-vertical`,paginationDisabledClass:`${r}-disabled`}}),t.pagination={el:null,$el:null,bullets:[]};let l=0;function o(){return!t.params.pagination.el||!t.pagination.el||!t.pagination.$el||0===t.pagination.$el.length}function c(e,s){const{bulletActiveClass:a}=t.params.pagination;e[s]().addClass(`${a}-${s}`)[s]().addClass(`${a}-${s}-${s}`)}function p(){const e=t.rtl,s=t.params.pagination;if(o())return;const a=t.virtual&&t.params.virtual.enabled?t.virtual.slides.length:t.slides.length,r=t.pagination.$el;let p;const u=t.params.loop?Math.ceil((a-2*t.loopedSlides)/t.params.slidesPerGroup):t.snapGrid.length;if(t.params.loop?(p=Math.ceil((t.activeIndex-t.loopedSlides)/t.params.slidesPerGroup),p>a-1-2*t.loopedSlides&&(p-=a-2*t.loopedSlides),p>u-1&&(p-=u),p<0&&"bullets"!==t.params.paginationType&&(p=u+p)):p=void 0!==t.snapIndex?t.snapIndex:t.activeIndex||0,"bullets"===s.type&&t.pagination.bullets&&t.pagination.bullets.length>0){const a=t.pagination.bullets;let i,o,u;if(s.dynamicBullets&&(n=a.eq(0)[t.isHorizontal()?"outerWidth":"outerHeight"](!0),r.css(t.isHorizontal()?"width":"height",n*(s.dynamicMainBullets+4)+"px"),s.dynamicMainBullets>1&&void 0!==t.previousIndex&&(l+=p-(t.previousIndex-t.loopedSlides||0),l>s.dynamicMainBullets-1?l=s.dynamicMainBullets-1:l<0&&(l=0)),i=Math.max(p-l,0),o=i+(Math.min(a.length,s.dynamicMainBullets)-1),u=(o+i)/2),a.removeClass(["","-next","-next-next","-prev","-prev-prev","-main"].map((e=>`${s.bulletActiveClass}${e}`)).join(" ")),r.length>1)a.each((e=>{const t=d(e),a=t.index();a===p&&t.addClass(s.bulletActiveClass),s.dynamicBullets&&(a>=i&&a<=o&&t.addClass(`${s.bulletActiveClass}-main`),a===i&&c(t,"prev"),a===o&&c(t,"next"))}));else{const e=a.eq(p),r=e.index();if(e.addClass(s.bulletActiveClass),s.dynamicBullets){const e=a.eq(i),n=a.eq(o);for(let e=i;e<=o;e+=1)a.eq(e).addClass(`${s.bulletActiveClass}-main`);if(t.params.loop)if(r>=a.length){for(let e=s.dynamicMainBullets;e>=0;e-=1)a.eq(a.length-e).addClass(`${s.bulletActiveClass}-main`);a.eq(a.length-s.dynamicMainBullets-1).addClass(`${s.bulletActiveClass}-prev`)}else c(e,"prev"),c(n,"next");else c(e,"prev"),c(n,"next")}}if(s.dynamicBullets){const i=Math.min(a.length,s.dynamicMainBullets+4),r=(n*i-n)/2-u*n,l=e?"right":"left";a.css(t.isHorizontal()?l:"top",`${r}px`)}}if("fraction"===s.type&&(r.find(U(s.currentClass)).text(s.formatFractionCurrent(p+1)),r.find(U(s.totalClass)).text(s.formatFractionTotal(u))),"progressbar"===s.type){let e;e=s.progressbarOpposite?t.isHorizontal()?"vertical":"horizontal":t.isHorizontal()?"horizontal":"vertical";const a=(p+1)/u;let i=1,n=1;"horizontal"===e?i=a:n=a,r.find(U(s.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${i}) scaleY(${n})`).transition(t.params.speed)}"custom"===s.type&&s.renderCustom?(r.html(s.renderCustom(t,p+1,u)),i("paginationRender",r[0])):i("paginationUpdate",r[0]),t.params.watchOverflow&&t.enabled&&r[t.isLocked?"addClass":"removeClass"](s.lockClass)}function u(){const e=t.params.pagination;if(o())return;const s=t.virtual&&t.params.virtual.enabled?t.virtual.slides.length:t.slides.length,a=t.pagination.$el;let r="";if("bullets"===e.type){let i=t.params.loop?Math.ceil((s-2*t.loopedSlides)/t.params.slidesPerGroup):t.snapGrid.length;t.params.freeMode&&t.params.freeMode.enabled&&!t.params.loop&&i>s&&(i=s);for(let s=0;s<i;s+=1)e.renderBullet?r+=e.renderBullet.call(t,s,e.bulletClass):r+=`<${e.bulletElement} class="${e.bulletClass}"></${e.bulletElement}>`;a.html(r),t.pagination.bullets=a.find(U(e.bulletClass))}"fraction"===e.type&&(r=e.renderFraction?e.renderFraction.call(t,e.currentClass,e.totalClass):`<span class="${e.currentClass}"></span> / <span class="${e.totalClass}"></span>`,a.html(r)),"progressbar"===e.type&&(r=e.renderProgressbar?e.renderProgressbar.call(t,e.progressbarFillClass):`<span class="${e.progressbarFillClass}"></span>`,a.html(r)),"custom"!==e.type&&i("paginationRender",t.pagination.$el[0])}function h(){t.params.pagination=F(t,t.originalParams.pagination,t.params.pagination,{el:"swiper-pagination"});const e=t.params.pagination;if(!e.el)return;let s=d(e.el);0!==s.length&&(t.params.uniqueNavElements&&"string"==typeof e.el&&s.length>1&&(s=t.$el.find(e.el),s.length>1&&(s=s.filter((e=>d(e).parents(".swiper")[0]===t.el)))),"bullets"===e.type&&e.clickable&&s.addClass(e.clickableClass),s.addClass(e.modifierClass+e.type),s.addClass(t.isHorizontal()?e.horizontalClass:e.verticalClass),"bullets"===e.type&&e.dynamicBullets&&(s.addClass(`${e.modifierClass}${e.type}-dynamic`),l=0,e.dynamicMainBullets<1&&(e.dynamicMainBullets=1)),"progressbar"===e.type&&e.progressbarOpposite&&s.addClass(e.progressbarOppositeClass),e.clickable&&s.on("click",U(e.bulletClass),(function(e){e.preventDefault();let s=d(this).index()*t.params.slidesPerGroup;t.params.loop&&(s+=t.loopedSlides),t.slideTo(s)})),Object.assign(t.pagination,{$el:s,el:s[0]}),t.enabled||s.addClass(e.lockClass))}function m(){const e=t.params.pagination;if(o())return;const s=t.pagination.$el;s.removeClass(e.hiddenClass),s.removeClass(e.modifierClass+e.type),s.removeClass(t.isHorizontal()?e.horizontalClass:e.verticalClass),t.pagination.bullets&&t.pagination.bullets.removeClass&&t.pagination.bullets.removeClass(e.bulletActiveClass),e.clickable&&s.off("click",U(e.bulletClass))}a("init",(()=>{!1===t.params.pagination.enabled?f():(h(),u(),p())})),a("activeIndexChange",(()=>{(t.params.loop||void 0===t.snapIndex)&&p()})),a("snapIndexChange",(()=>{t.params.loop||p()})),a("slidesLengthChange",(()=>{t.params.loop&&(u(),p())})),a("snapGridLengthChange",(()=>{t.params.loop||(u(),p())})),a("destroy",(()=>{m()})),a("enable disable",(()=>{const{$el:e}=t.pagination;e&&e[t.enabled?"removeClass":"addClass"](t.params.pagination.lockClass)})),a("lock unlock",(()=>{p()})),a("click",((e,s)=>{const a=s.target,{$el:r}=t.pagination;if(t.params.pagination.el&&t.params.pagination.hideOnClick&&r&&r.length>0&&!d(a).hasClass(t.params.pagination.bulletClass)){if(t.navigation&&(t.navigation.nextEl&&a===t.navigation.nextEl||t.navigation.prevEl&&a===t.navigation.prevEl))return;const e=r.hasClass(t.params.pagination.hiddenClass);i(!0===e?"paginationShow":"paginationHide"),r.toggleClass(t.params.pagination.hiddenClass)}}));const f=()=>{t.$el.addClass(t.params.pagination.paginationDisabledClass),t.pagination.$el&&t.pagination.$el.addClass(t.params.pagination.paginationDisabledClass),m()};Object.assign(t.pagination,{enable:()=>{t.$el.removeClass(t.params.pagination.paginationDisabledClass),t.pagination.$el&&t.pagination.$el.removeClass(t.params.pagination.paginationDisabledClass),h(),u(),p()},disable:f,render:u,update:p,init:h,destroy:m})},function(e){let{swiper:t,extendParams:s,on:i,emit:r}=e;const n=a();let l,o,c,u,h=!1,m=null,f=null;function g(){if(!t.params.scrollbar.el||!t.scrollbar.el)return;const{scrollbar:e,rtlTranslate:s,progress:a}=t,{$dragEl:i,$el:r}=e,n=t.params.scrollbar;let l=o,d=(c-o)*a;s?(d=-d,d>0?(l=o-d,d=0):-d+o>c&&(l=c+d)):d<0?(l=o+d,d=0):d+o>c&&(l=c-d),t.isHorizontal()?(i.transform(`translate3d(${d}px, 0, 0)`),i[0].style.width=`${l}px`):(i.transform(`translate3d(0px, ${d}px, 0)`),i[0].style.height=`${l}px`),n.hide&&(clearTimeout(m),r[0].style.opacity=1,m=setTimeout((()=>{r[0].style.opacity=0,r.transition(400)}),1e3))}function v(){if(!t.params.scrollbar.el||!t.scrollbar.el)return;const{scrollbar:e}=t,{$dragEl:s,$el:a}=e;s[0].style.width="",s[0].style.height="",c=t.isHorizontal()?a[0].offsetWidth:a[0].offsetHeight,u=t.size/(t.virtualSize+t.params.slidesOffsetBefore-(t.params.centeredSlides?t.snapGrid[0]:0)),o="auto"===t.params.scrollbar.dragSize?c*u:parseInt(t.params.scrollbar.dragSize,10),t.isHorizontal()?s[0].style.width=`${o}px`:s[0].style.height=`${o}px`,a[0].style.display=u>=1?"none":"",t.params.scrollbar.hide&&(a[0].style.opacity=0),t.params.watchOverflow&&t.enabled&&e.$el[t.isLocked?"addClass":"removeClass"](t.params.scrollbar.lockClass)}function w(e){return t.isHorizontal()?"touchstart"===e.type||"touchmove"===e.type?e.targetTouches[0].clientX:e.clientX:"touchstart"===e.type||"touchmove"===e.type?e.targetTouches[0].clientY:e.clientY}function b(e){const{scrollbar:s,rtlTranslate:a}=t,{$el:i}=s;let r;r=(w(e)-i.offset()[t.isHorizontal()?"left":"top"]-(null!==l?l:o/2))/(c-o),r=Math.max(Math.min(r,1),0),a&&(r=1-r);const n=t.minTranslate()+(t.maxTranslate()-t.minTranslate())*r;t.updateProgress(n),t.setTranslate(n),t.updateActiveIndex(),t.updateSlidesClasses()}function x(e){const s=t.params.scrollbar,{scrollbar:a,$wrapperEl:i}=t,{$el:n,$dragEl:o}=a;h=!0,l=e.target===o[0]||e.target===o?w(e)-e.target.getBoundingClientRect()[t.isHorizontal()?"left":"top"]:null,e.preventDefault(),e.stopPropagation(),i.transition(100),o.transition(100),b(e),clearTimeout(f),n.transition(0),s.hide&&n.css("opacity",1),t.params.cssMode&&t.$wrapperEl.css("scroll-snap-type","none"),r("scrollbarDragStart",e)}function y(e){const{scrollbar:s,$wrapperEl:a}=t,{$el:i,$dragEl:n}=s;h&&(e.preventDefault?e.preventDefault():e.returnValue=!1,b(e),a.transition(0),i.transition(0),n.transition(0),r("scrollbarDragMove",e))}function E(e){const s=t.params.scrollbar,{scrollbar:a,$wrapperEl:i}=t,{$el:n}=a;h&&(h=!1,t.params.cssMode&&(t.$wrapperEl.css("scroll-snap-type",""),i.transition("")),s.hide&&(clearTimeout(f),f=p((()=>{n.css("opacity",0),n.transition(400)}),1e3)),r("scrollbarDragEnd",e),s.snapOnRelease&&t.slideToClosest())}function C(e){const{scrollbar:s,touchEventsTouch:a,touchEventsDesktop:i,params:r,support:l}=t,o=s.$el;if(!o)return;const d=o[0],c=!(!l.passiveListener||!r.passiveListeners)&&{passive:!1,capture:!1},p=!(!l.passiveListener||!r.passiveListeners)&&{passive:!0,capture:!1};if(!d)return;const u="on"===e?"addEventListener":"removeEventListener";l.touch?(d[u](a.start,x,c),d[u](a.move,y,c),d[u](a.end,E,p)):(d[u](i.start,x,c),n[u](i.move,y,c),n[u](i.end,E,p))}function T(){const{scrollbar:e,$el:s}=t;t.params.scrollbar=F(t,t.originalParams.scrollbar,t.params.scrollbar,{el:"swiper-scrollbar"});const a=t.params.scrollbar;if(!a.el)return;let i=d(a.el);t.params.uniqueNavElements&&"string"==typeof a.el&&i.length>1&&1===s.find(a.el).length&&(i=s.find(a.el)),i.addClass(t.isHorizontal()?a.horizontalClass:a.verticalClass);let r=i.find(`.${t.params.scrollbar.dragClass}`);0===r.length&&(r=d(`<div class="${t.params.scrollbar.dragClass}"></div>`),i.append(r)),Object.assign(e,{$el:i,el:i[0],$dragEl:r,dragEl:r[0]}),a.draggable&&t.params.scrollbar.el&&t.scrollbar.el&&C("on"),i&&i[t.enabled?"removeClass":"addClass"](t.params.scrollbar.lockClass)}function $(){const e=t.params.scrollbar,s=t.scrollbar.$el;s&&s.removeClass(t.isHorizontal()?e.horizontalClass:e.verticalClass),t.params.scrollbar.el&&t.scrollbar.el&&C("off")}s({scrollbar:{el:null,dragSize:"auto",hide:!1,draggable:!1,snapOnRelease:!0,lockClass:"swiper-scrollbar-lock",dragClass:"swiper-scrollbar-drag",scrollbarDisabledClass:"swiper-scrollbar-disabled",horizontalClass:"swiper-scrollbar-horizontal",verticalClass:"swiper-scrollbar-vertical"}}),t.scrollbar={el:null,dragEl:null,$el:null,$dragEl:null},i("init",(()=>{!1===t.params.scrollbar.enabled?S():(T(),v(),g())})),i("update resize observerUpdate lock unlock",(()=>{v()})),i("setTranslate",(()=>{g()})),i("setTransition",((e,s)=>{!function(e){t.params.scrollbar.el&&t.scrollbar.el&&t.scrollbar.$dragEl.transition(e)}(s)})),i("enable disable",(()=>{const{$el:e}=t.scrollbar;e&&e[t.enabled?"removeClass":"addClass"](t.params.scrollbar.lockClass)})),i("destroy",(()=>{$()}));const S=()=>{t.$el.addClass(t.params.scrollbar.scrollbarDisabledClass),t.scrollbar.$el&&t.scrollbar.$el.addClass(t.params.scrollbar.scrollbarDisabledClass),$()};Object.assign(t.scrollbar,{enable:()=>{t.$el.removeClass(t.params.scrollbar.scrollbarDisabledClass),t.scrollbar.$el&&t.scrollbar.$el.removeClass(t.params.scrollbar.scrollbarDisabledClass),T(),v(),g()},disable:S,updateSize:v,setTranslate:g,init:T,destroy:$})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({parallax:{enabled:!1}});const i=(e,s)=>{const{rtl:a}=t,i=d(e),r=a?-1:1,n=i.attr("data-swiper-parallax")||"0";let l=i.attr("data-swiper-parallax-x"),o=i.attr("data-swiper-parallax-y");const c=i.attr("data-swiper-parallax-scale"),p=i.attr("data-swiper-parallax-opacity");if(l||o?(l=l||"0",o=o||"0"):t.isHorizontal()?(l=n,o="0"):(o=n,l="0"),l=l.indexOf("%")>=0?parseInt(l,10)*s*r+"%":l*s*r+"px",o=o.indexOf("%")>=0?parseInt(o,10)*s+"%":o*s+"px",null!=p){const e=p-(p-1)*(1-Math.abs(s));i[0].style.opacity=e}if(null==c)i.transform(`translate3d(${l}, ${o}, 0px)`);else{const e=c-(c-1)*(1-Math.abs(s));i.transform(`translate3d(${l}, ${o}, 0px) scale(${e})`)}},r=()=>{const{$el:e,slides:s,progress:a,snapGrid:r}=t;e.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((e=>{i(e,a)})),s.each(((e,s)=>{let n=e.progress;t.params.slidesPerGroup>1&&"auto"!==t.params.slidesPerView&&(n+=Math.ceil(s/2)-a*(r.length-1)),n=Math.min(Math.max(n,-1),1),d(e).find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((e=>{i(e,n)}))}))};a("beforeInit",(()=>{t.params.parallax.enabled&&(t.params.watchSlidesProgress=!0,t.originalParams.watchSlidesProgress=!0)})),a("init",(()=>{t.params.parallax.enabled&&r()})),a("setTranslate",(()=>{t.params.parallax.enabled&&r()})),a("setTransition",((e,s)=>{t.params.parallax.enabled&&function(e){void 0===e&&(e=t.params.speed);const{$el:s}=t;s.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((t=>{const s=d(t);let a=parseInt(s.attr("data-swiper-parallax-duration"),10)||e;0===e&&(a=0),s.transition(a)}))}(s)}))},function(e){let{swiper:t,extendParams:s,on:a,emit:i}=e;const n=r();s({zoom:{enabled:!1,maxRatio:3,minRatio:1,toggle:!0,containerClass:"swiper-zoom-container",zoomedSlideClass:"swiper-slide-zoomed"}}),t.zoom={enabled:!1};let l,o,c,p=1,u=!1;const m={$slideEl:void 0,slideWidth:void 0,slideHeight:void 0,$imageEl:void 0,$imageWrapEl:void 0,maxRatio:3},f={isTouched:void 0,isMoved:void 0,currentX:void 0,currentY:void 0,minX:void 0,minY:void 0,maxX:void 0,maxY:void 0,width:void 0,height:void 0,startX:void 0,startY:void 0,touchesStart:{},touchesCurrent:{}},g={x:void 0,y:void 0,prevPositionX:void 0,prevPositionY:void 0,prevTime:void 0};let v=1;function w(e){if(e.targetTouches.length<2)return 1;const t=e.targetTouches[0].pageX,s=e.targetTouches[0].pageY,a=e.targetTouches[1].pageX,i=e.targetTouches[1].pageY;return Math.sqrt((a-t)**2+(i-s)**2)}function b(e){const s=t.support,a=t.params.zoom;if(o=!1,c=!1,!s.gestures){if("touchstart"!==e.type||"touchstart"===e.type&&e.targetTouches.length<2)return;o=!0,m.scaleStart=w(e)}m.$slideEl&&m.$slideEl.length||(m.$slideEl=d(e.target).closest(`.${t.params.slideClass}`),0===m.$slideEl.length&&(m.$slideEl=t.slides.eq(t.activeIndex)),m.$imageEl=m.$slideEl.find(`.${a.containerClass}`).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0),m.$imageWrapEl=m.$imageEl.parent(`.${a.containerClass}`),m.maxRatio=m.$imageWrapEl.attr("data-swiper-zoom")||a.maxRatio,0!==m.$imageWrapEl.length)?(m.$imageEl&&m.$imageEl.transition(0),u=!0):m.$imageEl=void 0}function x(e){const s=t.support,a=t.params.zoom,i=t.zoom;if(!s.gestures){if("touchmove"!==e.type||"touchmove"===e.type&&e.targetTouches.length<2)return;c=!0,m.scaleMove=w(e)}m.$imageEl&&0!==m.$imageEl.length?(s.gestures?i.scale=e.scale*p:i.scale=m.scaleMove/m.scaleStart*p,i.scale>m.maxRatio&&(i.scale=m.maxRatio-1+(i.scale-m.maxRatio+1)**.5),i.scale<a.minRatio&&(i.scale=a.minRatio+1-(a.minRatio-i.scale+1)**.5),m.$imageEl.transform(`translate3d(0,0,0) scale(${i.scale})`)):"gesturechange"===e.type&&b(e)}function y(e){const s=t.device,a=t.support,i=t.params.zoom,r=t.zoom;if(!a.gestures){if(!o||!c)return;if("touchend"!==e.type||"touchend"===e.type&&e.changedTouches.length<2&&!s.android)return;o=!1,c=!1}m.$imageEl&&0!==m.$imageEl.length&&(r.scale=Math.max(Math.min(r.scale,m.maxRatio),i.minRatio),m.$imageEl.transition(t.params.speed).transform(`translate3d(0,0,0) scale(${r.scale})`),p=r.scale,u=!1,1===r.scale&&(m.$slideEl=void 0))}function E(e){const s=t.zoom;if(!m.$imageEl||0===m.$imageEl.length)return;if(t.allowClick=!1,!f.isTouched||!m.$slideEl)return;f.isMoved||(f.width=m.$imageEl[0].offsetWidth,f.height=m.$imageEl[0].offsetHeight,f.startX=h(m.$imageWrapEl[0],"x")||0,f.startY=h(m.$imageWrapEl[0],"y")||0,m.slideWidth=m.$slideEl[0].offsetWidth,m.slideHeight=m.$slideEl[0].offsetHeight,m.$imageWrapEl.transition(0));const a=f.width*s.scale,i=f.height*s.scale;if(!(a<m.slideWidth&&i<m.slideHeight)){if(f.minX=Math.min(m.slideWidth/2-a/2,0),f.maxX=-f.minX,f.minY=Math.min(m.slideHeight/2-i/2,0),f.maxY=-f.minY,f.touchesCurrent.x="touchmove"===e.type?e.targetTouches[0].pageX:e.pageX,f.touchesCurrent.y="touchmove"===e.type?e.targetTouches[0].pageY:e.pageY,!f.isMoved&&!u){if(t.isHorizontal()&&(Math.floor(f.minX)===Math.floor(f.startX)&&f.touchesCurrent.x<f.touchesStart.x||Math.floor(f.maxX)===Math.floor(f.startX)&&f.touchesCurrent.x>f.touchesStart.x))return void(f.isTouched=!1);if(!t.isHorizontal()&&(Math.floor(f.minY)===Math.floor(f.startY)&&f.touchesCurrent.y<f.touchesStart.y||Math.floor(f.maxY)===Math.floor(f.startY)&&f.touchesCurrent.y>f.touchesStart.y))return void(f.isTouched=!1)}e.cancelable&&e.preventDefault(),e.stopPropagation(),f.isMoved=!0,f.currentX=f.touchesCurrent.x-f.touchesStart.x+f.startX,f.currentY=f.touchesCurrent.y-f.touchesStart.y+f.startY,f.currentX<f.minX&&(f.currentX=f.minX+1-(f.minX-f.currentX+1)**.8),f.currentX>f.maxX&&(f.currentX=f.maxX-1+(f.currentX-f.maxX+1)**.8),f.currentY<f.minY&&(f.currentY=f.minY+1-(f.minY-f.currentY+1)**.8),f.currentY>f.maxY&&(f.currentY=f.maxY-1+(f.currentY-f.maxY+1)**.8),g.prevPositionX||(g.prevPositionX=f.touchesCurrent.x),g.prevPositionY||(g.prevPositionY=f.touchesCurrent.y),g.prevTime||(g.prevTime=Date.now()),g.x=(f.touchesCurrent.x-g.prevPositionX)/(Date.now()-g.prevTime)/2,g.y=(f.touchesCurrent.y-g.prevPositionY)/(Date.now()-g.prevTime)/2,Math.abs(f.touchesCurrent.x-g.prevPositionX)<2&&(g.x=0),Math.abs(f.touchesCurrent.y-g.prevPositionY)<2&&(g.y=0),g.prevPositionX=f.touchesCurrent.x,g.prevPositionY=f.touchesCurrent.y,g.prevTime=Date.now(),m.$imageWrapEl.transform(`translate3d(${f.currentX}px, ${f.currentY}px,0)`)}}function C(){const e=t.zoom;m.$slideEl&&t.previousIndex!==t.activeIndex&&(m.$imageEl&&m.$imageEl.transform("translate3d(0,0,0) scale(1)"),m.$imageWrapEl&&m.$imageWrapEl.transform("translate3d(0,0,0)"),e.scale=1,p=1,m.$slideEl=void 0,m.$imageEl=void 0,m.$imageWrapEl=void 0)}function T(e){const s=t.zoom,a=t.params.zoom;if(m.$slideEl||(e&&e.target&&(m.$slideEl=d(e.target).closest(`.${t.params.slideClass}`)),m.$slideEl||(t.params.virtual&&t.params.virtual.enabled&&t.virtual?m.$slideEl=t.$wrapperEl.children(`.${t.params.slideActiveClass}`):m.$slideEl=t.slides.eq(t.activeIndex)),m.$imageEl=m.$slideEl.find(`.${a.containerClass}`).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0),m.$imageWrapEl=m.$imageEl.parent(`.${a.containerClass}`)),!m.$imageEl||0===m.$imageEl.length||!m.$imageWrapEl||0===m.$imageWrapEl.length)return;let i,r,l,o,c,u,h,g,v,w,b,x,y,E,C,T,$,S;t.params.cssMode&&(t.wrapperEl.style.overflow="hidden",t.wrapperEl.style.touchAction="none"),m.$slideEl.addClass(`${a.zoomedSlideClass}`),void 0===f.touchesStart.x&&e?(i="touchend"===e.type?e.changedTouches[0].pageX:e.pageX,r="touchend"===e.type?e.changedTouches[0].pageY:e.pageY):(i=f.touchesStart.x,r=f.touchesStart.y),s.scale=m.$imageWrapEl.attr("data-swiper-zoom")||a.maxRatio,p=m.$imageWrapEl.attr("data-swiper-zoom")||a.maxRatio,e?($=m.$slideEl[0].offsetWidth,S=m.$slideEl[0].offsetHeight,l=m.$slideEl.offset().left+n.scrollX,o=m.$slideEl.offset().top+n.scrollY,c=l+$/2-i,u=o+S/2-r,v=m.$imageEl[0].offsetWidth,w=m.$imageEl[0].offsetHeight,b=v*s.scale,x=w*s.scale,y=Math.min($/2-b/2,0),E=Math.min(S/2-x/2,0),C=-y,T=-E,h=c*s.scale,g=u*s.scale,h<y&&(h=y),h>C&&(h=C),g<E&&(g=E),g>T&&(g=T)):(h=0,g=0),m.$imageWrapEl.transition(300).transform(`translate3d(${h}px, ${g}px,0)`),m.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${s.scale})`)}function $(){const e=t.zoom,s=t.params.zoom;m.$slideEl||(t.params.virtual&&t.params.virtual.enabled&&t.virtual?m.$slideEl=t.$wrapperEl.children(`.${t.params.slideActiveClass}`):m.$slideEl=t.slides.eq(t.activeIndex),m.$imageEl=m.$slideEl.find(`.${s.containerClass}`).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0),m.$imageWrapEl=m.$imageEl.parent(`.${s.containerClass}`)),m.$imageEl&&0!==m.$imageEl.length&&m.$imageWrapEl&&0!==m.$imageWrapEl.length&&(t.params.cssMode&&(t.wrapperEl.style.overflow="",t.wrapperEl.style.touchAction=""),e.scale=1,p=1,m.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"),m.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)"),m.$slideEl.removeClass(`${s.zoomedSlideClass}`),m.$slideEl=void 0)}function S(e){const s=t.zoom;s.scale&&1!==s.scale?$():T(e)}function M(){const e=t.support;return{passiveListener:!("touchstart"!==t.touchEvents.start||!e.passiveListener||!t.params.passiveListeners)&&{passive:!0,capture:!1},activeListenerWithCapture:!e.passiveListener||{passive:!1,capture:!0}}}function P(){return`.${t.params.slideClass}`}function k(e){const{passiveListener:s}=M(),a=P();t.$wrapperEl[e]("gesturestart",a,b,s),t.$wrapperEl[e]("gesturechange",a,x,s),t.$wrapperEl[e]("gestureend",a,y,s)}function z(){l||(l=!0,k("on"))}function L(){l&&(l=!1,k("off"))}function O(){const e=t.zoom;if(e.enabled)return;e.enabled=!0;const s=t.support,{passiveListener:a,activeListenerWithCapture:i}=M(),r=P();s.gestures?(t.$wrapperEl.on(t.touchEvents.start,z,a),t.$wrapperEl.on(t.touchEvents.end,L,a)):"touchstart"===t.touchEvents.start&&(t.$wrapperEl.on(t.touchEvents.start,r,b,a),t.$wrapperEl.on(t.touchEvents.move,r,x,i),t.$wrapperEl.on(t.touchEvents.end,r,y,a),t.touchEvents.cancel&&t.$wrapperEl.on(t.touchEvents.cancel,r,y,a)),t.$wrapperEl.on(t.touchEvents.move,`.${t.params.zoom.containerClass}`,E,i)}function I(){const e=t.zoom;if(!e.enabled)return;const s=t.support;e.enabled=!1;const{passiveListener:a,activeListenerWithCapture:i}=M(),r=P();s.gestures?(t.$wrapperEl.off(t.touchEvents.start,z,a),t.$wrapperEl.off(t.touchEvents.end,L,a)):"touchstart"===t.touchEvents.start&&(t.$wrapperEl.off(t.touchEvents.start,r,b,a),t.$wrapperEl.off(t.touchEvents.move,r,x,i),t.$wrapperEl.off(t.touchEvents.end,r,y,a),t.touchEvents.cancel&&t.$wrapperEl.off(t.touchEvents.cancel,r,y,a)),t.$wrapperEl.off(t.touchEvents.move,`.${t.params.zoom.containerClass}`,E,i)}Object.defineProperty(t.zoom,"scale",{get:()=>v,set(e){if(v!==e){const t=m.$imageEl?m.$imageEl[0]:void 0,s=m.$slideEl?m.$slideEl[0]:void 0;i("zoomChange",e,t,s)}v=e}}),a("init",(()=>{t.params.zoom.enabled&&O()})),a("destroy",(()=>{I()})),a("touchStart",((e,s)=>{t.zoom.enabled&&function(e){const s=t.device;m.$imageEl&&0!==m.$imageEl.length&&(f.isTouched||(s.android&&e.cancelable&&e.preventDefault(),f.isTouched=!0,f.touchesStart.x="touchstart"===e.type?e.targetTouches[0].pageX:e.pageX,f.touchesStart.y="touchstart"===e.type?e.targetTouches[0].pageY:e.pageY))}(s)})),a("touchEnd",((e,s)=>{t.zoom.enabled&&function(){const e=t.zoom;if(!m.$imageEl||0===m.$imageEl.length)return;if(!f.isTouched||!f.isMoved)return f.isTouched=!1,void(f.isMoved=!1);f.isTouched=!1,f.isMoved=!1;let s=300,a=300;const i=g.x*s,r=f.currentX+i,n=g.y*a,l=f.currentY+n;0!==g.x&&(s=Math.abs((r-f.currentX)/g.x)),0!==g.y&&(a=Math.abs((l-f.currentY)/g.y));const o=Math.max(s,a);f.currentX=r,f.currentY=l;const d=f.width*e.scale,c=f.height*e.scale;f.minX=Math.min(m.slideWidth/2-d/2,0),f.maxX=-f.minX,f.minY=Math.min(m.slideHeight/2-c/2,0),f.maxY=-f.minY,f.currentX=Math.max(Math.min(f.currentX,f.maxX),f.minX),f.currentY=Math.max(Math.min(f.currentY,f.maxY),f.minY),m.$imageWrapEl.transition(o).transform(`translate3d(${f.currentX}px, ${f.currentY}px,0)`)}()})),a("doubleTap",((e,s)=>{!t.animating&&t.params.zoom.enabled&&t.zoom.enabled&&t.params.zoom.toggle&&S(s)})),a("transitionEnd",(()=>{t.zoom.enabled&&t.params.zoom.enabled&&C()})),a("slideChange",(()=>{t.zoom.enabled&&t.params.zoom.enabled&&t.params.cssMode&&C()})),Object.assign(t.zoom,{enable:O,disable:I,in:T,out:$,toggle:S})},function(e){let{swiper:t,extendParams:s,on:a,emit:i}=e;s({lazy:{checkInView:!1,enabled:!1,loadPrevNext:!1,loadPrevNextAmount:1,loadOnTransitionStart:!1,scrollingElement:"",elementClass:"swiper-lazy",loadingClass:"swiper-lazy-loading",loadedClass:"swiper-lazy-loaded",preloaderClass:"swiper-lazy-preloader"}}),t.lazy={};let n=!1,l=!1;function o(e,s){void 0===s&&(s=!0);const a=t.params.lazy;if(void 0===e)return;if(0===t.slides.length)return;const r=t.virtual&&t.params.virtual.enabled?t.$wrapperEl.children(`.${t.params.slideClass}[data-swiper-slide-index="${e}"]`):t.slides.eq(e),n=r.find(`.${a.elementClass}:not(.${a.loadedClass}):not(.${a.loadingClass})`);!r.hasClass(a.elementClass)||r.hasClass(a.loadedClass)||r.hasClass(a.loadingClass)||n.push(r[0]),0!==n.length&&n.each((e=>{const n=d(e);n.addClass(a.loadingClass);const l=n.attr("data-background"),c=n.attr("data-src"),p=n.attr("data-srcset"),u=n.attr("data-sizes"),h=n.parent("picture");t.loadImage(n[0],c||l,p,u,!1,(()=>{if(null!=t&&t&&(!t||t.params)&&!t.destroyed){if(l?(n.css("background-image",`url("${l}")`),n.removeAttr("data-background")):(p&&(n.attr("srcset",p),n.removeAttr("data-srcset")),u&&(n.attr("sizes",u),n.removeAttr("data-sizes")),h.length&&h.children("source").each((e=>{const t=d(e);t.attr("data-srcset")&&(t.attr("srcset",t.attr("data-srcset")),t.removeAttr("data-srcset"))})),c&&(n.attr("src",c),n.removeAttr("data-src"))),n.addClass(a.loadedClass).removeClass(a.loadingClass),r.find(`.${a.preloaderClass}`).remove(),t.params.loop&&s){const e=r.attr("data-swiper-slide-index");if(r.hasClass(t.params.slideDuplicateClass)){o(t.$wrapperEl.children(`[data-swiper-slide-index="${e}"]:not(.${t.params.slideDuplicateClass})`).index(),!1)}else{o(t.$wrapperEl.children(`.${t.params.slideDuplicateClass}[data-swiper-slide-index="${e}"]`).index(),!1)}}i("lazyImageReady",r[0],n[0]),t.params.autoHeight&&t.updateAutoHeight()}})),i("lazyImageLoad",r[0],n[0])}))}function c(){const{$wrapperEl:e,params:s,slides:a,activeIndex:i}=t,r=t.virtual&&s.virtual.enabled,n=s.lazy;let c=s.slidesPerView;function p(t){if(r){if(e.children(`.${s.slideClass}[data-swiper-slide-index="${t}"]`).length)return!0}else if(a[t])return!0;return!1}function u(e){return r?d(e).attr("data-swiper-slide-index"):d(e).index()}if("auto"===c&&(c=0),l||(l=!0),t.params.watchSlidesProgress)e.children(`.${s.slideVisibleClass}`).each((e=>{o(r?d(e).attr("data-swiper-slide-index"):d(e).index())}));else if(c>1)for(let e=i;e<i+c;e+=1)p(e)&&o(e);else o(i);if(n.loadPrevNext)if(c>1||n.loadPrevNextAmount&&n.loadPrevNextAmount>1){const e=n.loadPrevNextAmount,t=Math.ceil(c),s=Math.min(i+t+Math.max(e,t),a.length),r=Math.max(i-Math.max(t,e),0);for(let e=i+t;e<s;e+=1)p(e)&&o(e);for(let e=r;e<i;e+=1)p(e)&&o(e)}else{const t=e.children(`.${s.slideNextClass}`);t.length>0&&o(u(t));const a=e.children(`.${s.slidePrevClass}`);a.length>0&&o(u(a))}}function p(){const e=r();if(!t||t.destroyed)return;const s=t.params.lazy.scrollingElement?d(t.params.lazy.scrollingElement):d(e),a=s[0]===e,i=a?e.innerWidth:s[0].offsetWidth,l=a?e.innerHeight:s[0].offsetHeight,o=t.$el.offset(),{rtlTranslate:u}=t;let h=!1;u&&(o.left-=t.$el[0].scrollLeft);const m=[[o.left,o.top],[o.left+t.width,o.top],[o.left,o.top+t.height],[o.left+t.width,o.top+t.height]];for(let e=0;e<m.length;e+=1){const t=m[e];if(t[0]>=0&&t[0]<=i&&t[1]>=0&&t[1]<=l){if(0===t[0]&&0===t[1])continue;h=!0}}const f=!("touchstart"!==t.touchEvents.start||!t.support.passiveListener||!t.params.passiveListeners)&&{passive:!0,capture:!1};h?(c(),s.off("scroll",p,f)):n||(n=!0,s.on("scroll",p,f))}a("beforeInit",(()=>{t.params.lazy.enabled&&t.params.preloadImages&&(t.params.preloadImages=!1)})),a("init",(()=>{t.params.lazy.enabled&&(t.params.lazy.checkInView?p():c())})),a("scroll",(()=>{t.params.freeMode&&t.params.freeMode.enabled&&!t.params.freeMode.sticky&&c()})),a("scrollbarDragMove resize _freeModeNoMomentumRelease",(()=>{t.params.lazy.enabled&&(t.params.lazy.checkInView?p():c())})),a("transitionStart",(()=>{t.params.lazy.enabled&&(t.params.lazy.loadOnTransitionStart||!t.params.lazy.loadOnTransitionStart&&!l)&&(t.params.lazy.checkInView?p():c())})),a("transitionEnd",(()=>{t.params.lazy.enabled&&!t.params.lazy.loadOnTransitionStart&&(t.params.lazy.checkInView?p():c())})),a("slideChange",(()=>{const{lazy:e,cssMode:s,watchSlidesProgress:a,touchReleaseOnEdges:i,resistanceRatio:r}=t.params;e.enabled&&(s||a&&(i||0===r))&&c()})),a("destroy",(()=>{t.$el&&t.$el.find(`.${t.params.lazy.loadingClass}`).removeClass(t.params.lazy.loadingClass)})),Object.assign(t.lazy,{load:c,loadInSlide:o})},function(e){let{swiper:t,extendParams:s,on:a}=e;function i(e,t){const s=function(){let e,t,s;return(a,i)=>{for(t=-1,e=a.length;e-t>1;)s=e+t>>1,a[s]<=i?t=s:e=s;return e}}();let a,i;return this.x=e,this.y=t,this.lastIndex=e.length-1,this.interpolate=function(e){return e?(i=s(this.x,e),a=i-1,(e-this.x[a])*(this.y[i]-this.y[a])/(this.x[i]-this.x[a])+this.y[a]):0},this}function r(){t.controller.control&&t.controller.spline&&(t.controller.spline=void 0,delete t.controller.spline)}s({controller:{control:void 0,inverse:!1,by:"slide"}}),t.controller={control:void 0},a("beforeInit",(()=>{t.controller.control=t.params.controller.control})),a("update",(()=>{r()})),a("resize",(()=>{r()})),a("observerUpdate",(()=>{r()})),a("setTranslate",((e,s,a)=>{t.controller.control&&t.controller.setTranslate(s,a)})),a("setTransition",((e,s,a)=>{t.controller.control&&t.controller.setTransition(s,a)})),Object.assign(t.controller,{setTranslate:function(e,s){const a=t.controller.control;let r,n;const l=t.constructor;function o(e){const s=t.rtlTranslate?-t.translate:t.translate;"slide"===t.params.controller.by&&(!function(e){t.controller.spline||(t.controller.spline=t.params.loop?new i(t.slidesGrid,e.slidesGrid):new i(t.snapGrid,e.snapGrid))}(e),n=-t.controller.spline.interpolate(-s)),n&&"container"!==t.params.controller.by||(r=(e.maxTranslate()-e.minTranslate())/(t.maxTranslate()-t.minTranslate()),n=(s-t.minTranslate())*r+e.minTranslate()),t.params.controller.inverse&&(n=e.maxTranslate()-n),e.updateProgress(n),e.setTranslate(n,t),e.updateActiveIndex(),e.updateSlidesClasses()}if(Array.isArray(a))for(let e=0;e<a.length;e+=1)a[e]!==s&&a[e]instanceof l&&o(a[e]);else a instanceof l&&s!==a&&o(a)},setTransition:function(e,s){const a=t.constructor,i=t.controller.control;let r;function n(s){s.setTransition(e,t),0!==e&&(s.transitionStart(),s.params.autoHeight&&p((()=>{s.updateAutoHeight()})),s.$wrapperEl.transitionEnd((()=>{i&&(s.params.loop&&"slide"===t.params.controller.by&&s.loopFix(),s.transitionEnd())})))}if(Array.isArray(i))for(r=0;r<i.length;r+=1)i[r]!==s&&i[r]instanceof a&&n(i[r]);else i instanceof a&&s!==i&&n(i)}})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({a11y:{enabled:!0,notificationClass:"swiper-notification",prevSlideMessage:"Previous slide",nextSlideMessage:"Next slide",firstSlideMessage:"This is the first slide",lastSlideMessage:"This is the last slide",paginationBulletMessage:"Go to slide {{index}}",slideLabelMessage:"{{index}} / {{slidesLength}}",containerMessage:null,containerRoleDescriptionMessage:null,itemRoleDescriptionMessage:null,slideRole:"group",id:null}});let i=null;function r(e){const t=i;0!==t.length&&(t.html(""),t.html(e))}function n(e){e.attr("tabIndex","0")}function l(e){e.attr("tabIndex","-1")}function o(e,t){e.attr("role",t)}function c(e,t){e.attr("aria-roledescription",t)}function p(e,t){e.attr("aria-label",t)}function u(e){e.attr("aria-disabled",!0)}function h(e){e.attr("aria-disabled",!1)}function m(e){if(13!==e.keyCode&&32!==e.keyCode)return;const s=t.params.a11y,a=d(e.target);t.navigation&&t.navigation.$nextEl&&a.is(t.navigation.$nextEl)&&(t.isEnd&&!t.params.loop||t.slideNext(),t.isEnd?r(s.lastSlideMessage):r(s.nextSlideMessage)),t.navigation&&t.navigation.$prevEl&&a.is(t.navigation.$prevEl)&&(t.isBeginning&&!t.params.loop||t.slidePrev(),t.isBeginning?r(s.firstSlideMessage):r(s.prevSlideMessage)),t.pagination&&a.is(U(t.params.pagination.bulletClass))&&a[0].click()}function f(){return t.pagination&&t.pagination.bullets&&t.pagination.bullets.length}function g(){return f()&&t.params.pagination.clickable}const v=(e,t,s)=>{n(e),"BUTTON"!==e[0].tagName&&(o(e,"button"),e.on("keydown",m)),p(e,s),function(e,t){e.attr("aria-controls",t)}(e,t)},w=e=>{const s=e.target.closest(`.${t.params.slideClass}`);if(!s||!t.slides.includes(s))return;const a=t.slides.indexOf(s)===t.activeIndex,i=t.params.watchSlidesProgress&&t.visibleSlides&&t.visibleSlides.includes(s);a||i||(t.isHorizontal()?t.el.scrollLeft=0:t.el.scrollTop=0,t.slideTo(t.slides.indexOf(s),0))},b=()=>{const e=t.params.a11y;e.itemRoleDescriptionMessage&&c(d(t.slides),e.itemRoleDescriptionMessage),e.slideRole&&o(d(t.slides),e.slideRole);const s=t.params.loop?t.slides.filter((e=>!e.classList.contains(t.params.slideDuplicateClass))).length:t.slides.length;e.slideLabelMessage&&t.slides.each(((a,i)=>{const r=d(a),n=t.params.loop?parseInt(r.attr("data-swiper-slide-index"),10):i;p(r,e.slideLabelMessage.replace(/\{\{index\}\}/,n+1).replace(/\{\{slidesLength\}\}/,s))}))},x=()=>{const e=t.params.a11y;t.$el.append(i);const s=t.$el;e.containerRoleDescriptionMessage&&c(s,e.containerRoleDescriptionMessage),e.containerMessage&&p(s,e.containerMessage);const a=t.$wrapperEl,r=e.id||a.attr("id")||`swiper-wrapper-${n=16,void 0===n&&(n=16),"x".repeat(n).replace(/x/g,(()=>Math.round(16*Math.random()).toString(16)))}`;var n;const l=t.params.autoplay&&t.params.autoplay.enabled?"off":"polite";var o;let d,u;o=r,a.attr("id",o),function(e,t){e.attr("aria-live",t)}(a,l),b(),t.navigation&&t.navigation.$nextEl&&(d=t.navigation.$nextEl),t.navigation&&t.navigation.$prevEl&&(u=t.navigation.$prevEl),d&&d.length&&v(d,r,e.nextSlideMessage),u&&u.length&&v(u,r,e.prevSlideMessage),g()&&t.pagination.$el.on("keydown",U(t.params.pagination.bulletClass),m),t.$el.on("focus",w,!0)};a("beforeInit",(()=>{i=d(`<span class="${t.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`)})),a("afterInit",(()=>{t.params.a11y.enabled&&x()})),a("slidesLengthChange snapGridLengthChange slidesGridLengthChange",(()=>{t.params.a11y.enabled&&b()})),a("fromEdge toEdge afterInit lock unlock",(()=>{t.params.a11y.enabled&&function(){if(t.params.loop||t.params.rewind||!t.navigation)return;const{$nextEl:e,$prevEl:s}=t.navigation;s&&s.length>0&&(t.isBeginning?(u(s),l(s)):(h(s),n(s))),e&&e.length>0&&(t.isEnd?(u(e),l(e)):(h(e),n(e)))}()})),a("paginationUpdate",(()=>{t.params.a11y.enabled&&function(){const e=t.params.a11y;f()&&t.pagination.bullets.each((s=>{const a=d(s);t.params.pagination.clickable&&(n(a),t.params.pagination.renderBullet||(o(a,"button"),p(a,e.paginationBulletMessage.replace(/\{\{index\}\}/,a.index()+1)))),a.is(`.${t.params.pagination.bulletActiveClass}`)?a.attr("aria-current","true"):a.removeAttr("aria-current")}))}()})),a("destroy",(()=>{t.params.a11y.enabled&&function(){let e,s;i&&i.length>0&&i.remove(),t.navigation&&t.navigation.$nextEl&&(e=t.navigation.$nextEl),t.navigation&&t.navigation.$prevEl&&(s=t.navigation.$prevEl),e&&e.off("keydown",m),s&&s.off("keydown",m),g()&&t.pagination.$el.off("keydown",U(t.params.pagination.bulletClass),m),t.$el.off("focus",w,!0)}()}))},function(e){let{swiper:t,extendParams:s,on:a}=e;s({history:{enabled:!1,root:"",replaceState:!1,key:"slides",keepQuery:!1}});let i=!1,n={};const l=e=>e.toString().replace(/\s+/g,"-").replace(/[^\w-]+/g,"").replace(/--+/g,"-").replace(/^-+/,"").replace(/-+$/,""),o=e=>{const t=r();let s;s=e?new URL(e):t.location;const a=s.pathname.slice(1).split("/").filter((e=>""!==e)),i=a.length;return{key:a[i-2],value:a[i-1]}},d=(e,s)=>{const a=r();if(!i||!t.params.history.enabled)return;let n;n=t.params.url?new URL(t.params.url):a.location;const o=t.slides.eq(s);let d=l(o.attr("data-history"));if(t.params.history.root.length>0){let s=t.params.history.root;"/"===s[s.length-1]&&(s=s.slice(0,s.length-1)),d=`${s}/${e}/${d}`}else n.pathname.includes(e)||(d=`${e}/${d}`);t.params.history.keepQuery&&(d+=n.search);const c=a.history.state;c&&c.value===d||(t.params.history.replaceState?a.history.replaceState({value:d},null,d):a.history.pushState({value:d},null,d))},c=(e,s,a)=>{if(s)for(let i=0,r=t.slides.length;i<r;i+=1){const r=t.slides.eq(i);if(l(r.attr("data-history"))===s&&!r.hasClass(t.params.slideDuplicateClass)){const s=r.index();t.slideTo(s,e,a)}}else t.slideTo(0,e,a)},p=()=>{n=o(t.params.url),c(t.params.speed,n.value,!1)};a("init",(()=>{t.params.history.enabled&&(()=>{const e=r();if(t.params.history){if(!e.history||!e.history.pushState)return t.params.history.enabled=!1,void(t.params.hashNavigation.enabled=!0);i=!0,n=o(t.params.url),(n.key||n.value)&&(c(0,n.value,t.params.runCallbacksOnInit),t.params.history.replaceState||e.addEventListener("popstate",p))}})()})),a("destroy",(()=>{t.params.history.enabled&&(()=>{const e=r();t.params.history.replaceState||e.removeEventListener("popstate",p)})()})),a("transitionEnd _freeModeNoMomentumRelease",(()=>{i&&d(t.params.history.key,t.activeIndex)})),a("slideChange",(()=>{i&&t.params.cssMode&&d(t.params.history.key,t.activeIndex)}))},function(e){let{swiper:t,extendParams:s,emit:i,on:n}=e,l=!1;const o=a(),c=r();s({hashNavigation:{enabled:!1,replaceState:!1,watchState:!1}});const p=()=>{i("hashChange");const e=o.location.hash.replace("#","");if(e!==t.slides.eq(t.activeIndex).attr("data-hash")){const s=t.$wrapperEl.children(`.${t.params.slideClass}[data-hash="${e}"]`).index();if(void 0===s)return;t.slideTo(s)}},u=()=>{if(l&&t.params.hashNavigation.enabled)if(t.params.hashNavigation.replaceState&&c.history&&c.history.replaceState)c.history.replaceState(null,null,`#${t.slides.eq(t.activeIndex).attr("data-hash")}`||""),i("hashSet");else{const e=t.slides.eq(t.activeIndex),s=e.attr("data-hash")||e.attr("data-history");o.location.hash=s||"",i("hashSet")}};n("init",(()=>{t.params.hashNavigation.enabled&&(()=>{if(!t.params.hashNavigation.enabled||t.params.history&&t.params.history.enabled)return;l=!0;const e=o.location.hash.replace("#","");if(e){const s=0;for(let a=0,i=t.slides.length;a<i;a+=1){const i=t.slides.eq(a);if((i.attr("data-hash")||i.attr("data-history"))===e&&!i.hasClass(t.params.slideDuplicateClass)){const e=i.index();t.slideTo(e,s,t.params.runCallbacksOnInit,!0)}}}t.params.hashNavigation.watchState&&d(c).on("hashchange",p)})()})),n("destroy",(()=>{t.params.hashNavigation.enabled&&t.params.hashNavigation.watchState&&d(c).off("hashchange",p)})),n("transitionEnd _freeModeNoMomentumRelease",(()=>{l&&u()})),n("slideChange",(()=>{l&&t.params.cssMode&&u()}))},function(e){let t,{swiper:s,extendParams:i,on:r,emit:n}=e;function l(){if(!s.size)return s.autoplay.running=!1,void(s.autoplay.paused=!1);const e=s.slides.eq(s.activeIndex);let a=s.params.autoplay.delay;e.attr("data-swiper-autoplay")&&(a=e.attr("data-swiper-autoplay")||s.params.autoplay.delay),clearTimeout(t),t=p((()=>{let e;s.params.autoplay.reverseDirection?s.params.loop?(s.loopFix(),e=s.slidePrev(s.params.speed,!0,!0),n("autoplay")):s.isBeginning?s.params.autoplay.stopOnLastSlide?d():(e=s.slideTo(s.slides.length-1,s.params.speed,!0,!0),n("autoplay")):(e=s.slidePrev(s.params.speed,!0,!0),n("autoplay")):s.params.loop?(s.loopFix(),e=s.slideNext(s.params.speed,!0,!0),n("autoplay")):s.isEnd?s.params.autoplay.stopOnLastSlide?d():(e=s.slideTo(0,s.params.speed,!0,!0),n("autoplay")):(e=s.slideNext(s.params.speed,!0,!0),n("autoplay")),(s.params.cssMode&&s.autoplay.running||!1===e)&&l()}),a)}function o(){return void 0===t&&(!s.autoplay.running&&(s.autoplay.running=!0,n("autoplayStart"),l(),!0))}function d(){return!!s.autoplay.running&&(void 0!==t&&(t&&(clearTimeout(t),t=void 0),s.autoplay.running=!1,n("autoplayStop"),!0))}function c(e){s.autoplay.running&&(s.autoplay.paused||(t&&clearTimeout(t),s.autoplay.paused=!0,0!==e&&s.params.autoplay.waitForTransition?["transitionend","webkitTransitionEnd"].forEach((e=>{s.$wrapperEl[0].addEventListener(e,h)})):(s.autoplay.paused=!1,l())))}function u(){const e=a();"hidden"===e.visibilityState&&s.autoplay.running&&c(),"visible"===e.visibilityState&&s.autoplay.paused&&(l(),s.autoplay.paused=!1)}function h(e){s&&!s.destroyed&&s.$wrapperEl&&e.target===s.$wrapperEl[0]&&(["transitionend","webkitTransitionEnd"].forEach((e=>{s.$wrapperEl[0].removeEventListener(e,h)})),s.autoplay.paused=!1,s.autoplay.running?l():d())}function m(){s.params.autoplay.disableOnInteraction?d():(n("autoplayPause"),c()),["transitionend","webkitTransitionEnd"].forEach((e=>{s.$wrapperEl[0].removeEventListener(e,h)}))}function f(){s.params.autoplay.disableOnInteraction||(s.autoplay.paused=!1,n("autoplayResume"),l())}s.autoplay={running:!1,paused:!1},i({autoplay:{enabled:!1,delay:3e3,waitForTransition:!0,disableOnInteraction:!0,stopOnLastSlide:!1,reverseDirection:!1,pauseOnMouseEnter:!1}}),r("init",(()=>{if(s.params.autoplay.enabled){o();a().addEventListener("visibilitychange",u),s.params.autoplay.pauseOnMouseEnter&&(s.$el.on("mouseenter",m),s.$el.on("mouseleave",f))}})),r("beforeTransitionStart",((e,t,a)=>{s.autoplay.running&&(a||!s.params.autoplay.disableOnInteraction?s.autoplay.pause(t):d())})),r("sliderFirstMove",(()=>{s.autoplay.running&&(s.params.autoplay.disableOnInteraction?d():c())})),r("touchEnd",(()=>{s.params.cssMode&&s.autoplay.paused&&!s.params.autoplay.disableOnInteraction&&l()})),r("destroy",(()=>{s.$el.off("mouseenter",m),s.$el.off("mouseleave",f),s.autoplay.running&&d();a().removeEventListener("visibilitychange",u)})),Object.assign(s.autoplay,{pause:c,run:l,start:o,stop:d})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({thumbs:{swiper:null,multipleActiveThumbs:!0,autoScrollOffset:0,slideThumbActiveClass:"swiper-slide-thumb-active",thumbsContainerClass:"swiper-thumbs"}});let i=!1,r=!1;function n(){const e=t.thumbs.swiper;if(!e||e.destroyed)return;const s=e.clickedIndex,a=e.clickedSlide;if(a&&d(a).hasClass(t.params.thumbs.slideThumbActiveClass))return;if(null==s)return;let i;if(i=e.params.loop?parseInt(d(e.clickedSlide).attr("data-swiper-slide-index"),10):s,t.params.loop){let e=t.activeIndex;t.slides.eq(e).hasClass(t.params.slideDuplicateClass)&&(t.loopFix(),t._clientLeft=t.$wrapperEl[0].clientLeft,e=t.activeIndex);const s=t.slides.eq(e).prevAll(`[data-swiper-slide-index="${i}"]`).eq(0).index(),a=t.slides.eq(e).nextAll(`[data-swiper-slide-index="${i}"]`).eq(0).index();i=void 0===s?a:void 0===a?s:a-e<e-s?a:s}t.slideTo(i)}function l(){const{thumbs:e}=t.params;if(i)return!1;i=!0;const s=t.constructor;if(e.swiper instanceof s)t.thumbs.swiper=e.swiper,Object.assign(t.thumbs.swiper.originalParams,{watchSlidesProgress:!0,slideToClickedSlide:!1}),Object.assign(t.thumbs.swiper.params,{watchSlidesProgress:!0,slideToClickedSlide:!1});else if(m(e.swiper)){const a=Object.assign({},e.swiper);Object.assign(a,{watchSlidesProgress:!0,slideToClickedSlide:!1}),t.thumbs.swiper=new s(a),r=!0}return t.thumbs.swiper.$el.addClass(t.params.thumbs.thumbsContainerClass),t.thumbs.swiper.on("tap",n),!0}function o(e){const s=t.thumbs.swiper;if(!s||s.destroyed)return;const a="auto"===s.params.slidesPerView?s.slidesPerViewDynamic():s.params.slidesPerView;let i=1;const r=t.params.thumbs.slideThumbActiveClass;if(t.params.slidesPerView>1&&!t.params.centeredSlides&&(i=t.params.slidesPerView),t.params.thumbs.multipleActiveThumbs||(i=1),i=Math.floor(i),s.slides.removeClass(r),s.params.loop||s.params.virtual&&s.params.virtual.enabled)for(let e=0;e<i;e+=1)s.$wrapperEl.children(`[data-swiper-slide-index="${t.realIndex+e}"]`).addClass(r);else for(let e=0;e<i;e+=1)s.slides.eq(t.realIndex+e).addClass(r);const n=t.params.thumbs.autoScrollOffset,l=n&&!s.params.loop;if(t.realIndex!==s.realIndex||l){let i,r,o=s.activeIndex;if(s.params.loop){s.slides.eq(o).hasClass(s.params.slideDuplicateClass)&&(s.loopFix(),s._clientLeft=s.$wrapperEl[0].clientLeft,o=s.activeIndex);const e=s.slides.eq(o).prevAll(`[data-swiper-slide-index="${t.realIndex}"]`).eq(0).index(),a=s.slides.eq(o).nextAll(`[data-swiper-slide-index="${t.realIndex}"]`).eq(0).index();i=void 0===e?a:void 0===a?e:a-o==o-e?s.params.slidesPerGroup>1?a:o:a-o<o-e?a:e,r=t.activeIndex>t.previousIndex?"next":"prev"}else i=t.realIndex,r=i>t.previousIndex?"next":"prev";l&&(i+="next"===r?n:-1*n),s.visibleSlidesIndexes&&s.visibleSlidesIndexes.indexOf(i)<0&&(s.params.centeredSlides?i=i>o?i-Math.floor(a/2)+1:i+Math.floor(a/2)-1:i>o&&s.params.slidesPerGroup,s.slideTo(i,e?0:void 0))}}t.thumbs={swiper:null},a("beforeInit",(()=>{const{thumbs:e}=t.params;e&&e.swiper&&(l(),o(!0))})),a("slideChange update resize observerUpdate",(()=>{o()})),a("setTransition",((e,s)=>{const a=t.thumbs.swiper;a&&!a.destroyed&&a.setTransition(s)})),a("beforeDestroy",(()=>{const e=t.thumbs.swiper;e&&!e.destroyed&&r&&e.destroy()})),Object.assign(t.thumbs,{init:l,update:o})},function(e){let{swiper:t,extendParams:s,emit:a,once:i}=e;s({freeMode:{enabled:!1,momentum:!0,momentumRatio:1,momentumBounce:!0,momentumBounceRatio:1,momentumVelocityRatio:1,sticky:!1,minimumVelocity:.02}}),Object.assign(t,{freeMode:{onTouchStart:function(){const e=t.getTranslate();t.setTranslate(e),t.setTransition(0),t.touchEventsData.velocities.length=0,t.freeMode.onTouchEnd({currentPos:t.rtl?t.translate:-t.translate})},onTouchMove:function(){const{touchEventsData:e,touches:s}=t;0===e.velocities.length&&e.velocities.push({position:s[t.isHorizontal()?"startX":"startY"],time:e.touchStartTime}),e.velocities.push({position:s[t.isHorizontal()?"currentX":"currentY"],time:u()})},onTouchEnd:function(e){let{currentPos:s}=e;const{params:r,$wrapperEl:n,rtlTranslate:l,snapGrid:o,touchEventsData:d}=t,c=u()-d.touchStartTime;if(s<-t.minTranslate())t.slideTo(t.activeIndex);else if(s>-t.maxTranslate())t.slides.length<o.length?t.slideTo(o.length-1):t.slideTo(t.slides.length-1);else{if(r.freeMode.momentum){if(d.velocities.length>1){const e=d.velocities.pop(),s=d.velocities.pop(),a=e.position-s.position,i=e.time-s.time;t.velocity=a/i,t.velocity/=2,Math.abs(t.velocity)<r.freeMode.minimumVelocity&&(t.velocity=0),(i>150||u()-e.time>300)&&(t.velocity=0)}else t.velocity=0;t.velocity*=r.freeMode.momentumVelocityRatio,d.velocities.length=0;let e=1e3*r.freeMode.momentumRatio;const s=t.velocity*e;let c=t.translate+s;l&&(c=-c);let p,h=!1;const m=20*Math.abs(t.velocity)*r.freeMode.momentumBounceRatio;let f;if(c<t.maxTranslate())r.freeMode.momentumBounce?(c+t.maxTranslate()<-m&&(c=t.maxTranslate()-m),p=t.maxTranslate(),h=!0,d.allowMomentumBounce=!0):c=t.maxTranslate(),r.loop&&r.centeredSlides&&(f=!0);else if(c>t.minTranslate())r.freeMode.momentumBounce?(c-t.minTranslate()>m&&(c=t.minTranslate()+m),p=t.minTranslate(),h=!0,d.allowMomentumBounce=!0):c=t.minTranslate(),r.loop&&r.centeredSlides&&(f=!0);else if(r.freeMode.sticky){let e;for(let t=0;t<o.length;t+=1)if(o[t]>-c){e=t;break}c=Math.abs(o[e]-c)<Math.abs(o[e-1]-c)||"next"===t.swipeDirection?o[e]:o[e-1],c=-c}if(f&&i("transitionEnd",(()=>{t.loopFix()})),0!==t.velocity){if(e=l?Math.abs((-c-t.translate)/t.velocity):Math.abs((c-t.translate)/t.velocity),r.freeMode.sticky){const s=Math.abs((l?-c:c)-t.translate),a=t.slidesSizesGrid[t.activeIndex];e=s<a?r.speed:s<2*a?1.5*r.speed:2.5*r.speed}}else if(r.freeMode.sticky)return void t.slideToClosest();r.freeMode.momentumBounce&&h?(t.updateProgress(p),t.setTransition(e),t.setTranslate(c),t.transitionStart(!0,t.swipeDirection),t.animating=!0,n.transitionEnd((()=>{t&&!t.destroyed&&d.allowMomentumBounce&&(a("momentumBounce"),t.setTransition(r.speed),setTimeout((()=>{t.setTranslate(p),n.transitionEnd((()=>{t&&!t.destroyed&&t.transitionEnd()}))}),0))}))):t.velocity?(a("_freeModeNoMomentumRelease"),t.updateProgress(c),t.setTransition(e),t.setTranslate(c),t.transitionStart(!0,t.swipeDirection),t.animating||(t.animating=!0,n.transitionEnd((()=>{t&&!t.destroyed&&t.transitionEnd()})))):t.updateProgress(c),t.updateActiveIndex(),t.updateSlidesClasses()}else{if(r.freeMode.sticky)return void t.slideToClosest();r.freeMode&&a("_freeModeNoMomentumRelease")}(!r.freeMode.momentum||c>=r.longSwipesMs)&&(t.updateProgress(),t.updateActiveIndex(),t.updateSlidesClasses())}}}})},function(e){let t,s,a,{swiper:i,extendParams:r}=e;r({grid:{rows:1,fill:"column"}}),i.grid={initSlides:e=>{const{slidesPerView:r}=i.params,{rows:n,fill:l}=i.params.grid;s=t/n,a=Math.floor(e/n),t=Math.floor(e/n)===e/n?e:Math.ceil(e/n)*n,"auto"!==r&&"row"===l&&(t=Math.max(t,r*n))},updateSlide:(e,r,n,l)=>{const{slidesPerGroup:o,spaceBetween:d}=i.params,{rows:c,fill:p}=i.params.grid;let u,h,m;if("row"===p&&o>1){const s=Math.floor(e/(o*c)),a=e-c*o*s,i=0===s?o:Math.min(Math.ceil((n-s*c*o)/c),o);m=Math.floor(a/i),h=a-m*i+s*o,u=h+m*t/c,r.css({"-webkit-order":u,order:u})}else"column"===p?(h=Math.floor(e/c),m=e-h*c,(h>a||h===a&&m===c-1)&&(m+=1,m>=c&&(m=0,h+=1))):(m=Math.floor(e/s),h=e-m*s);r.css(l("margin-top"),0!==m?d&&`${d}px`:"")},updateWrapperSize:(e,s,a)=>{const{spaceBetween:r,centeredSlides:n,roundLengths:l}=i.params,{rows:o}=i.params.grid;if(i.virtualSize=(e+r)*t,i.virtualSize=Math.ceil(i.virtualSize/o)-r,i.$wrapperEl.css({[a("width")]:`${i.virtualSize+r}px`}),n){s.splice(0,s.length);const e=[];for(let t=0;t<s.length;t+=1){let a=s[t];l&&(a=Math.floor(a)),s[t]<i.virtualSize+s[0]&&e.push(a)}s.push(...e)}}}},function(e){let{swiper:t}=e;Object.assign(t,{appendSlide:K.bind(t),prependSlide:Z.bind(t),addSlide:Q.bind(t),removeSlide:J.bind(t),removeAllSlides:ee.bind(t)})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({fadeEffect:{crossFade:!1,transformEl:null}}),te({effect:"fade",swiper:t,on:a,setTranslate:()=>{const{slides:e}=t,s=t.params.fadeEffect;for(let a=0;a<e.length;a+=1){const e=t.slides.eq(a);let i=-e[0].swiperSlideOffset;t.params.virtualTranslate||(i-=t.translate);let r=0;t.isHorizontal()||(r=i,i=0);const n=t.params.fadeEffect.crossFade?Math.max(1-Math.abs(e[0].progress),0):1+Math.min(Math.max(e[0].progress,-1),0);se(s,e).css({opacity:n}).transform(`translate3d(${i}px, ${r}px, 0px)`)}},setTransition:e=>{const{transformEl:s}=t.params.fadeEffect;(s?t.slides.find(s):t.slides).transition(e),ae({swiper:t,duration:e,transformEl:s,allSlides:!0})},overwriteParams:()=>({slidesPerView:1,slidesPerGroup:1,watchSlidesProgress:!0,spaceBetween:0,virtualTranslate:!t.params.cssMode})})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({cubeEffect:{slideShadows:!0,shadow:!0,shadowOffset:20,shadowScale:.94}});const i=(e,t,s)=>{let a=s?e.find(".swiper-slide-shadow-left"):e.find(".swiper-slide-shadow-top"),i=s?e.find(".swiper-slide-shadow-right"):e.find(".swiper-slide-shadow-bottom");0===a.length&&(a=d(`<div class="swiper-slide-shadow-${s?"left":"top"}"></div>`),e.append(a)),0===i.length&&(i=d(`<div class="swiper-slide-shadow-${s?"right":"bottom"}"></div>`),e.append(i)),a.length&&(a[0].style.opacity=Math.max(-t,0)),i.length&&(i[0].style.opacity=Math.max(t,0))};te({effect:"cube",swiper:t,on:a,setTranslate:()=>{const{$el:e,$wrapperEl:s,slides:a,width:r,height:n,rtlTranslate:l,size:o,browser:c}=t,p=t.params.cubeEffect,u=t.isHorizontal(),h=t.virtual&&t.params.virtual.enabled;let m,f=0;p.shadow&&(u?(m=s.find(".swiper-cube-shadow"),0===m.length&&(m=d('<div class="swiper-cube-shadow"></div>'),s.append(m)),m.css({height:`${r}px`})):(m=e.find(".swiper-cube-shadow"),0===m.length&&(m=d('<div class="swiper-cube-shadow"></div>'),e.append(m))));for(let e=0;e<a.length;e+=1){const t=a.eq(e);let s=e;h&&(s=parseInt(t.attr("data-swiper-slide-index"),10));let r=90*s,n=Math.floor(r/360);l&&(r=-r,n=Math.floor(-r/360));const d=Math.max(Math.min(t[0].progress,1),-1);let c=0,m=0,g=0;s%4==0?(c=4*-n*o,g=0):(s-1)%4==0?(c=0,g=4*-n*o):(s-2)%4==0?(c=o+4*n*o,g=o):(s-3)%4==0&&(c=-o,g=3*o+4*o*n),l&&(c=-c),u||(m=c,c=0);const v=`rotateX(${u?0:-r}deg) rotateY(${u?r:0}deg) translate3d(${c}px, ${m}px, ${g}px)`;d<=1&&d>-1&&(f=90*s+90*d,l&&(f=90*-s-90*d)),t.transform(v),p.slideShadows&&i(t,d,u)}if(s.css({"-webkit-transform-origin":`50% 50% -${o/2}px`,"transform-origin":`50% 50% -${o/2}px`}),p.shadow)if(u)m.transform(`translate3d(0px, ${r/2+p.shadowOffset}px, ${-r/2}px) rotateX(90deg) rotateZ(0deg) scale(${p.shadowScale})`);else{const e=Math.abs(f)-90*Math.floor(Math.abs(f)/90),t=1.5-(Math.sin(2*e*Math.PI/360)/2+Math.cos(2*e*Math.PI/360)/2),s=p.shadowScale,a=p.shadowScale/t,i=p.shadowOffset;m.transform(`scale3d(${s}, 1, ${a}) translate3d(0px, ${n/2+i}px, ${-n/2/a}px) rotateX(-90deg)`)}const g=c.isSafari||c.isWebView?-o/2:0;s.transform(`translate3d(0px,0,${g}px) rotateX(${t.isHorizontal()?0:f}deg) rotateY(${t.isHorizontal()?-f:0}deg)`),s[0].style.setProperty("--swiper-cube-translate-z",`${g}px`)},setTransition:e=>{const{$el:s,slides:a}=t;a.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e),t.params.cubeEffect.shadow&&!t.isHorizontal()&&s.find(".swiper-cube-shadow").transition(e)},recreateShadows:()=>{const e=t.isHorizontal();t.slides.each((t=>{const s=Math.max(Math.min(t.progress,1),-1);i(d(t),s,e)}))},getEffectParams:()=>t.params.cubeEffect,perspective:()=>!0,overwriteParams:()=>({slidesPerView:1,slidesPerGroup:1,watchSlidesProgress:!0,resistanceRatio:0,spaceBetween:0,centeredSlides:!1,virtualTranslate:!0})})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({flipEffect:{slideShadows:!0,limitRotation:!0,transformEl:null}});const i=(e,s,a)=>{let i=t.isHorizontal()?e.find(".swiper-slide-shadow-left"):e.find(".swiper-slide-shadow-top"),r=t.isHorizontal()?e.find(".swiper-slide-shadow-right"):e.find(".swiper-slide-shadow-bottom");0===i.length&&(i=ie(a,e,t.isHorizontal()?"left":"top")),0===r.length&&(r=ie(a,e,t.isHorizontal()?"right":"bottom")),i.length&&(i[0].style.opacity=Math.max(-s,0)),r.length&&(r[0].style.opacity=Math.max(s,0))};te({effect:"flip",swiper:t,on:a,setTranslate:()=>{const{slides:e,rtlTranslate:s}=t,a=t.params.flipEffect;for(let r=0;r<e.length;r+=1){const n=e.eq(r);let l=n[0].progress;t.params.flipEffect.limitRotation&&(l=Math.max(Math.min(n[0].progress,1),-1));const o=n[0].swiperSlideOffset;let d=-180*l,c=0,p=t.params.cssMode?-o-t.translate:-o,u=0;t.isHorizontal()?s&&(d=-d):(u=p,p=0,c=-d,d=0),n[0].style.zIndex=-Math.abs(Math.round(l))+e.length,a.slideShadows&&i(n,l,a);const h=`translate3d(${p}px, ${u}px, 0px) rotateX(${c}deg) rotateY(${d}deg)`;se(a,n).transform(h)}},setTransition:e=>{const{transformEl:s}=t.params.flipEffect;(s?t.slides.find(s):t.slides).transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e),ae({swiper:t,duration:e,transformEl:s})},recreateShadows:()=>{const e=t.params.flipEffect;t.slides.each((s=>{const a=d(s);let r=a[0].progress;t.params.flipEffect.limitRotation&&(r=Math.max(Math.min(s.progress,1),-1)),i(a,r,e)}))},getEffectParams:()=>t.params.flipEffect,perspective:()=>!0,overwriteParams:()=>({slidesPerView:1,slidesPerGroup:1,watchSlidesProgress:!0,spaceBetween:0,virtualTranslate:!t.params.cssMode})})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({coverflowEffect:{rotate:50,stretch:0,depth:100,scale:1,modifier:1,slideShadows:!0,transformEl:null}}),te({effect:"coverflow",swiper:t,on:a,setTranslate:()=>{const{width:e,height:s,slides:a,slidesSizesGrid:i}=t,r=t.params.coverflowEffect,n=t.isHorizontal(),l=t.translate,o=n?e/2-l:s/2-l,d=n?r.rotate:-r.rotate,c=r.depth;for(let e=0,t=a.length;e<t;e+=1){const t=a.eq(e),s=i[e],l=(o-t[0].swiperSlideOffset-s/2)/s,p="function"==typeof r.modifier?r.modifier(l):l*r.modifier;let u=n?d*p:0,h=n?0:d*p,m=-c*Math.abs(p),f=r.stretch;"string"==typeof f&&-1!==f.indexOf("%")&&(f=parseFloat(r.stretch)/100*s);let g=n?0:f*p,v=n?f*p:0,w=1-(1-r.scale)*Math.abs(p);Math.abs(v)<.001&&(v=0),Math.abs(g)<.001&&(g=0),Math.abs(m)<.001&&(m=0),Math.abs(u)<.001&&(u=0),Math.abs(h)<.001&&(h=0),Math.abs(w)<.001&&(w=0);const b=`translate3d(${v}px,${g}px,${m}px)  rotateX(${h}deg) rotateY(${u}deg) scale(${w})`;if(se(r,t).transform(b),t[0].style.zIndex=1-Math.abs(Math.round(p)),r.slideShadows){let e=n?t.find(".swiper-slide-shadow-left"):t.find(".swiper-slide-shadow-top"),s=n?t.find(".swiper-slide-shadow-right"):t.find(".swiper-slide-shadow-bottom");0===e.length&&(e=ie(r,t,n?"left":"top")),0===s.length&&(s=ie(r,t,n?"right":"bottom")),e.length&&(e[0].style.opacity=p>0?p:0),s.length&&(s[0].style.opacity=-p>0?-p:0)}}},setTransition:e=>{const{transformEl:s}=t.params.coverflowEffect;(s?t.slides.find(s):t.slides).transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e)},perspective:()=>!0,overwriteParams:()=>({watchSlidesProgress:!0})})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({creativeEffect:{transformEl:null,limitProgress:1,shadowPerProgress:!1,progressMultiplier:1,perspective:!0,prev:{translate:[0,0,0],rotate:[0,0,0],opacity:1,scale:1},next:{translate:[0,0,0],rotate:[0,0,0],opacity:1,scale:1}}});const i=e=>"string"==typeof e?e:`${e}px`;te({effect:"creative",swiper:t,on:a,setTranslate:()=>{const{slides:e,$wrapperEl:s,slidesSizesGrid:a}=t,r=t.params.creativeEffect,{progressMultiplier:n}=r,l=t.params.centeredSlides;if(l){const e=a[0]/2-t.params.slidesOffsetBefore||0;s.transform(`translateX(calc(50% - ${e}px))`)}for(let s=0;s<e.length;s+=1){const a=e.eq(s),o=a[0].progress,d=Math.min(Math.max(a[0].progress,-r.limitProgress),r.limitProgress);let c=d;l||(c=Math.min(Math.max(a[0].originalProgress,-r.limitProgress),r.limitProgress));const p=a[0].swiperSlideOffset,u=[t.params.cssMode?-p-t.translate:-p,0,0],h=[0,0,0];let m=!1;t.isHorizontal()||(u[1]=u[0],u[0]=0);let f={translate:[0,0,0],rotate:[0,0,0],scale:1,opacity:1};d<0?(f=r.next,m=!0):d>0&&(f=r.prev,m=!0),u.forEach(((e,t)=>{u[t]=`calc(${e}px + (${i(f.translate[t])} * ${Math.abs(d*n)}))`})),h.forEach(((e,t)=>{h[t]=f.rotate[t]*Math.abs(d*n)})),a[0].style.zIndex=-Math.abs(Math.round(o))+e.length;const g=u.join(", "),v=`rotateX(${h[0]}deg) rotateY(${h[1]}deg) rotateZ(${h[2]}deg)`,w=c<0?`scale(${1+(1-f.scale)*c*n})`:`scale(${1-(1-f.scale)*c*n})`,b=c<0?1+(1-f.opacity)*c*n:1-(1-f.opacity)*c*n,x=`translate3d(${g}) ${v} ${w}`;if(m&&f.shadow||!m){let e=a.children(".swiper-slide-shadow");if(0===e.length&&f.shadow&&(e=ie(r,a)),e.length){const t=r.shadowPerProgress?d*(1/r.limitProgress):d;e[0].style.opacity=Math.min(Math.max(Math.abs(t),0),1)}}const y=se(r,a);y.transform(x).css({opacity:b}),f.origin&&y.css("transform-origin",f.origin)}},setTransition:e=>{const{transformEl:s}=t.params.creativeEffect;(s?t.slides.find(s):t.slides).transition(e).find(".swiper-slide-shadow").transition(e),ae({swiper:t,duration:e,transformEl:s,allSlides:!0})},perspective:()=>t.params.creativeEffect.perspective,overwriteParams:()=>({watchSlidesProgress:!0,virtualTranslate:!t.params.cssMode})})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({cardsEffect:{slideShadows:!0,transformEl:null,rotate:!0}}),te({effect:"cards",swiper:t,on:a,setTranslate:()=>{const{slides:e,activeIndex:s}=t,a=t.params.cardsEffect,{startTranslate:i,isTouched:r}=t.touchEventsData,n=t.translate;for(let l=0;l<e.length;l+=1){const o=e.eq(l),d=o[0].progress,c=Math.min(Math.max(d,-4),4);let p=o[0].swiperSlideOffset;t.params.centeredSlides&&!t.params.cssMode&&t.$wrapperEl.transform(`translateX(${t.minTranslate()}px)`),t.params.centeredSlides&&t.params.cssMode&&(p-=e[0].swiperSlideOffset);let u=t.params.cssMode?-p-t.translate:-p,h=0;const m=-100*Math.abs(c);let f=1,g=-2*c,v=8-.75*Math.abs(c);const w=t.virtual&&t.params.virtual.enabled?t.virtual.from+l:l,b=(w===s||w===s-1)&&c>0&&c<1&&(r||t.params.cssMode)&&n<i,x=(w===s||w===s+1)&&c<0&&c>-1&&(r||t.params.cssMode)&&n>i;if(b||x){const e=(1-Math.abs((Math.abs(c)-.5)/.5))**.5;g+=-28*c*e,f+=-.5*e,v+=96*e,h=-25*e*Math.abs(c)+"%"}if(u=c<0?`calc(${u}px + (${v*Math.abs(c)}%))`:c>0?`calc(${u}px + (-${v*Math.abs(c)}%))`:`${u}px`,!t.isHorizontal()){const e=h;h=u,u=e}const y=c<0?""+(1+(1-f)*c):""+(1-(1-f)*c),E=`\n        translate3d(${u}, ${h}, ${m}px)\n        rotateZ(${a.rotate?g:0}deg)\n        scale(${y})\n      `;if(a.slideShadows){let e=o.find(".swiper-slide-shadow");0===e.length&&(e=ie(a,o)),e.length&&(e[0].style.opacity=Math.min(Math.max((Math.abs(c)-.5)/.5,0),1))}o[0].style.zIndex=-Math.abs(Math.round(d))+e.length;se(a,o).transform(E)}},setTransition:e=>{const{transformEl:s}=t.params.cardsEffect;(s?t.slides.find(s):t.slides).transition(e).find(".swiper-slide-shadow").transition(e),ae({swiper:t,duration:e,transformEl:s})},perspective:()=>!0,overwriteParams:()=>({watchSlidesProgress:!0,virtualTranslate:!t.params.cssMode})})}];return V.use(re),V}));
 //# sourceMappingURL=swiper-bundle.min.js.map
 
 //------------------------------------------
 ///
 //	jquery.vnm.percentWithinViewport
 //	
 //	Description:
 //	A handy, tiny jQuery plugin to determine how far inside the viewport your elements are (vertical only, at the moment)
 //
 //	Example usages:
 //	$('.element').percentWithinViewport();								//	All elements with .element class given `data-viewport-percent` attribute
 //	var withinViewportArray = $('.element').percentWithinViewport();	//	As above, and returns array of elements that are within the viewport
 //	
 //	Version: 0.1.20180317
 //	
 //	Copyright (c) 2018 Lawrie Malen / Very New Media
 //	Licensed under MIT license.
 //	
 //	Project Home Page:
 //	http://indextwo.github.io/jquery-percentwithinviewport/
 //	
 //	GitHub repository:
 //	https://github.com/indextwo/jquery-percentwithinviewport/
 //	
 //	Developed for & by Lawrie Malen @ Very New Media
 //	http://www.verynewmedia.com
 //	
 ///
 
 (function ($) {
     $.fn.percentWithinViewport = function(options) {
         
         var settings = $.extend({
             offsetTop: 0,
             offsetTopElement: false,
             offsetBottom: 0,
             offsetBottomElement: false,
         }, options);
         
         var offsetTop = settings.offsetTop + ((settings.offsetTopElement !== false && settings.offsetTopElement.length > 0) ? settings.offsetTopElement.outerHeight() : 0);
         var offsetBottom = settings.offsetBottom + ((settings.offsetBottomElement !== false && settings.offsetBottomElement > 0) ? settings.offsetBottomElement.outerHeight() : 0);
         
         var viewportTop = $(window).scrollTop() + offsetTop;
         var viewportHeight = ($(window).height() - offsetTop) - offsetBottom;
         var viewportBottom = (viewportTop + viewportHeight);
         
         var visibleArray = [];
         
         this.each(function() {
             var elementTop = $(this).offset().top;
             var elementHeight = $(this).outerHeight();
             var elementBottom = elementTop + elementHeight;
             
             var totalHeight = Math.max(elementBottom, viewportBottom) - Math.min(elementTop, viewportTop);
             var heightDiff = totalHeight - viewportHeight;
             var elementInside = elementHeight - heightDiff;
             
             var percent = parseInt(elementInside <= 0 ? 0 : elementInside / elementHeight * 100);
             
             $(this).attr('data-percent-viewport', percent);
             
             if (percent > 0) {
                 visibleArray.push($(this));
             }
         });
         
         return visibleArray;
     };
 }(jQuery));
 
 //------------------------------------------
 /*!
  * imagesLoaded PACKAGED v5.0.0
  * JavaScript is all like "You images are done yet or what?"
  * MIT License
  */
 !function(t,e){"object"==typeof module&&module.exports?module.exports=e():t.EvEmitter=e()}("undefined"!=typeof window?window:this,(function(){function t(){}let e=t.prototype;return e.on=function(t,e){if(!t||!e)return this;let i=this._events=this._events||{},s=i[t]=i[t]||[];return s.includes(e)||s.push(e),this},e.once=function(t,e){if(!t||!e)return this;this.on(t,e);let i=this._onceEvents=this._onceEvents||{};return(i[t]=i[t]||{})[e]=!0,this},e.off=function(t,e){let i=this._events&&this._events[t];if(!i||!i.length)return this;let s=i.indexOf(e);return-1!=s&&i.splice(s,1),this},e.emitEvent=function(t,e){let i=this._events&&this._events[t];if(!i||!i.length)return this;i=i.slice(0),e=e||[];let s=this._onceEvents&&this._onceEvents[t];for(let n of i){s&&s[n]&&(this.off(t,n),delete s[n]),n.apply(this,e)}return this},e.allOff=function(){return delete this._events,delete this._onceEvents,this},t})),
 /*!
  * imagesLoaded v5.0.0
  * JavaScript is all like "You images are done yet or what?"
  * MIT License
  */
 function(t,e){"object"==typeof module&&module.exports?module.exports=e(t,require("ev-emitter")):t.imagesLoaded=e(t,t.EvEmitter)}("undefined"!=typeof window?window:this,(function(t,e){let i=t.jQuery,s=t.console;function n(t,e,o){if(!(this instanceof n))return new n(t,e,o);let r=t;var h;("string"==typeof t&&(r=document.querySelectorAll(t)),r)?(this.elements=(h=r,Array.isArray(h)?h:"object"==typeof h&&"number"==typeof h.length?[...h]:[h]),this.options={},"function"==typeof e?o=e:Object.assign(this.options,e),o&&this.on("always",o),this.getImages(),i&&(this.jqDeferred=new i.Deferred),setTimeout(this.check.bind(this))):s.error(`Bad element for imagesLoaded ${r||t}`)}n.prototype=Object.create(e.prototype),n.prototype.getImages=function(){this.images=[],this.elements.forEach(this.addElementImages,this)};const o=[1,9,11];n.prototype.addElementImages=function(t){"IMG"===t.nodeName&&this.addImage(t),!0===this.options.background&&this.addElementBackgroundImages(t);let{nodeType:e}=t;if(!e||!o.includes(e))return;let i=t.querySelectorAll("img");for(let t of i)this.addImage(t);if("string"==typeof this.options.background){let e=t.querySelectorAll(this.options.background);for(let t of e)this.addElementBackgroundImages(t)}};const r=/url\((['"])?(.*?)\1\)/gi;function h(t){this.img=t}function d(t,e){this.url=t,this.element=e,this.img=new Image}return n.prototype.addElementBackgroundImages=function(t){let e=getComputedStyle(t);if(!e)return;let i=r.exec(e.backgroundImage);for(;null!==i;){let s=i&&i[2];s&&this.addBackground(s,t),i=r.exec(e.backgroundImage)}},n.prototype.addImage=function(t){let e=new h(t);this.images.push(e)},n.prototype.addBackground=function(t,e){let i=new d(t,e);this.images.push(i)},n.prototype.check=function(){if(this.progressedCount=0,this.hasAnyBroken=!1,!this.images.length)return void this.complete();let t=(t,e,i)=>{setTimeout((()=>{this.progress(t,e,i)}))};this.images.forEach((function(e){e.once("progress",t),e.check()}))},n.prototype.progress=function(t,e,i){this.progressedCount++,this.hasAnyBroken=this.hasAnyBroken||!t.isLoaded,this.emitEvent("progress",[this,t,e]),this.jqDeferred&&this.jqDeferred.notify&&this.jqDeferred.notify(this,t),this.progressedCount===this.images.length&&this.complete(),this.options.debug&&s&&s.log(`progress: ${i}`,t,e)},n.prototype.complete=function(){let t=this.hasAnyBroken?"fail":"done";if(this.isComplete=!0,this.emitEvent(t,[this]),this.emitEvent("always",[this]),this.jqDeferred){let t=this.hasAnyBroken?"reject":"resolve";this.jqDeferred[t](this)}},h.prototype=Object.create(e.prototype),h.prototype.check=function(){this.getIsImageComplete()?this.confirm(0!==this.img.naturalWidth,"naturalWidth"):(this.proxyImage=new Image,this.img.crossOrigin&&(this.proxyImage.crossOrigin=this.img.crossOrigin),this.proxyImage.addEventListener("load",this),this.proxyImage.addEventListener("error",this),this.img.addEventListener("load",this),this.img.addEventListener("error",this),this.proxyImage.src=this.img.currentSrc||this.img.src)},h.prototype.getIsImageComplete=function(){return this.img.complete&&this.img.naturalWidth},h.prototype.confirm=function(t,e){this.isLoaded=t;let{parentNode:i}=this.img,s="PICTURE"===i.nodeName?i:this.img;this.emitEvent("progress",[this,s,e])},h.prototype.handleEvent=function(t){let e="on"+t.type;this[e]&&this[e](t)},h.prototype.onload=function(){this.confirm(!0,"onload"),this.unbindEvents()},h.prototype.onerror=function(){this.confirm(!1,"onerror"),this.unbindEvents()},h.prototype.unbindEvents=function(){this.proxyImage.removeEventListener("load",this),this.proxyImage.removeEventListener("error",this),this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},d.prototype=Object.create(h.prototype),d.prototype.check=function(){this.img.addEventListener("load",this),this.img.addEventListener("error",this),this.img.src=this.url,this.getIsImageComplete()&&(this.confirm(0!==this.img.naturalWidth,"naturalWidth"),this.unbindEvents())},d.prototype.unbindEvents=function(){this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},d.prototype.confirm=function(t,e){this.isLoaded=t,this.emitEvent("progress",[this,this.element,e])},n.makeJQueryPlugin=function(e){(e=e||t.jQuery)&&(i=e,i.fn.imagesLoaded=function(t,e){return new n(this,t,e).jqDeferred.promise(i(this))})},n.makeJQueryPlugin(),n}));
 
 //------------------------------------------
 /*!
  * jQuery Mousewheel 3.1.13
  * Copyright OpenJS Foundation and other contributors
  */
 
 ( function( factory ) {
     if ( typeof define === "function" && define.amd ) {
 
         // AMD. Register as an anonymous module.
         define( [ "jquery" ], factory );
     } else if ( typeof exports === "object" ) {
 
         // Node/CommonJS style for Browserify
         module.exports = factory;
     } else {
 
         // Browser globals
         factory( jQuery );
     }
 } )( function( $ ) {
 
     var toFix  = [ "wheel", "mousewheel", "DOMMouseScroll", "MozMousePixelScroll" ],
         toBind = ( "onwheel" in window.document || window.document.documentMode >= 9 ) ?
                     [ "wheel" ] : [ "mousewheel", "DomMouseScroll", "MozMousePixelScroll" ],
         slice  = Array.prototype.slice,
         nullLowestDeltaTimeout, lowestDelta;
 
     if ( $.event.fixHooks ) {
         for ( var i = toFix.length; i; ) {
             $.event.fixHooks[ toFix[ --i ] ] = $.event.mouseHooks;
         }
     }
 
     var special = $.event.special.mousewheel = {
         version: "3.1.12",
 
         setup: function() {
             if ( this.addEventListener ) {
                 for ( var i = toBind.length; i; ) {
                     this.addEventListener( toBind[ --i ], handler, false );
                 }
             } else {
                 this.onmousewheel = handler;
             }
 
             // Store the line height and page height for this particular element
             $.data( this, "mousewheel-line-height", special.getLineHeight( this ) );
             $.data( this, "mousewheel-page-height", special.getPageHeight( this ) );
         },
 
         teardown: function() {
             if ( this.removeEventListener ) {
                 for ( var i = toBind.length; i; ) {
                     this.removeEventListener( toBind[ --i ], handler, false );
                 }
             } else {
                 this.onmousewheel = null;
             }
 
             // Clean up the data we added to the element
             $.removeData( this, "mousewheel-line-height" );
             $.removeData( this, "mousewheel-page-height" );
         },
 
         getLineHeight: function( elem ) {
             var $elem = $( elem ),
                 $parent = $elem[ "offsetParent" in $.fn ? "offsetParent" : "parent" ]();
             if ( !$parent.length ) {
                 $parent = $( "body" );
             }
             return parseInt( $parent.css( "fontSize" ), 10 ) ||
                 parseInt( $elem.css( "fontSize" ), 10 ) || 16;
         },
 
         getPageHeight: function( elem ) {
             return $( elem ).height();
         },
 
         settings: {
             adjustOldDeltas: true, // see shouldAdjustOldDeltas() below
             normalizeOffset: true  // calls getBoundingClientRect for each event
         }
     };
 
     $.fn.extend( {
         mousewheel: function( fn ) {
             return fn ? this.on( "mousewheel", fn ) : this.trigger( "mousewheel" );
         },
 
         unmousewheel: function( fn ) {
             return this.off( "mousewheel", fn );
         }
     } );
 
 
     function handler( event ) {
         var orgEvent   = event || window.event,
             args       = slice.call( arguments, 1 ),
             delta      = 0,
             deltaX     = 0,
             deltaY     = 0,
             absDelta   = 0;
         event = $.event.fix( orgEvent );
         event.type = "mousewheel";
 
         // Old school scrollwheel delta
         if ( "detail" in orgEvent ) {
             deltaY = orgEvent.detail * -1;
         }
         if ( "wheelDelta" in orgEvent ) {
             deltaY = orgEvent.wheelDelta;
         }
         if ( "wheelDeltaY" in orgEvent ) {
             deltaY = orgEvent.wheelDeltaY;
         }
         if ( "wheelDeltaX" in orgEvent ) {
             deltaX = orgEvent.wheelDeltaX * -1;
         }
 
         // Firefox < 17 horizontal scrolling related to DOMMouseScroll event
         if ( "axis" in orgEvent && orgEvent.axis === orgEvent.HORIZONTAL_AXIS ) {
             deltaX = deltaY * -1;
             deltaY = 0;
         }
 
         // Set delta to be deltaY or deltaX if deltaY is 0 for backwards compatabilitiy
         delta = deltaY === 0 ? deltaX : deltaY;
 
         // New school wheel delta (wheel event)
         if ( "deltaY" in orgEvent ) {
             deltaY = orgEvent.deltaY * -1;
             delta  = deltaY;
         }
         if ( "deltaX" in orgEvent ) {
             deltaX = orgEvent.deltaX;
             if ( deltaY === 0 ) {
                 delta  = deltaX * -1;
             }
         }
 
         // No change actually happened, no reason to go any further
         if ( deltaY === 0 && deltaX === 0 ) {
             return;
         }
 
         // Need to convert lines and pages to pixels if we aren't already in pixels
         // There are three delta modes:
         //   * deltaMode 0 is by pixels, nothing to do
         //   * deltaMode 1 is by lines
         //   * deltaMode 2 is by pages
         if ( orgEvent.deltaMode === 1 ) {
             var lineHeight = $.data( this, "mousewheel-line-height" );
             delta  *= lineHeight;
             deltaY *= lineHeight;
             deltaX *= lineHeight;
         } else if ( orgEvent.deltaMode === 2 ) {
             var pageHeight = $.data( this, "mousewheel-page-height" );
             delta  *= pageHeight;
             deltaY *= pageHeight;
             deltaX *= pageHeight;
         }
 
         // Store lowest absolute delta to normalize the delta values
         absDelta = Math.max( Math.abs( deltaY ), Math.abs( deltaX ) );
 
         if ( !lowestDelta || absDelta < lowestDelta ) {
             lowestDelta = absDelta;
 
             // Adjust older deltas if necessary
             if ( shouldAdjustOldDeltas( orgEvent, absDelta ) ) {
                 lowestDelta /= 40;
             }
         }
 
         // Adjust older deltas if necessary
         if ( shouldAdjustOldDeltas( orgEvent, absDelta ) ) {
 
             // Divide all the things by 40!
             delta  /= 40;
             deltaX /= 40;
             deltaY /= 40;
         }
 
         // Get a whole, normalized value for the deltas
         delta  = Math[ delta  >= 1 ? "floor" : "ceil" ]( delta  / lowestDelta );
         deltaX = Math[ deltaX >= 1 ? "floor" : "ceil" ]( deltaX / lowestDelta );
         deltaY = Math[ deltaY >= 1 ? "floor" : "ceil" ]( deltaY / lowestDelta );
 
         // Normalise offsetX and offsetY properties
         if ( special.settings.normalizeOffset && this.getBoundingClientRect ) {
             var boundingRect = this.getBoundingClientRect();
             event.offsetX = event.clientX - boundingRect.left;
             event.offsetY = event.clientY - boundingRect.top;
         }
 
         // Add information to the event object
         event.deltaX = deltaX;
         event.deltaY = deltaY;
         event.deltaFactor = lowestDelta;
 
         // Go ahead and set deltaMode to 0 since we converted to pixels
         // Although this is a little odd since we overwrite the deltaX/Y
         // properties with normalized deltas.
         event.deltaMode = 0;
 
         // Add event and delta to the front of the arguments
         args.unshift( event, delta, deltaX, deltaY );
 
         // Clearout lowestDelta after sometime to better
         // handle multiple device types that give different
         // a different lowestDelta
         // Ex: trackpad = 3 and mouse wheel = 120
         if ( nullLowestDeltaTimeout ) {
             window.clearTimeout( nullLowestDeltaTimeout );
         }
         nullLowestDeltaTimeout = window.setTimeout( nullLowestDelta, 200 );
 
         return ( $.event.dispatch || $.event.handle ).apply( this, args );
     }
 
     function nullLowestDelta() {
         lowestDelta = null;
     }
 
     function shouldAdjustOldDeltas( orgEvent, absDelta ) {
 
         // If this is an older event and the delta is divisable by 120,
         // then we are assuming that the browser is treating this as an
         // older mouse wheel event and that we should divide the deltas
         // by 40 to try and get a more usable deltaFactor.
         // Side note, this actually impacts the reported scroll distance
         // in older browsers and can cause scrolling to be slower than native.
         // Turn this off by setting $.event.special.mousewheel.settings.adjustOldDeltas to false.
         return special.settings.adjustOldDeltas && orgEvent.type === "mousewheel" &&
             absDelta % 120 === 0;
     }
 
 } );
 
 
 //------------------------------------------
 /*!
  * GSAP 3.10.4
  * https://greensock.com
  * 
  * @license Copyright 2022, GreenSock. All rights reserved.
  * Subject to the terms at https://greensock.com/standard-license or for Club GreenSock members, the agreement issued with that membership.
  * @author: Jack Doyle, jack@greensock.com
  */
 
 !function(t,e){"object"==typeof exports&&"undefined"!=typeof module?e(exports):"function"==typeof define&&define.amd?define(["exports"],e):e((t=t||self).window=t.window||{})}(this,function(e){"use strict";function _inheritsLoose(t,e){t.prototype=Object.create(e.prototype),(t.prototype.constructor=t).__proto__=e}function _assertThisInitialized(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function o(t){return"string"==typeof t}function p(t){return"function"==typeof t}function q(t){return"number"==typeof t}function r(t){return void 0===t}function s(t){return"object"==typeof t}function t(t){return!1!==t}function u(){return"undefined"!=typeof window}function v(t){return p(t)||o(t)}function M(t){return(h=mt(t,ot))&&he}function N(t,e){return console.warn("Invalid property",t,"set to",e,"Missing plugin? gsap.registerPlugin()")}function O(t,e){return!e&&console.warn(t)}function P(t,e){return t&&(ot[t]=e)&&h&&(h[t]=e)||ot}function Q(){return 0}function $(t){var e,r,i=t[0];if(s(i)||p(i)||(t=[t]),!(e=(i._gsap||{}).harness)){for(r=pt.length;r--&&!pt[r].targetTest(i););e=pt[r]}for(r=t.length;r--;)t[r]&&(t[r]._gsap||(t[r]._gsap=new Lt(t[r],e)))||t.splice(r,1);return t}function _(t){return t._gsap||$(xt(t))[0]._gsap}function aa(t,e,i){return(i=t[e])&&p(i)?t[e]():r(i)&&t.getAttribute&&t.getAttribute(e)||i}function ba(t,e){return(t=t.split(",")).forEach(e)||t}function ca(t){return Math.round(1e5*t)/1e5||0}function da(t){return Math.round(1e7*t)/1e7||0}function ea(t,e){var r=e.charAt(0),i=parseFloat(e.substr(2));return t=parseFloat(t),"+"===r?t+i:"-"===r?t-i:"*"===r?t*i:t/i}function fa(t,e){for(var r=e.length,i=0;t.indexOf(e[i])<0&&++i<r;);return i<r}function ga(){var t,e,r=ht.length,i=ht.slice(0);for(lt={},t=ht.length=0;t<r;t++)(e=i[t])&&e._lazy&&(e.render(e._lazy[0],e._lazy[1],!0)._lazy=0)}function ha(t,e,r,i){ht.length&&ga(),t.render(e,r,i),ht.length&&ga()}function ia(t){var e=parseFloat(t);return(e||0===e)&&(t+"").match(at).length<2?e:o(t)?t.trim():t}function ja(t){return t}function ka(t,e){for(var r in e)r in t||(t[r]=e[r]);return t}function na(t,e){for(var r in e)"__proto__"!==r&&"constructor"!==r&&"prototype"!==r&&(t[r]=s(e[r])?na(t[r]||(t[r]={}),e[r]):e[r]);return t}function oa(t,e){var r,i={};for(r in t)r in e||(i[r]=t[r]);return i}function pa(e){var r=e.parent||I,i=e.keyframes?function _setKeyframeDefaults(i){return function(t,e){for(var r in e)r in t||"duration"===r&&i||"ease"===r||(t[r]=e[r])}}(J(e.keyframes)):ka;if(t(e.inherit))for(;r;)i(e,r.vars.defaults),r=r.parent||r._dp;return e}function ra(t,e,r,i,n){void 0===r&&(r="_first"),void 0===i&&(i="_last");var a,s=t[i];if(n)for(a=e[n];s&&s[n]>a;)s=s._prev;return s?(e._next=s._next,s._next=e):(e._next=t[r],t[r]=e),e._next?e._next._prev=e:t[i]=e,e._prev=s,e.parent=e._dp=t,e}function sa(t,e,r,i){void 0===r&&(r="_first"),void 0===i&&(i="_last");var n=e._prev,a=e._next;n?n._next=a:t[r]===e&&(t[r]=a),a?a._prev=n:t[i]===e&&(t[i]=n),e._next=e._prev=e.parent=null}function ta(t,e){!t.parent||e&&!t.parent.autoRemoveChildren||t.parent.remove(t),t._act=0}function ua(t,e){if(t&&(!e||e._end>t._dur||e._start<0))for(var r=t;r;)r._dirty=1,r=r.parent;return t}function xa(t){return t._repeat?gt(t._tTime,t=t.duration()+t._rDelay)*t:0}function za(t,e){return(t-e._start)*e._ts+(0<=e._ts?0:e._dirty?e.totalDuration():e._tDur)}function Aa(t){return t._end=da(t._start+(t._tDur/Math.abs(t._ts||t._rts||V)||0))}function Ba(t,e){var r=t._dp;return r&&r.smoothChildTiming&&t._ts&&(t._start=da(r._time-(0<t._ts?e/t._ts:((t._dirty?t.totalDuration():t._tDur)-e)/-t._ts)),Aa(t),r._dirty||ua(r,t)),t}function Ca(t,e){var r;if((e._time||e._initted&&!e._dur)&&(r=za(t.rawTime(),e),(!e._dur||bt(0,e.totalDuration(),r)-e._tTime>V)&&e.render(r,!0)),ua(t,e)._dp&&t._initted&&t._time>=t._dur&&t._ts){if(t._dur<t.duration())for(r=t;r._dp;)0<=r.rawTime()&&r.totalTime(r._tTime),r=r._dp;t._zTime=-V}}function Da(t,e,r,i){return e.parent&&ta(e),e._start=da((q(r)?r:r||t!==I?Tt(t,r,e):t._time)+e._delay),e._end=da(e._start+(e.totalDuration()/Math.abs(e.timeScale())||0)),ra(t,e,"_first","_last",t._sort?"_start":0),vt(e)||(t._recent=e),i||Ca(t,e),t}function Ea(t,e){return(ot.ScrollTrigger||N("scrollTrigger",e))&&ot.ScrollTrigger.create(e,t)}function Fa(t,e,r,i){return Xt(t,e),t._initted?!r&&t._pt&&(t._dur&&!1!==t.vars.lazy||!t._dur&&t.vars.lazy)&&f!==Dt.frame?(ht.push(t),t._lazy=[e,i],1):void 0:1}function Ka(t,e,r,i){var n=t._repeat,a=da(e)||0,s=t._tTime/t._tDur;return s&&!i&&(t._time*=a/t._dur),t._dur=a,t._tDur=n?n<0?1e10:da(a*(n+1)+t._rDelay*n):a,0<s&&!i?Ba(t,t._tTime=t._tDur*s):t.parent&&Aa(t),r||ua(t.parent,t),t}function La(t){return t instanceof Ut?ua(t):Ka(t,t._dur)}function Oa(e,r,i){var n,a,s=q(r[1]),o=(s?2:1)+(e<2?0:1),u=r[o];if(s&&(u.duration=r[1]),u.parent=i,e){for(n=u,a=i;a&&!("immediateRender"in n);)n=a.vars.defaults||{},a=t(a.vars.inherit)&&a.parent;u.immediateRender=t(n.immediateRender),e<2?u.runBackwards=1:u.startAt=r[o-1]}return new $t(r[0],u,r[1+o])}function Pa(t,e){return t||0===t?e(t):e}function Ra(t,e){return o(t)&&(e=st.exec(t))?e[1]:""}function Ua(t,e){return t&&s(t)&&"length"in t&&(!e&&!t.length||t.length-1 in t&&s(t[0]))&&!t.nodeType&&t!==i}function Ya(t){return t.sort(function(){return.5-Math.random()})}function Za(t){if(p(t))return t;var c=s(t)?t:{each:t},m=Bt(c.ease),g=c.from||0,v=parseFloat(c.base)||0,y={},e=0<g&&g<1,T=isNaN(g)||e,b=c.axis,w=g,x=g;return o(g)?w=x={center:.5,edges:.5,end:1}[g]||0:!e&&T&&(w=g[0],x=g[1]),function(t,e,r){var i,n,a,s,o,u,h,l,f,d=(r||c).length,_=y[d];if(!_){if(!(f="auto"===c.grid?0:(c.grid||[1,Y])[1])){for(h=-Y;h<(h=r[f++].getBoundingClientRect().left)&&f<d;);f--}for(_=y[d]=[],i=T?Math.min(f,d)*w-.5:g%f,n=f===Y?0:T?d*x/f-.5:g/f|0,l=Y,u=h=0;u<d;u++)a=u%f-i,s=n-(u/f|0),_[u]=o=b?Math.abs("y"===b?s:a):G(a*a+s*s),h<o&&(h=o),o<l&&(l=o);"random"===g&&Ya(_),_.max=h-l,_.min=l,_.v=d=(parseFloat(c.amount)||parseFloat(c.each)*(d<f?d-1:b?"y"===b?d/f:f:Math.max(f,d/f))||0)*("edges"===g?-1:1),_.b=d<0?v-d:v,_.u=Ra(c.amount||c.each)||0,m=m&&d<0?Ft(m):m}return d=(_[t]-_.min)/_.max||0,da(_.b+(m?m(d):d)*_.v)+_.u}}function $a(r){var i=Math.pow(10,((r+"").split(".")[1]||"").length);return function(t){var e=Math.round(parseFloat(t)/r)*r*i;return(e-e%1)/i+(q(t)?0:Ra(t))}}function _a(u,t){var h,l,e=J(u);return!e&&s(u)&&(h=e=u.radius||Y,u.values?(u=xt(u.values),(l=!q(u[0]))&&(h*=h)):u=$a(u.increment)),Pa(t,e?p(u)?function(t){return l=u(t),Math.abs(l-t)<=h?l:t}:function(t){for(var e,r,i=parseFloat(l?t.x:t),n=parseFloat(l?t.y:0),a=Y,s=0,o=u.length;o--;)(e=l?(e=u[o].x-i)*e+(r=u[o].y-n)*r:Math.abs(u[o]-i))<a&&(a=e,s=o);return s=!h||a<=h?u[s]:t,l||s===t||q(t)?s:s+Ra(t)}:$a(u))}function ab(t,e,r,i){return Pa(J(t)?!e:!0===r?!!(r=0):!i,function(){return J(t)?t[~~(Math.random()*t.length)]:(r=r||1e-5)&&(i=r<1?Math.pow(10,(r+"").length-2):1)&&Math.floor(Math.round((t-r/2+Math.random()*(e-t+.99*r))/r)*r*i)/i})}function eb(e,r,t){return Pa(t,function(t){return e[~~r(t)]})}function hb(t){for(var e,r,i,n,a=0,s="";~(e=t.indexOf("random(",a));)i=t.indexOf(")",e),n="["===t.charAt(e+7),r=t.substr(e+7,i-e-7).match(n?at:tt),s+=t.substr(a,e-a)+ab(n?r:+r[0],n?0:+r[1],+r[2]||1e-5),a=i+1;return s+t.substr(a,t.length-a)}function kb(t,e,r){var i,n,a,s=t.labels,o=Y;for(i in s)(n=s[i]-e)<0==!!r&&n&&o>(n=Math.abs(n))&&(a=i,o=n);return a}function mb(t){return ta(t),t.scrollTrigger&&t.scrollTrigger.kill(!1),t.progress()<1&&Ot(t,"onInterrupt"),t}function rb(t,e,r){return(6*(t+=t<0?1:1<t?-1:0)<1?e+(r-e)*t*6:t<.5?r:3*t<2?e+(r-e)*(2/3-t)*6:e)*Pt+.5|0}function sb(t,e,r){var i,n,a,s,o,u,h,l,f,d,_=t?q(t)?[t>>16,t>>8&Pt,t&Pt]:0:Mt.black;if(!_){if(","===t.substr(-1)&&(t=t.substr(0,t.length-1)),Mt[t])_=Mt[t];else if("#"===t.charAt(0)){if(t.length<6&&(t="#"+(i=t.charAt(1))+i+(n=t.charAt(2))+n+(a=t.charAt(3))+a+(5===t.length?t.charAt(4)+t.charAt(4):"")),9===t.length)return[(_=parseInt(t.substr(1,6),16))>>16,_>>8&Pt,_&Pt,parseInt(t.substr(7),16)/255];_=[(t=parseInt(t.substr(1),16))>>16,t>>8&Pt,t&Pt]}else if("hsl"===t.substr(0,3))if(_=d=t.match(tt),e){if(~t.indexOf("="))return _=t.match(et),r&&_.length<4&&(_[3]=1),_}else s=+_[0]%360/360,o=_[1]/100,i=2*(u=_[2]/100)-(n=u<=.5?u*(o+1):u+o-u*o),3<_.length&&(_[3]*=1),_[0]=rb(s+1/3,i,n),_[1]=rb(s,i,n),_[2]=rb(s-1/3,i,n);else _=t.match(tt)||Mt.transparent;_=_.map(Number)}return e&&!d&&(i=_[0]/Pt,n=_[1]/Pt,a=_[2]/Pt,u=((h=Math.max(i,n,a))+(l=Math.min(i,n,a)))/2,h===l?s=o=0:(f=h-l,o=.5<u?f/(2-h-l):f/(h+l),s=h===i?(n-a)/f+(n<a?6:0):h===n?(a-i)/f+2:(i-n)/f+4,s*=60),_[0]=~~(s+.5),_[1]=~~(100*o+.5),_[2]=~~(100*u+.5)),r&&_.length<4&&(_[3]=1),_}function tb(t){var r=[],i=[],n=-1;return t.split(Ct).forEach(function(t){var e=t.match(rt)||[];r.push.apply(r,e),i.push(n+=e.length+1)}),r.c=i,r}function ub(t,e,r){var i,n,a,s,o="",u=(t+o).match(Ct),h=e?"hsla(":"rgba(",l=0;if(!u)return t;if(u=u.map(function(t){return(t=sb(t,e,1))&&h+(e?t[0]+","+t[1]+"%,"+t[2]+"%,"+t[3]:t.join(","))+")"}),r&&(a=tb(t),(i=r.c).join(o)!==a.c.join(o)))for(s=(n=t.replace(Ct,"1").split(rt)).length-1;l<s;l++)o+=n[l]+(~i.indexOf(l)?u.shift()||h+"0,0,0,0)":(a.length?a:u.length?u:r).shift());if(!n)for(s=(n=t.split(Ct)).length-1;l<s;l++)o+=n[l]+u[l];return o+n[s]}function xb(t){var e,r=t.join(" ");if(Ct.lastIndex=0,Ct.test(r))return e=At.test(r),t[1]=ub(t[1],e),t[0]=ub(t[0],e,tb(t[1])),!0}function Gb(t){var e=(t+"").split("("),r=zt[e[0]];return r&&1<e.length&&r.config?r.config.apply(null,~t.indexOf("{")?[function _parseObjectInString(t){for(var e,r,i,n={},a=t.substr(1,t.length-3).split(":"),s=a[0],o=1,u=a.length;o<u;o++)r=a[o],e=o!==u-1?r.lastIndexOf(","):r.length,i=r.substr(0,e),n[s]=isNaN(i)?i.replace(Et,"").trim():+i,s=r.substr(e+1).trim();return n}(e[1])]:function _valueInParentheses(t){var e=t.indexOf("(")+1,r=t.indexOf(")"),i=t.indexOf("(",e);return t.substring(e,~i&&i<r?t.indexOf(")",r+1):r)}(t).split(",").map(ia)):zt._CE&&Rt.test(t)?zt._CE("",t):r}function Ib(t,e){for(var r,i=t._first;i;)i instanceof Ut?Ib(i,e):!i.vars.yoyoEase||i._yoyo&&i._repeat||i._yoyo===e||(i.timeline?Ib(i.timeline,e):(r=i._ease,i._ease=i._yEase,i._yEase=r,i._yoyo=e)),i=i._next}function Kb(t,e,r,i){void 0===r&&(r=function easeOut(t){return 1-e(1-t)}),void 0===i&&(i=function easeInOut(t){return t<.5?e(2*t)/2:1-e(2*(1-t))/2});var n,a={easeIn:e,easeOut:r,easeInOut:i};return ba(t,function(t){for(var e in zt[t]=ot[t]=a,zt[n=t.toLowerCase()]=r,a)zt[n+("easeIn"===e?".in":"easeOut"===e?".out":".inOut")]=zt[t+"."+e]=a[e]}),a}function Lb(e){return function(t){return t<.5?(1-e(1-2*t))/2:.5+e(2*(t-.5))/2}}function Mb(r,t,e){function em(t){return 1===t?1:i*Math.pow(2,-10*t)*Z((t-a)*n)+1}var i=1<=t?t:1,n=(e||(r?.3:.45))/(t<1?t:1),a=n/X*(Math.asin(1/i)||0),s="out"===r?em:"in"===r?function(t){return 1-em(1-t)}:Lb(em);return n=X/n,s.config=function(t,e){return Mb(r,t,e)},s}function Nb(e,r){function mm(t){return t?--t*t*((r+1)*t+r)+1:0}void 0===r&&(r=1.70158);var t="out"===e?mm:"in"===e?function(t){return 1-mm(1-t)}:Lb(mm);return t.config=function(t){return Nb(e,t)},t}var B,I,i,n,a,h,l,f,d,c,m,g,y,T,b,w,x,k,C,A,D,S,z,R,E,F,U={autoSleep:120,force3D:"auto",nullTargetWarn:1,units:{lineHeight:""}},L={duration:.5,overwrite:!1,delay:0},Y=1e8,V=1/Y,X=2*Math.PI,j=X/4,K=0,G=Math.sqrt,W=Math.cos,Z=Math.sin,H="function"==typeof ArrayBuffer&&ArrayBuffer.isView||function(){},J=Array.isArray,tt=/(?:-?\.?\d|\.)+/gi,et=/[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,rt=/[-+=.]*\d+[.e-]*\d*[a-z%]*/g,it=/[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,nt=/[+-]=-?[.\d]+/,at=/[^,'"\[\]\s]+/gi,st=/^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i,ot={},ut={},ht=[],lt={},ft={},dt={},_t=30,pt=[],ct="",mt=function _merge(t,e){for(var r in e)t[r]=e[r];return t},gt=function _animationCycle(t,e){var r=Math.floor(t/=e);return t&&r===t?r-1:r},vt=function _isFromOrFromStart(t){var e=t.data;return"isFromStart"===e||"isStart"===e},yt={_start:0,endTime:Q,totalDuration:Q},Tt=function _parsePosition(t,e,r){var i,n,a,s=t.labels,u=t._recent||yt,h=t.duration()>=Y?u.endTime(!1):t._dur;return o(e)&&(isNaN(e)||e in s)?(n=e.charAt(0),a="%"===e.substr(-1),i=e.indexOf("="),"<"===n||">"===n?(0<=i&&(e=e.replace(/=/,"")),("<"===n?u._start:u.endTime(0<=u._repeat))+(parseFloat(e.substr(1))||0)*(a?(i<0?u:r).totalDuration()/100:1)):i<0?(e in s||(s[e]=h),s[e]):(n=parseFloat(e.charAt(i-1)+e.substr(i+1)),a&&r&&(n=n/100*(J(r)?r[0]:r).totalDuration()),1<i?_parsePosition(t,e.substr(0,i-1),r)+n:h+n)):null==e?h:+e},bt=function _clamp(t,e,r){return r<t?t:e<r?e:r},wt=[].slice,xt=function toArray(t,e,r){return!o(t)||r||!n&&St()?J(t)?function _flatten(t,e,r){return void 0===r&&(r=[]),t.forEach(function(t){return o(t)&&!e||Ua(t,1)?r.push.apply(r,xt(t)):r.push(t)})||r}(t,r):Ua(t)?wt.call(t,0):t?[t]:[]:wt.call((e||a).querySelectorAll(t),0)},kt=function mapRange(e,t,r,i,n){var a=t-e,s=i-r;return Pa(n,function(t){return r+((t-e)/a*s||0)})},Ot=function _callback(t,e,r){var i,n,a=t.vars,s=a[e];if(s)return i=a[e+"Params"],n=a.callbackScope||t,r&&ht.length&&ga(),i?s.apply(n,i):s.call(n)},Pt=255,Mt={aqua:[0,Pt,Pt],lime:[0,Pt,0],silver:[192,192,192],black:[0,0,0],maroon:[128,0,0],teal:[0,128,128],blue:[0,0,Pt],navy:[0,0,128],white:[Pt,Pt,Pt],olive:[128,128,0],yellow:[Pt,Pt,0],orange:[Pt,165,0],gray:[128,128,128],purple:[128,0,128],green:[0,128,0],red:[Pt,0,0],pink:[Pt,192,203],cyan:[0,Pt,Pt],transparent:[Pt,Pt,Pt,0]},Ct=function(){var t,e="(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b";for(t in Mt)e+="|"+t+"\\b";return new RegExp(e+")","gi")}(),At=/hsl[a]?\(/,Dt=(x=Date.now,k=500,C=33,A=x(),D=A,z=S=1e3/240,T={time:0,frame:0,tick:function tick(){Vk(!0)},deltaRatio:function deltaRatio(t){return b/(1e3/(t||60))},wake:function wake(){l&&(!n&&u()&&(i=n=window,a=i.document||{},ot.gsap=he,(i.gsapVersions||(i.gsapVersions=[])).push(he.version),M(h||i.GreenSockGlobals||!i.gsap&&i||{}),y=i.requestAnimationFrame),m&&T.sleep(),g=y||function(t){return setTimeout(t,z-1e3*T.time+1|0)},c=1,Vk(2))},sleep:function sleep(){(y?i.cancelAnimationFrame:clearTimeout)(m),c=0,g=Q},lagSmoothing:function lagSmoothing(t,e){k=t||1e8,C=Math.min(e,k,0)},fps:function fps(t){S=1e3/(t||240),z=1e3*T.time+S},add:function add(n,t,e){var a=t?function(t,e,r,i){n(t,e,r,i),T.remove(a)}:n;return T.remove(n),R[e?"unshift":"push"](a),St(),a},remove:function remove(t,e){~(e=R.indexOf(t))&&R.splice(e,1)&&e<=w&&w--},_listeners:R=[]}),St=function _wake(){return!c&&Dt.wake()},zt={},Rt=/^[\d.\-M][\d.\-,\s]/,Et=/["']/g,Ft=function _invertEase(e){return function(t){return 1-e(1-t)}},Bt=function _parseEase(t,e){return t&&(p(t)?t:zt[t]||Gb(t))||e};function Vk(t){var e,r,i,n,a=x()-D,s=!0===t;if(k<a&&(A+=a-C),(0<(e=(i=(D+=a)-A)-z)||s)&&(n=++T.frame,b=i-1e3*T.time,T.time=i/=1e3,z+=e+(S<=e?4:S-e),r=1),s||(m=g(Vk)),r)for(w=0;w<R.length;w++)R[w](i,b,n,t)}function Dm(t){return t<F?E*t*t:t<.7272727272727273?E*Math.pow(t-1.5/2.75,2)+.75:t<.9090909090909092?E*(t-=2.25/2.75)*t+.9375:E*Math.pow(t-2.625/2.75,2)+.984375}ba("Linear,Quad,Cubic,Quart,Quint,Strong",function(t,e){var r=e<5?e+1:e;Kb(t+",Power"+(r-1),e?function(t){return Math.pow(t,r)}:function(t){return t},function(t){return 1-Math.pow(1-t,r)},function(t){return t<.5?Math.pow(2*t,r)/2:1-Math.pow(2*(1-t),r)/2})}),zt.Linear.easeNone=zt.none=zt.Linear.easeIn,Kb("Elastic",Mb("in"),Mb("out"),Mb()),E=7.5625,F=1/2.75,Kb("Bounce",function(t){return 1-Dm(1-t)},Dm),Kb("Expo",function(t){return t?Math.pow(2,10*(t-1)):0}),Kb("Circ",function(t){return-(G(1-t*t)-1)}),Kb("Sine",function(t){return 1===t?1:1-W(t*j)}),Kb("Back",Nb("in"),Nb("out"),Nb()),zt.SteppedEase=zt.steps=ot.SteppedEase={config:function config(t,e){void 0===t&&(t=1);var r=1/t,i=t+(e?0:1),n=e?1:0;return function(t){return((i*bt(0,.99999999,t)|0)+n)*r}}},L.ease=zt["quad.out"],ba("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt",function(t){return ct+=t+","+t+"Params,"});var It,Lt=function GSCache(t,e){this.id=K++,(t._gsap=this).target=t,this.harness=e,this.get=e?e.get:aa,this.set=e?e.getSetter:Ht},Nt=((It=Animation.prototype).delay=function delay(t){return t||0===t?(this.parent&&this.parent.smoothChildTiming&&this.startTime(this._start+t-this._delay),this._delay=t,this):this._delay},It.duration=function duration(t){return arguments.length?this.totalDuration(0<this._repeat?t+(t+this._rDelay)*this._repeat:t):this.totalDuration()&&this._dur},It.totalDuration=function totalDuration(t){return arguments.length?(this._dirty=0,Ka(this,this._repeat<0?t:(t-this._repeat*this._rDelay)/(this._repeat+1))):this._tDur},It.totalTime=function totalTime(t,e){if(St(),!arguments.length)return this._tTime;var r=this._dp;if(r&&r.smoothChildTiming&&this._ts){for(Ba(this,t),!r._dp||r.parent||Ca(r,this);r&&r.parent;)r.parent._time!==r._start+(0<=r._ts?r._tTime/r._ts:(r.totalDuration()-r._tTime)/-r._ts)&&r.totalTime(r._tTime,!0),r=r.parent;!this.parent&&this._dp.autoRemoveChildren&&(0<this._ts&&t<this._tDur||this._ts<0&&0<t||!this._tDur&&!t)&&Da(this._dp,this,this._start-this._delay)}return(this._tTime!==t||!this._dur&&!e||this._initted&&Math.abs(this._zTime)===V||!t&&!this._initted&&(this.add||this._ptLookup))&&(this._ts||(this._pTime=t),ha(this,t,e)),this},It.time=function time(t,e){return arguments.length?this.totalTime(Math.min(this.totalDuration(),t+xa(this))%(this._dur+this._rDelay)||(t?this._dur:0),e):this._time},It.totalProgress=function totalProgress(t,e){return arguments.length?this.totalTime(this.totalDuration()*t,e):this.totalDuration()?Math.min(1,this._tTime/this._tDur):this.ratio},It.progress=function progress(t,e){return arguments.length?this.totalTime(this.duration()*(!this._yoyo||1&this.iteration()?t:1-t)+xa(this),e):this.duration()?Math.min(1,this._time/this._dur):this.ratio},It.iteration=function iteration(t,e){var r=this.duration()+this._rDelay;return arguments.length?this.totalTime(this._time+(t-1)*r,e):this._repeat?gt(this._tTime,r)+1:1},It.timeScale=function timeScale(t){if(!arguments.length)return this._rts===-V?0:this._rts;if(this._rts===t)return this;var e=this.parent&&this._ts?za(this.parent._time,this):this._tTime;return this._rts=+t||0,this._ts=this._ps||t===-V?0:this._rts,this.totalTime(bt(-this._delay,this._tDur,e),!0),Aa(this),function _recacheAncestors(t){for(var e=t.parent;e&&e.parent;)e._dirty=1,e.totalDuration(),e=e.parent;return t}(this)},It.paused=function paused(t){return arguments.length?(this._ps!==t&&((this._ps=t)?(this._pTime=this._tTime||Math.max(-this._delay,this.rawTime()),this._ts=this._act=0):(St(),this._ts=this._rts,this.totalTime(this.parent&&!this.parent.smoothChildTiming?this.rawTime():this._tTime||this._pTime,1===this.progress()&&Math.abs(this._zTime)!==V&&(this._tTime-=V)))),this):this._ps},It.startTime=function startTime(t){if(arguments.length){this._start=t;var e=this.parent||this._dp;return!e||!e._sort&&this.parent||Da(e,this,t-this._delay),this}return this._start},It.endTime=function endTime(e){return this._start+(t(e)?this.totalDuration():this.duration())/Math.abs(this._ts||1)},It.rawTime=function rawTime(t){var e=this.parent||this._dp;return e?t&&(!this._ts||this._repeat&&this._time&&this.totalProgress()<1)?this._tTime%(this._dur+this._rDelay):this._ts?za(e.rawTime(t),this):this._tTime:this._tTime},It.globalTime=function globalTime(t){for(var e=this,r=arguments.length?t:e.rawTime();e;)r=e._start+r/(e._ts||1),e=e._dp;return r},It.repeat=function repeat(t){return arguments.length?(this._repeat=t===1/0?-2:t,La(this)):-2===this._repeat?1/0:this._repeat},It.repeatDelay=function repeatDelay(t){if(arguments.length){var e=this._time;return this._rDelay=t,La(this),e?this.time(e):this}return this._rDelay},It.yoyo=function yoyo(t){return arguments.length?(this._yoyo=t,this):this._yoyo},It.seek=function seek(e,r){return this.totalTime(Tt(this,e),t(r))},It.restart=function restart(e,r){return this.play().totalTime(e?-this._delay:0,t(r))},It.play=function play(t,e){return null!=t&&this.seek(t,e),this.reversed(!1).paused(!1)},It.reverse=function reverse(t,e){return null!=t&&this.seek(t||this.totalDuration(),e),this.reversed(!0).paused(!1)},It.pause=function pause(t,e){return null!=t&&this.seek(t,e),this.paused(!0)},It.resume=function resume(){return this.paused(!1)},It.reversed=function reversed(t){return arguments.length?(!!t!==this.reversed()&&this.timeScale(-this._rts||(t?-V:0)),this):this._rts<0},It.invalidate=function invalidate(){return this._initted=this._act=0,this._zTime=-V,this},It.isActive=function isActive(){var t,e=this.parent||this._dp,r=this._start;return!(e&&!(this._ts&&this._initted&&e.isActive()&&(t=e.rawTime(!0))>=r&&t<this.endTime(!0)-V))},It.eventCallback=function eventCallback(t,e,r){var i=this.vars;return 1<arguments.length?(e?(i[t]=e,r&&(i[t+"Params"]=r),"onUpdate"===t&&(this._onUpdate=e)):delete i[t],this):i[t]},It.then=function then(t){var i=this;return new Promise(function(e){function Un(){var t=i.then;i.then=null,p(r)&&(r=r(i))&&(r.then||r===i)&&(i.then=t),e(r),i.then=t}var r=p(t)?t:ja;i._initted&&1===i.totalProgress()&&0<=i._ts||!i._tTime&&i._ts<0?Un():i._prom=Un})},It.kill=function kill(){mb(this)},Animation);function Animation(t){this.vars=t,this._delay=+t.delay||0,(this._repeat=t.repeat===1/0?-2:t.repeat||0)&&(this._rDelay=t.repeatDelay||0,this._yoyo=!!t.yoyo||!!t.yoyoEase),this._ts=1,Ka(this,+t.duration,1,1),this.data=t.data,c||Dt.wake()}ka(Nt.prototype,{_time:0,_start:0,_end:0,_tTime:0,_tDur:0,_dirty:0,_repeat:0,_yoyo:!1,parent:null,_initted:!1,_rDelay:0,_ts:1,_dp:0,ratio:0,_zTime:-V,_prom:0,_ps:!1,_rts:1});var Ut=function(n){function Timeline(e,r){var i;return void 0===e&&(e={}),(i=n.call(this,e)||this).labels={},i.smoothChildTiming=!!e.smoothChildTiming,i.autoRemoveChildren=!!e.autoRemoveChildren,i._sort=t(e.sortChildren),I&&Da(e.parent||I,_assertThisInitialized(i),r),e.reversed&&i.reverse(),e.paused&&i.paused(!0),e.scrollTrigger&&Ea(_assertThisInitialized(i),e.scrollTrigger),i}_inheritsLoose(Timeline,n);var e=Timeline.prototype;return e.to=function to(t,e,r){return Oa(0,arguments,this),this},e.from=function from(t,e,r){return Oa(1,arguments,this),this},e.fromTo=function fromTo(t,e,r,i){return Oa(2,arguments,this),this},e.set=function set(t,e,r){return e.duration=0,e.parent=this,pa(e).repeatDelay||(e.repeat=0),e.immediateRender=!!e.immediateRender,new $t(t,e,Tt(this,r),1),this},e.call=function call(t,e,r){return Da(this,$t.delayedCall(0,t,e),r)},e.staggerTo=function staggerTo(t,e,r,i,n,a,s){return r.duration=e,r.stagger=r.stagger||i,r.onComplete=a,r.onCompleteParams=s,r.parent=this,new $t(t,r,Tt(this,n)),this},e.staggerFrom=function staggerFrom(e,r,i,n,a,s,o){return i.runBackwards=1,pa(i).immediateRender=t(i.immediateRender),this.staggerTo(e,r,i,n,a,s,o)},e.staggerFromTo=function staggerFromTo(e,r,i,n,a,s,o,u){return n.startAt=i,pa(n).immediateRender=t(n.immediateRender),this.staggerTo(e,r,n,a,s,o,u)},e.render=function render(t,e,r){var i,n,a,s,o,u,h,l,f,d,_,p,c=this._time,m=this._dirty?this.totalDuration():this._tDur,g=this._dur,v=t<=0?0:da(t),y=this._zTime<0!=t<0&&(this._initted||!g);if(this!==I&&m<v&&0<=t&&(v=m),v!==this._tTime||r||y){if(c!==this._time&&g&&(v+=this._time-c,t+=this._time-c),i=v,f=this._start,u=!(l=this._ts),y&&(g||(c=this._zTime),!t&&e||(this._zTime=t)),this._repeat){if(_=this._yoyo,o=g+this._rDelay,this._repeat<-1&&t<0)return this.totalTime(100*o+t,e,r);if(i=da(v%o),v===m?(s=this._repeat,i=g):((s=~~(v/o))&&s===v/o&&(i=g,s--),g<i&&(i=g)),d=gt(this._tTime,o),!c&&this._tTime&&d!==s&&(d=s),_&&1&s&&(i=g-i,p=1),s!==d&&!this._lock){var T=_&&1&d,b=T===(_&&1&s);if(s<d&&(T=!T),c=T?0:g,this._lock=1,this.render(c||(p?0:da(s*o)),e,!g)._lock=0,this._tTime=v,!e&&this.parent&&Ot(this,"onRepeat"),this.vars.repeatRefresh&&!p&&(this.invalidate()._lock=1),c&&c!==this._time||u!=!this._ts||this.vars.onRepeat&&!this.parent&&!this._act)return this;if(g=this._dur,m=this._tDur,b&&(this._lock=2,c=T?g:-1e-4,this.render(c,!0),this.vars.repeatRefresh&&!p&&this.invalidate()),this._lock=0,!this._ts&&!u)return this;Ib(this,p)}}if(this._hasPause&&!this._forcing&&this._lock<2&&(h=function _findNextPauseTween(t,e,r){var i;if(e<r)for(i=t._first;i&&i._start<=r;){if("isPause"===i.data&&i._start>e)return i;i=i._next}else for(i=t._last;i&&i._start>=r;){if("isPause"===i.data&&i._start<e)return i;i=i._prev}}(this,da(c),da(i)))&&(v-=i-(i=h._start)),this._tTime=v,this._time=i,this._act=!l,this._initted||(this._onUpdate=this.vars.onUpdate,this._initted=1,this._zTime=t,c=0),!c&&i&&!e&&(Ot(this,"onStart"),this._tTime!==v))return this;if(c<=i&&0<=t)for(n=this._first;n;){if(a=n._next,(n._act||i>=n._start)&&n._ts&&h!==n){if(n.parent!==this)return this.render(t,e,r);if(n.render(0<n._ts?(i-n._start)*n._ts:(n._dirty?n.totalDuration():n._tDur)+(i-n._start)*n._ts,e,r),i!==this._time||!this._ts&&!u){h=0,a&&(v+=this._zTime=-V);break}}n=a}else{n=this._last;for(var w=t<0?t:i;n;){if(a=n._prev,(n._act||w<=n._end)&&n._ts&&h!==n){if(n.parent!==this)return this.render(t,e,r);if(n.render(0<n._ts?(w-n._start)*n._ts:(n._dirty?n.totalDuration():n._tDur)+(w-n._start)*n._ts,e,r),i!==this._time||!this._ts&&!u){h=0,a&&(v+=this._zTime=w?-V:V);break}}n=a}}if(h&&!e&&(this.pause(),h.render(c<=i?0:-V)._zTime=c<=i?1:-1,this._ts))return this._start=f,Aa(this),this.render(t,e,r);this._onUpdate&&!e&&Ot(this,"onUpdate",!0),(v===m&&this._tTime>=this.totalDuration()||!v&&c)&&(f!==this._start&&Math.abs(l)===Math.abs(this._ts)||this._lock||(!t&&g||!(v===m&&0<this._ts||!v&&this._ts<0)||ta(this,1),e||t<0&&!c||!v&&!c&&m||(Ot(this,v===m&&0<=t?"onComplete":"onReverseComplete",!0),!this._prom||v<m&&0<this.timeScale()||this._prom())))}return this},e.add=function add(t,e){var r=this;if(q(e)||(e=Tt(this,e,t)),!(t instanceof Nt)){if(J(t))return t.forEach(function(t){return r.add(t,e)}),this;if(o(t))return this.addLabel(t,e);if(!p(t))return this;t=$t.delayedCall(0,t)}return this!==t?Da(this,t,e):this},e.getChildren=function getChildren(t,e,r,i){void 0===t&&(t=!0),void 0===e&&(e=!0),void 0===r&&(r=!0),void 0===i&&(i=-Y);for(var n=[],a=this._first;a;)a._start>=i&&(a instanceof $t?e&&n.push(a):(r&&n.push(a),t&&n.push.apply(n,a.getChildren(!0,e,r)))),a=a._next;return n},e.getById=function getById(t){for(var e=this.getChildren(1,1,1),r=e.length;r--;)if(e[r].vars.id===t)return e[r]},e.remove=function remove(t){return o(t)?this.removeLabel(t):p(t)?this.killTweensOf(t):(sa(this,t),t===this._recent&&(this._recent=this._last),ua(this))},e.totalTime=function totalTime(t,e){return arguments.length?(this._forcing=1,!this._dp&&this._ts&&(this._start=da(Dt.time-(0<this._ts?t/this._ts:(this.totalDuration()-t)/-this._ts))),n.prototype.totalTime.call(this,t,e),this._forcing=0,this):this._tTime},e.addLabel=function addLabel(t,e){return this.labels[t]=Tt(this,e),this},e.removeLabel=function removeLabel(t){return delete this.labels[t],this},e.addPause=function addPause(t,e,r){var i=$t.delayedCall(0,e||Q,r);return i.data="isPause",this._hasPause=1,Da(this,i,Tt(this,t))},e.removePause=function removePause(t){var e=this._first;for(t=Tt(this,t);e;)e._start===t&&"isPause"===e.data&&ta(e),e=e._next},e.killTweensOf=function killTweensOf(t,e,r){for(var i=this.getTweensOf(t,r),n=i.length;n--;)Yt!==i[n]&&i[n].kill(t,e);return this},e.getTweensOf=function getTweensOf(t,e){for(var r,i=[],n=xt(t),a=this._first,s=q(e);a;)a instanceof $t?fa(a._targets,n)&&(s?(!Yt||a._initted&&a._ts)&&a.globalTime(0)<=e&&a.globalTime(a.totalDuration())>e:!e||a.isActive())&&i.push(a):(r=a.getTweensOf(n,e)).length&&i.push.apply(i,r),a=a._next;return i},e.tweenTo=function tweenTo(t,e){e=e||{};var r,i=this,n=Tt(i,t),a=e.startAt,s=e.onStart,o=e.onStartParams,u=e.immediateRender,h=$t.to(i,ka({ease:e.ease||"none",lazy:!1,immediateRender:!1,time:n,overwrite:"auto",duration:e.duration||Math.abs((n-(a&&"time"in a?a.time:i._time))/i.timeScale())||V,onStart:function onStart(){if(i.pause(),!r){var t=e.duration||Math.abs((n-(a&&"time"in a?a.time:i._time))/i.timeScale());h._dur!==t&&Ka(h,t,0,1).render(h._time,!0,!0),r=1}s&&s.apply(h,o||[])}},e));return u?h.render(0):h},e.tweenFromTo=function tweenFromTo(t,e,r){return this.tweenTo(e,ka({startAt:{time:Tt(this,t)}},r))},e.recent=function recent(){return this._recent},e.nextLabel=function nextLabel(t){return void 0===t&&(t=this._time),kb(this,Tt(this,t))},e.previousLabel=function previousLabel(t){return void 0===t&&(t=this._time),kb(this,Tt(this,t),1)},e.currentLabel=function currentLabel(t){return arguments.length?this.seek(t,!0):this.previousLabel(this._time+V)},e.shiftChildren=function shiftChildren(t,e,r){void 0===r&&(r=0);for(var i,n=this._first,a=this.labels;n;)n._start>=r&&(n._start+=t,n._end+=t),n=n._next;if(e)for(i in a)a[i]>=r&&(a[i]+=t);return ua(this)},e.invalidate=function invalidate(){var t=this._first;for(this._lock=0;t;)t.invalidate(),t=t._next;return n.prototype.invalidate.call(this)},e.clear=function clear(t){void 0===t&&(t=!0);for(var e,r=this._first;r;)e=r._next,this.remove(r),r=e;return this._dp&&(this._time=this._tTime=this._pTime=0),t&&(this.labels={}),ua(this)},e.totalDuration=function totalDuration(t){var e,r,i,n=0,a=this,s=a._last,o=Y;if(arguments.length)return a.timeScale((a._repeat<0?a.duration():a.totalDuration())/(a.reversed()?-t:t));if(a._dirty){for(i=a.parent;s;)e=s._prev,s._dirty&&s.totalDuration(),o<(r=s._start)&&a._sort&&s._ts&&!a._lock?(a._lock=1,Da(a,s,r-s._delay,1)._lock=0):o=r,r<0&&s._ts&&(n-=r,(!i&&!a._dp||i&&i.smoothChildTiming)&&(a._start+=r/a._ts,a._time-=r,a._tTime-=r),a.shiftChildren(-r,!1,-Infinity),o=0),s._end>n&&s._ts&&(n=s._end),s=e;Ka(a,a===I&&a._time>n?a._time:n,1,1),a._dirty=0}return a._tDur},Timeline.updateRoot=function updateRoot(t){if(I._ts&&(ha(I,za(t,I)),f=Dt.frame),Dt.frame>=_t){_t+=U.autoSleep||120;var e=I._first;if((!e||!e._ts)&&U.autoSleep&&Dt._listeners.length<2){for(;e&&!e._ts;)e=e._next;e||Dt.sleep()}}},Timeline}(Nt);ka(Ut.prototype,{_lock:0,_hasPause:0,_forcing:0});function Ub(t,e,r,i,n,a){var u,h,l,f;if(ft[t]&&!1!==(u=new ft[t]).init(n,u.rawVars?e[t]:function _processVars(t,e,r,i,n){if(p(t)&&(t=Qt(t,n,e,r,i)),!s(t)||t.style&&t.nodeType||J(t)||H(t))return o(t)?Qt(t,n,e,r,i):t;var a,u={};for(a in t)u[a]=Qt(t[a],n,e,r,i);return u}(e[t],i,n,a,r),r,i,a)&&(r._pt=h=new oe(r._pt,n,t,0,1,u.render,u,0,u.priority),r!==d))for(l=r._ptLookup[r._targets.indexOf(n)],f=u._props.length;f--;)l[u._props[f]]=h;return u}function $b(t,r,e,i){var n,a,s=r.ease||i||"power1.inOut";if(J(r))a=e[t]||(e[t]=[]),r.forEach(function(t,e){return a.push({t:e/(r.length-1)*100,v:t,e:s})});else for(n in r)a=e[n]||(e[n]=[]),"ease"===n||a.push({t:parseFloat(t),v:r[n],e:s})}var Yt,qt,Vt=function _addPropTween(t,e,r,i,n,a,s,u,h){p(i)&&(i=i(n||0,t,a));var l,f=t[e],d="get"!==r?r:p(f)?h?t[e.indexOf("set")||!p(t["get"+e.substr(3)])?e:"get"+e.substr(3)](h):t[e]():f,_=p(f)?h?Zt:Wt:Gt;if(o(i)&&(~i.indexOf("random(")&&(i=hb(i)),"="===i.charAt(1)&&(!(l=ea(d,i)+(Ra(d)||0))&&0!==l||(i=l))),d!==i||qt)return isNaN(d*i)||""===i?(f||e in t||N(e,i),function _addComplexStringPropTween(t,e,r,i,n,a,s){var o,u,h,l,f,d,_,p,c=new oe(this._pt,t,e,0,1,ee,null,n),m=0,g=0;for(c.b=r,c.e=i,r+="",(_=~(i+="").indexOf("random("))&&(i=hb(i)),a&&(a(p=[r,i],t,e),r=p[0],i=p[1]),u=r.match(it)||[];o=it.exec(i);)l=o[0],f=i.substring(m,o.index),h?h=(h+1)%5:"rgba("===f.substr(-5)&&(h=1),l!==u[g++]&&(d=parseFloat(u[g-1])||0,c._pt={_next:c._pt,p:f||1===g?f:",",s:d,c:"="===l.charAt(1)?ea(d,l)-d:parseFloat(l)-d,m:h&&h<4?Math.round:0},m=it.lastIndex);return c.c=m<i.length?i.substring(m,i.length):"",c.fp=s,(nt.test(i)||_)&&(c.e=0),this._pt=c}.call(this,t,e,d,i,_,u||U.stringFilter,h)):(l=new oe(this._pt,t,e,+d||0,i-(d||0),"boolean"==typeof f?te:Jt,0,_),h&&(l.fp=h),s&&l.modifier(s,this,t),this._pt=l)},Xt=function _initTween(e,r){var i,n,a,s,o,u,h,l,f,d,p,c,m,g=e.vars,v=g.ease,y=g.startAt,T=g.immediateRender,b=g.lazy,w=g.onUpdate,x=g.onUpdateParams,k=g.callbackScope,O=g.runBackwards,P=g.yoyoEase,M=g.keyframes,C=g.autoRevert,A=e._dur,D=e._startAt,S=e._targets,z=e.parent,R=z&&"nested"===z.data?z.parent._targets:S,E="auto"===e._overwrite&&!B,F=e.timeline;if(!F||M&&v||(v="none"),e._ease=Bt(v,L.ease),e._yEase=P?Ft(Bt(!0===P?v:P,L.ease)):0,P&&e._yoyo&&!e._repeat&&(P=e._yEase,e._yEase=e._ease,e._ease=P),e._from=!F&&!!g.runBackwards,!F||M&&!g.stagger){if(c=(l=S[0]?_(S[0]).harness:0)&&g[l.prop],i=oa(g,ut),D&&(ta(D.render(-1,!0)),D._lazy=0),y)if(ta(e._startAt=$t.set(S,ka({data:"isStart",overwrite:!1,parent:z,immediateRender:!0,lazy:t(b),startAt:null,delay:0,onUpdate:w,onUpdateParams:x,callbackScope:k,stagger:0},y))),r<0&&!T&&!C&&e._startAt.render(-1,!0),T){if(0<r&&!C&&(e._startAt=0),A&&r<=0)return void(r&&(e._zTime=r))}else!1===C&&(e._startAt=0);else if(O&&A)if(D)C||(e._startAt=0);else if(r&&(T=!1),a=ka({overwrite:!1,data:"isFromStart",lazy:T&&t(b),immediateRender:T,stagger:0,parent:z},i),c&&(a[l.prop]=c),ta(e._startAt=$t.set(S,a)),r<0&&e._startAt.render(-1,!0),e._zTime=r,T){if(!r)return}else _initTween(e._startAt,V);for(e._pt=e._ptCache=0,b=A&&t(b)||b&&!A,n=0;n<S.length;n++){if(h=(o=S[n])._gsap||$(S)[n]._gsap,e._ptLookup[n]=d={},lt[h.id]&&ht.length&&ga(),p=R===S?n:R.indexOf(o),l&&!1!==(f=new l).init(o,c||i,e,p,R)&&(e._pt=s=new oe(e._pt,o,f.name,0,1,f.render,f,0,f.priority),f._props.forEach(function(t){d[t]=s}),f.priority&&(u=1)),!l||c)for(a in i)ft[a]&&(f=Ub(a,i,e,p,o,R))?f.priority&&(u=1):d[a]=s=Vt.call(e,o,a,"get",i[a],p,R,0,g.stringFilter);e._op&&e._op[n]&&e.kill(o,e._op[n]),E&&e._pt&&(Yt=e,I.killTweensOf(o,d,e.globalTime(r)),m=!e.parent,Yt=0),e._pt&&b&&(lt[h.id]=1)}u&&se(e),e._onInit&&e._onInit(e)}e._onUpdate=w,e._initted=(!e._op||e._pt)&&!m,M&&r<=0&&F.render(Y,!0,!0)},Qt=function _parseFuncOrString(t,e,r,i,n){return p(t)?t.call(e,r,i,n):o(t)&&~t.indexOf("random(")?hb(t):t},jt=ct+"repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert",Kt={};ba(jt+",id,stagger,delay,duration,paused,scrollTrigger",function(t){return Kt[t]=1});var $t=function(R){function Tween(e,r,i,n){var a;"number"==typeof r&&(i.duration=r,r=i,i=null);var o,u,h,l,f,d,_,p,c=(a=R.call(this,n?r:pa(r))||this).vars,m=c.duration,g=c.delay,y=c.immediateRender,T=c.stagger,b=c.overwrite,w=c.keyframes,x=c.defaults,k=c.scrollTrigger,P=c.yoyoEase,M=r.parent||I,C=(J(e)||H(e)?q(e[0]):"length"in r)?[e]:xt(e);if(a._targets=C.length?$(C):O("GSAP target "+e+" not found. https://greensock.com",!U.nullTargetWarn)||[],a._ptLookup=[],a._overwrite=b,w||T||v(m)||v(g)){if(r=a.vars,(o=a.timeline=new Ut({data:"nested",defaults:x||{}})).kill(),o.parent=o._dp=_assertThisInitialized(a),o._start=0,T||v(m)||v(g)){if(l=C.length,_=T&&Za(T),s(T))for(f in T)~jt.indexOf(f)&&((p=p||{})[f]=T[f]);for(u=0;u<l;u++)(h=oa(r,Kt)).stagger=0,P&&(h.yoyoEase=P),p&&mt(h,p),d=C[u],h.duration=+Qt(m,_assertThisInitialized(a),u,d,C),h.delay=(+Qt(g,_assertThisInitialized(a),u,d,C)||0)-a._delay,!T&&1===l&&h.delay&&(a._delay=g=h.delay,a._start+=g,h.delay=0),o.to(d,h,_?_(u,d,C):0),o._ease=zt.none;o.duration()?m=g=0:a.timeline=0}else if(w){pa(ka(o.vars.defaults,{ease:"none"})),o._ease=Bt(w.ease||r.ease||"none");var A,D,S,z=0;if(J(w))w.forEach(function(t){return o.to(C,t,">")});else{for(f in h={},w)"ease"===f||"easeEach"===f||$b(f,w[f],h,w.easeEach);for(f in h)for(A=h[f].sort(function(t,e){return t.t-e.t}),u=z=0;u<A.length;u++)(S={ease:(D=A[u]).e,duration:(D.t-(u?A[u-1].t:0))/100*m})[f]=D.v,o.to(C,S,z),z+=S.duration;o.duration()<m&&o.to({},{duration:m-o.duration()})}}m||a.duration(m=o.duration())}else a.timeline=0;return!0!==b||B||(Yt=_assertThisInitialized(a),I.killTweensOf(C),Yt=0),Da(M,_assertThisInitialized(a),i),r.reversed&&a.reverse(),r.paused&&a.paused(!0),(y||!m&&!w&&a._start===da(M._time)&&t(y)&&function _hasNoPausedAncestors(t){return!t||t._ts&&_hasNoPausedAncestors(t.parent)}(_assertThisInitialized(a))&&"nested"!==M.data)&&(a._tTime=-V,a.render(Math.max(0,-g))),k&&Ea(_assertThisInitialized(a),k),a}_inheritsLoose(Tween,R);var e=Tween.prototype;return e.render=function render(t,e,r){var i,n,a,s,o,u,h,l,f,d=this._time,_=this._tDur,p=this._dur,c=_-V<t&&0<=t?_:t<V?0:t;if(p){if(c!==this._tTime||!t||r||!this._initted&&this._tTime||this._startAt&&this._zTime<0!=t<0){if(i=c,l=this.timeline,this._repeat){if(s=p+this._rDelay,this._repeat<-1&&t<0)return this.totalTime(100*s+t,e,r);if(i=da(c%s),c===_?(a=this._repeat,i=p):((a=~~(c/s))&&a===c/s&&(i=p,a--),p<i&&(i=p)),(u=this._yoyo&&1&a)&&(f=this._yEase,i=p-i),o=gt(this._tTime,s),i===d&&!r&&this._initted)return this._tTime=c,this;a!==o&&(l&&this._yEase&&Ib(l,u),!this.vars.repeatRefresh||u||this._lock||(this._lock=r=1,this.render(da(s*a),!0).invalidate()._lock=0))}if(!this._initted){if(Fa(this,t<0?t:i,r,e))return this._tTime=0,this;if(d!==this._time)return this;if(p!==this._dur)return this.render(t,e,r)}if(this._tTime=c,this._time=i,!this._act&&this._ts&&(this._act=1,this._lazy=0),this.ratio=h=(f||this._ease)(i/p),this._from&&(this.ratio=h=1-h),i&&!d&&!e&&(Ot(this,"onStart"),this._tTime!==c))return this;for(n=this._pt;n;)n.r(h,n.d),n=n._next;l&&l.render(t<0?t:!i&&u?-V:l._dur*l._ease(i/this._dur),e,r)||this._startAt&&(this._zTime=t),this._onUpdate&&!e&&(t<0&&this._startAt&&this._startAt.render(t,!0,r),Ot(this,"onUpdate")),this._repeat&&a!==o&&this.vars.onRepeat&&!e&&this.parent&&Ot(this,"onRepeat"),c!==this._tDur&&c||this._tTime!==c||(t<0&&this._startAt&&!this._onUpdate&&this._startAt.render(t,!0,!0),!t&&p||!(c===this._tDur&&0<this._ts||!c&&this._ts<0)||ta(this,1),e||t<0&&!d||!c&&!d||(Ot(this,c===_?"onComplete":"onReverseComplete",!0),!this._prom||c<_&&0<this.timeScale()||this._prom()))}}else!function _renderZeroDurationTween(t,e,r,i){var n,a,s,o=t.ratio,u=e<0||!e&&(!t._start&&function _parentPlayheadIsBeforeStart(t){var e=t.parent;return e&&e._ts&&e._initted&&!e._lock&&(e.rawTime()<0||_parentPlayheadIsBeforeStart(e))}(t)&&(t._initted||!vt(t))||(t._ts<0||t._dp._ts<0)&&!vt(t))?0:1,h=t._rDelay,l=0;if(h&&t._repeat&&(l=bt(0,t._tDur,e),a=gt(l,h),t._yoyo&&1&a&&(u=1-u),a!==gt(t._tTime,h)&&(o=1-u,t.vars.repeatRefresh&&t._initted&&t.invalidate())),u!==o||i||t._zTime===V||!e&&t._zTime){if(!t._initted&&Fa(t,e,i,r))return;for(s=t._zTime,t._zTime=e||(r?V:0),r=r||e&&!s,t.ratio=u,t._from&&(u=1-u),t._time=0,t._tTime=l,n=t._pt;n;)n.r(u,n.d),n=n._next;t._startAt&&e<0&&t._startAt.render(e,!0,!0),t._onUpdate&&!r&&Ot(t,"onUpdate"),l&&t._repeat&&!r&&t.parent&&Ot(t,"onRepeat"),(e>=t._tDur||e<0)&&t.ratio===u&&(u&&ta(t,1),r||(Ot(t,u?"onComplete":"onReverseComplete",!0),t._prom&&t._prom()))}else t._zTime||(t._zTime=e)}(this,t,e,r);return this},e.targets=function targets(){return this._targets},e.invalidate=function invalidate(){return this._pt=this._op=this._startAt=this._onUpdate=this._lazy=this.ratio=0,this._ptLookup=[],this.timeline&&this.timeline.invalidate(),R.prototype.invalidate.call(this)},e.resetTo=function resetTo(t,e,r,i){c||Dt.wake(),this._ts||this.play();var n,a=Math.min(this._dur,(this._dp._time-this._start)*this._ts);return this._initted||Xt(this,a),n=this._ease(a/this._dur),function _updatePropTweens(t,e,r,i,n,a,s){var o,u,h,l=(t._pt&&t._ptCache||(t._ptCache={}))[e];if(!l)for(l=t._ptCache[e]=[],u=t._ptLookup,h=t._targets.length;h--;){if((o=u[h][e])&&o.d&&o.d._pt)for(o=o.d._pt;o&&o.p!==e;)o=o._next;if(!o)return qt=1,t.vars[e]="+=0",Xt(t,s),qt=0,1;l.push(o)}for(h=l.length;h--;)(o=l[h]).s=!i&&0!==i||n?o.s+(i||0)+a*o.c:i,o.c=r-o.s,o.e&&(o.e=ca(r)+Ra(o.e)),o.b&&(o.b=o.s+Ra(o.b))}(this,t,e,r,i,n,a)?this.resetTo(t,e,r,i):(Ba(this,0),this.parent||ra(this._dp,this,"_first","_last",this._dp._sort?"_start":0),this.render(0))},e.kill=function kill(t,e){if(void 0===e&&(e="all"),!(t||e&&"all"!==e))return this._lazy=this._pt=0,this.parent?mb(this):this;if(this.timeline){var r=this.timeline.totalDuration();return this.timeline.killTweensOf(t,e,Yt&&!0!==Yt.vars.overwrite)._first||mb(this),this.parent&&r!==this.timeline.totalDuration()&&Ka(this,this._dur*this.timeline._tDur/r,0,1),this}var i,n,a,s,u,h,l,f=this._targets,d=t?xt(t):f,p=this._ptLookup,c=this._pt;if((!e||"all"===e)&&function _arraysMatch(t,e){for(var r=t.length,i=r===e.length;i&&r--&&t[r]===e[r];);return r<0}(f,d))return"all"===e&&(this._pt=0),mb(this);for(i=this._op=this._op||[],"all"!==e&&(o(e)&&(u={},ba(e,function(t){return u[t]=1}),e=u),e=function _addAliasesToVars(t,e){var r,i,n,a,s=t[0]?_(t[0]).harness:0,o=s&&s.aliases;if(!o)return e;for(i in r=mt({},e),o)if(i in r)for(n=(a=o[i].split(",")).length;n--;)r[a[n]]=r[i];return r}(f,e)),l=f.length;l--;)if(~d.indexOf(f[l]))for(u in n=p[l],"all"===e?(i[l]=e,s=n,a={}):(a=i[l]=i[l]||{},s=e),s)(h=n&&n[u])&&("kill"in h.d&&!0!==h.d.kill(u)||sa(this,h,"_pt"),delete n[u]),"all"!==a&&(a[u]=1);return this._initted&&!this._pt&&c&&mb(this),this},Tween.to=function to(t,e,r){return new Tween(t,e,r)},Tween.from=function from(t,e){return Oa(1,arguments)},Tween.delayedCall=function delayedCall(t,e,r,i){return new Tween(e,0,{immediateRender:!1,lazy:!1,overwrite:!1,delay:t,onComplete:e,onReverseComplete:e,onCompleteParams:r,onReverseCompleteParams:r,callbackScope:i})},Tween.fromTo=function fromTo(t,e,r){return Oa(2,arguments)},Tween.set=function set(t,e){return e.duration=0,e.repeatDelay||(e.repeat=0),new Tween(t,e)},Tween.killTweensOf=function killTweensOf(t,e,r){return I.killTweensOf(t,e,r)},Tween}(Nt);ka($t.prototype,{_targets:[],_lazy:0,_startAt:0,_op:0,_onInit:0}),ba("staggerTo,staggerFrom,staggerFromTo",function(r){$t[r]=function(){var t=new Ut,e=wt.call(arguments,0);return e.splice("staggerFromTo"===r?5:4,0,0),t[r].apply(t,e)}});function gc(t,e,r){return t.setAttribute(e,r)}function oc(t,e,r,i){i.mSet(t,e,i.m.call(i.tween,r,i.mt),i)}var Gt=function _setterPlain(t,e,r){return t[e]=r},Wt=function _setterFunc(t,e,r){return t[e](r)},Zt=function _setterFuncWithParam(t,e,r,i){return t[e](i.fp,r)},Ht=function _getSetter(t,e){return p(t[e])?Wt:r(t[e])&&t.setAttribute?gc:Gt},Jt=function _renderPlain(t,e){return e.set(e.t,e.p,Math.round(1e6*(e.s+e.c*t))/1e6,e)},te=function _renderBoolean(t,e){return e.set(e.t,e.p,!!(e.s+e.c*t),e)},ee=function _renderComplexString(t,e){var r=e._pt,i="";if(!t&&e.b)i=e.b;else if(1===t&&e.e)i=e.e;else{for(;r;)i=r.p+(r.m?r.m(r.s+r.c*t):Math.round(1e4*(r.s+r.c*t))/1e4)+i,r=r._next;i+=e.c}e.set(e.t,e.p,i,e)},re=function _renderPropTweens(t,e){for(var r=e._pt;r;)r.r(t,r.d),r=r._next},ie=function _addPluginModifier(t,e,r,i){for(var n,a=this._pt;a;)n=a._next,a.p===i&&a.modifier(t,e,r),a=n},ne=function _killPropTweensOf(t){for(var e,r,i=this._pt;i;)r=i._next,i.p===t&&!i.op||i.op===t?sa(this,i,"_pt"):i.dep||(e=1),i=r;return!e},se=function _sortPropTweensByPriority(t){for(var e,r,i,n,a=t._pt;a;){for(e=a._next,r=i;r&&r.pr>a.pr;)r=r._next;(a._prev=r?r._prev:n)?a._prev._next=a:i=a,(a._next=r)?r._prev=a:n=a,a=e}t._pt=i},oe=(PropTween.prototype.modifier=function modifier(t,e,r){this.mSet=this.mSet||this.set,this.set=oc,this.m=t,this.mt=r,this.tween=e},PropTween);function PropTween(t,e,r,i,n,a,s,o,u){this.t=e,this.s=i,this.c=n,this.p=r,this.r=a||Jt,this.d=s||this,this.set=o||Gt,this.pr=u||0,(this._next=t)&&(t._prev=this)}ba(ct+"parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger",function(t){return ut[t]=1}),ot.TweenMax=ot.TweenLite=$t,ot.TimelineLite=ot.TimelineMax=Ut,I=new Ut({sortChildren:!1,defaults:L,autoRemoveChildren:!0,id:"root",smoothChildTiming:!0}),U.stringFilter=xb;var ue={registerPlugin:function registerPlugin(){for(var t=arguments.length,e=new Array(t),r=0;r<t;r++)e[r]=arguments[r];e.forEach(function(t){return function _createPlugin(t){var e=(t=!t.name&&t.default||t).name,r=p(t),i=e&&!r&&t.init?function(){this._props=[]}:t,n={init:Q,render:re,add:Vt,kill:ne,modifier:ie,rawVars:0},a={targetTest:0,get:0,getSetter:Ht,aliases:{},register:0};if(St(),t!==i){if(ft[e])return;ka(i,ka(oa(t,n),a)),mt(i.prototype,mt(n,oa(t,a))),ft[i.prop=e]=i,t.targetTest&&(pt.push(i),ut[e]=1),e=("css"===e?"CSS":e.charAt(0).toUpperCase()+e.substr(1))+"Plugin"}P(e,i),t.register&&t.register(he,i,oe)}(t)})},timeline:function timeline(t){return new Ut(t)},getTweensOf:function getTweensOf(t,e){return I.getTweensOf(t,e)},getProperty:function getProperty(i,t,e,r){o(i)&&(i=xt(i)[0]);var n=_(i||{}).get,a=e?ja:ia;return"native"===e&&(e=""),i?t?a((ft[t]&&ft[t].get||n)(i,t,e,r)):function(t,e,r){return a((ft[t]&&ft[t].get||n)(i,t,e,r))}:i},quickSetter:function quickSetter(r,e,i){if(1<(r=xt(r)).length){var n=r.map(function(t){return he.quickSetter(t,e,i)}),a=n.length;return function(t){for(var e=a;e--;)n[e](t)}}r=r[0]||{};var s=ft[e],o=_(r),u=o.harness&&(o.harness.aliases||{})[e]||e,h=s?function(t){var e=new s;d._pt=0,e.init(r,i?t+i:t,d,0,[r]),e.render(1,e),d._pt&&re(1,d)}:o.set(r,u);return s?h:function(t){return h(r,u,i?t+i:t,o,1)}},quickTo:function quickTo(t,i,e){function iw(t,e,r){return n.resetTo(i,t,e,r)}var r,n=he.to(t,mt(((r={})[i]="+=0.1",r.paused=!0,r),e||{}));return iw.tween=n,iw},isTweening:function isTweening(t){return 0<I.getTweensOf(t,!0).length},defaults:function defaults(t){return t&&t.ease&&(t.ease=Bt(t.ease,L.ease)),na(L,t||{})},config:function config(t){return na(U,t||{})},registerEffect:function registerEffect(t){var i=t.name,n=t.effect,e=t.plugins,a=t.defaults,r=t.extendTimeline;(e||"").split(",").forEach(function(t){return t&&!ft[t]&&!ot[t]&&O(i+" effect requires "+t+" plugin.")}),dt[i]=function(t,e,r){return n(xt(t),ka(e||{},a),r)},r&&(Ut.prototype[i]=function(t,e,r){return this.add(dt[i](t,s(e)?e:(r=e)&&{},this),r)})},registerEase:function registerEase(t,e){zt[t]=Bt(e)},parseEase:function parseEase(t,e){return arguments.length?Bt(t,e):zt},getById:function getById(t){return I.getById(t)},exportRoot:function exportRoot(e,r){void 0===e&&(e={});var i,n,a=new Ut(e);for(a.smoothChildTiming=t(e.smoothChildTiming),I.remove(a),a._dp=0,a._time=a._tTime=I._time,i=I._first;i;)n=i._next,!r&&!i._dur&&i instanceof $t&&i.vars.onComplete===i._targets[0]||Da(a,i,i._start-i._delay),i=n;return Da(I,a,0),a},utils:{wrap:function wrap(e,t,r){var i=t-e;return J(e)?eb(e,wrap(0,e.length),t):Pa(r,function(t){return(i+(t-e)%i)%i+e})},wrapYoyo:function wrapYoyo(e,t,r){var i=t-e,n=2*i;return J(e)?eb(e,wrapYoyo(0,e.length-1),t):Pa(r,function(t){return e+(i<(t=(n+(t-e)%n)%n||0)?n-t:t)})},distribute:Za,random:ab,snap:_a,normalize:function normalize(t,e,r){return kt(t,e,0,1,r)},getUnit:Ra,clamp:function clamp(e,r,t){return Pa(t,function(t){return bt(e,r,t)})},splitColor:sb,toArray:xt,selector:function selector(r){return r=xt(r)[0]||O("Invalid scope")||{},function(t){var e=r.current||r.nativeElement||r;return xt(t,e.querySelectorAll?e:e===r?O("Invalid scope")||a.createElement("div"):r)}},mapRange:kt,pipe:function pipe(){for(var t=arguments.length,e=new Array(t),r=0;r<t;r++)e[r]=arguments[r];return function(t){return e.reduce(function(t,e){return e(t)},t)}},unitize:function unitize(e,r){return function(t){return e(parseFloat(t))+(r||Ra(t))}},interpolate:function interpolate(e,r,t,i){var n=isNaN(e+r)?0:function(t){return(1-t)*e+t*r};if(!n){var a,s,u,h,l,f=o(e),d={};if(!0===t&&(i=1)&&(t=null),f)e={p:e},r={p:r};else if(J(e)&&!J(r)){for(u=[],h=e.length,l=h-2,s=1;s<h;s++)u.push(interpolate(e[s-1],e[s]));h--,n=function func(t){t*=h;var e=Math.min(l,~~t);return u[e](t-e)},t=r}else i||(e=mt(J(e)?[]:{},e));if(!u){for(a in r)Vt.call(d,e,a,"get",r[a]);n=function func(t){return re(t,d)||(f?e.p:e)}}}return Pa(t,n)},shuffle:Ya},install:M,effects:dt,ticker:Dt,updateRoot:Ut.updateRoot,plugins:ft,globalTimeline:I,core:{PropTween:oe,globals:P,Tween:$t,Timeline:Ut,Animation:Nt,getCache:_,_removeLinkedListItem:sa,suppressOverwrites:function suppressOverwrites(t){return B=t}}};ba("to,from,fromTo,delayedCall,set,killTweensOf",function(t){return ue[t]=$t[t]}),Dt.add(Ut.updateRoot),d=ue.to({},{duration:0});function sc(t,e){for(var r=t._pt;r&&r.p!==e&&r.op!==e&&r.fp!==e;)r=r._next;return r}function uc(t,n){return{name:t,rawVars:1,init:function init(t,i,e){e._onInit=function(t){var e,r;if(o(i)&&(e={},ba(i,function(t){return e[t]=1}),i=e),n){for(r in e={},i)e[r]=n(i[r]);i=e}!function _addModifiers(t,e){var r,i,n,a=t._targets;for(r in e)for(i=a.length;i--;)(n=(n=t._ptLookup[i][r])&&n.d)&&(n._pt&&(n=sc(n,r)),n&&n.modifier&&n.modifier(e[r],t,a[i],r))}(t,i)}}}}var he=ue.registerPlugin({name:"attr",init:function init(t,e,r,i,n){var a,s;for(a in e)(s=this.add(t,"setAttribute",(t.getAttribute(a)||0)+"",e[a],i,n,0,0,a))&&(s.op=a),this._props.push(a)}},{name:"endArray",init:function init(t,e){for(var r=e.length;r--;)this.add(t,r,t[r]||0,e[r])}},uc("roundProps",$a),uc("modifiers"),uc("snap",_a))||ue;$t.version=Ut.version=he.version="3.10.4",l=1,u()&&St();function dd(t,e){return e.set(e.t,e.p,Math.round(1e4*(e.s+e.c*t))/1e4+e.u,e)}function ed(t,e){return e.set(e.t,e.p,1===t?e.e:Math.round(1e4*(e.s+e.c*t))/1e4+e.u,e)}function fd(t,e){return e.set(e.t,e.p,t?Math.round(1e4*(e.s+e.c*t))/1e4+e.u:e.b,e)}function gd(t,e){var r=e.s+e.c*t;e.set(e.t,e.p,~~(r+(r<0?-.5:.5))+e.u,e)}function hd(t,e){return e.set(e.t,e.p,t?e.e:e.b,e)}function id(t,e){return e.set(e.t,e.p,1!==t?e.b:e.e,e)}function jd(t,e,r){return t.style[e]=r}function kd(t,e,r){return t.style.setProperty(e,r)}function ld(t,e,r){return t._gsap[e]=r}function md(t,e,r){return t._gsap.scaleX=t._gsap.scaleY=r}function nd(t,e,r,i,n){var a=t._gsap;a.scaleX=a.scaleY=r,a.renderTransform(n,a)}function od(t,e,r,i,n){var a=t._gsap;a[e]=r,a.renderTransform(n,a)}function sd(t,e){var r=fe.createElementNS?fe.createElementNS((e||"http://www.w3.org/1999/xhtml").replace(/^https/,"http"),t):fe.createElement(t);return r.style?r:fe.createElement(t)}function td(t,e,r){var i=getComputedStyle(t);return i[e]||i.getPropertyValue(e.replace(Ne,"-$1").toLowerCase())||i.getPropertyValue(e)||!r&&td(t,je(e)||e,1)||""}function wd(){(function _windowExists(){return"undefined"!=typeof window})()&&window.document&&(le=window,fe=le.document,de=fe.documentElement,pe=sd("div")||{style:{}},sd("div"),Ve=je(Ve),Xe=Ve+"Origin",pe.style.cssText="border-width:0;line-height:0;position:absolute;padding:0",me=!!je("perspective"),_e=1)}function xd(t){var e,r=sd("svg",this.ownerSVGElement&&this.ownerSVGElement.getAttribute("xmlns")||"http://www.w3.org/2000/svg"),i=this.parentNode,n=this.nextSibling,a=this.style.cssText;if(de.appendChild(r),r.appendChild(this),this.style.display="block",t)try{e=this.getBBox(),this._gsapBBox=this.getBBox,this.getBBox=xd}catch(t){}else this._gsapBBox&&(e=this._gsapBBox());return i&&(n?i.insertBefore(this,n):i.appendChild(this)),de.removeChild(r),this.style.cssText=a,e}function yd(t,e){for(var r=e.length;r--;)if(t.hasAttribute(e[r]))return t.getAttribute(e[r])}function zd(e){var r;try{r=e.getBBox()}catch(t){r=xd.call(e,!0)}return r&&(r.width||r.height)||e.getBBox===xd||(r=xd.call(e,!0)),!r||r.width||r.x||r.y?r:{x:+yd(e,["x","cx","x1"])||0,y:+yd(e,["y","cy","y1"])||0,width:0,height:0}}function Ad(t){return!(!t.getCTM||t.parentNode&&!t.ownerSVGElement||!zd(t))}function Bd(t,e){if(e){var r=t.style;e in Fe&&e!==Xe&&(e=Ve),r.removeProperty?("ms"!==e.substr(0,2)&&"webkit"!==e.substr(0,6)||(e="-"+e),r.removeProperty(e.replace(Ne,"-$1").toLowerCase())):r.removeAttribute(e)}}function Cd(t,e,r,i,n,a){var s=new oe(t._pt,e,r,0,1,a?id:hd);return(t._pt=s).b=i,s.e=n,t._props.push(r),s}function Ed(t,e,r,i){var n,a,s,o,u=parseFloat(r)||0,h=(r+"").trim().substr((u+"").length)||"px",l=pe.style,f=Ue.test(e),d="svg"===t.tagName.toLowerCase(),p=(d?"client":"offset")+(f?"Width":"Height"),c="px"===i,m="%"===i;return i===h||!u||Ke[i]||Ke[h]?u:("px"===h||c||(u=Ed(t,e,r,"px")),o=t.getCTM&&Ad(t),!m&&"%"!==h||!Fe[e]&&!~e.indexOf("adius")?(l[f?"width":"height"]=100+(c?h:i),a=~e.indexOf("adius")||"em"===i&&t.appendChild&&!d?t:t.parentNode,o&&(a=(t.ownerSVGElement||{}).parentNode),a&&a!==fe&&a.appendChild||(a=fe.body),(s=a._gsap)&&m&&s.width&&f&&s.time===Dt.time?ca(u/s.width*100):(!m&&"%"!==h||(l.position=td(t,"position")),a===t&&(l.position="static"),a.appendChild(pe),n=pe[p],a.removeChild(pe),l.position="absolute",f&&m&&((s=_(a)).time=Dt.time,s.width=a[p]),ca(c?n*u/100:n&&u?100/n*u:0))):(n=o?t.getBBox()[f?"width":"height"]:t[p],ca(m?u/n*100:u/100*n)))}function Fd(t,e,r,i){var n;return _e||wd(),e in qe&&"transform"!==e&&~(e=qe[e]).indexOf(",")&&(e=e.split(",")[0]),Fe[e]&&"transform"!==e?(n=He(t,i),n="transformOrigin"!==e?n[e]:n.svg?n.origin:Je(td(t,Xe))+" "+n.zOrigin+"px"):(n=t.style[e])&&"auto"!==n&&!i&&!~(n+"").indexOf("calc(")||(n=Ge[e]&&Ge[e](t,e,r)||td(t,e)||aa(t,e)||("opacity"===e?1:0)),r&&!~(n+"").trim().indexOf(" ")?Ed(t,e,n,r)+r:n}function Gd(t,e,r,i){if(!r||"none"===r){var n=je(e,t,1),a=n&&td(t,n,1);a&&a!==r?(e=n,r=a):"borderColor"===e&&(r=td(t,"borderTopColor"))}var s,o,u,h,l,f,d,_,p,c,m,g=new oe(this._pt,t.style,e,0,1,ee),v=0,y=0;if(g.b=r,g.e=i,r+="","auto"===(i+="")&&(t.style[e]=i,i=td(t,e)||i,t.style[e]=r),xb(s=[r,i]),i=s[1],u=(r=s[0]).match(rt)||[],(i.match(rt)||[]).length){for(;o=rt.exec(i);)d=o[0],p=i.substring(v,o.index),l?l=(l+1)%5:"rgba("!==p.substr(-5)&&"hsla("!==p.substr(-5)||(l=1),d!==(f=u[y++]||"")&&(h=parseFloat(f)||0,m=f.substr((h+"").length),"="===d.charAt(1)&&(d=ea(h,d)+m),_=parseFloat(d),c=d.substr((_+"").length),v=rt.lastIndex-c.length,c||(c=c||U.units[e]||m,v===i.length&&(i+=c,g.e+=c)),m!==c&&(h=Ed(t,e,f,c)||0),g._pt={_next:g._pt,p:p||1===y?p:",",s:h,c:_-h,m:l&&l<4||"zIndex"===e?Math.round:0});g.c=v<i.length?i.substring(v,i.length):""}else g.r="display"===e&&"none"===i?id:hd;return nt.test(i)&&(g.e=0),this._pt=g}function Id(t){var e=t.split(" "),r=e[0],i=e[1]||"50%";return"top"!==r&&"bottom"!==r&&"left"!==i&&"right"!==i||(t=r,r=i,i=t),e[0]=$e[r]||r,e[1]=$e[i]||i,e.join(" ")}function Jd(t,e){if(e.tween&&e.tween._time===e.tween._dur){var r,i,n,a=e.t,s=a.style,o=e.u,u=a._gsap;if("all"===o||!0===o)s.cssText="",i=1;else for(n=(o=o.split(",")).length;-1<--n;)r=o[n],Fe[r]&&(i=1,r="transformOrigin"===r?Xe:Ve),Bd(a,r);i&&(Bd(a,Ve),u&&(u.svg&&a.removeAttribute("transform"),He(a,1),u.uncache=1))}}function Nd(t){return"matrix(1, 0, 0, 1, 0, 0)"===t||"none"===t||!t}function Od(t){var e=td(t,Ve);return Nd(e)?We:e.substr(7).match(et).map(ca)}function Pd(t,e){var r,i,n,a,s=t._gsap||_(t),o=t.style,u=Od(t);return s.svg&&t.getAttribute("transform")?"1,0,0,1,0,0"===(u=[(n=t.transform.baseVal.consolidate().matrix).a,n.b,n.c,n.d,n.e,n.f]).join(",")?We:u:(u!==We||t.offsetParent||t===de||s.svg||(n=o.display,o.display="block",(r=t.parentNode)&&t.offsetParent||(a=1,i=t.nextSibling,de.appendChild(t)),u=Od(t),n?o.display=n:Bd(t,"display"),a&&(i?r.insertBefore(t,i):r?r.appendChild(t):de.removeChild(t))),e&&6<u.length?[u[0],u[1],u[4],u[5],u[12],u[13]]:u)}function Qd(t,e,r,i,n,a){var s,o,u,h=t._gsap,l=n||Pd(t,!0),f=h.xOrigin||0,d=h.yOrigin||0,_=h.xOffset||0,p=h.yOffset||0,c=l[0],m=l[1],g=l[2],v=l[3],y=l[4],T=l[5],b=e.split(" "),w=parseFloat(b[0])||0,x=parseFloat(b[1])||0;r?l!==We&&(o=c*v-m*g)&&(u=w*(-m/o)+x*(c/o)-(c*T-m*y)/o,w=w*(v/o)+x*(-g/o)+(g*T-v*y)/o,x=u):(w=(s=zd(t)).x+(~b[0].indexOf("%")?w/100*s.width:w),x=s.y+(~(b[1]||b[0]).indexOf("%")?x/100*s.height:x)),i||!1!==i&&h.smooth?(y=w-f,T=x-d,h.xOffset=_+(y*c+T*g)-y,h.yOffset=p+(y*m+T*v)-T):h.xOffset=h.yOffset=0,h.xOrigin=w,h.yOrigin=x,h.smooth=!!i,h.origin=e,h.originIsAbsolute=!!r,t.style[Xe]="0px 0px",a&&(Cd(a,h,"xOrigin",f,w),Cd(a,h,"yOrigin",d,x),Cd(a,h,"xOffset",_,h.xOffset),Cd(a,h,"yOffset",p,h.yOffset)),t.setAttribute("data-svg-origin",w+" "+x)}function Td(t,e,r){var i=Ra(e);return ca(parseFloat(e)+parseFloat(Ed(t,"x",r+"px",i)))+i}function $d(t,e,r,i,n){var a,s,u=360,h=o(n),l=parseFloat(n)*(h&&~n.indexOf("rad")?Be:1)-i,f=i+l+"deg";return h&&("short"===(a=n.split("_")[1])&&(l%=u)!==l%180&&(l+=l<0?u:-u),"cw"===a&&l<0?l=(l+36e9)%u-~~(l/u)*u:"ccw"===a&&0<l&&(l=(l-36e9)%u-~~(l/u)*u)),t._pt=s=new oe(t._pt,e,r,i,l,ed),s.e=f,s.u="deg",t._props.push(r),s}function _d(t,e){for(var r in e)t[r]=e[r];return t}function ae(t,e,r){var i,n,a,s,o,u,h,l=_d({},r._gsap),f=r.style;for(n in l.svg?(a=r.getAttribute("transform"),r.setAttribute("transform",""),f[Ve]=e,i=He(r,1),Bd(r,Ve),r.setAttribute("transform",a)):(a=getComputedStyle(r)[Ve],f[Ve]=e,i=He(r,1),f[Ve]=a),Fe)(a=l[n])!==(s=i[n])&&"perspective,force3D,transformOrigin,svgOrigin".indexOf(n)<0&&(o=Ra(a)!==(h=Ra(s))?Ed(r,n,a,h):parseFloat(a),u=parseFloat(s),t._pt=new oe(t._pt,i,n,o,u-o,dd),t._pt.u=h||0,t._props.push(n));_d(i,l)}var le,fe,de,_e,pe,ce,me,ge=zt.Power0,ve=zt.Power1,ye=zt.Power2,Te=zt.Power3,be=zt.Power4,we=zt.Linear,xe=zt.Quad,ke=zt.Cubic,Oe=zt.Quart,Pe=zt.Quint,Me=zt.Strong,Ce=zt.Elastic,Ae=zt.Back,De=zt.SteppedEase,Se=zt.Bounce,ze=zt.Sine,Re=zt.Expo,Ee=zt.Circ,Fe={},Be=180/Math.PI,Ie=Math.PI/180,Le=Math.atan2,Ne=/([A-Z])/g,Ue=/(left|right|width|margin|padding|x)/i,Ye=/[\s,\(]\S/,qe={autoAlpha:"opacity,visibility",scale:"scaleX,scaleY",alpha:"opacity"},Ve="transform",Xe=Ve+"Origin",Qe="O,Moz,ms,Ms,Webkit".split(","),je=function _checkPropPrefix(t,e,r){var i=(e||pe).style,n=5;if(t in i&&!r)return t;for(t=t.charAt(0).toUpperCase()+t.substr(1);n--&&!(Qe[n]+t in i););return n<0?null:(3===n?"ms":0<=n?Qe[n]:"")+t},Ke={deg:1,rad:1,turn:1},$e={top:"0%",bottom:"100%",left:"0%",right:"100%",center:"50%"},Ge={clearProps:function clearProps(t,e,r,i,n){if("isFromStart"!==n.data){var a=t._pt=new oe(t._pt,e,r,0,0,Jd);return a.u=i,a.pr=-10,a.tween=n,t._props.push(r),1}}},We=[1,0,0,1,0,0],Ze={},He=function _parseTransform(t,e){var r=t._gsap||new Lt(t);if("x"in r&&!e&&!r.uncache)return r;var i,n,a,s,o,u,h,l,f,d,_,p,c,m,g,v,y,T,b,w,x,k,O,P,M,C,A,D,S,z,R,E,F=t.style,B=r.scaleX<0,I="deg",L=td(t,Xe)||"0";return i=n=a=u=h=l=f=d=_=0,s=o=1,r.svg=!(!t.getCTM||!Ad(t)),m=Pd(t,r.svg),r.svg&&(P=(!r.uncache||"0px 0px"===L)&&!e&&t.getAttribute("data-svg-origin"),Qd(t,P||L,!!P||r.originIsAbsolute,!1!==r.smooth,m)),p=r.xOrigin||0,c=r.yOrigin||0,m!==We&&(T=m[0],b=m[1],w=m[2],x=m[3],i=k=m[4],n=O=m[5],6===m.length?(s=Math.sqrt(T*T+b*b),o=Math.sqrt(x*x+w*w),u=T||b?Le(b,T)*Be:0,(f=w||x?Le(w,x)*Be+u:0)&&(o*=Math.abs(Math.cos(f*Ie))),r.svg&&(i-=p-(p*T+c*w),n-=c-(p*b+c*x))):(E=m[6],z=m[7],A=m[8],D=m[9],S=m[10],R=m[11],i=m[12],n=m[13],a=m[14],h=(g=Le(E,S))*Be,g&&(P=k*(v=Math.cos(-g))+A*(y=Math.sin(-g)),M=O*v+D*y,C=E*v+S*y,A=k*-y+A*v,D=O*-y+D*v,S=E*-y+S*v,R=z*-y+R*v,k=P,O=M,E=C),l=(g=Le(-w,S))*Be,g&&(v=Math.cos(-g),R=x*(y=Math.sin(-g))+R*v,T=P=T*v-A*y,b=M=b*v-D*y,w=C=w*v-S*y),u=(g=Le(b,T))*Be,g&&(P=T*(v=Math.cos(g))+b*(y=Math.sin(g)),M=k*v+O*y,b=b*v-T*y,O=O*v-k*y,T=P,k=M),h&&359.9<Math.abs(h)+Math.abs(u)&&(h=u=0,l=180-l),s=ca(Math.sqrt(T*T+b*b+w*w)),o=ca(Math.sqrt(O*O+E*E)),g=Le(k,O),f=2e-4<Math.abs(g)?g*Be:0,_=R?1/(R<0?-R:R):0),r.svg&&(P=t.getAttribute("transform"),r.forceCSS=t.setAttribute("transform","")||!Nd(td(t,Ve)),P&&t.setAttribute("transform",P))),90<Math.abs(f)&&Math.abs(f)<270&&(B?(s*=-1,f+=u<=0?180:-180,u+=u<=0?180:-180):(o*=-1,f+=f<=0?180:-180)),e=e||r.uncache,r.x=i-((r.xPercent=i&&(!e&&r.xPercent||(Math.round(t.offsetWidth/2)===Math.round(-i)?-50:0)))?t.offsetWidth*r.xPercent/100:0)+"px",r.y=n-((r.yPercent=n&&(!e&&r.yPercent||(Math.round(t.offsetHeight/2)===Math.round(-n)?-50:0)))?t.offsetHeight*r.yPercent/100:0)+"px",r.z=a+"px",r.scaleX=ca(s),r.scaleY=ca(o),r.rotation=ca(u)+I,r.rotationX=ca(h)+I,r.rotationY=ca(l)+I,r.skewX=f+I,r.skewY=d+I,r.transformPerspective=_+"px",(r.zOrigin=parseFloat(L.split(" ")[2])||0)&&(F[Xe]=Je(L)),r.xOffset=r.yOffset=0,r.force3D=U.force3D,r.renderTransform=r.svg?ar:me?nr:tr,r.uncache=0,r},Je=function _firstTwoOnly(t){return(t=t.split(" "))[0]+" "+t[1]},tr=function _renderNon3DTransforms(t,e){e.z="0px",e.rotationY=e.rotationX="0deg",e.force3D=0,nr(t,e)},er="0deg",rr="0px",ir=") ",nr=function _renderCSSTransforms(t,e){var r=e||this,i=r.xPercent,n=r.yPercent,a=r.x,s=r.y,o=r.z,u=r.rotation,h=r.rotationY,l=r.rotationX,f=r.skewX,d=r.skewY,_=r.scaleX,p=r.scaleY,c=r.transformPerspective,m=r.force3D,g=r.target,v=r.zOrigin,y="",T="auto"===m&&t&&1!==t||!0===m;if(v&&(l!==er||h!==er)){var b,w=parseFloat(h)*Ie,x=Math.sin(w),k=Math.cos(w);w=parseFloat(l)*Ie,b=Math.cos(w),a=Td(g,a,x*b*-v),s=Td(g,s,-Math.sin(w)*-v),o=Td(g,o,k*b*-v+v)}c!==rr&&(y+="perspective("+c+ir),(i||n)&&(y+="translate("+i+"%, "+n+"%) "),!T&&a===rr&&s===rr&&o===rr||(y+=o!==rr||T?"translate3d("+a+", "+s+", "+o+") ":"translate("+a+", "+s+ir),u!==er&&(y+="rotate("+u+ir),h!==er&&(y+="rotateY("+h+ir),l!==er&&(y+="rotateX("+l+ir),f===er&&d===er||(y+="skew("+f+", "+d+ir),1===_&&1===p||(y+="scale("+_+", "+p+ir),g.style[Ve]=y||"translate(0, 0)"},ar=function _renderSVGTransforms(t,e){var r,i,n,a,s,o=e||this,u=o.xPercent,h=o.yPercent,l=o.x,f=o.y,d=o.rotation,_=o.skewX,p=o.skewY,c=o.scaleX,m=o.scaleY,g=o.target,v=o.xOrigin,y=o.yOrigin,T=o.xOffset,b=o.yOffset,w=o.forceCSS,x=parseFloat(l),k=parseFloat(f);d=parseFloat(d),_=parseFloat(_),(p=parseFloat(p))&&(_+=p=parseFloat(p),d+=p),d||_?(d*=Ie,_*=Ie,r=Math.cos(d)*c,i=Math.sin(d)*c,n=Math.sin(d-_)*-m,a=Math.cos(d-_)*m,_&&(p*=Ie,s=Math.tan(_-p),n*=s=Math.sqrt(1+s*s),a*=s,p&&(s=Math.tan(p),r*=s=Math.sqrt(1+s*s),i*=s)),r=ca(r),i=ca(i),n=ca(n),a=ca(a)):(r=c,a=m,i=n=0),(x&&!~(l+"").indexOf("px")||k&&!~(f+"").indexOf("px"))&&(x=Ed(g,"x",l,"px"),k=Ed(g,"y",f,"px")),(v||y||T||b)&&(x=ca(x+v-(v*r+y*n)+T),k=ca(k+y-(v*i+y*a)+b)),(u||h)&&(s=g.getBBox(),x=ca(x+u/100*s.width),k=ca(k+h/100*s.height)),s="matrix("+r+","+i+","+n+","+a+","+x+","+k+")",g.setAttribute("transform",s),w&&(g.style[Ve]=s)};ba("padding,margin,Width,Radius",function(e,r){var t="Right",i="Bottom",n="Left",o=(r<3?["Top",t,i,n]:["Top"+n,"Top"+t,i+t,i+n]).map(function(t){return r<2?e+t:"border"+t+e});Ge[1<r?"border"+e:e]=function(e,t,r,i,n){var a,s;if(arguments.length<4)return a=o.map(function(t){return Fd(e,t,r)}),5===(s=a.join(" ")).split(a[0]).length?a[0]:s;a=(i+"").split(" "),s={},o.forEach(function(t,e){return s[t]=a[e]=a[e]||a[(e-1)/2|0]}),e.init(t,s,n)}});var sr,or,ur,hr={name:"css",register:wd,targetTest:function targetTest(t){return t.style&&t.nodeType},init:function init(t,e,r,i,n){var a,s,u,h,l,f,d,_,p,c,m,g,v,y,T,b=this._props,w=t.style,x=r.vars.startAt;for(d in _e||wd(),e)if("autoRound"!==d&&(s=e[d],!ft[d]||!Ub(d,e,r,i,t,n)))if(l=typeof s,f=Ge[d],"function"===l&&(l=typeof(s=s.call(r,i,t,n))),"string"===l&&~s.indexOf("random(")&&(s=hb(s)),f)f(this,t,d,s,r)&&(T=1);else if("--"===d.substr(0,2))a=(getComputedStyle(t).getPropertyValue(d)+"").trim(),s+="",Ct.lastIndex=0,Ct.test(a)||(_=Ra(a),p=Ra(s)),p?_!==p&&(a=Ed(t,d,a,p)+p):_&&(s+=_),this.add(w,"setProperty",a,s,i,n,0,0,d),b.push(d);else if("undefined"!==l){if(x&&d in x?(a="function"==typeof x[d]?x[d].call(r,i,t,n):x[d],o(a)&&~a.indexOf("random(")&&(a=hb(a)),Ra(a+"")||(a+=U.units[d]||Ra(Fd(t,d))||""),"="===(a+"").charAt(1)&&(a=Fd(t,d))):a=Fd(t,d),h=parseFloat(a),(c="string"===l&&"="===s.charAt(1)&&s.substr(0,2))&&(s=s.substr(2)),u=parseFloat(s),d in qe&&("autoAlpha"===d&&(1===h&&"hidden"===Fd(t,"visibility")&&u&&(h=0),Cd(this,w,"visibility",h?"inherit":"hidden",u?"inherit":"hidden",!u)),"scale"!==d&&"transform"!==d&&~(d=qe[d]).indexOf(",")&&(d=d.split(",")[0])),m=d in Fe)if(g||((v=t._gsap).renderTransform&&!e.parseTransform||He(t,e.parseTransform),y=!1!==e.smoothOrigin&&v.smooth,(g=this._pt=new oe(this._pt,w,Ve,0,1,v.renderTransform,v,0,-1)).dep=1),"scale"===d)this._pt=new oe(this._pt,v,"scaleY",v.scaleY,(c?ea(v.scaleY,c+u):u)-v.scaleY||0),b.push("scaleY",d),d+="X";else{if("transformOrigin"===d){s=Id(s),v.svg?Qd(t,s,0,y,0,this):((p=parseFloat(s.split(" ")[2])||0)!==v.zOrigin&&Cd(this,v,"zOrigin",v.zOrigin,p),Cd(this,w,d,Je(a),Je(s)));continue}if("svgOrigin"===d){Qd(t,s,1,y,0,this);continue}if(d in Ze){$d(this,v,d,h,c?ea(h,c+s):s);continue}if("smoothOrigin"===d){Cd(this,v,"smooth",v.smooth,s);continue}if("force3D"===d){v[d]=s;continue}if("transform"===d){ae(this,s,t);continue}}else d in w||(d=je(d)||d);if(m||(u||0===u)&&(h||0===h)&&!Ye.test(s)&&d in w)u=u||0,(_=(a+"").substr((h+"").length))!==(p=Ra(s)||(d in U.units?U.units[d]:_))&&(h=Ed(t,d,a,p)),this._pt=new oe(this._pt,m?v:w,d,h,(c?ea(h,c+u):u)-h,m||"px"!==p&&"zIndex"!==d||!1===e.autoRound?dd:gd),this._pt.u=p||0,_!==p&&"%"!==p&&(this._pt.b=a,this._pt.r=fd);else if(d in w)Gd.call(this,t,d,a,c?c+s:s);else{if(!(d in t)){N(d,s);continue}this.add(t,d,a||t[d],c?c+s:s,i,n)}b.push(d)}T&&se(this)},get:Fd,aliases:qe,getSetter:function getSetter(t,e,i){var n=qe[e];return n&&n.indexOf(",")<0&&(e=n),e in Fe&&e!==Xe&&(t._gsap.x||Fd(t,"x"))?i&&ce===i?"scale"===e?md:ld:(ce=i||{})&&("scale"===e?nd:od):t.style&&!r(t.style[e])?jd:~e.indexOf("-")?kd:Ht(t,e)},core:{_removeProperty:Bd,_getMatrix:Pd}};he.utils.checkPrefix=je,ur=ba((sr="x,y,z,scale,scaleX,scaleY,xPercent,yPercent")+","+(or="rotation,rotationX,rotationY,skewX,skewY")+",transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective",function(t){Fe[t]=1}),ba(or,function(t){U.units[t]="deg",Ze[t]=1}),qe[ur[13]]=sr+","+or,ba("0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY",function(t){var e=t.split(":");qe[e[1]]=ur[e[0]]}),ba("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective",function(t){U.units[t]="px"}),he.registerPlugin(hr);var lr=he.registerPlugin(hr)||he,fr=lr.core.Tween;e.Back=Ae,e.Bounce=Se,e.CSSPlugin=hr,e.Circ=Ee,e.Cubic=ke,e.Elastic=Ce,e.Expo=Re,e.Linear=we,e.Power0=ge,e.Power1=ve,e.Power2=ye,e.Power3=Te,e.Power4=be,e.Quad=xe,e.Quart=Oe,e.Quint=Pe,e.Sine=ze,e.SteppedEase=De,e.Strong=Me,e.TimelineLite=Ut,e.TimelineMax=Ut,e.TweenLite=$t,e.TweenMax=fr,e.default=lr,e.gsap=lr;if (typeof(window)==="undefined"||window!==e){Object.defineProperty(e,"__esModule",{value:!0})} else {delete e.default}});
 
 
 
 //------------------------------------------
 /*!
 * Customized version of iScroll.js 0.0.8
 * It fixes bugs affecting its integration with fullpage.js
 */
 /*! iScroll v5.2.0 ~ (c) 2008-2016 Matteo Spinelli ~ http://cubiq.org/license */
 (function (window, document, Math) {
 var rAF = window.requestAnimationFrame  ||
     window.webkitRequestAnimationFrame  ||
     window.mozRequestAnimationFrame     ||
     window.oRequestAnimationFrame       ||
     window.msRequestAnimationFrame      ||
     function (callback) { window.setTimeout(callback, 1000 / 60); };
 
 var utils = (function () {
     var me = {};
 
     var _elementStyle = document.createElement('div').style;
     var _vendor = (function () {
         var vendors = ['t', 'webkitT', 'MozT', 'msT', 'OT'],
             transform,
             i = 0,
             l = vendors.length;
 
         for ( ; i < l; i++ ) {
             transform = vendors[i] + 'ransform';
             if ( transform in _elementStyle ) return vendors[i].substr(0, vendors[i].length-1);
         }
 
         return false;
     })();
 
     function _prefixStyle (style) {
         if ( _vendor === false ) return false;
         if ( _vendor === '' ) return style;
         return _vendor + style.charAt(0).toUpperCase() + style.substr(1);
     }
 
     me.getTime = Date.now || function getTime () { return new Date().getTime(); };
 
     me.extend = function (target, obj) {
         for ( var i in obj ) {
             target[i] = obj[i];
         }
     };
 
     me.addEvent = function (el, type, fn, capture) {
         el.addEventListener(type, fn, !!capture);
     };
 
     me.removeEvent = function (el, type, fn, capture) {
         el.removeEventListener(type, fn, !!capture);
     };
 
     me.prefixPointerEvent = function (pointerEvent) {
         return window.MSPointerEvent ?
             'MSPointer' + pointerEvent.charAt(7).toUpperCase() + pointerEvent.substr(8):
             pointerEvent;
     };
 
     me.momentum = function (current, start, time, lowerMargin, wrapperSize, deceleration) {
         var distance = current - start,
             speed = Math.abs(distance) / time,
             destination,
             duration;
 
         deceleration = deceleration === undefined ? 0.0006 : deceleration;
 
         destination = current + ( speed * speed ) / ( 2 * deceleration ) * ( distance < 0 ? -1 : 1 );
         duration = speed / deceleration;
 
         if ( destination < lowerMargin ) {
             destination = wrapperSize ? lowerMargin - ( wrapperSize / 2.5 * ( speed / 8 ) ) : lowerMargin;
             distance = Math.abs(destination - current);
             duration = distance / speed;
         } else if ( destination > 0 ) {
             destination = wrapperSize ? wrapperSize / 2.5 * ( speed / 8 ) : 0;
             distance = Math.abs(current) + destination;
             duration = distance / speed;
         }
 
         return {
             destination: Math.round(destination),
             duration: duration
         };
     };
 
     var _transform = _prefixStyle('transform');
 
     me.extend(me, {
         hasTransform: _transform !== false,
         hasPerspective: _prefixStyle('perspective') in _elementStyle,
         hasTouch: 'ontouchstart' in window,
         hasPointer: !!(window.PointerEvent || window.MSPointerEvent), // IE10 is prefixed
         hasTransition: _prefixStyle('transition') in _elementStyle
     });
 
     /*
     This should find all Android browsers lower than build 535.19 (both stock browser and webview)
     - galaxy S2 is ok
     - 2.3.6 : `AppleWebKit/533.1 (KHTML, like Gecko) Version/4.0 Mobile Safari/533.1`
     - 4.0.4 : `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
    - galaxy S3 is badAndroid (stock brower, webview)
      `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
    - galaxy S4 is badAndroid (stock brower, webview)
      `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
    - galaxy S5 is OK
      `AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Mobile Safari/537.36 (Chrome/)`
    - galaxy S6 is OK
      `AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Mobile Safari/537.36 (Chrome/)`
   */
     me.isBadAndroid = (function() {
         var appVersion = window.navigator.appVersion;
         // Android browser is not a chrome browser.
         if (/Android/.test(appVersion) && !(/Chrome\/\d/.test(appVersion))) {
             var safariVersion = appVersion.match(/Safari\/(\d+.\d)/);
             if(safariVersion && typeof safariVersion === "object" && safariVersion.length >= 2) {
                 return parseFloat(safariVersion[1]) < 535.19;
             } else {
                 return true;
             }
         } else {
             return false;
         }
     })();
 
     me.extend(me.style = {}, {
         transform: _transform,
         transitionTimingFunction: _prefixStyle('transitionTimingFunction'),
         transitionDuration: _prefixStyle('transitionDuration'),
         transitionDelay: _prefixStyle('transitionDelay'),
         transformOrigin: _prefixStyle('transformOrigin')
     });
 
     me.hasClass = function (e, c) {
         var re = new RegExp("(^|\\s)" + c + "(\\s|$)");
         return re.test(e.className);
     };
 
     me.addClass = function (e, c) {
         if ( me.hasClass(e, c) ) {
             return;
         }
 
         var newclass = e.className.split(' ');
         newclass.push(c);
         e.className = newclass.join(' ');
     };
 
     me.removeClass = function (e, c) {
         if ( !me.hasClass(e, c) ) {
             return;
         }
 
         var re = new RegExp("(^|\\s)" + c + "(\\s|$)", 'g');
         e.className = e.className.replace(re, ' ');
     };
 
     me.offset = function (el) {
         var left = -el.offsetLeft,
             top = -el.offsetTop;
 
         // jshint -W084
         while (el = el.offsetParent) {
             left -= el.offsetLeft;
             top -= el.offsetTop;
         }
         // jshint +W084
 
         return {
             left: left,
             top: top
         };
     };
 
     me.preventDefaultException = function (el, exceptions) {
         for ( var i in exceptions ) {
             if ( exceptions[i].test(el[i]) ) {
                 return true;
             }
         }
 
         return false;
     };
 
     me.extend(me.eventType = {}, {
         touchstart: 1,
         touchmove: 1,
         touchend: 1,
 
         mousedown: 2,
         mousemove: 2,
         mouseup: 2,
 
         pointerdown: 3,
         pointermove: 3,
         pointerup: 3,
 
         MSPointerDown: 3,
         MSPointerMove: 3,
         MSPointerUp: 3
     });
 
     me.extend(me.ease = {}, {
         quadratic: {
             style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
             fn: function (k) {
                 return k * ( 2 - k );
             }
         },
         circular: {
             style: 'cubic-bezier(0.1, 0.57, 0.1, 1)',   // Not properly "circular" but this looks better, it should be (0.075, 0.82, 0.165, 1)
             fn: function (k) {
                 return Math.sqrt( 1 - ( --k * k ) );
             }
         },
         back: {
             style: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
             fn: function (k) {
                 var b = 4;
                 return ( k = k - 1 ) * k * ( ( b + 1 ) * k + b ) + 1;
             }
         },
         bounce: {
             style: '',
             fn: function (k) {
                 if ( ( k /= 1 ) < ( 1 / 2.75 ) ) {
                     return 7.5625 * k * k;
                 } else if ( k < ( 2 / 2.75 ) ) {
                     return 7.5625 * ( k -= ( 1.5 / 2.75 ) ) * k + 0.75;
                 } else if ( k < ( 2.5 / 2.75 ) ) {
                     return 7.5625 * ( k -= ( 2.25 / 2.75 ) ) * k + 0.9375;
                 } else {
                     return 7.5625 * ( k -= ( 2.625 / 2.75 ) ) * k + 0.984375;
                 }
             }
         },
         elastic: {
             style: '',
             fn: function (k) {
                 var f = 0.22,
                     e = 0.4;
 
                 if ( k === 0 ) { return 0; }
                 if ( k == 1 ) { return 1; }
 
                 return ( e * Math.pow( 2, - 10 * k ) * Math.sin( ( k - f / 4 ) * ( 2 * Math.PI ) / f ) + 1 );
             }
         }
     });
 
     me.tap = function (e, eventName) {
         var ev = document.createEvent('Event');
         ev.initEvent(eventName, true, true);
         ev.pageX = e.pageX;
         ev.pageY = e.pageY;
         e.target.dispatchEvent(ev);
     };
 
     me.click = function (e) {
         var target = e.target,
             ev;
 
         if ( !(/(SELECT|INPUT|TEXTAREA)/i).test(target.tagName) ) {
             // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/initMouseEvent
             // initMouseEvent is deprecated.
             ev = document.createEvent(window.MouseEvent ? 'MouseEvents' : 'Event');
             ev.initEvent('click', true, true);
             ev.view = e.view || window;
             ev.detail = 1;
             ev.screenX = target.screenX || 0;
             ev.screenY = target.screenY || 0;
             ev.clientX = target.clientX || 0;
             ev.clientY = target.clientY || 0;
             ev.ctrlKey = !!e.ctrlKey;
             ev.altKey = !!e.altKey;
             ev.shiftKey = !!e.shiftKey;
             ev.metaKey = !!e.metaKey;
             ev.button = 0;
             ev.relatedTarget = null;
             ev._constructed = true;
             target.dispatchEvent(ev);
         }
     };
 
     return me;
 })();
 function IScroll (el, options) {
     this.wrapper = typeof el == 'string' ? document.querySelector(el) : el;
     this.scroller = this.wrapper.children[0];
     this.scrollerStyle = this.scroller.style;       // cache style for better performance
 
     this.options = {
 
         resizeScrollbars: true,
 
         mouseWheelSpeed: 20,
 
         snapThreshold: 0.334,
 
 // INSERT POINT: OPTIONS
         disablePointer : !utils.hasPointer,
         disableTouch : utils.hasPointer || !utils.hasTouch,
         disableMouse : utils.hasPointer || utils.hasTouch,
         startX: 0,
         startY: 0,
         scrollY: true,
         directionLockThreshold: 5,
         momentum: true,
 
         bounce: true,
         bounceTime: 600,
         bounceEasing: '',
 
         preventDefault: true,
         preventDefaultException: { tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT|LABEL)$/ },
 
         HWCompositing: true,
         useTransition: true,
         useTransform: true,
         bindToWrapper: typeof window.onmousedown === "undefined"
     };
 
     for ( var i in options ) {
         this.options[i] = options[i];
     }
 
     // Normalize options
     this.translateZ = this.options.HWCompositing && utils.hasPerspective ? ' translateZ(0)' : '';
 
     this.options.useTransition = utils.hasTransition && this.options.useTransition;
     this.options.useTransform = utils.hasTransform && this.options.useTransform;
 
     this.options.eventPassthrough = this.options.eventPassthrough === true ? 'vertical' : this.options.eventPassthrough;
     this.options.preventDefault = !this.options.eventPassthrough && this.options.preventDefault;
 
     // If you want eventPassthrough I have to lock one of the axes
     this.options.scrollY = this.options.eventPassthrough == 'vertical' ? false : this.options.scrollY;
     this.options.scrollX = this.options.eventPassthrough == 'horizontal' ? false : this.options.scrollX;
 
     // With eventPassthrough we also need lockDirection mechanism
     this.options.freeScroll = this.options.freeScroll && !this.options.eventPassthrough;
     this.options.directionLockThreshold = this.options.eventPassthrough ? 0 : this.options.directionLockThreshold;
 
     this.options.bounceEasing = typeof this.options.bounceEasing == 'string' ? utils.ease[this.options.bounceEasing] || utils.ease.circular : this.options.bounceEasing;
 
     this.options.resizePolling = this.options.resizePolling === undefined ? 60 : this.options.resizePolling;
 
     if ( this.options.tap === true ) {
         this.options.tap = 'tap';
     }
 
     // https://github.com/cubiq/iscroll/issues/1029
     if (!this.options.useTransition && !this.options.useTransform) {
         if(!(/relative|absolute/i).test(this.scrollerStyle.position)) {
             this.scrollerStyle.position = "relative";
         }
     }
 
     if ( this.options.shrinkScrollbars == 'scale' ) {
         this.options.useTransition = false;
     }
 
     this.options.invertWheelDirection = this.options.invertWheelDirection ? -1 : 1;
 
 // INSERT POINT: NORMALIZATION
 
     // Some defaults
     this.x = 0;
     this.y = 0;
     this.directionX = 0;
     this.directionY = 0;
     this._events = {};
 
 // INSERT POINT: DEFAULTS
 
     this._init();
     this.refresh();
 
     this.scrollTo(this.options.startX, this.options.startY);
     this.enable();
 }
 
 IScroll.prototype = {
     version: '5.2.0',
 
     _init: function () {
         this._initEvents();
 
         if ( this.options.scrollbars || this.options.indicators ) {
             this._initIndicators();
         }
 
         if ( this.options.mouseWheel ) {
             this._initWheel();
         }
 
         if ( this.options.snap ) {
             this._initSnap();
         }
 
         if ( this.options.keyBindings ) {
             this._initKeys();
         }
 
 // INSERT POINT: _init
 
     },
 
     destroy: function () {
         this._initEvents(true);
         clearTimeout(this.resizeTimeout);
         this.resizeTimeout = null;
         this._execEvent('destroy');
     },
 
     _transitionEnd: function (e) {
         if ( e.target != this.scroller || !this.isInTransition ) {
             return;
         }
 
         this._transitionTime();
         if ( !this.resetPosition(this.options.bounceTime) ) {
             this.isInTransition = false;
             this._execEvent('scrollEnd');
         }
     },
 
     _start: function (e) {
         // React to left mouse button only
         if ( utils.eventType[e.type] != 1 ) {
           // for button property
           // http://unixpapa.com/js/mouse.html
           var button;
         if (!e.which) {
           /* IE case */
           button = (e.button < 2) ? 0 :
                    ((e.button == 4) ? 1 : 2);
         } else {
           /* All others */
           button = e.button;
         }
             if ( button !== 0 ) {
                 return;
             }
         }
 
         if ( !this.enabled || (this.initiated && utils.eventType[e.type] !== this.initiated) ) {
             return;
         }
 
         if ( this.options.preventDefault && !utils.isBadAndroid && !utils.preventDefaultException(e.target, this.options.preventDefaultException) ) {
             e.preventDefault();
         }
 
         var point = e.touches ? e.touches[0] : e,
             pos;
 
         this.initiated  = utils.eventType[e.type];
         this.moved      = false;
         this.distX      = 0;
         this.distY      = 0;
         this.directionX = 0;
         this.directionY = 0;
         this.directionLocked = 0;
 
         this.startTime = utils.getTime();
 
         if ( this.options.useTransition && this.isInTransition ) {
             this._transitionTime();
             this.isInTransition = false;
             pos = this.getComputedPosition();
             this._translate(Math.round(pos.x), Math.round(pos.y));
             this._execEvent('scrollEnd');
         } else if ( !this.options.useTransition && this.isAnimating ) {
             this.isAnimating = false;
             this._execEvent('scrollEnd');
         }
 
         this.startX    = this.x;
         this.startY    = this.y;
         this.absStartX = this.x;
         this.absStartY = this.y;
         this.pointX    = point.pageX;
         this.pointY    = point.pageY;
 
         this._execEvent('beforeScrollStart');
     },
 
     _move: function (e) {
         if ( !this.enabled || utils.eventType[e.type] !== this.initiated ) {
             return;
         }
 
         if ( this.options.preventDefault ) {    // increases performance on Android? TODO: check!
             e.preventDefault();
         }
 
         var point       = e.touches ? e.touches[0] : e,
             deltaX      = point.pageX - this.pointX,
             deltaY      = point.pageY - this.pointY,
             timestamp   = utils.getTime(),
             newX, newY,
             absDistX, absDistY;
 
         this.pointX     = point.pageX;
         this.pointY     = point.pageY;
 
         this.distX      += deltaX;
         this.distY      += deltaY;
         absDistX        = Math.abs(this.distX);
         absDistY        = Math.abs(this.distY);
 
         // We need to move at least 10 pixels for the scrolling to initiate
         if ( timestamp - this.endTime > 300 && (absDistX < 10 && absDistY < 10) ) {
             return;
         }
 
         // If you are scrolling in one direction lock the other
         if ( !this.directionLocked && !this.options.freeScroll ) {
             if ( absDistX > absDistY + this.options.directionLockThreshold ) {
                 this.directionLocked = 'h';     // lock horizontally
             } else if ( absDistY >= absDistX + this.options.directionLockThreshold ) {
                 this.directionLocked = 'v';     // lock vertically
             } else {
                 this.directionLocked = 'n';     // no lock
             }
         }
 
         if ( this.directionLocked == 'h' ) {
             if ( this.options.eventPassthrough == 'vertical' ) {
                 e.preventDefault();
             } else if ( this.options.eventPassthrough == 'horizontal' ) {
                 this.initiated = false;
                 return;
             }
 
             deltaY = 0;
         } else if ( this.directionLocked == 'v' ) {
             if ( this.options.eventPassthrough == 'horizontal' ) {
                 e.preventDefault();
             } else if ( this.options.eventPassthrough == 'vertical' ) {
                 this.initiated = false;
                 return;
             }
 
             deltaX = 0;
         }
 
         deltaX = this.hasHorizontalScroll ? deltaX : 0;
         deltaY = this.hasVerticalScroll ? deltaY : 0;
 
         newX = this.x + deltaX;
         newY = this.y + deltaY;
 
         // Slow down if outside of the boundaries
         if ( newX > 0 || newX < this.maxScrollX ) {
             newX = this.options.bounce ? this.x + deltaX / 3 : newX > 0 ? 0 : this.maxScrollX;
         }
         if ( newY > 0 || newY < this.maxScrollY ) {
             newY = this.options.bounce ? this.y + deltaY / 3 : newY > 0 ? 0 : this.maxScrollY;
         }
 
         this.directionX = deltaX > 0 ? -1 : deltaX < 0 ? 1 : 0;
         this.directionY = deltaY > 0 ? -1 : deltaY < 0 ? 1 : 0;
 
         if ( !this.moved ) {
             this._execEvent('scrollStart');
         }
 
         this.moved = true;
 
         this._translate(newX, newY);
 
 /* REPLACE START: _move */
 
         if ( timestamp - this.startTime > 300 ) {
             this.startTime = timestamp;
             this.startX = this.x;
             this.startY = this.y;
         }
 
 /* REPLACE END: _move */
 
     },
 
     _end: function (e) {
         if ( !this.enabled || utils.eventType[e.type] !== this.initiated ) {
             return;
         }
 
         if ( this.options.preventDefault && !utils.preventDefaultException(e.target, this.options.preventDefaultException) ) {
             e.preventDefault();
         }
 
         var point = e.changedTouches ? e.changedTouches[0] : e,
             momentumX,
             momentumY,
             duration = utils.getTime() - this.startTime,
             newX = Math.round(this.x),
             newY = Math.round(this.y),
             distanceX = Math.abs(newX - this.startX),
             distanceY = Math.abs(newY - this.startY),
             time = 0,
             easing = '';
 
         this.isInTransition = 0;
         this.initiated = 0;
         this.endTime = utils.getTime();
 
         // reset if we are outside of the boundaries
         if ( this.resetPosition(this.options.bounceTime) ) {
             return;
         }
 
         this.scrollTo(newX, newY);  // ensures that the last position is rounded
 
         // we scrolled less than 10 pixels
         if ( !this.moved ) {
             if ( this.options.tap ) {
                 utils.tap(e, this.options.tap);
             }
 
             if ( this.options.click ) {
                 utils.click(e);
             }
 
             this._execEvent('scrollCancel');
             return;
         }
 
         if ( this._events.flick && duration < 200 && distanceX < 100 && distanceY < 100 ) {
             this._execEvent('flick');
             return;
         }
 
         // start momentum animation if needed
         if ( this.options.momentum && duration < 300 ) {
             momentumX = this.hasHorizontalScroll ? utils.momentum(this.x, this.startX, duration, this.maxScrollX, this.options.bounce ? this.wrapperWidth : 0, this.options.deceleration) : { destination: newX, duration: 0 };
             momentumY = this.hasVerticalScroll ? utils.momentum(this.y, this.startY, duration, this.maxScrollY, this.options.bounce ? this.wrapperHeight : 0, this.options.deceleration) : { destination: newY, duration: 0 };
             newX = momentumX.destination;
             newY = momentumY.destination;
             time = Math.max(momentumX.duration, momentumY.duration);
             this.isInTransition = 1;
         }
 
 
         if ( this.options.snap ) {
             var snap = this._nearestSnap(newX, newY);
             this.currentPage = snap;
             time = this.options.snapSpeed || Math.max(
                     Math.max(
                         Math.min(Math.abs(newX - snap.x), 1000),
                         Math.min(Math.abs(newY - snap.y), 1000)
                     ), 300);
             newX = snap.x;
             newY = snap.y;
 
             this.directionX = 0;
             this.directionY = 0;
             easing = this.options.bounceEasing;
         }
 
 // INSERT POINT: _end
 
         if ( newX != this.x || newY != this.y ) {
             // change easing function when scroller goes out of the boundaries
             if ( newX > 0 || newX < this.maxScrollX || newY > 0 || newY < this.maxScrollY ) {
                 easing = utils.ease.quadratic;
             }
 
             this.scrollTo(newX, newY, time, easing);
             return;
         }
 
         this._execEvent('scrollEnd');
     },
 
     _resize: function () {
         var that = this;
 
         clearTimeout(this.resizeTimeout);
 
         this.resizeTimeout = setTimeout(function () {
             that.refresh();
         }, this.options.resizePolling);
     },
 
     resetPosition: function (time) {
         var x = this.x,
             y = this.y;
 
         time = time || 0;
 
         if ( !this.hasHorizontalScroll || this.x > 0 ) {
             x = 0;
         } else if ( this.x < this.maxScrollX ) {
             x = this.maxScrollX;
         }
 
         if ( !this.hasVerticalScroll || this.y > 0 ) {
             y = 0;
         } else if ( this.y < this.maxScrollY ) {
             y = this.maxScrollY;
         }
 
         if ( x == this.x && y == this.y ) {
             return false;
         }
 
         this.scrollTo(x, y, time, this.options.bounceEasing);
 
         return true;
     },
 
     disable: function () {
         this.enabled = false;
     },
 
     enable: function () {
         this.enabled = true;
     },
 
     refresh: function () {
         var rf = this.wrapper.offsetHeight;     // Force reflow
 
         this.wrapperWidth   = this.wrapper.clientWidth;
         this.wrapperHeight  = this.wrapper.clientHeight;
 
 /* REPLACE START: refresh */
 
         this.scrollerWidth  = this.scroller.offsetWidth;
         this.scrollerHeight = this.scroller.offsetHeight;
 
         this.maxScrollX     = this.wrapperWidth - this.scrollerWidth;
         this.maxScrollY     = this.wrapperHeight - this.scrollerHeight;
 
 /* REPLACE END: refresh */
 
         this.hasHorizontalScroll    = this.options.scrollX && this.maxScrollX < 0;
         this.hasVerticalScroll      = this.options.scrollY && this.maxScrollY < 0;
 
         if ( !this.hasHorizontalScroll ) {
             this.maxScrollX = 0;
             this.scrollerWidth = this.wrapperWidth;
         }
 
         if ( !this.hasVerticalScroll ) {
             this.maxScrollY = 0;
             this.scrollerHeight = this.wrapperHeight;
         }
 
         this.endTime = 0;
         this.directionX = 0;
         this.directionY = 0;
 
         this.wrapperOffset = utils.offset(this.wrapper);
 
         this._execEvent('refresh');
 
         this.resetPosition();
 
 // INSERT POINT: _refresh
 
     },
 
     on: function (type, fn) {
         if ( !this._events[type] ) {
             this._events[type] = [];
         }
 
         this._events[type].push(fn);
     },
 
     off: function (type, fn) {
         if ( !this._events[type] ) {
             return;
         }
 
         var index = this._events[type].indexOf(fn);
 
         if ( index > -1 ) {
             this._events[type].splice(index, 1);
         }
     },
 
     _execEvent: function (type) {
         if ( !this._events[type] ) {
             return;
         }
 
         var i = 0,
             l = this._events[type].length;
 
         if ( !l ) {
             return;
         }
 
         for ( ; i < l; i++ ) {
             this._events[type][i].apply(this, [].slice.call(arguments, 1));
         }
     },
 
     scrollBy: function (x, y, time, easing) {
         x = this.x + x;
         y = this.y + y;
         time = time || 0;
 
         this.scrollTo(x, y, time, easing);
     },
 
     scrollTo: function (x, y, time, easing) {
         easing = easing || utils.ease.circular;
 
         this.isInTransition = this.options.useTransition && time > 0;
         var transitionType = this.options.useTransition && easing.style;
         if ( !time || transitionType ) {
                 if(transitionType) {
                     this._transitionTimingFunction(easing.style);
                     this._transitionTime(time);
                 }
             this._translate(x, y);
         } else {
             this._animate(x, y, time, easing.fn);
         }
     },
 
     scrollToElement: function (el, time, offsetX, offsetY, easing) {
         el = el.nodeType ? el : this.scroller.querySelector(el);
 
         if ( !el ) {
             return;
         }
 
         var pos = utils.offset(el);
 
         pos.left -= this.wrapperOffset.left;
         pos.top  -= this.wrapperOffset.top;
 
         // if offsetX/Y are true we center the element to the screen
         if ( offsetX === true ) {
             offsetX = Math.round(el.offsetWidth / 2 - this.wrapper.offsetWidth / 2);
         }
         if ( offsetY === true ) {
             offsetY = Math.round(el.offsetHeight / 2 - this.wrapper.offsetHeight / 2);
         }
 
         pos.left -= offsetX || 0;
         pos.top  -= offsetY || 0;
 
         pos.left = pos.left > 0 ? 0 : pos.left < this.maxScrollX ? this.maxScrollX : pos.left;
         pos.top  = pos.top  > 0 ? 0 : pos.top  < this.maxScrollY ? this.maxScrollY : pos.top;
 
         time = time === undefined || time === null || time === 'auto' ? Math.max(Math.abs(this.x-pos.left), Math.abs(this.y-pos.top)) : time;
 
         this.scrollTo(pos.left, pos.top, time, easing);
     },
 
     _transitionTime: function (time) {
         if (!this.options.useTransition) {
             return;
         }
         time = time || 0;
         var durationProp = utils.style.transitionDuration;
         if(!durationProp) {
             return;
         }
 
         this.scrollerStyle[durationProp] = time + 'ms';
 
         if ( !time && utils.isBadAndroid ) {
             this.scrollerStyle[durationProp] = '0.0001ms';
             // remove 0.0001ms
             var self = this;
             rAF(function() {
                 if(self.scrollerStyle[durationProp] === '0.0001ms') {
                     self.scrollerStyle[durationProp] = '0s';
                 }
             });
         }
 
 
         if ( this.indicators ) {
             for ( var i = this.indicators.length; i--; ) {
                 this.indicators[i].transitionTime(time);
             }
         }
 
 
 // INSERT POINT: _transitionTime
 
     },
 
     _transitionTimingFunction: function (easing) {
         this.scrollerStyle[utils.style.transitionTimingFunction] = easing;
 
 
         if ( this.indicators ) {
             for ( var i = this.indicators.length; i--; ) {
                 this.indicators[i].transitionTimingFunction(easing);
             }
         }
 
 
 // INSERT POINT: _transitionTimingFunction
 
     },
 
     _translate: function (x, y) {
         if ( this.options.useTransform ) {
 
 /* REPLACE START: _translate */
 
             this.scrollerStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.translateZ;
 
 /* REPLACE END: _translate */
 
         } else {
             x = Math.round(x);
             y = Math.round(y);
             this.scrollerStyle.left = x + 'px';
             this.scrollerStyle.top = y + 'px';
         }
 
         this.x = x;
         this.y = y;
 
 
     if ( this.indicators ) {
         for ( var i = this.indicators.length; i--; ) {
             this.indicators[i].updatePosition();
         }
     }
 
 
 // INSERT POINT: _translate
 
     },
 
     _initEvents: function (remove) {
         var eventType = remove ? utils.removeEvent : utils.addEvent,
             target = this.options.bindToWrapper ? this.wrapper : window;
 
         eventType(window, 'orientationchange', this);
         eventType(window, 'resize', this);
 
         if ( this.options.click ) {
             eventType(this.wrapper, 'click', this, true);
         }
 
         if ( !this.options.disableMouse ) {
             eventType(this.wrapper, 'mousedown', this);
             eventType(target, 'mousemove', this);
             eventType(target, 'mousecancel', this);
             eventType(target, 'mouseup', this);
         }
 
         if ( utils.hasPointer && !this.options.disablePointer ) {
             eventType(this.wrapper, utils.prefixPointerEvent('pointerdown'), this);
             eventType(target, utils.prefixPointerEvent('pointermove'), this);
             eventType(target, utils.prefixPointerEvent('pointercancel'), this);
             eventType(target, utils.prefixPointerEvent('pointerup'), this);
         }
 
         if ( utils.hasTouch && !this.options.disableTouch ) {
             eventType(this.wrapper, 'touchstart', this);
             eventType(target, 'touchmove', this);
             eventType(target, 'touchcancel', this);
             eventType(target, 'touchend', this);
         }
 
         eventType(this.scroller, 'transitionend', this);
         eventType(this.scroller, 'webkitTransitionEnd', this);
         eventType(this.scroller, 'oTransitionEnd', this);
         eventType(this.scroller, 'MSTransitionEnd', this);
     },
 
     getComputedPosition: function () {
         var matrix = window.getComputedStyle(this.scroller, null),
             x, y;
 
         if ( this.options.useTransform ) {
             matrix = matrix[utils.style.transform].split(')')[0].split(', ');
             x = +(matrix[12] || matrix[4]);
             y = +(matrix[13] || matrix[5]);
         } else {
             x = +matrix.left.replace(/[^-\d.]/g, '');
             y = +matrix.top.replace(/[^-\d.]/g, '');
         }
 
         return { x: x, y: y };
     },
     _initIndicators: function () {
         var interactive = this.options.interactiveScrollbars,
             customStyle = typeof this.options.scrollbars != 'string',
             indicators = [],
             indicator;
 
         var that = this;
 
         this.indicators = [];
 
         if ( this.options.scrollbars ) {
             // Vertical scrollbar
             if ( this.options.scrollY ) {
                 indicator = {
                     el: createDefaultScrollbar('v', interactive, this.options.scrollbars),
                     interactive: interactive,
                     defaultScrollbars: true,
                     customStyle: customStyle,
                     resize: this.options.resizeScrollbars,
                     shrink: this.options.shrinkScrollbars,
                     fade: this.options.fadeScrollbars,
                     listenX: false
                 };
 
                 this.wrapper.appendChild(indicator.el);
                 indicators.push(indicator);
             }
 
             // Horizontal scrollbar
             if ( this.options.scrollX ) {
                 indicator = {
                     el: createDefaultScrollbar('h', interactive, this.options.scrollbars),
                     interactive: interactive,
                     defaultScrollbars: true,
                     customStyle: customStyle,
                     resize: this.options.resizeScrollbars,
                     shrink: this.options.shrinkScrollbars,
                     fade: this.options.fadeScrollbars,
                     listenY: false
                 };
 
                 this.wrapper.appendChild(indicator.el);
                 indicators.push(indicator);
             }
         }
 
         if ( this.options.indicators ) {
             // TODO: check concat compatibility
             indicators = indicators.concat(this.options.indicators);
         }
 
         for ( var i = indicators.length; i--; ) {
             this.indicators.push( new Indicator(this, indicators[i]) );
         }
 
         // TODO: check if we can use array.map (wide compatibility and performance issues)
         function _indicatorsMap (fn) {
             if (that.indicators) {
                 for ( var i = that.indicators.length; i--; ) {
                     fn.call(that.indicators[i]);
                 }
             }
         }
 
         if ( this.options.fadeScrollbars ) {
             this.on('scrollEnd', function () {
                 _indicatorsMap(function () {
                     this.fade();
                 });
             });
 
             this.on('scrollCancel', function () {
                 _indicatorsMap(function () {
                     this.fade();
                 });
             });
 
             this.on('scrollStart', function () {
                 _indicatorsMap(function () {
                     this.fade(1);
                 });
             });
 
             this.on('beforeScrollStart', function () {
                 _indicatorsMap(function () {
                     this.fade(1, true);
                 });
             });
         }
 
 
         this.on('refresh', function () {
             _indicatorsMap(function () {
                 this.refresh();
             });
         });
 
         this.on('destroy', function () {
             _indicatorsMap(function () {
                 this.destroy();
             });
 
             delete this.indicators;
         });
     },
 
     _initWheel: function () {
         utils.addEvent(this.wrapper, 'wheel', this);
         utils.addEvent(this.wrapper, 'mousewheel', this);
         utils.addEvent(this.wrapper, 'DOMMouseScroll', this);
 
         this.on('destroy', function () {
             clearTimeout(this.wheelTimeout);
             this.wheelTimeout = null;
             utils.removeEvent(this.wrapper, 'wheel', this);
             utils.removeEvent(this.wrapper, 'mousewheel', this);
             utils.removeEvent(this.wrapper, 'DOMMouseScroll', this);
         });
     },
 
     _wheel: function (e) {
         if ( !this.enabled ) {
             return;
         }
 
         var wheelDeltaX, wheelDeltaY,
             newX, newY,
             that = this;
 
         if ( this.wheelTimeout === undefined ) {
             that._execEvent('scrollStart');
         }
 
         // Execute the scrollEnd event after 400ms the wheel stopped scrolling
         clearTimeout(this.wheelTimeout);
         this.wheelTimeout = setTimeout(function () {
             if(!that.options.snap) {
                 that._execEvent('scrollEnd');
             }
             that.wheelTimeout = undefined;
         }, 400);
 
         if ( 'deltaX' in e ) {
             if (e.deltaMode === 1) {
                 wheelDeltaX = -e.deltaX * this.options.mouseWheelSpeed;
                 wheelDeltaY = -e.deltaY * this.options.mouseWheelSpeed;
             } else {
                 wheelDeltaX = -e.deltaX;
                 wheelDeltaY = -e.deltaY;
             }
         } else if ( 'wheelDeltaX' in e ) {
             wheelDeltaX = e.wheelDeltaX / 120 * this.options.mouseWheelSpeed;
             wheelDeltaY = e.wheelDeltaY / 120 * this.options.mouseWheelSpeed;
         } else if ( 'wheelDelta' in e ) {
             wheelDeltaX = wheelDeltaY = e.wheelDelta / 120 * this.options.mouseWheelSpeed;
         } else if ( 'detail' in e ) {
             wheelDeltaX = wheelDeltaY = -e.detail / 3 * this.options.mouseWheelSpeed;
         } else {
             return;
         }
 
         wheelDeltaX *= this.options.invertWheelDirection;
         wheelDeltaY *= this.options.invertWheelDirection;
 
         if ( !this.hasVerticalScroll ) {
             wheelDeltaX = wheelDeltaY;
             wheelDeltaY = 0;
         }
 
         if ( this.options.snap ) {
             newX = this.currentPage.pageX;
             newY = this.currentPage.pageY;
 
             if ( wheelDeltaX > 0 ) {
                 newX--;
             } else if ( wheelDeltaX < 0 ) {
                 newX++;
             }
 
             if ( wheelDeltaY > 0 ) {
                 newY--;
             } else if ( wheelDeltaY < 0 ) {
                 newY++;
             }
 
             this.goToPage(newX, newY);
 
             return;
         }
 
         newX = this.x + Math.round(this.hasHorizontalScroll ? wheelDeltaX : 0);
         newY = this.y + Math.round(this.hasVerticalScroll ? wheelDeltaY : 0);
 
         this.directionX = wheelDeltaX > 0 ? -1 : wheelDeltaX < 0 ? 1 : 0;
         this.directionY = wheelDeltaY > 0 ? -1 : wheelDeltaY < 0 ? 1 : 0;
 
         if ( newX > 0 ) {
             newX = 0;
         } else if ( newX < this.maxScrollX ) {
             newX = this.maxScrollX;
         }
 
         if ( newY > 0 ) {
             newY = 0;
         } else if ( newY < this.maxScrollY ) {
             newY = this.maxScrollY;
         }
 
         this.scrollTo(newX, newY, 0);
 
 // INSERT POINT: _wheel
     },
 
     _initSnap: function () {
         this.currentPage = {};
 
         if ( typeof this.options.snap == 'string' ) {
             this.options.snap = this.scroller.querySelectorAll(this.options.snap);
         }
 
         this.on('refresh', function () {
             var i = 0, l,
                 m = 0, n,
                 cx, cy,
                 x = 0, y,
                 stepX = this.options.snapStepX || this.wrapperWidth,
                 stepY = this.options.snapStepY || this.wrapperHeight,
                 el;
 
             this.pages = [];
 
             if ( !this.wrapperWidth || !this.wrapperHeight || !this.scrollerWidth || !this.scrollerHeight ) {
                 return;
             }
 
             if ( this.options.snap === true ) {
                 cx = Math.round( stepX / 2 );
                 cy = Math.round( stepY / 2 );
 
                 while ( x > -this.scrollerWidth ) {
                     this.pages[i] = [];
                     l = 0;
                     y = 0;
 
                     while ( y > -this.scrollerHeight ) {
                         this.pages[i][l] = {
                             x: Math.max(x, this.maxScrollX),
                             y: Math.max(y, this.maxScrollY),
                             width: stepX,
                             height: stepY,
                             cx: x - cx,
                             cy: y - cy
                         };
 
                         y -= stepY;
                         l++;
                     }
 
                     x -= stepX;
                     i++;
                 }
             } else {
                 el = this.options.snap;
                 l = el.length;
                 n = -1;
 
                 for ( ; i < l; i++ ) {
                     if ( i === 0 || el[i].offsetLeft <= el[i-1].offsetLeft ) {
                         m = 0;
                         n++;
                     }
 
                     if ( !this.pages[m] ) {
                         this.pages[m] = [];
                     }
 
                     x = Math.max(-el[i].offsetLeft, this.maxScrollX);
                     y = Math.max(-el[i].offsetTop, this.maxScrollY);
                     cx = x - Math.round(el[i].offsetWidth / 2);
                     cy = y - Math.round(el[i].offsetHeight / 2);
 
                     this.pages[m][n] = {
                         x: x,
                         y: y,
                         width: el[i].offsetWidth,
                         height: el[i].offsetHeight,
                         cx: cx,
                         cy: cy
                     };
 
                     if ( x > this.maxScrollX ) {
                         m++;
                     }
                 }
             }
 
             this.goToPage(this.currentPage.pageX || 0, this.currentPage.pageY || 0, 0);
 
             // Update snap threshold if needed
             if ( this.options.snapThreshold % 1 === 0 ) {
                 this.snapThresholdX = this.options.snapThreshold;
                 this.snapThresholdY = this.options.snapThreshold;
             } else {
                 this.snapThresholdX = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].width * this.options.snapThreshold);
                 this.snapThresholdY = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].height * this.options.snapThreshold);
             }
         });
 
         this.on('flick', function () {
             var time = this.options.snapSpeed || Math.max(
                     Math.max(
                         Math.min(Math.abs(this.x - this.startX), 1000),
                         Math.min(Math.abs(this.y - this.startY), 1000)
                     ), 300);
 
             this.goToPage(
                 this.currentPage.pageX + this.directionX,
                 this.currentPage.pageY + this.directionY,
                 time
             );
         });
     },
 
     _nearestSnap: function (x, y) {
         if ( !this.pages.length ) {
             return { x: 0, y: 0, pageX: 0, pageY: 0 };
         }
 
         var i = 0,
             l = this.pages.length,
             m = 0;
 
         // Check if we exceeded the snap threshold
         if ( Math.abs(x - this.absStartX) < this.snapThresholdX &&
             Math.abs(y - this.absStartY) < this.snapThresholdY ) {
             return this.currentPage;
         }
 
         if ( x > 0 ) {
             x = 0;
         } else if ( x < this.maxScrollX ) {
             x = this.maxScrollX;
         }
 
         if ( y > 0 ) {
             y = 0;
         } else if ( y < this.maxScrollY ) {
             y = this.maxScrollY;
         }
 
         for ( ; i < l; i++ ) {
             if ( x >= this.pages[i][0].cx ) {
                 x = this.pages[i][0].x;
                 break;
             }
         }
 
         l = this.pages[i].length;
 
         for ( ; m < l; m++ ) {
             if ( y >= this.pages[0][m].cy ) {
                 y = this.pages[0][m].y;
                 break;
             }
         }
 
         if ( i == this.currentPage.pageX ) {
             i += this.directionX;
 
             if ( i < 0 ) {
                 i = 0;
             } else if ( i >= this.pages.length ) {
                 i = this.pages.length - 1;
             }
 
             x = this.pages[i][0].x;
         }
 
         if ( m == this.currentPage.pageY ) {
             m += this.directionY;
 
             if ( m < 0 ) {
                 m = 0;
             } else if ( m >= this.pages[0].length ) {
                 m = this.pages[0].length - 1;
             }
 
             y = this.pages[0][m].y;
         }
 
         return {
             x: x,
             y: y,
             pageX: i,
             pageY: m
         };
     },
 
     goToPage: function (x, y, time, easing) {
         easing = easing || this.options.bounceEasing;
 
         if ( x >= this.pages.length ) {
             x = this.pages.length - 1;
         } else if ( x < 0 ) {
             x = 0;
         }
 
         if ( y >= this.pages[x].length ) {
             y = this.pages[x].length - 1;
         } else if ( y < 0 ) {
             y = 0;
         }
 
         var posX = this.pages[x][y].x,
             posY = this.pages[x][y].y;
 
         time = time === undefined ? this.options.snapSpeed || Math.max(
             Math.max(
                 Math.min(Math.abs(posX - this.x), 1000),
                 Math.min(Math.abs(posY - this.y), 1000)
             ), 300) : time;
 
         this.currentPage = {
             x: posX,
             y: posY,
             pageX: x,
             pageY: y
         };
 
         this.scrollTo(posX, posY, time, easing);
     },
 
     next: function (time, easing) {
         var x = this.currentPage.pageX,
             y = this.currentPage.pageY;
 
         x++;
 
         if ( x >= this.pages.length && this.hasVerticalScroll ) {
             x = 0;
             y++;
         }
 
         this.goToPage(x, y, time, easing);
     },
 
     prev: function (time, easing) {
         var x = this.currentPage.pageX,
             y = this.currentPage.pageY;
 
         x--;
 
         if ( x < 0 && this.hasVerticalScroll ) {
             x = 0;
             y--;
         }
 
         this.goToPage(x, y, time, easing);
     },
 
     _initKeys: function (e) {
         // default key bindings
         var keys = {
             pageUp: 33,
             pageDown: 34,
             end: 35,
             home: 36,
             left: 37,
             up: 38,
             right: 39,
             down: 40
         };
         var i;
 
         // if you give me characters I give you keycode
         if ( typeof this.options.keyBindings == 'object' ) {
             for ( i in this.options.keyBindings ) {
                 if ( typeof this.options.keyBindings[i] == 'string' ) {
                     this.options.keyBindings[i] = this.options.keyBindings[i].toUpperCase().charCodeAt(0);
                 }
             }
         } else {
             this.options.keyBindings = {};
         }
 
         for ( i in keys ) {
             this.options.keyBindings[i] = this.options.keyBindings[i] || keys[i];
         }
 
         utils.addEvent(window, 'keydown', this);
 
         this.on('destroy', function () {
             utils.removeEvent(window, 'keydown', this);
         });
     },
 
     _key: function (e) {
         if ( !this.enabled ) {
             return;
         }
 
         var snap = this.options.snap,   // we are using this alot, better to cache it
             newX = snap ? this.currentPage.pageX : this.x,
             newY = snap ? this.currentPage.pageY : this.y,
             now = utils.getTime(),
             prevTime = this.keyTime || 0,
             acceleration = 0.250,
             pos;
 
         if ( this.options.useTransition && this.isInTransition ) {
             pos = this.getComputedPosition();
 
             this._translate(Math.round(pos.x), Math.round(pos.y));
             this.isInTransition = false;
         }
 
         this.keyAcceleration = now - prevTime < 200 ? Math.min(this.keyAcceleration + acceleration, 50) : 0;
 
         switch ( e.keyCode ) {
             case this.options.keyBindings.pageUp:
                 if ( this.hasHorizontalScroll && !this.hasVerticalScroll ) {
                     newX += snap ? 1 : this.wrapperWidth;
                 } else {
                     newY += snap ? 1 : this.wrapperHeight;
                 }
                 break;
             case this.options.keyBindings.pageDown:
                 if ( this.hasHorizontalScroll && !this.hasVerticalScroll ) {
                     newX -= snap ? 1 : this.wrapperWidth;
                 } else {
                     newY -= snap ? 1 : this.wrapperHeight;
                 }
                 break;
             case this.options.keyBindings.end:
                 newX = snap ? this.pages.length-1 : this.maxScrollX;
                 newY = snap ? this.pages[0].length-1 : this.maxScrollY;
                 break;
             case this.options.keyBindings.home:
                 newX = 0;
                 newY = 0;
                 break;
             case this.options.keyBindings.left:
                 newX += snap ? -1 : 5 + this.keyAcceleration>>0;
                 break;
             case this.options.keyBindings.up:
                 newY += snap ? 1 : 5 + this.keyAcceleration>>0;
                 break;
             case this.options.keyBindings.right:
                 newX -= snap ? -1 : 5 + this.keyAcceleration>>0;
                 break;
             case this.options.keyBindings.down:
                 newY -= snap ? 1 : 5 + this.keyAcceleration>>0;
                 break;
             default:
                 return;
         }
 
         if ( snap ) {
             this.goToPage(newX, newY);
             return;
         }
 
         if ( newX > 0 ) {
             newX = 0;
             this.keyAcceleration = 0;
         } else if ( newX < this.maxScrollX ) {
             newX = this.maxScrollX;
             this.keyAcceleration = 0;
         }
 
         if ( newY > 0 ) {
             newY = 0;
             this.keyAcceleration = 0;
         } else if ( newY < this.maxScrollY ) {
             newY = this.maxScrollY;
             this.keyAcceleration = 0;
         }
 
         this.scrollTo(newX, newY, 0);
 
         this.keyTime = now;
     },
 
     _animate: function (destX, destY, duration, easingFn) {
         var that = this,
             startX = this.x,
             startY = this.y,
             startTime = utils.getTime(),
             destTime = startTime + duration;
 
         function step () {
             var now = utils.getTime(),
                 newX, newY,
                 easing;
 
             if ( now >= destTime ) {
                 that.isAnimating = false;
                 that._translate(destX, destY);
 
                 if ( !that.resetPosition(that.options.bounceTime) ) {
                     that._execEvent('scrollEnd');
                 }
 
                 return;
             }
 
             now = ( now - startTime ) / duration;
             easing = easingFn(now);
             newX = ( destX - startX ) * easing + startX;
             newY = ( destY - startY ) * easing + startY;
             that._translate(newX, newY);
 
             if ( that.isAnimating ) {
                 rAF(step);
             }
         }
 
         this.isAnimating = true;
         step();
     },
     handleEvent: function (e) {
         switch ( e.type ) {
             case 'touchstart':
             case 'pointerdown':
             case 'MSPointerDown':
             case 'mousedown':
                 this._start(e);
                 break;
             case 'touchmove':
             case 'pointermove':
             case 'MSPointerMove':
             case 'mousemove':
                 this._move(e);
                 break;
             case 'touchend':
             case 'pointerup':
             case 'MSPointerUp':
             case 'mouseup':
             case 'touchcancel':
             case 'pointercancel':
             case 'MSPointerCancel':
             case 'mousecancel':
                 this._end(e);
                 break;
             case 'orientationchange':
             case 'resize':
                 this._resize();
                 break;
             case 'transitionend':
             case 'webkitTransitionEnd':
             case 'oTransitionEnd':
             case 'MSTransitionEnd':
                 this._transitionEnd(e);
                 break;
             case 'wheel':
             case 'DOMMouseScroll':
             case 'mousewheel':
                 this._wheel(e);
                 break;
             case 'keydown':
                 this._key(e);
                 break;
             case 'click':
                 if ( this.enabled && !e._constructed ) {
                     e.preventDefault();
                     e.stopPropagation();
                 }
                 break;
         }
     }
 };
 function createDefaultScrollbar (direction, interactive, type) {
     var scrollbar = document.createElement('div'),
         indicator = document.createElement('div');
 
     if ( type === true ) {
         scrollbar.style.cssText = 'position:absolute;z-index:9999';
         indicator.style.cssText = '-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:absolute;background:rgba(0,0,0,0.5);border:1px solid rgba(255,255,255,0.9);border-radius:3px';
     }
 
     indicator.className = 'iScrollIndicator';
 
     if ( direction == 'h' ) {
         if ( type === true ) {
             scrollbar.style.cssText += ';height:7px;left:2px;right:2px;bottom:0';
             indicator.style.height = '100%';
         }
         scrollbar.className = 'iScrollHorizontalScrollbar';
     } else {
         if ( type === true ) {
             scrollbar.style.cssText += ';width:7px;bottom:2px;top:2px;right:1px';
             indicator.style.width = '100%';
         }
         scrollbar.className = 'iScrollVerticalScrollbar';
     }
 
     scrollbar.style.cssText += ';overflow:hidden';
 
     if ( !interactive ) {
         scrollbar.style.pointerEvents = 'none';
     }
 
     scrollbar.appendChild(indicator);
 
     return scrollbar;
 }
 
 function Indicator (scroller, options) {
     this.wrapper = typeof options.el == 'string' ? document.querySelector(options.el) : options.el;
     this.wrapperStyle = this.wrapper.style;
     this.indicator = this.wrapper.children[0];
     this.indicatorStyle = this.indicator.style;
     this.scroller = scroller;
 
     this.options = {
         listenX: true,
         listenY: true,
         interactive: false,
         resize: true,
         defaultScrollbars: false,
         shrink: false,
         fade: false,
         speedRatioX: 0,
         speedRatioY: 0
     };
 
     for ( var i in options ) {
         this.options[i] = options[i];
     }
 
     this.sizeRatioX = 1;
     this.sizeRatioY = 1;
     this.maxPosX = 0;
     this.maxPosY = 0;
 
     if ( this.options.interactive ) {
         if ( !this.options.disableTouch ) {
             utils.addEvent(this.indicator, 'touchstart', this);
             utils.addEvent(window, 'touchend', this);
         }
         if ( !this.options.disablePointer ) {
             utils.addEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
             utils.addEvent(window, utils.prefixPointerEvent('pointerup'), this);
         }
         if ( !this.options.disableMouse ) {
             utils.addEvent(this.indicator, 'mousedown', this);
             utils.addEvent(window, 'mouseup', this);
         }
     }
 
     if ( this.options.fade ) {
         this.wrapperStyle[utils.style.transform] = this.scroller.translateZ;
         var durationProp = utils.style.transitionDuration;
         if(!durationProp) {
             return;
         }
         this.wrapperStyle[durationProp] = utils.isBadAndroid ? '0.0001ms' : '0ms';
         // remove 0.0001ms
         var self = this;
         if(utils.isBadAndroid) {
             rAF(function() {
                 if(self.wrapperStyle[durationProp] === '0.0001ms') {
                     self.wrapperStyle[durationProp] = '0s';
                 }
             });
         }
         this.wrapperStyle.opacity = '0';
     }
 }
 
 Indicator.prototype = {
     handleEvent: function (e) {
         switch ( e.type ) {
             case 'touchstart':
             case 'pointerdown':
             case 'MSPointerDown':
             case 'mousedown':
                 this._start(e);
                 break;
             case 'touchmove':
             case 'pointermove':
             case 'MSPointerMove':
             case 'mousemove':
                 this._move(e);
                 break;
             case 'touchend':
             case 'pointerup':
             case 'MSPointerUp':
             case 'mouseup':
             case 'touchcancel':
             case 'pointercancel':
             case 'MSPointerCancel':
             case 'mousecancel':
                 this._end(e);
                 break;
         }
     },
 
     destroy: function () {
         if ( this.options.fadeScrollbars ) {
             clearTimeout(this.fadeTimeout);
             this.fadeTimeout = null;
         }
         if ( this.options.interactive ) {
             utils.removeEvent(this.indicator, 'touchstart', this);
             utils.removeEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
             utils.removeEvent(this.indicator, 'mousedown', this);
 
             utils.removeEvent(window, 'touchmove', this);
             utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
             utils.removeEvent(window, 'mousemove', this);
 
             utils.removeEvent(window, 'touchend', this);
             utils.removeEvent(window, utils.prefixPointerEvent('pointerup'), this);
             utils.removeEvent(window, 'mouseup', this);
         }
 
         if ( this.options.defaultScrollbars ) {
             this.wrapper.parentNode.removeChild(this.wrapper);
         }
     },
 
     _start: function (e) {
         var point = e.touches ? e.touches[0] : e;
 
         e.preventDefault();
         e.stopPropagation();
 
         this.transitionTime();
 
         this.initiated = true;
         this.moved = false;
         this.lastPointX = point.pageX;
         this.lastPointY = point.pageY;
 
         this.startTime  = utils.getTime();
 
         if ( !this.options.disableTouch ) {
             utils.addEvent(window, 'touchmove', this);
         }
         if ( !this.options.disablePointer ) {
             utils.addEvent(window, utils.prefixPointerEvent('pointermove'), this);
         }
         if ( !this.options.disableMouse ) {
             utils.addEvent(window, 'mousemove', this);
         }
 
         this.scroller._execEvent('beforeScrollStart');
     },
 
     _move: function (e) {
         var point = e.touches ? e.touches[0] : e,
             deltaX, deltaY,
             newX, newY,
             timestamp = utils.getTime();
 
         if ( !this.moved ) {
             this.scroller._execEvent('scrollStart');
         }
 
         this.moved = true;
 
         deltaX = point.pageX - this.lastPointX;
         this.lastPointX = point.pageX;
 
         deltaY = point.pageY - this.lastPointY;
         this.lastPointY = point.pageY;
 
         newX = this.x + deltaX;
         newY = this.y + deltaY;
 
         this._pos(newX, newY);
 
 // INSERT POINT: indicator._move
 
         e.preventDefault();
         e.stopPropagation();
     },
 
     _end: function (e) {
         if ( !this.initiated ) {
             return;
         }
 
         this.initiated = false;
 
         e.preventDefault();
         e.stopPropagation();
 
         utils.removeEvent(window, 'touchmove', this);
         utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
         utils.removeEvent(window, 'mousemove', this);
 
         if ( this.scroller.options.snap ) {
             var snap = this.scroller._nearestSnap(this.scroller.x, this.scroller.y);
 
             var time = this.options.snapSpeed || Math.max(
                     Math.max(
                         Math.min(Math.abs(this.scroller.x - snap.x), 1000),
                         Math.min(Math.abs(this.scroller.y - snap.y), 1000)
                     ), 300);
 
             if ( this.scroller.x != snap.x || this.scroller.y != snap.y ) {
                 this.scroller.directionX = 0;
                 this.scroller.directionY = 0;
                 this.scroller.currentPage = snap;
                 this.scroller.scrollTo(snap.x, snap.y, time, this.scroller.options.bounceEasing);
             }
         }
 
         if ( this.moved ) {
             this.scroller._execEvent('scrollEnd');
         }
     },
 
     transitionTime: function (time) {
         time = time || 0;
         var durationProp = utils.style.transitionDuration;
         if(!durationProp) {
             return;
         }
 
         this.indicatorStyle[durationProp] = time + 'ms';
 
         if ( !time && utils.isBadAndroid ) {
             this.indicatorStyle[durationProp] = '0.0001ms';
             // remove 0.0001ms
             var self = this;
             rAF(function() {
                 if(self.indicatorStyle[durationProp] === '0.0001ms') {
                     self.indicatorStyle[durationProp] = '0s';
                 }
             });
         }
     },
 
     transitionTimingFunction: function (easing) {
         this.indicatorStyle[utils.style.transitionTimingFunction] = easing;
     },
 
     refresh: function () {
         this.transitionTime();
 
         if ( this.options.listenX && !this.options.listenY ) {
             this.indicatorStyle.display = this.scroller.hasHorizontalScroll ? 'block' : 'none';
         } else if ( this.options.listenY && !this.options.listenX ) {
             this.indicatorStyle.display = this.scroller.hasVerticalScroll ? 'block' : 'none';
         } else {
             this.indicatorStyle.display = this.scroller.hasHorizontalScroll || this.scroller.hasVerticalScroll ? 'block' : 'none';
         }
 
         if ( this.scroller.hasHorizontalScroll && this.scroller.hasVerticalScroll ) {
             utils.addClass(this.wrapper, 'iScrollBothScrollbars');
             utils.removeClass(this.wrapper, 'iScrollLoneScrollbar');
 
             if ( this.options.defaultScrollbars && this.options.customStyle ) {
                 if ( this.options.listenX ) {
                     this.wrapper.style.right = '8px';
                 } else {
                     this.wrapper.style.bottom = '8px';
                 }
             }
         } else {
             utils.removeClass(this.wrapper, 'iScrollBothScrollbars');
             utils.addClass(this.wrapper, 'iScrollLoneScrollbar');
 
             if ( this.options.defaultScrollbars && this.options.customStyle ) {
                 if ( this.options.listenX ) {
                     this.wrapper.style.right = '2px';
                 } else {
                     this.wrapper.style.bottom = '2px';
                 }
             }
         }
 
         var r = this.wrapper.offsetHeight;  // force refresh
 
         if ( this.options.listenX ) {
             this.wrapperWidth = this.wrapper.clientWidth;
             if ( this.options.resize ) {
                 this.indicatorWidth = Math.max(Math.round(this.wrapperWidth * this.wrapperWidth / (this.scroller.scrollerWidth || this.wrapperWidth || 1)), 8);
                 this.indicatorStyle.width = this.indicatorWidth + 'px';
             } else {
                 this.indicatorWidth = this.indicator.clientWidth;
             }
 
             this.maxPosX = this.wrapperWidth - this.indicatorWidth;
 
             if ( this.options.shrink == 'clip' ) {
                 this.minBoundaryX = -this.indicatorWidth + 8;
                 this.maxBoundaryX = this.wrapperWidth - 8;
             } else {
                 this.minBoundaryX = 0;
                 this.maxBoundaryX = this.maxPosX;
             }
 
             this.sizeRatioX = this.options.speedRatioX || (this.scroller.maxScrollX && (this.maxPosX / this.scroller.maxScrollX));
         }
 
         if ( this.options.listenY ) {
             this.wrapperHeight = this.wrapper.clientHeight;
             if ( this.options.resize ) {
                 this.indicatorHeight = Math.max(Math.round(this.wrapperHeight * this.wrapperHeight / (this.scroller.scrollerHeight || this.wrapperHeight || 1)), 8);
                 this.indicatorStyle.height = this.indicatorHeight + 'px';
             } else {
                 this.indicatorHeight = this.indicator.clientHeight;
             }
 
             this.maxPosY = this.wrapperHeight - this.indicatorHeight;
 
             if ( this.options.shrink == 'clip' ) {
                 this.minBoundaryY = -this.indicatorHeight + 8;
                 this.maxBoundaryY = this.wrapperHeight - 8;
             } else {
                 this.minBoundaryY = 0;
                 this.maxBoundaryY = this.maxPosY;
             }
 
             this.maxPosY = this.wrapperHeight - this.indicatorHeight;
             this.sizeRatioY = this.options.speedRatioY || (this.scroller.maxScrollY && (this.maxPosY / this.scroller.maxScrollY));
         }
 
         this.updatePosition();
     },
 
     updatePosition: function () {
         var x = this.options.listenX && Math.round(this.sizeRatioX * this.scroller.x) || 0,
             y = this.options.listenY && Math.round(this.sizeRatioY * this.scroller.y) || 0;
 
         if ( !this.options.ignoreBoundaries ) {
             if ( x < this.minBoundaryX ) {
                 if ( this.options.shrink == 'scale' ) {
                     this.width = Math.max(this.indicatorWidth + x, 8);
                     this.indicatorStyle.width = this.width + 'px';
                 }
                 x = this.minBoundaryX;
             } else if ( x > this.maxBoundaryX ) {
                 if ( this.options.shrink == 'scale' ) {
                     this.width = Math.max(this.indicatorWidth - (x - this.maxPosX), 8);
                     this.indicatorStyle.width = this.width + 'px';
                     x = this.maxPosX + this.indicatorWidth - this.width;
                 } else {
                     x = this.maxBoundaryX;
                 }
             } else if ( this.options.shrink == 'scale' && this.width != this.indicatorWidth ) {
                 this.width = this.indicatorWidth;
                 this.indicatorStyle.width = this.width + 'px';
             }
 
             if ( y < this.minBoundaryY ) {
                 if ( this.options.shrink == 'scale' ) {
                     this.height = Math.max(this.indicatorHeight + y * 3, 8);
                     this.indicatorStyle.height = this.height + 'px';
                 }
                 y = this.minBoundaryY;
             } else if ( y > this.maxBoundaryY ) {
                 if ( this.options.shrink == 'scale' ) {
                     this.height = Math.max(this.indicatorHeight - (y - this.maxPosY) * 3, 8);
                     this.indicatorStyle.height = this.height + 'px';
                     y = this.maxPosY + this.indicatorHeight - this.height;
                 } else {
                     y = this.maxBoundaryY;
                 }
             } else if ( this.options.shrink == 'scale' && this.height != this.indicatorHeight ) {
                 this.height = this.indicatorHeight;
                 this.indicatorStyle.height = this.height + 'px';
             }
         }
 
         this.x = x;
         this.y = y;
 
         if ( this.scroller.options.useTransform ) {
             this.indicatorStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.scroller.translateZ;
         } else {
             this.indicatorStyle.left = x + 'px';
             this.indicatorStyle.top = y + 'px';
         }
     },
 
     _pos: function (x, y) {
         if ( x < 0 ) {
             x = 0;
         } else if ( x > this.maxPosX ) {
             x = this.maxPosX;
         }
 
         if ( y < 0 ) {
             y = 0;
         } else if ( y > this.maxPosY ) {
             y = this.maxPosY;
         }
 
         x = this.options.listenX ? Math.round(x / this.sizeRatioX) : this.scroller.x;
         y = this.options.listenY ? Math.round(y / this.sizeRatioY) : this.scroller.y;
 
         this.scroller.scrollTo(x, y);
     },
 
     fade: function (val, hold) {
         if ( hold && !this.visible ) {
             return;
         }
 
         clearTimeout(this.fadeTimeout);
         this.fadeTimeout = null;
 
         var time = val ? 250 : 500,
             delay = val ? 0 : 300;
 
         val = val ? '1' : '0';
 
         this.wrapperStyle[utils.style.transitionDuration] = time + 'ms';
 
         this.fadeTimeout = setTimeout((function (val) {
             this.wrapperStyle.opacity = val;
             this.visible = +val;
         }).bind(this, val), delay);
     }
 };
 
 IScroll.utils = utils;
 
 if ( typeof module != 'undefined' && module.exports ) {
     module.exports = IScroll;
 } else if ( typeof define == 'function' && define.amd ) {
         define( function () { return IScroll; } );
 } else {
     window.IScroll = IScroll;
 }
 
 })(window, document, Math);
 
 
 // scrolloverflow module
 (function (window, document, $) {
     $.fn.fp_scrolloverflow = (function() {
 
         // keeping central set of classnames and selectors
         var SCROLLABLE =            'fp-scrollable';
         var SCROLLABLE_SEL =        '.' + SCROLLABLE;
 
         var ACTIVE =                'active';
         var ACTIVE_SEL =            '.' + ACTIVE;
 
         var SECTION =               'fp-section';
         var SECTION_SEL =           '.' + SECTION;
         var SECTION_ACTIVE_SEL =    SECTION_SEL + ACTIVE_SEL;
 
         var SLIDE =                 'fp-slide';
         var SLIDE_SEL =             '.' + SLIDE;
         var SLIDE_ACTIVE_SEL =      SLIDE_SEL + ACTIVE_SEL;
 
         var SLIDES_WRAPPER =        'fp-slides';
         var SLIDES_WRAPPER_SEL =    '.' + SLIDES_WRAPPER;
 
         var TABLE_CELL =            'fp-tableCell';
         var TABLE_CELL_SEL =        '.' + TABLE_CELL;
 
         var RESPONSIVE =            'fp-responsive';
         var AUTO_HEIGHT_RESPONSIVE= 'fp-auto-height-responsive';
 
         /*
         * Turns iScroll `mousewheel` option off dynamically
         * https://github.com/cubiq/iscroll/issues/1036
         */
         IScroll.prototype.wheelOn = function () {
             this.wrapper.addEventListener('wheel', this);
             this.wrapper.addEventListener('mousewheel', this);
             this.wrapper.addEventListener('DOMMouseScroll', this);
         };
 
         /*
         * Turns iScroll `mousewheel` option on dynamically
         * https://github.com/cubiq/iscroll/issues/1036
         */
         IScroll.prototype.wheelOff = function () {
             this.wrapper.removeEventListener('wheel', this);
             this.wrapper.removeEventListener('mousewheel', this);
             this.wrapper.removeEventListener('DOMMouseScroll', this);
         };
 
         /**
         * Returns an integer representing the padding dimensions in px.
         */
         function getPaddings(element){
             var section = element.closest(SECTION_SEL);
             if(section.length){
                 return parseInt(section.css('padding-bottom')) + parseInt(section.css('padding-top'));
             }
             return 0;
         }
 
         function scrollBarHandler(){
             var self = this;
             self.options = null;
 
             self.init = function(options, iscrollOptions){
                 self.options = options;
                 self.iscrollOptions = iscrollOptions;
 
                 if(document.readyState === 'complete'){
                     createScrollBarForAll();
                     $.fn.fullpage.shared.afterRenderActions();
                 }
                 //after DOM and images are loaded
                 $(window).on('load', function(){
                     createScrollBarForAll();
                     $.fn.fullpage.shared.afterRenderActions();
                 });
 
                 return self;
             };
 
             /**
             * Creates the scrollbar for the sections and slides in the site
             */
             function createScrollBarForAll(){
                 if($('body').hasClass(RESPONSIVE)){
                     removeResponsiveScrollOverflows();
                 }
                 else{
                     forEachSectionAndSlide(createScrollBar);
                 }
             }
 
             /**
             * Checks if the element needs scrollbar and if the user wants to apply it.
             * If so it creates it.
             *
             * @param {Object} element   jQuery object of the section or slide
             */
             function createScrollBar(element){
                 //User doesn't want scrollbar here? Sayonara baby!
                 if(element.hasClass('fp-noscroll')) return;
 
                 //necessary to make `scrollHeight` work under Opera 12
                 element.css('overflow', 'hidden');
 
                 var scrollOverflowHandler = self.options.scrollOverflowHandler;
                 var wrap = scrollOverflowHandler.wrapContent();
                 var section = element.closest(SECTION_SEL); //in case element is a slide
                 var scrollable = scrollOverflowHandler.scrollable(element);
                 var contentHeight;
                 var paddings = getPaddings(section);
 
                 //if there was scroll, the contentHeight will be the one in the scrollable section
                 if(scrollable.length){
                     contentHeight = scrollOverflowHandler.scrollHeight(element);
                 }
                 else{
                     contentHeight = element.get(0).scrollHeight - paddings;
                     if(self.options.verticalCentered){
                         contentHeight = element.find(TABLE_CELL_SEL).get(0).scrollHeight - paddings;
                     }
                 }
 
                 var scrollHeight = $(window).height() - paddings;
 
                 //needs scroll?
                 if ( contentHeight > scrollHeight) {
                     //did we already have an scrollbar ? Updating it
                     if(scrollable.length){
                         scrollOverflowHandler.update(element, scrollHeight);
                     }
                     //creating the scrolling
                     else{
                         if(self.options.verticalCentered){
                             element.find(TABLE_CELL_SEL).wrapInner(wrap);
                         }else{
                             element.wrapInner(wrap);
                         }
                         scrollOverflowHandler.create(element, scrollHeight, self.iscrollOptions);
                     }
                 }
                 //removing the scrolling when it is not necessary anymore
                 else{
                     scrollOverflowHandler.remove(element);
                 }
 
                 //undo
                 element.css('overflow', '');
             }
 
             /**
             * Applies a callback function to each section in the site
             * or the slides within them
             */
             function forEachSectionAndSlide(callback){
                 $(SECTION_SEL).each(function(){
                     var slides = $(this).find(SLIDE_SEL);
 
                     if(slides.length){
                         slides.each(function(){
                             callback($(this));
                         });
                     }else{
                         callback($(this));
                     }
                 });
             }
 
             /**
             * Removes scrollOverflow for sections using the class `fp-auto-height-responsive`
             */
             function removeResponsiveScrollOverflows(){
                 var scrollOverflowHandler = self.options.scrollOverflowHandler;
                 forEachSectionAndSlide(function(element){
                     if(element.closest(SECTION_SEL).hasClass(AUTO_HEIGHT_RESPONSIVE)){
                         scrollOverflowHandler.remove(element);
                     }
                 });
             }
 
             //public functions
             self.createScrollBarForAll = createScrollBarForAll;
         }
 
         /**
          * An object to handle overflow scrolling.
          * This uses jquery.slimScroll to accomplish overflow scrolling.
          * It is possible to pass in an alternate scrollOverflowHandler
          * to the fullpage.js option that implements the same functions
          * as this handler.
          *
          * @type {Object}
          */
         var iscrollHandler = {
             refreshId: null,
             iScrollInstances: [],
 
             // Default options for iScroll.js used when using scrollOverflow
             iscrollOptions: {
                 scrollbars: true,
                 mouseWheel: true,
                 hideScrollbars: false,
                 fadeScrollbars: false,
                 disableMouse: true,
                 interactiveScrollbars: true
             },
 
             init: function(options){
                 var isTouch = (('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0) || (navigator.maxTouchPoints));
 
                 //fixing bug in iScroll with links: https://github.com/cubiq/iscroll/issues/783
                 iscrollHandler.iscrollOptions.click = isTouch; // see #2035
 
                 //extending iScroll options with the user custom ones
                 iscrollHandler.iscrollOptions = $.extend(iscrollHandler.iscrollOptions, options.scrollOverflowOptions);
 
                 return new scrollBarHandler().init(options, iscrollHandler.iscrollOptions);
             },
 
             // Enables or disables the mouse wheel for the active section or all slides in it
             toggleWheel: function(value){
                 var scrollable = $(SECTION_ACTIVE_SEL).find(SCROLLABLE_SEL);
                 scrollable.each(function(){
                     var iScrollInstance = $(this).data('iscrollInstance');
                     if(typeof iScrollInstance !== 'undefined' && iScrollInstance){
                         if(value){
                             iScrollInstance.wheelOn();
                         }
                         else{
                             iScrollInstance.wheelOff();
                         }
                     }
                 });
             },
 
             /**
             * Turns off iScroll for the destination section.
             * When scrolling very fast on some trackpads (and Apple laptops) the inertial scrolling would
             * scroll the destination section/slide before the sections animations ends.
             */
             onLeave: function(){
                 iscrollHandler.toggleWheel(false);
             },
 
             // Turns off iScroll for the leaving section
             beforeLeave: function(){
                 iscrollHandler.onLeave()
             },
 
             // Turns on iScroll on section load
             afterLoad: function(){
                 iscrollHandler.toggleWheel(true);
             },
 
             /**
              * Called when overflow scrolling is needed for a section.
              *
              * @param  {Object} element      jQuery object containing current section
              * @param  {Number} scrollHeight Current window height in pixels
              */
             create: function(element, scrollHeight, iscrollOptions) {
                 var scrollable = element.find(SCROLLABLE_SEL);
 
                 scrollable.height(scrollHeight);
                 scrollable.each(function() {
                     var $this = $(this);
                     var iScrollInstance = $this.data('iscrollInstance');
                     if (iScrollInstance) {
                         $.each(iscrollHandler.iScrollInstances, function(){
                             $(this).destroy();
                         });
                     }
 
                     iScrollInstance = new IScroll($this.get(0), iscrollOptions);
                     iscrollHandler.iScrollInstances.push(iScrollInstance);
 
                     if(!element.closest(SECTION_SEL).hasClass(ACTIVE)){
                         //off by default until the section gets active
                         iScrollInstance.wheelOff();
                     }
 
                     $this.data('iscrollInstance', iScrollInstance);
                 });
             },
 
             /**
              * Return a boolean depending on whether the scrollable element is a
              * the end or at the start of the scrolling depending on the given type.
              *
              * @param  {String}  type       Either 'top' or 'bottom'
              * @param  {Object}  scrollable jQuery object for the scrollable element
              * @return {Boolean}
              */
             isScrolled: function(type, scrollable) {
                 var scroller = scrollable.data('iscrollInstance');
 
                 //no scroller?
                 if (!scroller) {
                     return true;
                 }
 
                 if (type === 'top') {
                     return scroller.y >= 0 && !scrollable.scrollTop();
                 } else if (type === 'bottom') {
                     return (0 - scroller.y) + scrollable.scrollTop() + 1 + scrollable.innerHeight() >= scrollable[0].scrollHeight;
                 }
             },
 
             /**
              * Returns the scrollable element for the given section.
              * If there are landscape slides, will only return a scrollable element
              * if it is in the active slide.
              *
              * @param  {Object}  activeSection jQuery object containing current section
              * @return {Boolean}
              */
             scrollable: function(activeSection){
                 // if there are landscape slides, we check if the scrolling bar is in the current one or not
                 if (activeSection.find(SLIDES_WRAPPER_SEL).length) {
                     return activeSection.find(SLIDE_ACTIVE_SEL).find(SCROLLABLE_SEL);
                 }
                 return activeSection.find(SCROLLABLE_SEL);
             },
 
             /**
              * Returns the scroll height of the wrapped content.
              * If this is larger than the window height minus section padding,
              * overflow scrolling is needed.
              *
              * @param  {Object} element jQuery object containing current section
              * @return {Number}
              */
             scrollHeight: function(element) {
                 return element.find(SCROLLABLE_SEL).children().first().get(0).scrollHeight;
             },
 
             /**
              * Called when overflow scrolling is no longer needed for a section.
              *
              * @param  {Object} element      jQuery object containing current section
              */
             remove: function(element) {
                 var scrollable = element.find(SCROLLABLE_SEL);
                 if (scrollable.length) {
                     var iScrollInstance = scrollable.data('iscrollInstance');
                     if(iScrollInstance){
                         iScrollInstance.destroy();
                     }
 
                     scrollable.data('iscrollInstance', null);
                 }
                 element.find(SCROLLABLE_SEL).children().first().children().first().unwrap().unwrap();
             },
 
             /**
              * Called when overflow scrolling has already been setup but the
              * window height has potentially changed.
              *
              * @param  {Object} element      jQuery object containing current section
              * @param  {Number} scrollHeight Current window height in pixels
              */
             update: function(element, scrollHeight) {
                 //using a timeout in order to execute the refresh function only once when `update` is called multiple times in a
                 //short period of time.
                 //it also comes on handy because iScroll requires the use of timeout when using `refresh`.
                 clearTimeout(iscrollHandler.refreshId);
                 iscrollHandler.refreshId = setTimeout(function(){
                     $.each(iscrollHandler.iScrollInstances, function(){
                         $(this).get(0).refresh();
 
                         //ugly hack that we are forced to use due to the timeout delay
                         //otherwise done on the fullpage.js reBuild function
                         $.fn.fullpage.silentMoveTo($(SECTION_ACTIVE_SEL).index() + 1);
                     });
                 }, 150);
 
                 //updating the wrappers height
                 element.find(SCROLLABLE_SEL)
                     .css('height', scrollHeight + 'px')
                     .parent().css('height', scrollHeight + getPaddings(element) + 'px');
             },
 
             /**
              * Called to get any additional elements needed to wrap the section
              * content in order to facilitate overflow scrolling.
              *
              * @return {String|Object} Can be a string containing HTML,
              *                         a DOM element, or jQuery object.
              */
             wrapContent: function() {
                 return '<div class="' + SCROLLABLE + '"><div class="fp-scroller"></div></div>';
             }
         };
 
         return {
             iscrollHandler: iscrollHandler
         };
     })();
 })(window, document, jQuery);
 
 //------------------------------------------
 /*!
  * fullPage 2.9.7 - Extensions 0.1.5
  * https://github.com/alvarotrigo/fullPage.js
  * @license http://alvarotrigo.com/fullPage/extensions/#license
  *
  * Copyright (C) 2015 alvarotrigo.com - A project by Alvaro Trigo
  */
 !function(e,n){"use strict";"function"==typeof define&&define.amd?define(["jquery"],function(t){return n(t,e,e.document,e.Math)}):"object"==typeof exports&&exports?module.exports=n(require("jquery"),e,e.document,e.Math):n(jQuery,e,e.document,e.Math)}("undefined"!=typeof window?window:this,function(e,n,t,o,i){"use strict";var a="fullpage-wrapper",r="."+a,l="fp-responsive",s="fp-notransition",c="fp-destroyed",d="fp-enabled",f="fp-viewing",u="active",v="."+u,h="fp-completely",p="."+h,g="fp-section",m="."+g,S=m+v,w=m+":first",b=m+":last",x="fp-tableCell",y="."+x,C="fp-auto-height",T="fp-normal-scroll",A="fp-nav",M="#"+A,k="fp-tooltip",O="."+k,R="fp-show-active",z="fp-slide",I="."+z,L=I+v,H="fp-slides",E="."+H,B="fp-slidesContainer",D="."+B,P="fp-table",Y="fp-initial",F="fp-slidesNav",W="."+F,X=W+" a",V="fp-controlArrow",Z="."+V,N="fp-prev",j=V+" "+N,q=Z+("."+N),G="fp-next",U=V+" "+G,Q=Z+".fp-next",J=e(n),K=e(t);e.fn.fullpage=function(V){if(e("html").hasClass(d))kt();else{var G=e("html, body"),_=e("body"),$=e.fn.fullpage;V=e.extend(!0,{menu:!1,anchors:[],lockAnchors:!1,navigation:!1,navigationPosition:"right",navigationTooltips:[],showActiveTooltip:!1,slidesNavigation:!1,slidesNavPosition:"bottom",scrollBar:!1,hybrid:!1,css3:!0,scrollingSpeed:700,autoScrolling:!0,fitToSection:!0,fitToSectionDelay:1e3,easing:"easeInOutCubic",easingcss3:"ease",loopBottom:!1,loopTop:!1,loopHorizontal:!0,continuousVertical:!1,continuousHorizontal:!1,scrollHorizontally:!1,interlockedSlides:!1,dragAndMove:!1,offsetSections:!1,resetSliders:!1,fadingEffect:!1,normalScrollElements:null,scrollOverflow:!1,scrollOverflowReset:!1,scrollOverflowHandler:e.fn.fp_scrolloverflow?e.fn.fp_scrolloverflow.iscrollHandler:null,scrollOverflowOptions:null,touchSensitivity:5,normalScrollElementTouchThreshold:5,bigSectionsDestination:null,keyboardScrolling:!0,animateAnchor:!0,recordHistory:!0,controlArrows:!0,controlArrowColor:"#fff",verticalCentered:!0,sectionsColor:[],paddingTop:0,paddingBottom:0,fixedElements:null,responsive:0,responsiveWidth:0,responsiveHeight:0,responsiveSlides:!1,parallax:!1,parallaxOptions:{type:"reveal",percentage:62,property:"translate"},sectionSelector:".section",slideSelector:".slide",afterLoad:null,onLeave:null,afterRender:null,afterResize:null,afterReBuild:null,afterSlideLoad:null,onSlideLeave:null,afterResponsive:null,lazyLoading:!0},V);var ee,ne,te,oe,ie=!1,ae=navigator.userAgent.match(/(iPhone|iPod|iPad|Android|playbook|silk|BlackBerry|BB10|Windows Phone|Tizen|Bada|webOS|IEMobile|Opera Mini)/),re="ontouchstart"in n||navigator.msMaxTouchPoints>0||navigator.maxTouchPoints,le=e(this),se=J.height(),ce=!1,de=!0,fe=!0,ue=[],ve={m:{up:!0,down:!0,left:!0,right:!0}};ve.k=e.extend(!0,{},ve.m);var he,pe,ge,me,Se,we,be,xe,ye=pt(),Ce={touchmove:"ontouchmove"in n?"touchmove":ye.move,touchstart:"ontouchstart"in n?"touchstart":ye.down},Te=!1,Ae='a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]',Me=e.extend(!0,{},V),ke={};kt(),e.extend(e.easing,{easeInOutCubic:function(e,n,t,o,i){return(n/=i/2)<1?o/2*n*n*n+t:o/2*((n-=2)*n*n+2)+t}}),e.event.special.destroyed={remove:function(e){e.handler&&e.handler()}},e(this).length&&($.version="2.9.7",$.setAutoScrolling=Ze,$.setRecordHistory=Ne,$.setScrollingSpeed=je,$.setFitToSection=qe,$.setLockAnchors=function(e){V.lockAnchors=e},$.setMouseWheelScrolling=Ge,$.setAllowScrolling=Ue,$.setKeyboardScrolling=Qe,$.moveSectionUp=Je,$.moveSectionDown=Ke,$.silentMoveTo=_e,$.moveTo=$e,$.moveSlideRight=en,$.moveSlideLeft=nn,$.fitToSection=fn,$.reBuild=tn,$.setResponsive=on,$.getFullpageData=function(){return{options:V,internals:{canScroll:fe,isScrollAllowed:ve,getDestinationPosition:xn,isTouch:re,c:Ln,getXmovement:it,removeAnimation:nt,getTransforms:wt,lazyLoad:An,addAnimation:et,performHorizontalMove:Kn,landscapeScroll:Un,silentLandscapeScroll:mt,keepSlidesPosition:bn,silentScroll:St,styleSlides:rn,scrollHandler:cn,getEventsPage:gt,getMSPointer:pt,isReallyTouch:pn,usingExtension:yt,toggleControlArrows:Qn}}},$.destroy=function(n){le.trigger("destroy",[n]),Ze(!1,"internal"),Ue(!1),Qe(!1),le.addClass(c),clearTimeout(me),clearTimeout(ge),clearTimeout(pe),clearTimeout(Se),clearTimeout(we),J.off("scroll",cn).off("hashchange",Dn).off("resize",_n),K.off("keydown",Yn).off("keyup",Wn).off("click touchstart",M+" a").off("mouseenter",M+" li").off("mouseleave",M+" li").off("click touchstart",X).off("mouseover",V.normalScrollElements).off("mouseout",V.normalScrollElements),e(m).off("click touchstart",Z),yt("dragAndMove")&&$.dragAndMove.destroy();clearTimeout(me),clearTimeout(ge),n&&function(){St(0),le.find("img[data-src], source[data-src], audio[data-src], iframe[data-src]").each(function(){Tn(e(this),"src")}),le.find("img[data-srcset]").each(function(){Tn(e(this),"srcset")}),e(M+", "+W+", "+Z).remove(),e(m).css({height:"","background-color":"",padding:""}),e(I).css({width:""}),le.css({height:"",position:"","-ms-touch-action":"","touch-action":""}),G.css({overflow:"",height:""}),e("html").removeClass(d),_.removeClass(l),e.each(_.get(0).className.split(/\s+/),function(e,n){0===n.indexOf(f)&&_.removeClass(n)}),e(m+", "+I).each(function(){V.scrollOverflowHandler&&V.scrollOverflowHandler.remove(e(this)),e(this).removeClass(P+" "+u),e(this).attr("style",e(this).data("fp-styles"))}),xt(le),le.find(y+", "+D+", "+E).each(function(){e(this).replaceWith(this.childNodes)}),G.scrollTop(0);var n=[g,z,B];e.each(n,function(n,t){e("."+t).removeClass(t)})}()},$.landscapeScroll=Un,$.shared={afterRenderActions:sn},an("continuousHorizontal"),an("scrollHorizontally"),an("resetSliders"),an("interlockedSlides"),an("responsiveSlides"),an("fadingEffect"),an("dragAndMove"),an("offsetSections"),an("scrollOverflowReset"),an("parallax"),yt("dragAndMove")&&$.dragAndMove.init(),function(){V.css3&&(V.css3=function(){var e,o=t.createElement("p"),a={webkitTransform:"-webkit-transform",OTransform:"-o-transform",msTransform:"-ms-transform",MozTransform:"-moz-transform",transform:"transform"};for(var r in t.body.insertBefore(o,null),a)o.style[r]!==i&&(o.style[r]="translate3d(1px,1px,1px)",e=n.getComputedStyle(o).getPropertyValue(a[r]));return t.body.removeChild(o),e!==i&&e.length>0&&"none"!==e}());V.scrollBar=V.scrollBar||V.hybrid,o=le.find(V.sectionSelector),V.anchors.length||(V.anchors=o.filter("[data-anchor]").map(function(){return e(this).data("anchor").toString()}).get()),V.navigationTooltips.length||(V.navigationTooltips=o.filter("[data-tooltip]").map(function(){return e(this).data("tooltip").toString()}).get()),le.css({height:"100%",position:"relative"}),le.addClass(a),e("html").addClass(d),se=J.height(),le.removeClass(c),le.find(V.sectionSelector).addClass(g),le.find(V.slideSelector).addClass(z),Ct("parallax","init"),e(m).each(function(n){var t,o,i,a,l=e(this),s=l.find(I),c=s.length;l.data("fp-styles",l.attr("style")),i=l,(a=n)||0!==e(S).length||i.addClass(u),oe=e(S),i.css("height",ln(i)+"px"),V.paddingTop&&i.css("padding-top",V.paddingTop),V.paddingBottom&&i.css("padding-bottom",V.paddingBottom),void 0!==V.sectionsColor[a]&&i.css("background-color",V.sectionsColor[a]),void 0!==V.anchors[a]&&i.attr("data-anchor",V.anchors[a]),t=l,o=n,void 0!==V.anchors[o]&&t.hasClass(u)&&tt(V.anchors[o],o),V.menu&&V.css3&&e(V.menu).closest(r).length&&e(V.menu).appendTo(_),c>0?rn(l,s,c):V.verticalCentered&&at(l)}),V.fixedElements&&V.css3&&e(V.fixedElements).appendTo(_),V.navigation&&function(){_.append('<div id="'+A+'"><ul></ul></div>');var n=e(M);n.addClass(function(){return V.showActiveTooltip?R+" "+V.navigationPosition:V.navigationPosition});for(var t=0;t<e(m).length;t++){var o="";V.anchors.length&&(o=V.anchors[t]);var i='<li><a href="#'+o+'"><span></span></a>',a=V.navigationTooltips[t];void 0!==a&&""!==a&&(i+='<div class="'+k+" "+V.navigationPosition+'">'+a+"</div>"),i+="</li>",n.find("ul").append(i)}e(M).css("margin-top","-"+e(M).height()/2+"px"),e(M).find("li").eq(e(S).index(m)).find("a").addClass(u)}(),le.find('iframe[src*="youtube.com/embed/"]').each(function(){var n,t,o;n=e(this),t="enablejsapi=1",o=n.attr("src"),n.attr("src",o+(/\?/.test(o)?"&":"?")+t)}),V.fadingEffect&&$.fadingEffect&&$.fadingEffect.apply(),V.scrollOverflow?he=V.scrollOverflowHandler.init(V):sn(),Ue(!0),Ze(V.autoScrolling,"internal"),$n(),ht(),"complete"===t.readyState&&Bn();var o;J.on("load",Bn)}(),J.on("scroll",cn).on("hashchange",Dn).blur(Nn).resize(_n),K.keydown(Yn).keyup(Wn).on("click touchstart",M+" a",jn).on("click touchstart",X,qn).on("click",O,Fn),e(m).on("click touchstart",Z,Zn),V.normalScrollElements&&(K.on("mouseenter touchstart",V.normalScrollElements,function(){Ue(!1)}),K.on("mouseleave touchend",V.normalScrollElements,function(){Ue(!0)})),yt("dragAndMove")&&$.dragAndMove.turnOffTouch());var Oe,Re=!1,ze=0,Ie=0,Le=0,He=0,Ee=0;Oe=n.requestAnimationFrame||n.mozRequestAnimationFrame||n.webkitRequestAnimationFrame||n.msRequestAnimationFrame,n.requestAnimationFrame=Oe;var Be,De,Pe,Ye=(new Date).getTime(),Fe=!1,We=0,Xe=0,Ve=se}function Ze(n,t){n||St(0),Mt("autoScrolling",n,t);var o=e(S);V.autoScrolling&&!V.scrollBar?(G.css({overflow:"hidden",height:"100%"}),Ne(Me.recordHistory,"internal"),le.css({"-ms-touch-action":"none","touch-action":"none"}),o.length&&St(o.position().top)):(G.css({overflow:"visible",height:"initial"}),Ne(!1,"internal"),le.css({"-ms-touch-action":"","touch-action":""}),xt(le),o.length&&G.scrollTop(o.position().top)),le.trigger("setAutoScrolling",[n])}function Ne(e,n){Mt("recordHistory",e,n)}function je(e,n){"internal"!==n&&V.fadingEffect&&$.fadingEffect&&$.fadingEffect.update(e),Mt("scrollingSpeed",e,n)}function qe(e,n){Mt("fitToSection",e,n)}function Ge(e){e?(!function(){var e,o="";n.addEventListener?e="addEventListener":(e="attachEvent",o="on");var a="onwheel"in t.createElement("div")?"wheel":t.onmousewheel!==i?"mousewheel":"DOMMouseScroll";"DOMMouseScroll"==a?t[e](o+"MozMousePixelScroll",Sn,!1):t[e](o+a,Sn,!1)}(),le.on("mousedown",Xn).on("mouseup",Vn)):(t.addEventListener?(t.removeEventListener("mousewheel",Sn,!1),t.removeEventListener("wheel",Sn,!1),t.removeEventListener("MozMousePixelScroll",Sn,!1)):t.detachEvent("onmousewheel",Sn),le.off("mousedown",Xn).off("mouseup",Vn))}function Ue(n,t){void 0!==t?(t=t.replace(/ /g,"").split(","),e.each(t,function(e,t){bt(n,t,"m")})):(bt(n,"all","m"),n?(Ge(!0),(ae||re)&&(V.autoScrolling&&_.off(Ce.touchmove).on(Ce.touchmove,vn),e(r).off(Ce.touchstart).on(Ce.touchstart,gn).off(Ce.touchmove).on(Ce.touchmove,hn))):(Ge(!1),(ae||re)&&(V.autoScrolling&&_.off(Ce.touchmove),e(r).off(Ce.touchstart).off(Ce.touchmove))))}function Qe(n,t){void 0!==t?(t=t.replace(/ /g,"").split(","),e.each(t,function(e,t){bt(n,t,"k")})):(bt(n,"all","k"),V.keyboardScrolling=n)}function Je(){var n=e(S).prev(m);n.length||!V.loopTop&&!V.continuousVertical||(n=e(m).last()),n.length&&yn(n,null,!0)}function Ke(){var n=e(S).next(m);n.length||!V.loopBottom&&!V.continuousVertical||(n=e(m).first()),n.length&&yn(n,null,!1)}function _e(e,n){je(0,"internal"),$e(e,n),je(Me.scrollingSpeed,"internal")}function $e(e,n){var t=st(e);void 0!==n?ct(e,n):t.length>0&&yn(t)}function en(e){wn("right",e)}function nn(e){wn("left",e)}function tn(n){if(!le.hasClass(c)){ce=!0,se=J.height(),e(m).each(function(){var n=e(this).find(E),t=e(this).find(I);V.verticalCentered&&e(this).find(y).css("height",rt(e(this))+"px"),e(this).css("height",ln(e(this))+"px"),t.length>1&&Un(n,n.find(L))}),V.scrollOverflow&&he.createScrollBarForAll();var t=e(S).index(m);t&&!yt("fadingEffect")&&_e(t+1),ce=!1,e.isFunction(V.afterResize)&&n&&V.afterResize.call(le),e.isFunction(V.afterReBuild)&&!n&&V.afterReBuild.call(le),le.trigger("afterRebuild")}}function on(n){var t=_.hasClass(l);n?t||(Ze(!1,"internal"),qe(!1,"internal"),e(M).hide(),_.addClass(l),e.isFunction(V.afterResponsive)&&V.afterResponsive.call(le,n),V.responsiveSlides&&$.responsiveSlides&&$.responsiveSlides.toSections(),le.trigger("afterResponsive",[n])):t&&(Ze(Me.autoScrolling,"internal"),qe(Me.autoScrolling,"internal"),e(M).show(),_.removeClass(l),e.isFunction(V.afterResponsive)&&V.afterResponsive.call(le,n),V.responsiveSlides&&$.responsiveSlides&&$.responsiveSlides.toSlides(),le.trigger("afterResponsive",[n]))}function an(e){var t="fp_"+e+"Extension";ke[e]=V[e+"Key"],$[e]=void 0!==n[t]?new n[t]:null,$[e]&&$[e].c(e)}function rn(n,t,o){var i=100*o,a=100/o;t.wrapAll('<div class="'+B+'" />'),t.parent().wrap('<div class="'+H+'" />'),n.find(D).css("width",i+"%"),o>1&&(V.controlArrows&&function(e){e.find(E).after('<div class="'+j+'"></div><div class="'+U+'"></div>'),"#fff"!=V.controlArrowColor&&(e.find(Q).css("border-color","transparent transparent transparent "+V.controlArrowColor),e.find(q).css("border-color","transparent "+V.controlArrowColor+" transparent transparent"));V.loopHorizontal||e.find(q).hide()}(n),V.slidesNavigation&&function(e,n){e.append('<div class="'+F+'"><ul></ul></div>');var t=e.find(W);t.addClass(V.slidesNavPosition);for(var o=0;o<n;o++)t.find("ul").append('<li><a href="#"><span></span></a></li>');t.css("margin-left","-"+t.width()/2+"px"),t.find("li").first().find("a").addClass(u)}(n,o)),t.each(function(n){e(this).css("width",a+"%"),V.verticalCentered&&at(e(this))});var r=n.find(L);r.length&&(0!==e(S).index(m)||0===e(S).index(m)&&0!==r.index())?(mt(r,"internal"),r.addClass(Y)):t.eq(0).addClass(u)}function ln(e){return V.offsetSections&&$.offsetSections?o.round($.offsetSections.getWindowHeight(e)):se}function sn(){var n,t=e(S);t.addClass(h),An(t),Mn(t),V.scrollOverflow&&V.scrollOverflowHandler.afterLoad(),(!(n=st(Pn().section))||n.length&&n.index()===oe.index())&&e.isFunction(V.afterLoad)&&V.afterLoad.call(t,t.data("anchor"),t.index(m)+1),e.isFunction(V.afterRender)&&V.afterRender.call(le),le.trigger("afterRender")}function cn(){Fe||(requestAnimationFrame(dn),Fe=!0)}function dn(){var n,i,a;if(le.trigger("onScroll"),(!V.autoScrolling||V.scrollBar||yt("dragAndMove"))&&!At()){var r=yt("dragAndMove")?o.abs($.dragAndMove.getCurrentScroll()):J.scrollTop(),l=(a=(i=r)>ze?"down":"up",ze=i,We=i,0),s=r+J.height()/2,c=(yt("dragAndMove")?$.dragAndMove.getDocumentHeight():_.height()-J.height())===r,d=t.querySelectorAll(m);if(c)l=d.length-1;else if(r)for(var f=0;f<d.length;++f){d[f].offsetTop<=s&&(l=f)}else l=0;if(!(n=e(d).eq(l)).hasClass(u)){Re=!0;var v,h,p=e(S),g=p.index(m)+1,w=ot(n),b=n.data("anchor"),x=n.index(m)+1,y=n.find(L);y.length&&(h=y.data("anchor"),v=y.index()),fe&&(n.addClass(u).siblings().removeClass(u),Ct("parallax","afterLoad"),e.isFunction(V.onLeave)&&V.onLeave.call(p,g,x,w),e.isFunction(V.afterLoad)&&V.afterLoad.call(n,b,x),V.resetSliders&&$.resetSliders&&$.resetSliders.apply({localIsResizing:ce,leavingSection:g}),On(p),An(n),Mn(n),tt(b,x-1),V.anchors.length&&(ee=b),ft(v,h,b,x)),clearTimeout(Se),Se=setTimeout(function(){Re=!1},100)}V.fitToSection&&(clearTimeout(we),we=setTimeout(function(){V.fitToSection&&e(S).outerHeight()<=se&&fn()},V.fitToSectionDelay))}Fe=!1}function fn(){fe&&(ce=!0,yn(e(S)),ce=!1)}function un(n){if(ve.m[n]){var t="down"===n?Ke:Je;if($.scrollHorizontally&&(t=$.scrollHorizontally.getScrollSection(n,t)),V.scrollOverflow){var o=V.scrollOverflowHandler.scrollable(e(S)),i="down"===n?"bottom":"top";if(o.length>0){if(!V.scrollOverflowHandler.isScrolled(i,o))return!0;t()}else t()}else t()}}function vn(e){var n=e.originalEvent;V.autoScrolling&&pn(n)&&e.preventDefault()}function hn(n){var t=n.originalEvent,i=e(t.target).closest(m);if(pn(t)){V.autoScrolling&&n.preventDefault();var a=gt(t);He=a.y,Ee=a.x,i.find(E).length&&o.abs(Le-Ee)>o.abs(Ie-He)?!ie&&o.abs(Le-Ee)>J.outerWidth()/100*V.touchSensitivity&&(Le>Ee?ve.m.right&&en(i):ve.m.left&&nn(i)):V.autoScrolling&&fe&&o.abs(Ie-He)>J.height()/100*V.touchSensitivity&&(Ie>He?un("down"):He>Ie&&un("up"))}}function pn(e){return void 0===e.pointerType||"mouse"!=e.pointerType}function gn(e){var n=e.originalEvent;if(V.fitToSection&&G.stop(),pn(n)){var t=gt(n);Ie=t.y,Le=t.x}}function mn(e,n){for(var t=0,i=e.slice(o.max(e.length-n,1)),a=0;a<i.length;a++)t+=i[a];return o.ceil(t/n)}function Sn(t){var i=(new Date).getTime(),a=e(p).hasClass(T);if(V.autoScrolling&&!te&&!a){var r=(t=t||n.event).wheelDelta||-t.deltaY||-t.detail,l=o.max(-1,o.min(1,r)),s=void 0!==t.wheelDeltaX||void 0!==t.deltaX,c=o.abs(t.wheelDeltaX)<o.abs(t.wheelDelta)||o.abs(t.deltaX)<o.abs(t.deltaY)||!s;ue.length>149&&ue.shift(),ue.push(o.abs(r)),V.scrollBar&&(t.preventDefault?t.preventDefault():t.returnValue=!1);var d=i-Ye;if(Ye=i,d>200&&(ue=[]),fe&&!Tt())mn(ue,10)>=mn(ue,70)&&c&&un(l<0?"down":"up");return!1}V.fitToSection&&G.stop()}function wn(n,t){var o=(void 0===t?e(S):t).find(E);if(!(!o.length||Tt()||ie||o.find(I).length<2)){var i=o.find(L),a=null;if(!(a="left"===n?i.prev(I):i.next(I)).length){if(!V.loopHorizontal)return;a="left"===n?i.siblings(":last"):i.siblings(":first")}ie=!0,Un(o,a,n)}}function bn(){e(L).each(function(){mt(e(this),"internal")})}function xn(e){var n=e.position(),t=n.top,o=yt("dragAndMove")&&$.dragAndMove.isGrabbing?$.dragAndMove.isScrollingDown():n.top>We,i=t-se+e.outerHeight(),a=V.bigSectionsDestination;return e.outerHeight()>se?(o||a)&&"bottom"!==a||(t=i):(o||ce&&e.is(":last-child"))&&(t=i),V.offsetSections&&$.offsetSections&&(t=$.offsetSections.getSectionPosition(o,t,e)),We=t,t}function yn(n,t,i){if(void 0!==n&&n.length){var a,l,s={element:n,callback:t,isMovementUp:i,dtop:xn(n),yMovement:ot(n),anchorLink:n.data("anchor"),sectionIndex:n.index(m),activeSlide:n.find(L),activeSection:e(S),leavingSection:e(S).index(m)+1,localIsResizing:ce};if(!(s.activeSection.is(n)&&!ce||V.scrollBar&&J.scrollTop()===s.dtop&&!n.hasClass(C))){if(s.activeSlide.length&&(a=s.activeSlide.data("anchor"),l=s.activeSlide.index()),e.isFunction(V.onLeave)&&!s.localIsResizing){var c=s.yMovement;if(void 0!==i&&(c=i?"up":"down"),!1===V.onLeave.call(s.activeSection,s.leavingSection,s.sectionIndex+1,c))return}Ct("parallax","apply",s),V.autoScrolling&&V.continuousVertical&&void 0!==s.isMovementUp&&(!s.isMovementUp&&"up"==s.yMovement||s.isMovementUp&&"down"==s.yMovement)&&(s=function(n){n.isMovementUp?n.activeSection.before(n.activeSection.nextAll(m)):n.activeSection.after(n.activeSection.prevAll(m).get().reverse());return St(e(S).position().top),bn(),n.wrapAroundElements=n.activeSection,n.dtop=n.element.position().top,n.yMovement=ot(n.element),n.leavingSection=n.activeSection.index(m)+1,n.sectionIndex=n.element.index(m),e(r).trigger("onContinuousVertical",[n]),n}(s)),yt("scrollOverflowReset")&&$.scrollOverflowReset.setPrevious(s.activeSection),s.localIsResizing||On(s.activeSection),V.scrollOverflow&&V.scrollOverflowHandler.beforeLeave(),n.addClass(u).siblings().removeClass(u),An(n),V.scrollOverflow&&V.scrollOverflowHandler.onLeave(),fe=!1,ft(l,a,s.anchorLink,s.sectionIndex),function(n){if(V.css3&&V.autoScrolling&&!V.scrollBar){var t="translate3d(0px, -"+o.round(n.dtop)+"px, 0px)";lt(t,!0),V.scrollingSpeed?(clearTimeout(ge),ge=setTimeout(function(){Cn(n)},V.scrollingSpeed)):Cn(n)}else{var i=function(e){var n={};V.autoScrolling&&!V.scrollBar?(n.options={top:-e.dtop},n.element=r):(n.options={scrollTop:e.dtop},n.element="html, body");return n}(n);e(i.element).animate(i.options,V.scrollingSpeed,V.easing).promise().done(function(){V.scrollBar?setTimeout(function(){Cn(n)},30):Cn(n)})}}(s),ee=s.anchorLink,tt(s.anchorLink,function(n){if(n.wrapAroundElements&&n.wrapAroundElements.length)return n.isMovementUp?e(m).length-1:0;return n.sectionIndex}(s))}}}function Cn(n){var t;(t=n).wrapAroundElements&&t.wrapAroundElements.length&&(t.isMovementUp?e(w).before(t.wrapAroundElements):e(b).after(t.wrapAroundElements),St(e(S).position().top),bn(),t.sectionIndex=t.element.index(m),t.leavingSection=t.activeSection.index(m)+1),e.isFunction(V.afterLoad)&&!n.localIsResizing&&V.afterLoad.call(n.element,n.anchorLink,n.sectionIndex+1),V.scrollOverflow&&V.scrollOverflowHandler.afterLoad(),Ct("parallax","afterLoad"),yt("scrollOverflowReset")&&$.scrollOverflowReset.reset(),V.resetSliders&&$.resetSliders&&$.resetSliders.apply(n),n.localIsResizing||Mn(n.element),n.element.addClass(h).siblings().removeClass(h),fe=!0,e.isFunction(n.callback)&&n.callback.call(this)}function Tn(e,n){e.attr(n,e.data(n)).removeAttr("data-"+n)}function An(n){var t;V.lazyLoading&&Rn(n).find("img[data-src], img[data-srcset], source[data-src], source[data-srcset], video[data-src], audio[data-src], iframe[data-src]").each(function(){if(t=e(this),e.each(["src","srcset"],function(e,n){var o=t.attr("data-"+n);void 0!==o&&o&&Tn(t,n)}),t.is("source")){var n=t.closest("video").length?"video":"audio";t.closest(n).get(0).load()}})}function Mn(n){var t=Rn(n);t.find("video, audio").each(function(){var n=e(this).get(0);n.hasAttribute("data-autoplay")&&"function"==typeof n.play&&n.play()}),t.find('iframe[src*="youtube.com/embed/"]').each(function(){var n=e(this).get(0);n.hasAttribute("data-autoplay")&&kn(n),n.onload=function(){n.hasAttribute("data-autoplay")&&kn(n)}})}function kn(e){e.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}',"*")}function On(n){var t=Rn(n);t.find("video, audio").each(function(){var n=e(this).get(0);n.hasAttribute("data-keepplaying")||"function"!=typeof n.pause||n.pause()}),t.find('iframe[src*="youtube.com/embed/"]').each(function(){var n=e(this).get(0);/youtube\.com\/embed\//.test(e(this).attr("src"))&&!n.hasAttribute("data-keepplaying")&&e(this).get(0).contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}',"*")})}function Rn(n){var t=n.find(L);return t.length&&(n=e(t)),n}function zn(e){var n="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";function t(e){var t,o,i,a,r,l,s="",c=0;for(e=e.replace(/[^A-Za-z0-9+/=]/g,"");c<e.length;)t=n.indexOf(e.charAt(c++))<<2|(a=n.indexOf(e.charAt(c++)))>>4,o=(15&a)<<4|(r=n.indexOf(e.charAt(c++)))>>2,i=(3&r)<<6|(l=n.indexOf(e.charAt(c++))),s+=String.fromCharCode(t),64!=r&&(s+=String.fromCharCode(o)),64!=l&&(s+=String.fromCharCode(i));return s=function(e){var n,t="",o=0,i=0,a=0;for(;o<e.length;)(i=e.charCodeAt(o))<128?(t+=String.fromCharCode(i),o++):i>191&&i<224?(a=e.charCodeAt(o+1),t+=String.fromCharCode((31&i)<<6|63&a),o+=2):(a=e.charCodeAt(o+1),n=e.charCodeAt(o+2),t+=String.fromCharCode((15&i)<<12|(63&a)<<6|63&n),o+=3);return t}(s)}function o(e){return e.slice(3).slice(0,-3)}return function(e){var n=e.split("_");if(n.length>1){var i=n[1];return e.replace(o(n[1]),"").split("_")[0]+"_"+t(i.slice(3).slice(0,-3))}return o(e)}(t(e))}function In(e){var n=function(){if(t.domain.length){for(var e=t.domain.replace(/^(www\.)/,"").split(".");e.length>2;)e.shift();return e.join(".").replace(/(^\.*)|(\.*$)/g,"")}return""}(),o=["MTM0bG9jYWxob3N0MjM0","MTM0MC4xMjM0","MTM0anNoZWxsLm5ldDIzNA==","UDdDQU5ZNlNN"],i=zn(o[0]),a=zn(o[1]),r=zn(o[2]),l=zn(o[3]),s=[i,a,r].indexOf(n)<0&&0!==n.length,c=void 0!==ke[e]&&ke[e].length;if(!c&&s)return!1;var d=c?zn(ke[e]):"",f=(d=d.split("_")).length>1&&d[1].indexOf(e,d[1].length-e.length)>-1;return!(d[0].indexOf(n,d[0].length-n.length)<0&&s&&l!=d[0])&&f||!s}function Ln(n){Be=zn("MTIzPGRpdj48YSBocmVmPSJodHRwOi8vYWx2YXJvdHJpZ28uY29tL2Z1bGxQYWdlL2V4dGVuc2lvbnMvIiBzdHlsZT0iY29sb3I6ICNmZmYgIWltcG9ydGFudDsgdGV4dC1kZWNvcmF0aW9uOm5vbmUgIWltcG9ydGFudDsiPlVubGljZW5zZWQgZnVsbFBhZ2UuanMgRXh0ZW5zaW9uPC9hPjwvZGl2PjEyMw=="),De=e("<div/>").html(Be).contents(),yt(n)&&$[n]&&(In(n)||(Hn(),setInterval(Hn,2e3)))}function Hn(){Te||(o.random()<.5?_.prepend(De):_.append(De),Te=!0,De.bind("destroyed",function(){clearTimeout(Pe),Pe=setTimeout(En,900)})),e(De).attr("style",zn("MTIzei1pbmRleDo5OTk5OTk5O3Bvc2l0aW9uOmZpeGVkO3RvcDoyMHB4O2JvdHRvbTphdXRvO2xlZnQ6MjBweDtyaWdodDphdXRvO2JhY2tncm91bmQ6cmVkO3BhZGRpbmc6N3B4IDE1cHg7Zm9udC1zaXplOjE0cHg7Zm9udC1mYW1pbHk6YXJpYWw7Y29sb3I6I2ZmZjtkaXNwbGF5OmlubGluZS1ibG9jazt0cmFuc2Zvcm06dHJhbnNsYXRlM2QoMCwwLDApO29wYWNpdHk6MTtoZWlnaHQ6YXV0bzt3aWR0aDphdXRvO3pvb206MTttYXJnaW46YXV0bztib3JkZXI6bm9uZTt2aXNpYmlsaXR5OnZpc2libGU7Y2xpcC1wYXRoOm5vbmU7MTIz").replace(/;/g,zn("MTIzICFpbXBvcnRhbnQ7MzQ1")))}function En(){Te=!1}function Bn(){var e=Pn(),n=e.section,t=e.slide;n&&(V.animateAnchor?ct(n,t):_e(n,t))}function Dn(){if(!Re&&!V.lockAnchors){var e=Pn(),n=e.section,t=e.slide,o=void 0===ee,i=void 0===ee&&void 0===t&&!ie;n&&n.length&&(n&&n!==ee&&!o||i||!ie&&ne!=t)&&ct(n,t)}}function Pn(){var e,t,o=n.location.hash;if(o.length){var i=o.replace("#","").split("/"),a=o.indexOf("#/")>-1;e=a?"/"+i[1]:decodeURIComponent(i[0]);var r=a?i[2]:i[1];r&&r.length&&(t=decodeURIComponent(r))}return{section:e,slide:t}}function Yn(n){clearTimeout(be);var t=e(":focus"),o=n.which;if(9===o)!function(n){var t=n.shiftKey,o=e(":focus"),i=e(S),a=i.find(L),r=(a.length?a:i).find(Ae).not('[tabindex="-1"]');function l(e){return e.preventDefault(),r.first().focus()}o.length?o.closest(S,L).length||(o=l(n)):l(n);(!t&&o.is(r.last())||t&&o.is(r.first()))&&n.preventDefault()}(n);else if(!t.is("textarea")&&!t.is("input")&&!t.is("select")&&"true"!==t.attr("contentEditable")&&""!==t.attr("contentEditable")&&V.keyboardScrolling&&V.autoScrolling){e.inArray(o,[40,38,32,33,34])>-1&&n.preventDefault(),te=n.ctrlKey,be=setTimeout(function(){!function(n){var t=n.shiftKey;if(!fe&&[37,39].indexOf(n.which)<0)return;switch(n.which){case 38:case 33:ve.k.up&&Je();break;case 32:if(t&&ve.k.up){Je();break}case 40:case 34:ve.k.down&&Ke();break;case 36:ve.k.up&&$e(1);break;case 35:ve.k.down&&$e(e(m).length);break;case 37:ve.k.left&&nn();break;case 39:ve.k.right&&en();break;default:;}}(n)},150)}}function Fn(){e(this).prev().trigger("click")}function Wn(e){de&&(te=e.ctrlKey)}function Xn(e){2==e.which&&(Xe=e.pageY,le.on("mousemove",Gn))}function Vn(e){2==e.which&&le.off("mousemove")}function Zn(){var n=e(this).closest(m);e(this).hasClass(N)?ve.m.left&&nn(n):ve.m.right&&en(n)}function Nn(){de=!1,te=!1}function jn(n){n.preventDefault();var t=e(this).parent().index();yn(e(m).eq(t))}function qn(n){n.preventDefault();var t=e(this).closest(m).find(E);Un(t,t.find(I).eq(e(this).closest("li").index()))}function Gn(e){fe&&(e.pageY<Xe&&ve.m.up?Je():e.pageY>Xe&&ve.m.down&&Ke()),Xe=e.pageY}function Un(n,t,o){var i=n.closest(m),a={slides:n,destiny:t,direction:o,destinyPos:t.position(),slideIndex:t.index(),section:i,sectionIndex:i.index(m),anchorLink:i.data("anchor"),slidesNav:i.find(W),slideAnchor:vt(t),prevSlide:i.find(L),prevSlideIndex:i.find(L).index(),localIsResizing:ce};a.xMovement=it(a.prevSlideIndex,a.slideIndex),a.localIsResizing||(fe=!1),Ct("parallax","applyHorizontal",a),V.onSlideLeave&&!a.localIsResizing&&"none"!==a.xMovement&&e.isFunction(V.onSlideLeave)&&!1===V.onSlideLeave.call(a.prevSlide,a.anchorLink,a.sectionIndex+1,a.prevSlideIndex,a.direction,a.slideIndex)?ie=!1:(t.addClass(u).siblings().removeClass(u),a.localIsResizing||(On(a.prevSlide),An(t)),Qn(a),i.hasClass(u)&&!a.localIsResizing&&ft(a.slideIndex,a.slideAnchor,a.anchorLink,a.sectionIndex),$.continuousHorizontal&&$.continuousHorizontal.apply(a),At()?Jn(a):Kn(n,a,!0),V.interlockedSlides&&$.interlockedSlides&&(yt("continuousHorizontal")&&void 0!==o&&o!==a.xMovement||$.interlockedSlides.apply(a)))}function Qn(e){!V.loopHorizontal&&V.controlArrows&&(e.section.find(q).toggle(0!==e.slideIndex),e.section.find(Q).toggle(!e.destiny.is(":last-child")))}function Jn(n){var t,o;$.continuousHorizontal&&$.continuousHorizontal.afterSlideLoads(n),t=n.slidesNav,o=n.slideIndex,t.find(v).removeClass(u),t.find("li").eq(o).find("a").addClass(u),n.localIsResizing||(Ct("parallax","afterSlideLoads"),e.isFunction(V.afterSlideLoad)&&V.afterSlideLoad.call(n.destiny,n.anchorLink,n.sectionIndex+1,n.slideAnchor,n.slideIndex),fe=!0,Mn(n.destiny)),ie=!1,yt("interlockedSlides")&&$.interlockedSlides.apply(n)}function Kn(e,n,t){var i=n.destinyPos;if(V.css3){var a="translate3d(-"+o.round(i.left)+"px, 0px, 0px)";et(e.find(D)).css(wt(a)),me=setTimeout(function(){t&&Jn(n)},V.scrollingSpeed,V.easing)}else e.animate({scrollLeft:o.round(i.left)},V.scrollingSpeed,V.easing,function(){t&&Jn(n)})}function _n(){if(le.trigger("onResize"),$n(),ae){var n=e(t.activeElement);if(!n.is("textarea")&&!n.is("input")&&!n.is("select")){var i=J.height();o.abs(i-Ve)>20*o.max(Ve,i)/100&&(tn(!0),Ve=i)}}else clearTimeout(pe),pe=setTimeout(function(){tn(!0)},350)}function $n(){var e=V.responsive||V.responsiveWidth,n=V.responsiveHeight,t=e&&J.outerWidth()<e,o=n&&J.height()<n;e&&n?on(t||o):e?on(t):n&&on(o)}function et(e){var n="all "+V.scrollingSpeed+"ms "+V.easingcss3;return e.removeClass(s),e.css({"-webkit-transition":n,transition:n})}function nt(e){return e.addClass(s)}function tt(n,t){var o,i,a;o=n,V.menu&&(e(V.menu).find(v).removeClass(u),e(V.menu).find('[data-menuanchor="'+o+'"]').addClass(u)),i=n,a=t,V.navigation&&(e(M).find(v).removeClass(u),i?e(M).find('a[href="#'+i+'"]').addClass(u):e(M).find("li").eq(a).find("a").addClass(u))}function ot(n){var t=e(S).index(m),o=n.index(m);return t==o?"none":t>o?"up":"down"}function it(e,n){return e==n?"none":e>n?"left":"right"}function at(n){if(!n.hasClass(P)){var t=e('<div class="'+x+'" />').height(rt(n));n.addClass(P).wrapInner(t)}}function rt(e){var n=ln(e);if(V.paddingTop||V.paddingBottom){var t=e;t.hasClass(g)||(t=e.closest(m)),n-=parseInt(t.css("padding-top"))+parseInt(t.css("padding-bottom"))}return n}function lt(e,n){n?et(le):nt(le),clearTimeout(xe),le.css(wt(e)),xe=setTimeout(function(){le.removeClass(s)},10)}function st(n){var t=le.find(m+'[data-anchor="'+n+'"]');if(!t.length){var o=void 0!==n?n-1:0;t=e(m).eq(o)}return t}function ct(e,n){var t=st(e);if(t.length){var o,i,a,r=(o=n,(a=(i=t).find(I+'[data-anchor="'+o+'"]')).length||(o=void 0!==o?o:0,a=i.find(I).eq(o)),a);e===ee||t.hasClass(u)?dt(r):yn(t,function(){dt(r)})}}function dt(e){e.length&&Un(e.closest(E),e)}function ft(e,n,t,o){var i="";V.anchors.length&&!V.lockAnchors&&(e?(void 0!==t&&(i=t),void 0===n&&(n=e),ne=n,ut(i+"/"+n)):void 0!==e?(ne=n,ut(t)):ut(t)),ht()}function ut(e){if(V.recordHistory)location.hash=e;else if(ae||re)n.history.replaceState(i,i,"#"+e);else{var t=n.location.href.split("#")[0];n.location.replace(t+"#"+e)}}function vt(e){var n=e.data("anchor"),t=e.index();return void 0===n&&(n=t),n}function ht(){var n=e(S),t=n.find(L),o=vt(n),i=vt(t),a=String(o);t.length&&(a=a+"-"+i),a=a.replace("/","-").replace("#","");var r=new RegExp("\\b\\s?"+f+"-[^\\s]+\\b","g");_[0].className=_[0].className.replace(r,""),_.addClass(f+"-"+a)}function pt(){return n.PointerEvent?{down:"pointerdown",move:"pointermove"}:{down:"MSPointerDown",move:"MSPointerMove"}}function gt(e){var n=[];return n.y=void 0!==e.pageY&&(e.pageY||e.pageX)?e.pageY:e.touches[0].pageY,n.x=void 0!==e.pageX&&(e.pageY||e.pageX)?e.pageX:e.touches[0].pageX,re&&pn(e)&&V.scrollBar&&void 0!==e.touches&&(n.y=e.touches[0].pageY,n.x=e.touches[0].pageX),n}function mt(e,n){je(0,"internal"),void 0!==n&&(ce=!0),Un(e.closest(E),e),void 0!==n&&(ce=!1),je(Me.scrollingSpeed,"internal")}function St(e){var n=o.round(e);V.css3&&V.autoScrolling&&!V.scrollBar?lt("translate3d(0px, -"+n+"px, 0px)",!1):V.autoScrolling&&!V.scrollBar?le.css("top",-n):G.scrollTop(n)}function wt(e){return{"-webkit-transform":e,"-moz-transform":e,"-ms-transform":e,transform:e}}function bt(n,t,o){"all"!==t?ve[o][t]=n:e.each(Object.keys(ve[o]),function(e,t){ve[o][t]=n})}function xt(e){return e.css({"-webkit-transition":"none",transition:"none"})}function yt(e){return null!==V[e]&&"object"==typeof V[e]?V[e].enabled&&$[e]:V[e]&&$[e]}function Ct(e,n,t){if(yt(e))return $[e][n](t)}function Tt(){return yt("dragAndMove")&&$.dragAndMove.isAnimating}function At(){return yt("dragAndMove")&&$.dragAndMove.isGrabbing}function Mt(e,n,t){V[e]=n,"internal"!==t&&(Me[e]=n)}function kt(){e("html").hasClass(d)?Ot("error","Fullpage.js can only be initialized once and you are doing it multiple times!"):(V.continuousVertical&&(V.loopTop||V.loopBottom)&&(V.continuousVertical=!1,Ot("warn","Option `loopTop/loopBottom` is mutually exclusive with `continuousVertical`; `continuousVertical` disabled")),V.scrollBar&&V.scrollOverflow&&Ot("warn","Option `scrollBar` is mutually exclusive with `scrollOverflow`. Sections with scrollOverflow might not work well in Firefox"),!V.continuousVertical||!V.scrollBar&&V.autoScrolling||(V.continuousVertical=!1,Ot("warn","Scroll bars (`scrollBar:true` or `autoScrolling:false`) are mutually exclusive with `continuousVertical`; `continuousVertical` disabled")),V.scrollOverflow&&!V.scrollOverflowHandler&&(V.scrollOverflow=!1,Ot("error","The option `scrollOverflow:true` requires the file `scrolloverflow.min.js`. Please include it before fullPage.js.")),e.each(V.anchors,function(n,t){var o=K.find("[name]").filter(function(){return e(this).attr("name")&&e(this).attr("name").toLowerCase()==t.toLowerCase()}),i=K.find("[id]").filter(function(){return e(this).attr("id")&&e(this).attr("id").toLowerCase()==t.toLowerCase()});(i.length||o.length)&&(Ot("error","data-anchor tags can not have the same value as any `id` element on the site (or `name` element for IE)."),i.length&&Ot("error",'"'+t+'" is is being used by another element `id` property'),o.length&&Ot("error",'"'+t+'" is is being used by another element `name` property'))}))}function Ot(e,n){console&&console[e]&&console[e]("fullPage: "+n)}}});
 
 //------------------------------------------
 /*!
  * fullPage 2.9.7
  * https://github.com/alvarotrigo/fullPage.js
  * @license MIT licensed
  *
  * Copyright (C) 2015 alvarotrigo.com - A project by Alvaro Trigo
  */
 (function(global, factory) {
     'use strict';
     if (typeof define === 'function' && define.amd) {
         define(['jquery'], function($) {
           return factory($, global, global.document, global.Math);
         });
     } else if (typeof exports === "object" && exports) {
         module.exports = factory(require('jquery'), global, global.document, global.Math);
     } else {
         factory(jQuery, global, global.document, global.Math);
     }
 })(typeof window !== 'undefined' ? window : this, function($, window, document, Math, undefined) {
     'use strict';
 
     // keeping central set of classnames and selectors
     var WRAPPER =               'fullpage-wrapper';
     var WRAPPER_SEL =           '.' + WRAPPER;
 
     // slimscroll
     var SCROLLABLE =            'fp-scrollable';
     var SCROLLABLE_SEL =        '.' + SCROLLABLE;
 
     // util
     var RESPONSIVE =            'fp-responsive';
     var NO_TRANSITION =         'fp-notransition';
     var DESTROYED =             'fp-destroyed';
     var ENABLED =               'fp-enabled';
     var VIEWING_PREFIX =        'fp-viewing';
     var ACTIVE =                'active';
     var ACTIVE_SEL =            '.' + ACTIVE;
     var COMPLETELY =            'fp-completely';
     var COMPLETELY_SEL =        '.' + COMPLETELY;
 
     // section
     var SECTION_DEFAULT_SEL =   '.section';
     var SECTION =               'fp-section';
     var SECTION_SEL =           '.' + SECTION;
     var SECTION_ACTIVE_SEL =    SECTION_SEL + ACTIVE_SEL;
     var SECTION_FIRST_SEL =     SECTION_SEL + ':first';
     var SECTION_LAST_SEL =      SECTION_SEL + ':last';
     var TABLE_CELL =            'fp-tableCell';
     var TABLE_CELL_SEL =        '.' + TABLE_CELL;
     var AUTO_HEIGHT =           'fp-auto-height';
     var AUTO_HEIGHT_SEL =       '.fp-auto-height';
     var NORMAL_SCROLL =         'fp-normal-scroll';
     var NORMAL_SCROLL_SEL =     '.fp-normal-scroll';
 
     // section nav
     var SECTION_NAV =           'fp-nav';
     var SECTION_NAV_SEL =       '#' + SECTION_NAV;
     var SECTION_NAV_TOOLTIP =   'fp-tooltip';
     var SECTION_NAV_TOOLTIP_SEL='.'+SECTION_NAV_TOOLTIP;
     var SHOW_ACTIVE_TOOLTIP =   'fp-show-active';
 
     // slide
     var SLIDE_DEFAULT_SEL =     '.slide';
     var SLIDE =                 'fp-slide';
     var SLIDE_SEL =             '.' + SLIDE;
     var SLIDE_ACTIVE_SEL =      SLIDE_SEL + ACTIVE_SEL;
     var SLIDES_WRAPPER =        'fp-slides';
     var SLIDES_WRAPPER_SEL =    '.' + SLIDES_WRAPPER;
     var SLIDES_CONTAINER =      'fp-slidesContainer';
     var SLIDES_CONTAINER_SEL =  '.' + SLIDES_CONTAINER;
     var TABLE =                 'fp-table';
 
     // slide nav
     var SLIDES_NAV =            'fp-slidesNav';
     var SLIDES_NAV_SEL =        '.' + SLIDES_NAV;
     var SLIDES_NAV_LINK_SEL =   SLIDES_NAV_SEL + ' a';
     var SLIDES_ARROW =          'fp-controlArrow';
     var SLIDES_ARROW_SEL =      '.' + SLIDES_ARROW;
     var SLIDES_PREV =           'fp-prev';
     var SLIDES_PREV_SEL =       '.' + SLIDES_PREV;
     var SLIDES_ARROW_PREV =     SLIDES_ARROW + ' ' + SLIDES_PREV;
     var SLIDES_ARROW_PREV_SEL = SLIDES_ARROW_SEL + SLIDES_PREV_SEL;
     var SLIDES_NEXT =           'fp-next';
     var SLIDES_NEXT_SEL =       '.' + SLIDES_NEXT;
     var SLIDES_ARROW_NEXT =     SLIDES_ARROW + ' ' + SLIDES_NEXT;
     var SLIDES_ARROW_NEXT_SEL = SLIDES_ARROW_SEL + SLIDES_NEXT_SEL;
 
     var $window = $(window);
     var $document = $(document);
 
     $.fn.fullpage = function(options) {
         //only once my friend!
         if($('html').hasClass(ENABLED)){ displayWarnings(); return; }
 
         // common jQuery objects
         var $htmlBody = $('html, body');
         var $body = $('body');
 
         var FP = $.fn.fullpage;
 
         // Creating some defaults, extending them with any options that were provided
         options = $.extend({
             //navigation
             menu: false,
             anchors:[],
             lockAnchors: false,
             navigation: false,
             navigationPosition: 'right',
             navigationTooltips: [],
             showActiveTooltip: false,
             slidesNavigation: false,
             slidesNavPosition: 'bottom',
             scrollBar: false,
             hybrid: false,
 
             //scrolling
             css3: true,
             scrollingSpeed: 700,
             autoScrolling: true,
             fitToSection: true,
             fitToSectionDelay: 1000,
             easing: 'easeInOutCubic',
             easingcss3: 'ease',
             loopBottom: false,
             loopTop: false,
             loopHorizontal: true,
             continuousVertical: false,
             continuousHorizontal: false,
             scrollHorizontally: false,
             interlockedSlides: false,
             dragAndMove: false,
             offsetSections: false,
             resetSliders: false,
             fadingEffect: false,
             normalScrollElements: null,
             scrollOverflow: false,
             scrollOverflowReset: false,
             scrollOverflowHandler: $.fn.fp_scrolloverflow ? $.fn.fp_scrolloverflow.iscrollHandler : null,
             scrollOverflowOptions: null,
             touchSensitivity: 5,
             normalScrollElementTouchThreshold: 5,
             bigSectionsDestination: null,
 
             //Accessibility
             keyboardScrolling: true,
             animateAnchor: true,
             recordHistory: true,
 
             //design
             controlArrows: true,
             controlArrowColor: '#fff',
             verticalCentered: true,
             sectionsColor : [],
             paddingTop: 0,
             paddingBottom: 0,
             fixedElements: null,
             responsive: 0, //backwards compabitility with responsiveWiddth
             responsiveWidth: 0,
             responsiveHeight: 0,
             responsiveSlides: false,
             parallax: false,
             parallaxOptions: {
                 type: 'reveal',
                 percentage: 62,
                 property: 'translate'
             },
 
             //Custom selectors
             sectionSelector: SECTION_DEFAULT_SEL,
             slideSelector: SLIDE_DEFAULT_SEL,
 
             //events
             afterLoad: null,
             onLeave: null,
             afterRender: null,
             afterResize: null,
             afterReBuild: null,
             afterSlideLoad: null,
             onSlideLeave: null,
             afterResponsive: null,
 
             lazyLoading: true
         }, options);
 
         //flag to avoid very fast sliding for landscape sliders
         var slideMoving = false;
 
         var isTouchDevice = navigator.userAgent.match(/(iPhone|iPod|iPad|Android|playbook|silk|BlackBerry|BB10|Windows Phone|Tizen|Bada|webOS|IEMobile|Opera Mini)/);
         var isTouch = (('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0) || (navigator.maxTouchPoints));
         var container = $(this);
         var windowsHeight = $window.height();
         var isResizing = false;
         var isWindowFocused = true;
         var lastScrolledDestiny;
         var lastScrolledSlide;
         var canScroll = true;
         var scrollings = [];
         var controlPressed;
         var startingSection;
         var isScrollAllowed = {};
         isScrollAllowed.m = {  'up':true, 'down':true, 'left':true, 'right':true };
         isScrollAllowed.k = $.extend(true,{}, isScrollAllowed.m);
         var MSPointer = getMSPointer();
         var events = {
             touchmove: 'ontouchmove' in window ? 'touchmove' :  MSPointer.move,
             touchstart: 'ontouchstart' in window ? 'touchstart' :  MSPointer.down
         };
         var scrollBarHandler;
 
         // taken from https://github.com/udacity/ud891/blob/gh-pages/lesson2-focus/07-modals-and-keyboard-traps/solution/modal.js
         var focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]';
 
         //timeouts
         var resizeId;
         var afterSectionLoadsId;
         var afterSlideLoadsId;
         var scrollId;
         var scrollId2;
         var keydownId;
         var originals = $.extend(true, {}, options); //deep copy
 
         displayWarnings();
 
         //easeInOutCubic animation included in the plugin
         $.extend($.easing,{ easeInOutCubic: function (x, t, b, c, d) {if ((t/=d/2) < 1) return c/2*t*t*t + b;return c/2*((t-=2)*t*t + 2) + b;}});
 
         /**
         * Sets the autoScroll option.
         * It changes the scroll bar visibility and the history of the site as a result.
         */
         function setAutoScrolling(value, type){
             //removing the transformation
             if(!value){
                  silentScroll(0);
            }

            var element = $(SECTION_ACTIVE_SEL);
            setVariableState('autoScrolling', value, type);
 
             if(options.autoScrolling && !options.scrollBar){
                 $htmlBody.css({
                     'overflow' : 'hidden',
                     'height' : '100%'
                 });
 
                 setRecordHistory(originals.recordHistory, 'internal');
 
                 //for IE touch devices
                 container.css({
                     '-ms-touch-action': 'none',
                     'touch-action': 'none'
                 });
 
                 if(element.length){
                     //moving the container up
                     silentScroll(element.position().top);
                 }
 
             }else{
                 $htmlBody.css({
                     'overflow' : 'visible',
                     'height' : 'initial'
                 });
                 
                 
                 setRecordHistory(false, 'internal');
                 
                 //for IE touch devices
                 container.css({
                     '-ms-touch-action': '',
                     'touch-action': ''
                    });
                    
                //  scrolling the page to the section with no animation
                if (element.length) {
                    // $(window).scrollTop(element.position().top);
                }
             }
         }
 
         /**
         * Defines wheter to record the history for each hash change in the URL.
         */
         function setRecordHistory(value, type){
             setVariableState('recordHistory', value, type);
         }
 
         /**
         * Defines the scrolling speed
         */
         function setScrollingSpeed(value, type){
             setVariableState('scrollingSpeed', value, type);
         }
 
         /**
         * Sets fitToSection
         */
         function setFitToSection(value, type){
             setVariableState('fitToSection', value, type);
         }
 
         /**
         * Sets lockAnchors
         */
         function setLockAnchors(value){
             options.lockAnchors = value;
         }
 
         /**
         * Adds or remove the possibility of scrolling through sections by using the mouse wheel or the trackpad.
         */
         function setMouseWheelScrolling(value){
             if(value){
                 addMouseWheelHandler();
                 addMiddleWheelHandler();
             }else{
                 removeMouseWheelHandler();
                 removeMiddleWheelHandler();
             }
         }
 
         /**
         * Adds or remove the possibility of scrolling through sections by using the mouse wheel/trackpad or touch gestures.
         * Optionally a second parameter can be used to specify the direction for which the action will be applied.
         *
         * @param directions string containing the direction or directions separated by comma.
         */
         function setAllowScrolling(value, directions){
             if(typeof directions !== 'undefined'){
                 directions = directions.replace(/ /g,'').split(',');
 
                 $.each(directions, function (index, direction){
                     setIsScrollAllowed(value, direction, 'm');
                 });
             }
             else{
                 setIsScrollAllowed(value, 'all', 'm');
 
                 if(value){
                     setMouseWheelScrolling(true);
                     addTouchHandler();
                 }else{
                     setMouseWheelScrolling(false);
                     removeTouchHandler();
                 }
             }
         }
 
         /**
         * Adds or remove the possibility of scrolling through sections by using the keyboard arrow keys
         */
         function setKeyboardScrolling(value, directions){
             if(typeof directions !== 'undefined'){
                 directions = directions.replace(/ /g,'').split(',');
 
                 $.each(directions, function (index, direction){
                     setIsScrollAllowed(value, direction, 'k');
                 });
             }else{
                 setIsScrollAllowed(value, 'all', 'k');
                 options.keyboardScrolling = value;
             }
         }
 
         /**
         * Moves the page up one section.
         */
         function moveSectionUp(){
             var prev = $(SECTION_ACTIVE_SEL).prev(SECTION_SEL);
 
             //looping to the bottom if there's no more sections above
             if (!prev.length && (options.loopTop || options.continuousVertical)) {
                 prev = $(SECTION_SEL).last();
             }
 
             if (prev.length) {
                 scrollPage(prev, null, true);
             }
         }
 
         /**
         * Moves the page down one section.
         */
         function moveSectionDown(){
             var next = $(SECTION_ACTIVE_SEL).next(SECTION_SEL);
 
             //looping to the top if there's no more sections below
             if(!next.length &&
                 (options.loopBottom || options.continuousVertical)){
                 next = $(SECTION_SEL).first();
             }
 
             if(next.length){
                 scrollPage(next, null, false);
             }
         }
 
         /**
         * Moves the page to the given section and slide with no animation.
         * Anchors or index positions can be used as params.
         */
         function silentMoveTo(sectionAnchor, slideAnchor){
             setScrollingSpeed (0, 'internal');
             moveTo(sectionAnchor, slideAnchor);
             setScrollingSpeed (originals.scrollingSpeed, 'internal');
         }
 
         /**
         * Moves the page to the given section and slide.
         * Anchors or index positions can be used as params.
         */
         function moveTo(sectionAnchor, slideAnchor){
             var destiny = getSectionByAnchor(sectionAnchor);
             console.log('moveTo',sectionAnchor)
 
             if (typeof slideAnchor !== 'undefined'){
                 scrollPageAndSlide(sectionAnchor, slideAnchor);
             }else if(destiny.length > 0){
                 scrollPage(destiny);
             }
         }
 
         /**
         * Slides right the slider of the active section.
         * Optional `section` param.
         */
         function moveSlideRight(section){
             moveSlide('right', section);
         }
 
         /**
         * Slides left the slider of the active section.
         * Optional `section` param.
         */
         function moveSlideLeft(section){
             moveSlide('left', section);
         }
 
         /**
          * When resizing is finished, we adjust the slides sizes and positions
          */
         function reBuild(resizing){
             if(container.hasClass(DESTROYED)){ return; }  //nothing to do if the plugin was destroyed
 
             isResizing = true;
 
             windowsHeight = $window.height();  //updating global var
 
             $(SECTION_SEL).each(function(){
                 var slidesWrap = $(this).find(SLIDES_WRAPPER_SEL);
                 var slides = $(this).find(SLIDE_SEL);
 
                 //adjusting the height of the table-cell for IE and Firefox
                 if(options.verticalCentered){
                     $(this).find(TABLE_CELL_SEL).css('height', getTableHeight($(this)) + 'px');
                 }
 
                 $(this).css('height', windowsHeight + 'px');
 
                 //adjusting the position fo the FULL WIDTH slides...
                 if (slides.length > 1) {
                     landscapeScroll(slidesWrap, slidesWrap.find(SLIDE_ACTIVE_SEL));
                 }
             });
 
             if(options.scrollOverflow){
                 scrollBarHandler.createScrollBarForAll();
             }
 
             var activeSection = $(SECTION_ACTIVE_SEL);
             var sectionIndex = activeSection.index(SECTION_SEL);
 
             //isn't it the first section?
             if(sectionIndex){
                 //adjusting the position for the current section
                 silentMoveTo(sectionIndex + 1);
             }
 
             isResizing = false;
             $.isFunction( options.afterResize ) && resizing && options.afterResize.call(container);
             $.isFunction( options.afterReBuild ) && !resizing && options.afterReBuild.call(container);
         }
 
         /**
         * Turns fullPage.js to normal scrolling mode when the viewport `width` or `height`
         * are smaller than the set limit values.
         */
         function setResponsive(active){
             var isResponsive = $body.hasClass(RESPONSIVE);
 
             if(active){
                 if(!isResponsive){
                     setAutoScrolling(false, 'internal');
                     setFitToSection(false, 'internal');
                     $(SECTION_NAV_SEL).hide();
                     $body.addClass(RESPONSIVE);
                     $.isFunction( options.afterResponsive ) && options.afterResponsive.call( container, active);
                 }
             }
             else if(isResponsive){
                 setAutoScrolling(originals.autoScrolling, 'internal');
                 setFitToSection(originals.autoScrolling, 'internal');
                 $(SECTION_NAV_SEL).show();
                 $body.removeClass(RESPONSIVE);
                 $.isFunction( options.afterResponsive ) && options.afterResponsive.call( container, active);
             }
         }
 
         if($(this).length){
             //public functions
             FP.version = '2.9.7';
             FP.setAutoScrolling = setAutoScrolling;
             FP.setRecordHistory = setRecordHistory;
             FP.setScrollingSpeed = setScrollingSpeed;
             FP.setFitToSection = setFitToSection;
             FP.setLockAnchors = setLockAnchors;
             FP.setMouseWheelScrolling = setMouseWheelScrolling;
             FP.setAllowScrolling = setAllowScrolling;
             FP.setKeyboardScrolling = setKeyboardScrolling;
             FP.moveSectionUp = moveSectionUp;
             FP.moveSectionDown = moveSectionDown;
             FP.silentMoveTo = silentMoveTo;
             FP.moveTo = moveTo;
             FP.moveSlideRight = moveSlideRight;
             FP.moveSlideLeft = moveSlideLeft;
             FP.fitToSection = fitToSection;
             FP.reBuild = reBuild;
             FP.setResponsive = setResponsive;
             FP.destroy = destroy;
 
             //functions we want to share across files but which are not
             //mean to be used on their own by developers
             FP.shared ={
                 afterRenderActions: afterRenderActions
             };
 
             init();
 
             bindEvents();
         }
 
         function init(){
             //if css3 is not supported, it will use jQuery animations
             if(options.css3){
                 options.css3 = support3d();
             }
 
             options.scrollBar = options.scrollBar || options.hybrid;
 
             setOptionsFromDOM();
             prepareDom();
             setAllowScrolling(true);
             setAutoScrolling(options.autoScrolling, 'internal');
             responsive();
 
             //setting the class for the body element
             setBodyClass();
 
             if(document.readyState === 'complete'){
                 scrollToAnchor();
             }
             $window.on('load', scrollToAnchor);
         }
 
         function bindEvents(){
             $window
                 //when scrolling...
                 .on('scroll', scrollHandler)
 
                 //detecting any change on the URL to scroll to the given anchor link
                 //(a way to detect back history button as we play with the hashes on the URL)
                 .on('hashchange', hashChangeHandler)
 
                 //when opening a new tab (ctrl + t), `control` won't be pressed when coming back.
                 .blur(blurHandler)
 
                 //when resizing the site, we adjust the heights of the sections, slimScroll...
                 .resize(resizeHandler);
 
             $document
                 //Sliding with arrow keys, both, vertical and horizontal
                 .keydown(keydownHandler)
 
                 //to prevent scrolling while zooming
                 .keyup(keyUpHandler)
 
                 //Scrolls to the section when clicking the navigation bullet
                 .on('click touchstart', SECTION_NAV_SEL + ' a', sectionBulletHandler)
 
                 //Scrolls the slider to the given slide destination for the given section
                 .on('click touchstart', SLIDES_NAV_LINK_SEL, slideBulletHandler)
 
                 .on('click', SECTION_NAV_TOOLTIP_SEL, tooltipTextHandler);
 
             //Scrolling horizontally when clicking on the slider controls.
             $(SECTION_SEL).on('click touchstart', SLIDES_ARROW_SEL, slideArrowHandler);
 
             /**
             * Applying normalScroll elements.
             * Ignoring the scrolls over the specified selectors.
             */
             if(options.normalScrollElements){
                 $document.on('mouseenter touchstart', options.normalScrollElements, function () {
                     setAllowScrolling(false);
                 });
 
                 $document.on('mouseleave touchend', options.normalScrollElements, function(){
                     setAllowScrolling(true);
                 });
             }
         }
 
         /**
         * Setting options from DOM elements if they are not provided.
         */
         function setOptionsFromDOM(){
             var sections = container.find(options.sectionSelector);
 
             //no anchors option? Checking for them in the DOM attributes
             if(!options.anchors.length){
                 options.anchors = sections.filter('[data-anchor]').map(function(){
                     return $(this).data('anchor').toString();
                 }).get();
             }
 
             //no tooltips option? Checking for them in the DOM attributes
             if(!options.navigationTooltips.length){
                 options.navigationTooltips = sections.filter('[data-tooltip]').map(function(){
                     return $(this).data('tooltip').toString();
                 }).get();
             }
         }
 
         /**
         * Works over the DOM structure to set it up for the current fullpage options.
         */
         function prepareDom(){
             container.css({
                 'height': '100%',
                 'position': 'relative'
             });
 
             //adding a class to recognize the container internally in the code
             container.addClass(WRAPPER);
             $('html').addClass(ENABLED);
 
             //due to https://github.com/alvarotrigo/fullPage.js/issues/1502
             windowsHeight = $window.height();
 
             container.removeClass(DESTROYED); //in case it was destroyed before initializing it again
 
             addInternalSelectors();
 
             //styling the sections / slides / menu
             $(SECTION_SEL).each(function(index){
                 var section = $(this);
                 var slides = section.find(SLIDE_SEL);
                 var numSlides = slides.length;
 
                 //caching the original styles to add them back on destroy('all')
                 section.data('fp-styles', section.attr('style'));
 
                 styleSection(section, index);
                 styleMenu(section, index);
 
                 // if there's any slide
                 if (numSlides > 0) {
                     styleSlides(section, slides, numSlides);
                 }else{
                     if(options.verticalCentered){
                         addTableClass(section);
                     }
                 }
             });
 
             //fixed elements need to be moved out of the plugin container due to problems with CSS3.
             if(options.fixedElements && options.css3){
                 $(options.fixedElements).appendTo($body);
             }
 
             //vertical centered of the navigation + active bullet
             if(options.navigation){
                 addVerticalNavigation();
             }
 
             enableYoutubeAPI();
 
             if(options.scrollOverflow){
                 scrollBarHandler = options.scrollOverflowHandler.init(options);
             }else{
                 afterRenderActions();
             }
         }
 
         /**
         * Styles the horizontal slides for a section.
         */
         function styleSlides(section, slides, numSlides){
             var sliderWidth = numSlides * 100;
             var slideWidth = 100 / numSlides;
 
             slides.wrapAll('<div class="' + SLIDES_CONTAINER + '" />');
             slides.parent().wrap('<div class="' + SLIDES_WRAPPER + '" />');
 
             section.find(SLIDES_CONTAINER_SEL).css('width', sliderWidth + '%');
 
             if(numSlides > 1){
                 if(options.controlArrows){
                     createSlideArrows(section);
                 }
 
                 if(options.slidesNavigation){
                     addSlidesNavigation(section, numSlides);
                 }
             }
 
             slides.each(function(index) {
                 $(this).css('width', slideWidth + '%');
 
                 if(options.verticalCentered){
                     addTableClass($(this));
                 }
             });
 
             var startingSlide = section.find(SLIDE_ACTIVE_SEL);
 
             //if the slide won't be an starting point, the default will be the first one
             //the active section isn't the first one? Is not the first slide of the first section? Then we load that section/slide by default.
             if( startingSlide.length &&  ($(SECTION_ACTIVE_SEL).index(SECTION_SEL) !== 0 || ($(SECTION_ACTIVE_SEL).index(SECTION_SEL) === 0 && startingSlide.index() !== 0))){
                 silentLandscapeScroll(startingSlide, 'internal');
             }else{
                 slides.eq(0).addClass(ACTIVE);
             }
         }
 
         /**
         * Styling vertical sections
         */
         function styleSection(section, index){
             //if no active section is defined, the 1st one will be the default one
             if(!index && $(SECTION_ACTIVE_SEL).length === 0) {
                 section.addClass(ACTIVE);
             }
             startingSection = $(SECTION_ACTIVE_SEL);
 
             section.css('height', windowsHeight + 'px');
 
             if(options.paddingTop){
                 section.css('padding-top', options.paddingTop);
             }
 
             if(options.paddingBottom){
                 section.css('padding-bottom', options.paddingBottom);
             }
 
             if (typeof options.sectionsColor[index] !==  'undefined') {
                 section.css('background-color', options.sectionsColor[index]);
             }
 
             if (typeof options.anchors[index] !== 'undefined') {
                 section.attr('data-anchor', options.anchors[index]);
             }
         }
 
         /**
         * Sets the data-anchor attributes to the menu elements and activates the current one.
         */
         function styleMenu(section, index){
             if (typeof options.anchors[index] !== 'undefined') {
                 //activating the menu / nav element on load
                 if(section.hasClass(ACTIVE)){
                     activateMenuAndNav(options.anchors[index], index);
                 }
             }
 
             //moving the menu outside the main container if it is inside (avoid problems with fixed positions when using CSS3 tranforms)
             if(options.menu && options.css3 && $(options.menu).closest(WRAPPER_SEL).length){
                 $(options.menu).appendTo($body);
             }
         }
 
         /**
         * Adds internal classes to be able to provide customizable selectors
         * keeping the link with the style sheet.
         */
         function addInternalSelectors(){
             container.find(options.sectionSelector).addClass(SECTION);
             container.find(options.slideSelector).addClass(SLIDE);
         }
 
         /**
         * Creates the control arrows for the given section
         */
         function createSlideArrows(section){
             section.find(SLIDES_WRAPPER_SEL).after('<div class="' + SLIDES_ARROW_PREV + '"></div><div class="' + SLIDES_ARROW_NEXT + '"></div>');
 
             if(options.controlArrowColor!='#fff'){
                 section.find(SLIDES_ARROW_NEXT_SEL).css('border-color', 'transparent transparent transparent '+options.controlArrowColor);
                 section.find(SLIDES_ARROW_PREV_SEL).css('border-color', 'transparent '+ options.controlArrowColor + ' transparent transparent');
             }
 
             if(!options.loopHorizontal){
                 section.find(SLIDES_ARROW_PREV_SEL).hide();
             }
         }
 
         /**
         * Creates a vertical navigation bar.
         */
         function addVerticalNavigation(){
             $body.append('<div id="' + SECTION_NAV + '"><ul></ul></div>');
             var nav = $(SECTION_NAV_SEL);
 
             nav.addClass(function() {
                 return options.showActiveTooltip ? SHOW_ACTIVE_TOOLTIP + ' ' + options.navigationPosition : options.navigationPosition;
             });
 
             for (var i = 0; i < $(SECTION_SEL).length; i++) {
                 var link = '';
                 if (options.anchors.length) {
                     link = options.anchors[i];
                 }
 
                 var li = '<li><a href="#' + link + '"><span></span></a>';
 
                 // Only add tooltip if needed (defined by user)
                 var tooltip = options.navigationTooltips[i];
 
                 if (typeof tooltip !== 'undefined' && tooltip !== '') {
                     li += '<div class="' + SECTION_NAV_TOOLTIP + ' ' + options.navigationPosition + '">' + tooltip + '</div>';
                 }
 
                 li += '</li>';
 
                 nav.find('ul').append(li);
             }
 
             //centering it vertically
             $(SECTION_NAV_SEL).css('margin-top', '-' + ($(SECTION_NAV_SEL).height()/2) + 'px');
 
             //activating the current active section
             $(SECTION_NAV_SEL).find('li').eq($(SECTION_ACTIVE_SEL).index(SECTION_SEL)).find('a').addClass(ACTIVE);
         }
 
         /*
         * Enables the Youtube videos API so we can control their flow if necessary.
         */
         function enableYoutubeAPI(){
             container.find('iframe[src*="youtube.com/embed/"]').each(function(){
                 addURLParam($(this), 'enablejsapi=1');
             });
         }
 
         /**
         * Adds a new parameter and its value to the `src` of a given element
         */
         function addURLParam(element, newParam){
             var originalSrc = element.attr('src');
             element.attr('src', originalSrc + getUrlParamSign(originalSrc) + newParam);
         }
 
         /*
         * Returns the prefix sign to use for a new parameter in an existen URL.
         *
         * @return {String}  ? | &
         */
         function getUrlParamSign(url){
             return ( !/\?/.test( url ) ) ? '?' : '&';
         }
 
         /**
         * Actions and callbacks to fire afterRender
         */
         function afterRenderActions(){
             var section = $(SECTION_ACTIVE_SEL);
 
             section.addClass(COMPLETELY);
             console.log(3769)
 
             lazyLoad(section);
             playMedia(section);
 
             if(options.scrollOverflow){
                 options.scrollOverflowHandler.afterLoad();
             }
 
             if(isDestinyTheStartingSection()){
                 $.isFunction( options.afterLoad ) && options.afterLoad.call(section, section.data('anchor'), (section.index(SECTION_SEL) + 1));
             }
 
             $.isFunction( options.afterRender ) && options.afterRender.call(container);
         }
 
         /**
         * Determines if the URL anchor destiny is the starting section (the one using 'active' class before initialization)
         */
         function isDestinyTheStartingSection(){
             var destinationSection = getSectionByAnchor(getAnchorsURL().section);
             return !destinationSection || destinationSection.length && destinationSection.index() === startingSection.index();
         }
 
 
         var isScrolling = false;
         var lastScroll = 0;
 
         //when scrolling...
         function scrollHandler(){
             var currentSection;
 
             if(!options.autoScrolling || options.scrollBar){
                 var currentScroll = $window.scrollTop();
                 var scrollDirection = getScrollDirection(currentScroll);
                 var visibleSectionIndex = 0;
                 var screen_mid = currentScroll + ($window.height() / 2.0);
                 var isAtBottom = $body.height() - $window.height() === currentScroll;
                 var sections =  document.querySelectorAll(SECTION_SEL);
 
                 //when using `auto-height` for a small last section it won't be centered in the viewport
                 if(isAtBottom){
                     visibleSectionIndex = sections.length - 1;
                 }
                 //is at top? when using `auto-height` for a small first section it won't be centered in the viewport
                 else if(!currentScroll){
                     visibleSectionIndex = 0;
                 }
 
                 //taking the section which is showing more content in the viewport
                 else{
                     for (var i = 0; i < sections.length; ++i) {
                         var section = sections[i];
 
                         // Pick the the last section which passes the middle line of the screen.
                         if (section.offsetTop <= screen_mid)
                         {
                             visibleSectionIndex = i;
                         }
                     }
                 }
 
                 if(isCompletelyInViewPort(scrollDirection)){
                     if(!$(SECTION_ACTIVE_SEL).hasClass(COMPLETELY)){
                         $(SECTION_ACTIVE_SEL).addClass(COMPLETELY).siblings().removeClass(COMPLETELY);
                        //  if($(SECTION_ACTIVE_SEL).attr('id') == "shopify-section-fe800-signatures_3" || $(SECTION_ACTIVE_SEL).attr('id') == "shopify-section-fe800-signatures_4"){
                        //     document.querySelector(SECTION_ACTIVE_SEL + ' video').play();
                        //     document.querySelector(SECTION_ACTIVE_SEL + ' .signatures-item').classList.add('active');
                        //  }else{
                        //     document.querySelector('#shopify-section-fe800-signatures_3 video').pause();
                        //     document.querySelector('#shopify-section-fe800-signatures_3 .signatures-item').classList.remove('active');
                        //     document.querySelector('#shopify-section-fe800-signatures_4 video').pause();
                        //     document.querySelector('#shopify-section-fe800-signatures_4 .signatures-item').classList.remove('active');
                        //  }
                     }
                 }
 
                 //geting the last one, the current one on the screen
                 currentSection = $(sections).eq(visibleSectionIndex);
 
                 //setting the visible section as active when manually scrolling
                 //executing only once the first time we reach the section
                 if(!currentSection.hasClass(ACTIVE)){
                     isScrolling = true;
                     var leavingSection = $(SECTION_ACTIVE_SEL);
                     var leavingSectionIndex = leavingSection.index(SECTION_SEL) + 1;
                     var yMovement = getYmovement(currentSection);
                     var anchorLink  = currentSection.data('anchor');
                     var sectionIndex = currentSection.index(SECTION_SEL) + 1;
                     var activeSlide = currentSection.find(SLIDE_ACTIVE_SEL);
                     var slideIndex;
                     var slideAnchorLink;
 
                     if(activeSlide.length){
                         slideAnchorLink = activeSlide.data('anchor');
                         slideIndex = activeSlide.index();
                     }
 
                     if(canScroll){
                         currentSection.addClass(ACTIVE).siblings().removeClass(ACTIVE);
 
                         $.isFunction( options.onLeave ) && options.onLeave.call( leavingSection, leavingSectionIndex, sectionIndex, yMovement);
                         $.isFunction( options.afterLoad ) && options.afterLoad.call( currentSection, anchorLink, sectionIndex);
 
                         stopMedia(leavingSection);
                         lazyLoad(currentSection);
                         playMedia(currentSection);
 
                         activateMenuAndNav(anchorLink, sectionIndex - 1);
 
                         if(options.anchors.length){
                             //needed to enter in hashChange event when using the menu with anchor links
                             lastScrolledDestiny = anchorLink;
                         }
                         setState(slideIndex, slideAnchorLink, anchorLink, sectionIndex);
                     }
 
                     //small timeout in order to avoid entering in hashChange event when scrolling is not finished yet
                     clearTimeout(scrollId);
                     scrollId = setTimeout(function(){
                         isScrolling = false;
                     }, 100);
                 }
 
                 if(options.fitToSection){
                     //for the auto adjust of the viewport to fit a whole section
                     clearTimeout(scrollId2);
 
                     scrollId2 = setTimeout(function(){
                         //checking it again in case it changed during the delay
                         if(options.fitToSection &&
 
                             //is the destination element bigger than the viewport?
                             $(SECTION_ACTIVE_SEL).outerHeight() <= windowsHeight
                         ){
                             fitToSection();
                         }
                     }, options.fitToSectionDelay);
                 }
             }
         }
 
         /**
         * Fits the site to the nearest active section
         */
         function fitToSection(){
             //checking fitToSection again in case it was set to false before the timeout delay
             if(canScroll){
                 //allows to scroll to an active section and
                 //if the section is already active, we prevent firing callbacks
                 isResizing = true;
 
                 scrollPage($(SECTION_ACTIVE_SEL));
                 isResizing = false;
             }
         }
 
         /**
         * Determines whether the active section has seen in its whole or not.
         */
         function isCompletelyInViewPort(movement){
             var top = $(SECTION_ACTIVE_SEL).position().top;
             var bottom = top + $window.height();
 
             if(movement == 'up'){
                 return bottom >= ($window.scrollTop() + $window.height());
             }
             return top <= $window.scrollTop();
         }
 
         /**
         * Gets the directon of the the scrolling fired by the scroll event.
         */
         function getScrollDirection(currentScroll){
             var direction = currentScroll > lastScroll ? 'down' : 'up';
 
             lastScroll = currentScroll;
 
             //needed for auto-height sections to determine if we want to scroll to the top or bottom of the destination
             previousDestTop = currentScroll;
 
             return direction;
         }
 
         /**
         * Determines the way of scrolling up or down:
         * by 'automatically' scrolling a section or by using the default and normal scrolling.
         */
         function scrolling(type){
             if (!isScrollAllowed.m[type]){
                 return;
             }
 
             var scrollSection = (type === 'down') ? moveSectionDown : moveSectionUp;
 
             if(options.scrollOverflow){
                 var scrollable = options.scrollOverflowHandler.scrollable($(SECTION_ACTIVE_SEL));
                 var check = (type === 'down') ? 'bottom' : 'top';
 
                 if(scrollable.length > 0 ){
                     //is the scrollbar at the start/end of the scroll?
                     if(options.scrollOverflowHandler.isScrolled(check, scrollable)){
                         scrollSection();
                     }else{
                         return true;
                     }
                 }else{
                     // moved up/down
                     scrollSection();
                 }
             }else{
                 // moved up/down
                 scrollSection();
             }
         }
 
         /*
         * Preventing bouncing in iOS #2285
         */
         function preventBouncing(event){
             var e = event.originalEvent;
             if(options.autoScrolling && isReallyTouch(e)){
                 //preventing the easing on iOS devices
                 event.preventDefault();
             }
         }
 
         var touchStartY = 0;
         var touchStartX = 0;
         var touchEndY = 0;
         var touchEndX = 0;
 
         /* Detecting touch events
 
         * As we are changing the top property of the page on scrolling, we can not use the traditional way to detect it.
         * This way, the touchstart and the touch moves shows an small difference between them which is the
         * used one to determine the direction.
         */
         function touchMoveHandler(event){
             var e = event.originalEvent;
             var activeSection = $(e.target).closest(SECTION_SEL);
 
             // additional: if one of the normalScrollElements isn't within options.normalScrollElementTouchThreshold hops up the DOM chain
             if (isReallyTouch(e) ) {
 
                 if(options.autoScrolling){
                     //preventing the easing on iOS devices
                     event.preventDefault();
                 }
 
                 var touchEvents = getEventsPage(e);
 
                 touchEndY = touchEvents.y;
                 touchEndX = touchEvents.x;
 
                 //if movement in the X axys is greater than in the Y and the currect section has slides...
                 if (activeSection.find(SLIDES_WRAPPER_SEL).length && Math.abs(touchStartX - touchEndX) > (Math.abs(touchStartY - touchEndY))) {
 
                     //is the movement greater than the minimum resistance to scroll?
                     if (!slideMoving && Math.abs(touchStartX - touchEndX) > ($window.outerWidth() / 100 * options.touchSensitivity)) {
                         if (touchStartX > touchEndX) {
                             if(isScrollAllowed.m.right){
                                 moveSlideRight(activeSection); //next
                             }
                         } else {
                             if(isScrollAllowed.m.left){
                                 moveSlideLeft(activeSection); //prev
                             }
                         }
                     }
                 }
 
                 //vertical scrolling (only when autoScrolling is enabled)
                 else if(options.autoScrolling && canScroll){
 
                     //is the movement greater than the minimum resistance to scroll?
                     if (Math.abs(touchStartY - touchEndY) > ($window.height() / 100 * options.touchSensitivity)) {
                         if (touchStartY > touchEndY) {
                             scrolling('down');
                         } else if (touchEndY > touchStartY) {
                             scrolling('up');
                         }
                     }
                 }
             }
         }
 
         /**
         * As IE >= 10 fires both touch and mouse events when using a mouse in a touchscreen
         * this way we make sure that is really a touch event what IE is detecting.
         */
         function isReallyTouch(e){
             //if is not IE   ||  IE is detecting `touch` or `pen`
             return typeof e.pointerType === 'undefined' || e.pointerType != 'mouse';
         }
 
         /**
         * Handler for the touch start event.
         */
         function touchStartHandler(event){
             var e = event.originalEvent;
 
             //stopping the auto scroll to adjust to a section
             if(options.fitToSection){
                 $htmlBody.stop();
             }
 
             if(isReallyTouch(e)){
                 var touchEvents = getEventsPage(e);
                 touchStartY = touchEvents.y;
                 touchStartX = touchEvents.x;
             }
         }
 
         /**
         * Gets the average of the last `number` elements of the given array.
         */
         function getAverage(elements, number){
             var sum = 0;
 
             //taking `number` elements from the end to make the average, if there are not enought, 1
             var lastElements = elements.slice(Math.max(elements.length - number, 1));
 
             for(var i = 0; i < lastElements.length; i++){
                 sum = sum + lastElements[i];
             }
 
             return Math.ceil(sum/number);
         }
 
         /**
          * Detecting mousewheel scrolling
          *
          * http://blogs.sitepointstatic.com/examples/tech/mouse-wheel/index.html
          * http://www.sitepoint.com/html5-javascript-mouse-wheel/
          */
         var prevTime = new Date().getTime();
 
         function MouseWheelHandler(e) {
             var curTime = new Date().getTime();
             var isNormalScroll = $(COMPLETELY_SEL).hasClass(NORMAL_SCROLL);
 
             //autoscrolling and not zooming?
             if(options.autoScrolling && !controlPressed && !isNormalScroll){
                 // cross-browser wheel delta
                 e = e || window.event;
                 var value = e.wheelDelta || -e.deltaY || -e.detail;
                 var delta = Math.max(-1, Math.min(1, value));
 
                 var horizontalDetection = typeof e.wheelDeltaX !== 'undefined' || typeof e.deltaX !== 'undefined';
                 var isScrollingVertically = (Math.abs(e.wheelDeltaX) < Math.abs(e.wheelDelta)) || (Math.abs(e.deltaX ) < Math.abs(e.deltaY) || !horizontalDetection);
 
                 //Limiting the array to 150 (lets not waste memory!)
                 if(scrollings.length > 149){
                     scrollings.shift();
                 }
 
                 //keeping record of the previous scrollings
                 scrollings.push(Math.abs(value));
 
                 //preventing to scroll the site on mouse wheel when scrollbar is present
                 if(options.scrollBar){
                     e.preventDefault ? e.preventDefault() : e.returnValue = false;
                 }
 
                 //time difference between the last scroll and the current one
                 var timeDiff = curTime-prevTime;
                 prevTime = curTime;
 
                 //haven't they scrolled in a while?
                 //(enough to be consider a different scrolling action to scroll another section)
                 if(timeDiff > 200){
                     //emptying the array, we dont care about old scrollings for our averages
                     scrollings = [];
                 }
 
                 if(canScroll){
                     var averageEnd = getAverage(scrollings, 10);
                     var averageMiddle = getAverage(scrollings, 70);
                     var isAccelerating = averageEnd >= averageMiddle;
 
                     //to avoid double swipes...
                     if(isAccelerating && isScrollingVertically){
                         //scrolling down?
                         if (delta < 0) {
                             scrolling('down');
 
                         //scrolling up?
                         }else {
                             scrolling('up');
                         }
                     }
                 }
 
                 return false;
             }
 
             if(options.fitToSection){
                 //stopping the auto scroll to adjust to a section
                 $htmlBody.stop();
             }
         }
 
         /**
         * Slides a slider to the given direction.
         * Optional `section` param.
         */
         function moveSlide(direction, section){
             var activeSection = typeof section === 'undefined' ? $(SECTION_ACTIVE_SEL) : section;
             var slides = activeSection.find(SLIDES_WRAPPER_SEL);
             var numSlides = slides.find(SLIDE_SEL).length;
 
             // more than one slide needed and nothing should be sliding
             if (!slides.length || slideMoving || numSlides < 2) {
                 return;
             }
 
             var currentSlide = slides.find(SLIDE_ACTIVE_SEL);
             var destiny = null;
 
             if(direction === 'left'){
                 destiny = currentSlide.prev(SLIDE_SEL);
             }else{
                 destiny = currentSlide.next(SLIDE_SEL);
             }
 
             //isn't there a next slide in the secuence?
             if(!destiny.length){
                 //respect loopHorizontal settin
                 if (!options.loopHorizontal) return;
 
                 if(direction === 'left'){
                     destiny = currentSlide.siblings(':last');
                 }else{
                     destiny = currentSlide.siblings(':first');
                 }
             }
 
             slideMoving = true;
 
             landscapeScroll(slides, destiny, direction);
         }
 
         /**
         * Maintains the active slides in the viewport
         * (Because the `scroll` animation might get lost with some actions, such as when using continuousVertical)
         */
         function keepSlidesPosition(){
             $(SLIDE_ACTIVE_SEL).each(function(){
                 silentLandscapeScroll($(this), 'internal');
             });
         }
 
         var previousDestTop = 0;
         /**
         * Returns the destination Y position based on the scrolling direction and
         * the height of the section.
         */
         function getDestinationPosition(element){
             var elemPosition = element.position();
 
             //top of the desination will be at the top of the viewport
             var position = elemPosition.top;
             var isScrollingDown =  elemPosition.top > previousDestTop;
             var sectionBottom = position - windowsHeight + element.outerHeight();
             var bigSectionsDestination = options.bigSectionsDestination;
 
             //is the destination element bigger than the viewport?
             if(element.outerHeight() > windowsHeight){
                 //scrolling up?
                 if(!isScrollingDown && !bigSectionsDestination || bigSectionsDestination === 'bottom' ){
                     position = sectionBottom;
                 }
             }
 
             //sections equal or smaller than the viewport height && scrolling down? ||  is resizing and its in the last section
             else if(isScrollingDown || (isResizing && element.is(':last-child')) ){
                 //The bottom of the destination will be at the bottom of the viewport
                 position = sectionBottom;
             }
 
             /*
             Keeping record of the last scrolled position to determine the scrolling direction.
             No conventional methods can be used as the scroll bar might not be present
             AND the section might not be active if it is auto-height and didnt reach the middle
             of the viewport.
             */
             previousDestTop = position;
             return position;
         }
 
         /**
         * Scrolls the site to the given element and scrolls to the slide if a callback is given.
         */
         function scrollPage(element, callback, isMovementUp){
             if(typeof element === 'undefined'){ return; } //there's no element to scroll, leaving the function
             console.log('scrollPage',element)
 
             var dtop = getDestinationPosition(element);
             var slideAnchorLink;
             var slideIndex;
 
             //local variables
             var v = {
                 element: element,
                 callback: callback,
                 isMovementUp: isMovementUp,
                 dtop: dtop,
                 yMovement: getYmovement(element),
                 anchorLink: element.data('anchor'),
                 sectionIndex: element.index(SECTION_SEL),
                 activeSlide: element.find(SLIDE_ACTIVE_SEL),
                 activeSection: $(SECTION_ACTIVE_SEL),
                 leavingSection: $(SECTION_ACTIVE_SEL).index(SECTION_SEL) + 1,
 
                 //caching the value of isResizing at the momment the function is called
                 //because it will be checked later inside a setTimeout and the value might change
                 localIsResizing: isResizing
             };
 
             //quiting when destination scroll is the same as the current one
             if((v.activeSection.is(element) && !isResizing) || (options.scrollBar && $window.scrollTop() === v.dtop && !element.hasClass(AUTO_HEIGHT) )){ return; }
 
             if(v.activeSlide.length){
                 slideAnchorLink = v.activeSlide.data('anchor');
                 slideIndex = v.activeSlide.index();
             }
 
             //callback (onLeave) if the site is not just resizing and readjusting the slides
             if($.isFunction(options.onLeave) && !v.localIsResizing){
                 var direction = v.yMovement;
 
                 //required for continousVertical
                 if(typeof isMovementUp !== 'undefined'){
                     direction = isMovementUp ? 'up' : 'down';
                 }
 
                 if(options.onLeave.call(v.activeSection, v.leavingSection, (v.sectionIndex + 1), direction) === false){
                     return;
                 }
             }
 
             // If continuousVertical && we need to wrap around
             if (options.autoScrolling && options.continuousVertical && typeof (v.isMovementUp) !== "undefined" &&
                 ((!v.isMovementUp && v.yMovement == 'up') || // Intending to scroll down but about to go up or
                 (v.isMovementUp && v.yMovement == 'down'))) { // intending to scroll up but about to go down
 
                 v = createInfiniteSections(v);
             }
 
             //pausing media of the leaving section (if we are not just resizing, as destinatino will be the same one)
             if(!v.localIsResizing){
                 stopMedia(v.activeSection);
             }
 
             if(options.scrollOverflow){
                 options.scrollOverflowHandler.beforeLeave();
             }
 
             element.addClass(ACTIVE).siblings().removeClass(ACTIVE);
             lazyLoad(element);
 
             if(options.scrollOverflow){
                 options.scrollOverflowHandler.onLeave();
             }
 
             //preventing from activating the MouseWheelHandler event
             //more than once if the page is scrolling
             canScroll = false;
 
             setState(slideIndex, slideAnchorLink, v.anchorLink, v.sectionIndex);
 
             performMovement(v);
 
             //flag to avoid callingn `scrollPage()` twice in case of using anchor links
             lastScrolledDestiny = v.anchorLink;
 
             //avoid firing it twice (as it does also on scroll)
             activateMenuAndNav(v.anchorLink, v.sectionIndex);
         }
 
         /**
         * Performs the vertical movement (by CSS3 or by jQuery)
         */
         function performMovement(v){
             // using CSS3 translate functionality
             if (options.css3 && options.autoScrolling && !options.scrollBar) {
 
                 // The first section can have a negative value in iOS 10. Not quite sure why: -0.0142822265625
                 // that's why we round it to 0.
                 var translate3d = 'translate3d(0px, -' + Math.round(v.dtop) + 'px, 0px)';
                 transformContainer(translate3d, true);
 
                 //even when the scrollingSpeed is 0 there's a little delay, which might cause the
                 //scrollingSpeed to change in case of using silentMoveTo();
                 if(options.scrollingSpeed){
                     clearTimeout(afterSectionLoadsId);
                     afterSectionLoadsId = setTimeout(function () {
                         afterSectionLoads(v);
                     }, options.scrollingSpeed);
                 }else{
                     afterSectionLoads(v);
                 }
             }
 
             // using jQuery animate
             else{
                 var scrollSettings = getScrollSettings(v);
 
                 $(scrollSettings.element).animate(
                     scrollSettings.options,
                 options.scrollingSpeed, options.easing).promise().done(function () { //only one single callback in case of animating  `html, body`
                     if(options.scrollBar){
 
                         /* Hack!
                         The timeout prevents setting the most dominant section in the viewport as "active" when the user
                         scrolled to a smaller section by using the mousewheel (auto scrolling) rather than draging the scroll bar.
 
                         When using scrollBar:true It seems like the scroll events still getting propagated even after the scrolling animation has finished.
                         */
                         setTimeout(function(){
                             afterSectionLoads(v);
                         },30);
                     }else{
                         afterSectionLoads(v);
                     }
                 });
             }
         }
 
         /**
         * Gets the scrolling settings depending on the plugin autoScrolling option
         */
         function getScrollSettings(v){
             var scroll = {};
 
             if(options.autoScrolling && !options.scrollBar){
                 scroll.options = { 'top': -v.dtop};
                 scroll.element = WRAPPER_SEL;
             }else{
                 scroll.options = { 'scrollTop': v.dtop};
                 scroll.element = 'html, body';
             }
 
             return scroll;
         }
 
         /**
         * Adds sections before or after the current one to create the infinite effect.
         */
         function createInfiniteSections(v){
             // Scrolling down
             if (!v.isMovementUp) {
                 // Move all previous sections to after the active section
                 $(SECTION_ACTIVE_SEL).after(v.activeSection.prevAll(SECTION_SEL).get().reverse());
             }
             else { // Scrolling up
                 // Move all next sections to before the active section
                 $(SECTION_ACTIVE_SEL).before(v.activeSection.nextAll(SECTION_SEL));
             }
 
             // Maintain the displayed position (now that we changed the element order)
             silentScroll($(SECTION_ACTIVE_SEL).position().top);
 
             // Maintain the active slides visible in the viewport
             keepSlidesPosition();
 
             // save for later the elements that still need to be reordered
             v.wrapAroundElements = v.activeSection;
 
             // Recalculate animation variables
             v.dtop = v.element.position().top;
             v.yMovement = getYmovement(v.element);
 
             //sections will temporally have another position in the DOM
             //updating this values in case we need them
             v.leavingSection = v.activeSection.index(SECTION_SEL) + 1;
             v.sectionIndex = v.element.index(SECTION_SEL);
 
             return v;
         }
 
         /**
         * Fix section order after continuousVertical changes have been animated
         */
         function continuousVerticalFixSectionOrder (v) {
             // If continuousVertical is in effect (and autoScrolling would also be in effect then),
             // finish moving the elements around so the direct navigation will function more simply
             if (!v.wrapAroundElements || !v.wrapAroundElements.length) {
                 return;
             }
 
             if (v.isMovementUp) {
                 $(SECTION_FIRST_SEL).before(v.wrapAroundElements);
             }
             else {
                 $(SECTION_LAST_SEL).after(v.wrapAroundElements);
             }
 
             silentScroll($(SECTION_ACTIVE_SEL).position().top);
 
             // Maintain the active slides visible in the viewport
             keepSlidesPosition();
         }
 
 
         /**
         * Actions to do once the section is loaded.
         */
         function afterSectionLoads (v){
             continuousVerticalFixSectionOrder(v);
 
             //callback (afterLoad) if the site is not just resizing and readjusting the slides
             $.isFunction(options.afterLoad) && !v.localIsResizing && options.afterLoad.call(v.element, v.anchorLink, (v.sectionIndex + 1));
 
             if(options.scrollOverflow){
                 options.scrollOverflowHandler.afterLoad();
             }
 
             if(!v.localIsResizing){
                 playMedia(v.element);
             }
 
             v.element.addClass(COMPLETELY).siblings().removeClass(COMPLETELY);
 
             canScroll = true;
 
             $.isFunction(v.callback) && v.callback.call(this);
         }
 
         /**
         * Sets the value for the given attribute from the `data-` attribute with the same suffix
         * ie: data-srcset ==> srcset  |  data-src ==> src
         */
         function setSrc(element, attribute){
             element
                 .attr(attribute, element.data(attribute))
                 .removeAttr('data-' + attribute);
         }
 
         /**
         * Lazy loads image, video and audio elements.
         */
         function lazyLoad(destiny){
             if (!options.lazyLoading){
                 return;
             }
 
             var panel = getSlideOrSection(destiny);
             var element;
 
             panel.find('img[data-src], img[data-srcset], source[data-src], source[data-srcset], video[data-src], audio[data-src], iframe[data-src]').each(function(){
                 element = $(this);
 
                 $.each(['src', 'srcset'], function(index, type){
                     var attribute = element.attr('data-' + type);
                     if(typeof attribute !== 'undefined' && attribute){
                         setSrc(element, type);
                     }
                 });
 
                 if(element.is('source')){
                     var typeToPlay = element.closest('video').length ? 'video' : 'audio';
                     element.closest(typeToPlay).get(0).load();
                 }
             });
         }
 
         /**
         * Plays video and audio elements.
         */
         function playMedia(destiny){
             var panel = getSlideOrSection(destiny);
 
             //playing HTML5 media elements
             panel.find('video, audio').each(function(){
                 var element = $(this).get(0);
 
                 if( element.hasAttribute('data-autoplay') && typeof element.play === 'function' ) {
                     element.play();
                 }
             });
 
             //youtube videos
             panel.find('iframe[src*="youtube.com/embed/"]').each(function(){
                 var element = $(this).get(0);
 
                 if ( element.hasAttribute('data-autoplay') ){
                     playYoutube(element);
                 }
 
                 //in case the URL was not loaded yet. On page load we need time for the new URL (with the API string) to load.
                 element.onload = function() {
                     if ( element.hasAttribute('data-autoplay') ){
                         playYoutube(element);
                     }
                 };
             });
         }
 
         /**
         * Plays a youtube video
         */
         function playYoutube(element){
             element.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
         }
 
         /**
         * Stops video and audio elements.
         */
         function stopMedia(destiny){
             var panel = getSlideOrSection(destiny);
 
             //stopping HTML5 media elements
             panel.find('video, audio').each(function(){
                 var element = $(this).get(0);
 
                 if( !element.hasAttribute('data-keepplaying') && typeof element.pause === 'function' ) {
                     element.pause();
                 }
             });
 
             //youtube videos
             panel.find('iframe[src*="youtube.com/embed/"]').each(function(){
                 var element = $(this).get(0);
 
                 if( /youtube\.com\/embed\//.test($(this).attr('src')) && !element.hasAttribute('data-keepplaying')){
                     $(this).get(0).contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}','*');
                 }
             });
         }
 
         /**
         * Gets the active slide (or section) for the given section
         */
         function getSlideOrSection(destiny){
             var slide = destiny.find(SLIDE_ACTIVE_SEL);
             if( slide.length ) {
                 destiny = $(slide);
             }
 
             return destiny;
         }
 
         /**
         * Scrolls to the anchor in the URL when loading the site
         */
         function scrollToAnchor(){
             var anchors =  getAnchorsURL();
             var sectionAnchor = anchors.section;
             var slideAnchor = anchors.slide;
 
             if(sectionAnchor){  //if theres any #
                 if(options.animateAnchor){
                     scrollPageAndSlide(sectionAnchor, slideAnchor);
                 }else{
                     silentMoveTo(sectionAnchor, slideAnchor);
                 }
             }
         }
 
         /**
         * Detecting any change on the URL to scroll to the given anchor link
         * (a way to detect back history button as we play with the hashes on the URL)
         */
         function hashChangeHandler(){
             if(!isScrolling && !options.lockAnchors){
                 var anchors = getAnchorsURL();
                 var sectionAnchor = anchors.section;
                 var slideAnchor = anchors.slide;
 
                 //when moving to a slide in the first section for the first time (first time to add an anchor to the URL)
                 var isFirstSlideMove =  (typeof lastScrolledDestiny === 'undefined');
                 var isFirstScrollMove = (typeof lastScrolledDestiny === 'undefined' && typeof slideAnchor === 'undefined' && !slideMoving);
 
                 if(sectionAnchor && sectionAnchor.length){
                     /*in order to call scrollpage() only once for each destination at a time
                     It is called twice for each scroll otherwise, as in case of using anchorlinks `hashChange`
                     event is fired on every scroll too.*/
                     if ((sectionAnchor && sectionAnchor !== lastScrolledDestiny) && !isFirstSlideMove
                         || isFirstScrollMove
                         || (!slideMoving && lastScrolledSlide != slideAnchor )){
 
                         scrollPageAndSlide(sectionAnchor, slideAnchor);
                     }
                 }
             }
         }
 
         //gets the URL anchors (section and slide)
         function getAnchorsURL(){
             var section;
             var slide;
             var hash = window.location.hash;
 
             if(hash.length){
                 //getting the anchor link in the URL and deleting the `#`
                 var anchorsParts =  hash.replace('#', '').split('/');
 
                 //using / for visual reasons and not as a section/slide separator #2803
                 var isFunkyAnchor = hash.indexOf('#/') > -1;
 
                 section = isFunkyAnchor ? '/' + anchorsParts[1] : decodeURIComponent(anchorsParts[0]);
 
                 var slideAnchor = isFunkyAnchor ? anchorsParts[2] : anchorsParts[1];
                 if(slideAnchor && slideAnchor.length){
                     slide = decodeURIComponent(slideAnchor);
                 }
             }
 
             return {
                 section: section,
                 slide: slide
             }
         }
 
         //Sliding with arrow keys, both, vertical and horizontal
         function keydownHandler(e) {
             clearTimeout(keydownId);
 
             var activeElement = $(':focus');
             var keyCode = e.which;
 
             //tab?
             if(keyCode === 9){
                 onTab(e);
             }
 
             else if(!activeElement.is('textarea') && !activeElement.is('input') && !activeElement.is('select') &&
                 activeElement.attr('contentEditable') !== "true" && activeElement.attr('contentEditable') !== '' &&
                 options.keyboardScrolling && options.autoScrolling){
 
                 //preventing the scroll with arrow keys & spacebar & Page Up & Down keys
                 var keyControls = [40, 38, 32, 33, 34];
                 if($.inArray(keyCode, keyControls) > -1){
                     e.preventDefault();
                 }
 
                 controlPressed = e.ctrlKey;
 
                 keydownId = setTimeout(function(){
                     onkeydown(e);
                 },150);
             }
         }
 
         function tooltipTextHandler(){
             $(this).prev().trigger('click');
         }
 
         //to prevent scrolling while zooming
         function keyUpHandler(e){
             if(isWindowFocused){ //the keyup gets fired on new tab ctrl + t in Firefox
                 controlPressed = e.ctrlKey;
             }
         }
 
         //binding the mousemove when the mouse's middle button is released
         function mouseDownHandler(e){
             //middle button
             if (e.which == 2){
                 oldPageY = e.pageY;
                 container.on('mousemove', mouseMoveHandler);
             }
         }
 
         //unbinding the mousemove when the mouse's middle button is released
         function mouseUpHandler(e){
             //middle button
             if (e.which == 2){
                 container.off('mousemove');
             }
         }
 
         //Scrolling horizontally when clicking on the slider controls.
         function slideArrowHandler(){
             var section = $(this).closest(SECTION_SEL);
 
             if ($(this).hasClass(SLIDES_PREV)) {
                 if(isScrollAllowed.m.left){
                     moveSlideLeft(section);
                 }
             } else {
                 if(isScrollAllowed.m.right){
                     moveSlideRight(section);
                 }
             }
         }
 
         //when opening a new tab (ctrl + t), `control` won't be pressed when coming back.
         function blurHandler(){
             isWindowFocused = false;
             controlPressed = false;
         }
 
         //Scrolls to the section when clicking the navigation bullet
         function sectionBulletHandler(e){
             e.preventDefault();
             var index = $(this).parent().index();
             scrollPage($(SECTION_SEL).eq(index));
         }
 
         //Scrolls the slider to the given slide destination for the given section
         function slideBulletHandler(e){
             e.preventDefault();
             var slides = $(this).closest(SECTION_SEL).find(SLIDES_WRAPPER_SEL);
             var destiny = slides.find(SLIDE_SEL).eq($(this).closest('li').index());
 
             landscapeScroll(slides, destiny);
         }
 
         /**
         * Keydown event
         */
         function onkeydown(e){
             var shiftPressed = e.shiftKey;
 
             //do nothing if we can not scroll or we are not using horizotnal key arrows.
             if(!canScroll && [37,39].indexOf(e.which) < 0){
                 return;
             }
 
             switch (e.which) {
                 //up
                 case 38:
                 case 33:
                     if(isScrollAllowed.k.up){
                         moveSectionUp();
                     }
                     break;
 
                 //down
                 case 32: //spacebar
                     if(shiftPressed && isScrollAllowed.k.up){
                         moveSectionUp();
                         break;
                     }
                 /* falls through */
                 case 40:
                 case 34:
                     if(isScrollAllowed.k.down){
                         moveSectionDown();
                     }
                     break;
 
                 //Home
                 case 36:
                     if(isScrollAllowed.k.up){
                         moveTo(1);
                     }
                     break;
 
                 //End
                 case 35:
                      if(isScrollAllowed.k.down){
                         moveTo( $(SECTION_SEL).length );
                     }
                     break;
 
                 //left
                 case 37:
                     if(isScrollAllowed.k.left){
                         moveSlideLeft();
                     }
                     break;
 
                 //right
                 case 39:
                     if(isScrollAllowed.k.right){
                         moveSlideRight();
                     }
                     break;
 
                 default:
                     return; // exit this handler for other keys
             }
         }
 
         /**
         * Makes sure the tab key will only focus elements within the current section/slide
         * preventing this way from breaking the page.
         * Based on "Modals and keyboard traps"
         * from https://developers.google.com/web/fundamentals/accessibility/focus/using-tabindex
         */
         function onTab(e){
             var isShiftPressed = e.shiftKey;
             var activeElement = $(':focus');
             var activeSection = $(SECTION_ACTIVE_SEL);
             var activeSlide = activeSection.find(SLIDE_ACTIVE_SEL);
             var focusableWrapper = activeSlide.length ? activeSlide : activeSection;
             var focusableElements = focusableWrapper.find(focusableElementsString).not('[tabindex="-1"]');
 
             function preventAndFocusFirst(e){
                 e.preventDefault();
                 return focusableElements.first().focus();
             }
 
             //is there an element with focus?
             if(activeElement.length){
                 if(!activeElement.closest(SECTION_ACTIVE_SEL, SLIDE_ACTIVE_SEL).length){
                     activeElement = preventAndFocusFirst(e);
                 }
             }
 
             //no element if focused? Let's focus the first one of the section/slide
             else{
                 preventAndFocusFirst(e);
             }
 
             //when reached the first or last focusable element of the section/slide
             //we prevent the tab action to keep it in the last focusable element
             if(!isShiftPressed && activeElement.is(focusableElements.last()) ||
                 isShiftPressed && activeElement.is(focusableElements.first())
             ){
                 e.preventDefault();
             }
         }
 
         /**
         * Detecting the direction of the mouse movement.
         * Used only for the middle button of the mouse.
         */
         var oldPageY = 0;
         function mouseMoveHandler(e){
             if(canScroll){
                 // moving up
                 if (e.pageY < oldPageY && isScrollAllowed.m.up){
                     moveSectionUp();
                 }
 
                 // moving down
                 else if(e.pageY > oldPageY && isScrollAllowed.m.down){
                     moveSectionDown();
                 }
             }
             oldPageY = e.pageY;
         }
 
         /**
         * Scrolls horizontal sliders.
         */
         function landscapeScroll(slides, destiny, direction){
             var section = slides.closest(SECTION_SEL);
             var v = {
                 slides: slides,
                 destiny: destiny,
                 direction: direction,
                 destinyPos: destiny.position(),
                 slideIndex: destiny.index(),
                 section: section,
                 sectionIndex: section.index(SECTION_SEL),
                 anchorLink: section.data('anchor'),
                 slidesNav: section.find(SLIDES_NAV_SEL),
                 slideAnchor:  getAnchor(destiny),
                 prevSlide: section.find(SLIDE_ACTIVE_SEL),
                 prevSlideIndex: section.find(SLIDE_ACTIVE_SEL).index(),
 
                 //caching the value of isResizing at the momment the function is called
                 //because it will be checked later inside a setTimeout and the value might change
                 localIsResizing: isResizing
             };
             v.xMovement = getXmovement(v.prevSlideIndex, v.slideIndex);
 
             //important!! Only do it when not resizing
             if(!v.localIsResizing){
                 //preventing from scrolling to the next/prev section when using scrollHorizontally
                 canScroll = false;
             }
 
             if(options.onSlideLeave){
 
                 //if the site is not just resizing and readjusting the slides
                 if(!v.localIsResizing && v.xMovement!=='none'){
                     if($.isFunction( options.onSlideLeave )){
                         if(options.onSlideLeave.call( v.prevSlide, v.anchorLink, (v.sectionIndex + 1), v.prevSlideIndex, v.direction, v.slideIndex ) === false){
                             slideMoving = false;
                             return;
                         }
                     }
                 }
             }
 
             destiny.addClass(ACTIVE).siblings().removeClass(ACTIVE);
 
             if(!v.localIsResizing){
                 stopMedia(v.prevSlide);
                 lazyLoad(destiny);
             }
 
             if(!options.loopHorizontal && options.controlArrows){
                 //hidding it for the fist slide, showing for the rest
                 section.find(SLIDES_ARROW_PREV_SEL).toggle(v.slideIndex!==0);
 
                 //hidding it for the last slide, showing for the rest
                 section.find(SLIDES_ARROW_NEXT_SEL).toggle(!destiny.is(':last-child'));
             }
 
             //only changing the URL if the slides are in the current section (not for resize re-adjusting)
             if(section.hasClass(ACTIVE) && !v.localIsResizing){
                 setState(v.slideIndex, v.slideAnchor, v.anchorLink, v.sectionIndex);
             }
 
             performHorizontalMove(slides, v, true);
         }
 
 
         function afterSlideLoads(v){
             activeSlidesNavigation(v.slidesNav, v.slideIndex);
 
             //if the site is not just resizing and readjusting the slides
             if(!v.localIsResizing){
                 $.isFunction( options.afterSlideLoad ) && options.afterSlideLoad.call( v.destiny, v.anchorLink, (v.sectionIndex + 1), v.slideAnchor, v.slideIndex);
 
                 //needs to be inside the condition to prevent problems with continuousVertical and scrollHorizontally
                 //and to prevent double scroll right after a windows resize
                 canScroll = true;
 
                 playMedia(v.destiny);
             }
 
             //letting them slide again
             slideMoving = false;
         }
 
         /**
         * Performs the horizontal movement. (CSS3 or jQuery)
         *
         * @param fireCallback {Bool} - determines whether or not to fire the callback
         */
         function performHorizontalMove(slides, v, fireCallback){
             var destinyPos = v.destinyPos;
 
             if(options.css3){
                 var translate3d = 'translate3d(-' + Math.round(destinyPos.left) + 'px, 0px, 0px)';
 
                 addAnimation(slides.find(SLIDES_CONTAINER_SEL)).css(getTransforms(translate3d));
 
                 afterSlideLoadsId = setTimeout(function(){
                     fireCallback && afterSlideLoads(v);
                 }, options.scrollingSpeed, options.easing);
             }else{
                 slides.animate({
                     scrollLeft : Math.round(destinyPos.left)
                 }, options.scrollingSpeed, options.easing, function() {
 
                     fireCallback && afterSlideLoads(v);
                 });
             }
         }
 
         /**
         * Sets the state for the horizontal bullet navigations.
         */
         function activeSlidesNavigation(slidesNav, slideIndex){
             slidesNav.find(ACTIVE_SEL).removeClass(ACTIVE);
             slidesNav.find('li').eq(slideIndex).find('a').addClass(ACTIVE);
         }
 
         var previousHeight = windowsHeight;
 
         //when resizing the site, we adjust the heights of the sections, slimScroll...
         function resizeHandler(){
             //checking if it needs to get responsive
             responsive();
 
             // rebuild immediately on touch devices
             if (isTouchDevice) {
                 var activeElement = $(document.activeElement);
 
                 //if the keyboard is NOT visible
                 if (!activeElement.is('textarea') && !activeElement.is('input') && !activeElement.is('select')) {
                     var currentHeight = $window.height();
 
                     //making sure the change in the viewport size is enough to force a rebuild. (20 % of the window to avoid problems when hidding scroll bars)
                     if( Math.abs(currentHeight - previousHeight) > (20 * Math.max(previousHeight, currentHeight) / 100) ){
                         reBuild(true);
                         previousHeight = currentHeight;
                     }
                 }
             }else{
                 //in order to call the functions only when the resize is finished
                 //http://stackoverflow.com/questions/4298612/jquery-how-to-call-resize-event-only-once-its-finished-resizing
                 clearTimeout(resizeId);
 
                 resizeId = setTimeout(function(){
                     reBuild(true);
                 }, 350);
             }
         }
 
         /**
         * Checks if the site needs to get responsive and disables autoScrolling if so.
         * A class `fp-responsive` is added to the plugin's container in case the user wants to use it for his own responsive CSS.
         */
         function responsive(){
             var widthLimit = options.responsive || options.responsiveWidth; //backwards compatiblity
             var heightLimit = options.responsiveHeight;
 
             //only calculating what we need. Remember its called on the resize event.
             var isBreakingPointWidth = widthLimit && $window.outerWidth() < widthLimit;
             var isBreakingPointHeight = heightLimit && $window.height() < heightLimit;
 
             if(widthLimit && heightLimit){
                 setResponsive(isBreakingPointWidth || isBreakingPointHeight);
             }
             else if(widthLimit){
                 setResponsive(isBreakingPointWidth);
             }
             else if(heightLimit){
                 setResponsive(isBreakingPointHeight);
             }
         }
 
         /**
         * Adds transition animations for the given element
         */
         function addAnimation(element){
             var transition = 'all ' + options.scrollingSpeed + 'ms ' + options.easingcss3;
 
             element.removeClass(NO_TRANSITION);
             return element.css({
                 '-webkit-transition': transition,
                 'transition': transition
             });
         }
 
         /**
         * Remove transition animations for the given element
         */
         function removeAnimation(element){
             return element.addClass(NO_TRANSITION);
         }
 
         /**
         * Activating the vertical navigation bullets according to the given slide name.
         */
         function activateNavDots(name, sectionIndex){
             if(options.navigation){
                 $(SECTION_NAV_SEL).find(ACTIVE_SEL).removeClass(ACTIVE);
                 if(name){
                     $(SECTION_NAV_SEL).find('a[href="#' + name + '"]').addClass(ACTIVE);
                 }else{
                     $(SECTION_NAV_SEL).find('li').eq(sectionIndex).find('a').addClass(ACTIVE);
                 }
             }
         }
 
         /**
         * Activating the website main menu elements according to the given slide name.
         */
         function activateMenuElement(name){
             if(options.menu){
                 $(options.menu).find(ACTIVE_SEL).removeClass(ACTIVE);
                 $(options.menu).find('[data-menuanchor="'+name+'"]').addClass(ACTIVE);
             }
         }
 
         /**
         * Sets to active the current menu and vertical nav items.
         */
         function activateMenuAndNav(anchor, index){
             activateMenuElement(anchor);
             activateNavDots(anchor, index);
         }
 
         /**
         * Retuns `up` or `down` depending on the scrolling movement to reach its destination
         * from the current section.
         */
         function getYmovement(destiny){
             var fromIndex = $(SECTION_ACTIVE_SEL).index(SECTION_SEL);
             var toIndex = destiny.index(SECTION_SEL);
             if( fromIndex == toIndex){
                 return 'none';
             }
             if(fromIndex > toIndex){
                 return 'up';
             }
             return 'down';
         }
 
         /**
         * Retuns `right` or `left` depending on the scrolling movement to reach its destination
         * from the current slide.
         */
         function getXmovement(fromIndex, toIndex){
             if( fromIndex == toIndex){
                 return 'none';
             }
             if(fromIndex > toIndex){
                 return 'left';
             }
             return 'right';
         }
 
         function addTableClass(element){
             //In case we are styling for the 2nd time as in with reponsiveSlides
             if(!element.hasClass(TABLE)){
                 var wrapper = $('<div class="' + TABLE_CELL + '" />').height(getTableHeight(element));
                 element.addClass(TABLE).wrapInner(wrapper);
             }
         }
 
         function getTableHeight(element){
             var sectionHeight = windowsHeight;
 
             if(options.paddingTop || options.paddingBottom){
                 var section = element;
                 if(!section.hasClass(SECTION)){
                     section = element.closest(SECTION_SEL);
                 }
 
                 var paddings = parseInt(section.css('padding-top')) + parseInt(section.css('padding-bottom'));
                 sectionHeight = (windowsHeight - paddings);
             }
 
             return sectionHeight;
         }
 
         /**
         * Adds a css3 transform property to the container class with or without animation depending on the animated param.
         */
         function transformContainer(translate3d, animated){
             if(animated){
                 addAnimation(container);
             }else{
                 removeAnimation(container);
             }
 
             container.css(getTransforms(translate3d));
 
             //syncronously removing the class after the animation has been applied.
             setTimeout(function(){
                 container.removeClass(NO_TRANSITION);
             },10);
         }
 
         /**
         * Gets a section by its anchor / index
         */
         function getSectionByAnchor(sectionAnchor){
             var section = container.find(SECTION_SEL + '[data-anchor="'+sectionAnchor+'"]');
             if(!section.length){
                 var sectionIndex = typeof sectionAnchor !== 'undefined' ? sectionAnchor -1 : 0;
                 console.log('getSectionByAnchor',sectionIndex)
                 section = $(SECTION_SEL).eq(sectionIndex);
             }
 
             return section;
         }
 
         /**
         * Gets a slide inside a given section by its anchor / index
         */
         function getSlideByAnchor(slideAnchor, section){
             var slide = section.find(SLIDE_SEL + '[data-anchor="'+slideAnchor+'"]');
             if(!slide.length){
                 slideAnchor = typeof slideAnchor !== 'undefined' ? slideAnchor : 0;
                 slide = section.find(SLIDE_SEL).eq(slideAnchor);
             }
 
             return slide;
         }
 
         /**
         * Scrolls to the given section and slide anchors
         */
         function scrollPageAndSlide(sectionAnchor, slideAnchor){
             var section = getSectionByAnchor(sectionAnchor);
             console.log('scrollPageAndSlide')
 
             //do nothing if there's no section with the given anchor name
             if(!section.length) return;
 
             var slide = getSlideByAnchor(slideAnchor, section);
 
             //we need to scroll to the section and then to the slide
             if (sectionAnchor !== lastScrolledDestiny && !section.hasClass(ACTIVE)){
                 scrollPage(section, function(){
                     scrollSlider(slide);
                 });
             }
             //if we were already in the section
             else{
                 scrollSlider(slide);
             }
         }
 
         /**
         * Scrolls the slider to the given slide destination for the given section
         */
         function scrollSlider(slide){
             if(slide.length){
                 landscapeScroll(slide.closest(SLIDES_WRAPPER_SEL), slide);
             }
         }
 
         /**
         * Creates a landscape navigation bar with dots for horizontal sliders.
         */
         function addSlidesNavigation(section, numSlides){
             section.append('<div class="' + SLIDES_NAV + '"><ul></ul></div>');
             var nav = section.find(SLIDES_NAV_SEL);
 
             //top or bottom
             nav.addClass(options.slidesNavPosition);
 
             for(var i=0; i< numSlides; i++){
                 nav.find('ul').append('<li><a href="#"><span></span></a></li>');
             }
 
             //centering it
             nav.css('margin-left', '-' + (nav.width()/2) + 'px');
 
             nav.find('li').first().find('a').addClass(ACTIVE);
         }
 
 
         /**
         * Sets the state of the website depending on the active section/slide.
         * It changes the URL hash when needed and updates the body class.
         */
         function setState(slideIndex, slideAnchor, anchorLink, sectionIndex){
             var sectionHash = '';
 
             if(options.anchors.length && !options.lockAnchors){
 
                 //isn't it the first slide?
                 if(slideIndex){
                     if(typeof anchorLink !== 'undefined'){
                         sectionHash = anchorLink;
                     }
 
                     //slide without anchor link? We take the index instead.
                     if(typeof slideAnchor === 'undefined'){
                         slideAnchor = slideIndex;
                     }
 
                     lastScrolledSlide = slideAnchor;
                     setUrlHash(sectionHash + '/' + slideAnchor);
 
                 //first slide won't have slide anchor, just the section one
                 }else if(typeof slideIndex !== 'undefined'){
                     lastScrolledSlide = slideAnchor;
                     setUrlHash(anchorLink);
                 }
 
                 //section without slides
                 else{
                     setUrlHash(anchorLink);
                 }
             }
 
             setBodyClass();
         }
 
         /**
         * Sets the URL hash.
         */
         function setUrlHash(url){
             if(options.recordHistory){
                 location.hash = url;
             }else{
                 //Mobile Chrome doesn't work the normal way, so... lets use HTML5 for phones :)
                 if(isTouchDevice || isTouch){
                     window.history.replaceState(undefined, undefined, '#' + url);
                 }else{
                     var baseUrl = window.location.href.split('#')[0];
                     window.location.replace( baseUrl + '#' + url );
                 }
             }
         }
 
         /**
         * Gets the anchor for the given slide / section. Its index will be used if there's none.
         */
         function getAnchor(element){
             var anchor = element.data('anchor');
             var index = element.index();
 
             //Slide without anchor link? We take the index instead.
             if(typeof anchor === 'undefined'){
                 anchor = index;
             }
 
             return anchor;
         }
 
         /**
         * Sets a class for the body of the page depending on the active section / slide
         */
         function setBodyClass(){
             var section = $(SECTION_ACTIVE_SEL);
             var slide = section.find(SLIDE_ACTIVE_SEL);
 
             var sectionAnchor = getAnchor(section);
             var slideAnchor = getAnchor(slide);
 
             var text = String(sectionAnchor);
 
             if(slide.length){
                 text = text + '-' + slideAnchor;
             }
 
             //changing slash for dash to make it a valid CSS style
             text = text.replace('/', '-').replace('#','');
 
             //removing previous anchor classes
             var classRe = new RegExp('\\b\\s?' + VIEWING_PREFIX + '-[^\\s]+\\b', "g");
             $body[0].className = $body[0].className.replace(classRe, '');
 
             //adding the current anchor
             $body.addClass(VIEWING_PREFIX + '-' + text);
         }
 
         /**
         * Checks for translate3d support
         * @return boolean
         * http://stackoverflow.com/questions/5661671/detecting-transform-translate3d-support
         */
         function support3d() {
             var el = document.createElement('p'),
                 has3d,
                 transforms = {
                     'webkitTransform':'-webkit-transform',
                     'OTransform':'-o-transform',
                     'msTransform':'-ms-transform',
                     'MozTransform':'-moz-transform',
                     'transform':'transform'
                 };
 
             // Add it to the body to get the computed style.
             document.body.insertBefore(el, null);
 
             for (var t in transforms) {
                 if (el.style[t] !== undefined) {
                     el.style[t] = 'translate3d(1px,1px,1px)';
                     has3d = window.getComputedStyle(el).getPropertyValue(transforms[t]);
                 }
             }
 
             document.body.removeChild(el);
 
             return (has3d !== undefined && has3d.length > 0 && has3d !== 'none');
         }
 
         /**
         * Removes the auto scrolling action fired by the mouse wheel and trackpad.
         * After this function is called, the mousewheel and trackpad movements won't scroll through sections.
         */
         function removeMouseWheelHandler(){
             if (document.addEventListener) {
                 document.removeEventListener('mousewheel', MouseWheelHandler, false); //IE9, Chrome, Safari, Oper
                 document.removeEventListener('wheel', MouseWheelHandler, false); //Firefox
                 document.removeEventListener('MozMousePixelScroll', MouseWheelHandler, false); //old Firefox
             } else {
                 document.detachEvent('onmousewheel', MouseWheelHandler); //IE 6/7/8
             }
         }
 
         /**
         * Adds the auto scrolling action for the mouse wheel and trackpad.
         * After this function is called, the mousewheel and trackpad movements will scroll through sections
         * https://developer.mozilla.org/en-US/docs/Web/Events/wheel
         */
         function addMouseWheelHandler(){
             var prefix = '';
             var _addEventListener;
 
             if (window.addEventListener){
                 _addEventListener = "addEventListener";
             }else{
                 _addEventListener = "attachEvent";
                 prefix = 'on';
             }
 
              // detect available wheel event
             var support = 'onwheel' in document.createElement('div') ? 'wheel' : // Modern browsers support "wheel"
                       document.onmousewheel !== undefined ? 'mousewheel' : // Webkit and IE support at least "mousewheel"
                       'DOMMouseScroll'; // let's assume that remaining browsers are older Firefox
 
 
             if(support == 'DOMMouseScroll'){
                 document[ _addEventListener ](prefix + 'MozMousePixelScroll', MouseWheelHandler, false);
             }
 
             //handle MozMousePixelScroll in older Firefox
             else{
                 document[ _addEventListener ](prefix + support, MouseWheelHandler, false);
             }
         }
 
         /**
         * Binding the mousemove when the mouse's middle button is pressed
         */
         function addMiddleWheelHandler(){
             container
                 .on('mousedown', mouseDownHandler)
                 .on('mouseup', mouseUpHandler);
         }
 
         /**
         * Unbinding the mousemove when the mouse's middle button is released
         */
         function removeMiddleWheelHandler(){
             container
                 .off('mousedown', mouseDownHandler)
                 .off('mouseup', mouseUpHandler);
         }
 
         /**
         * Adds the possibility to auto scroll through sections on touch devices.
         */
         function addTouchHandler(){
             if(isTouchDevice || isTouch){
                 if(options.autoScrolling){
                     $body.off(events.touchmove).on(events.touchmove, preventBouncing);
                 }
 
                 $(WRAPPER_SEL)
                     .off(events.touchstart).on(events.touchstart, touchStartHandler)
                     .off(events.touchmove).on(events.touchmove, touchMoveHandler);
             }
         }
 
         /**
         * Removes the auto scrolling for touch devices.
         */
         function removeTouchHandler(){
             if(isTouchDevice || isTouch){
                 if(options.autoScrolling){
                     $body.off(events.touchmove);
                 }
 
                 $(WRAPPER_SEL)
                     .off(events.touchstart)
                     .off(events.touchmove);
             }
         }
 
         /*
         * Returns and object with Microsoft pointers (for IE<11 and for IE >= 11)
         * http://msdn.microsoft.com/en-us/library/ie/dn304886(v=vs.85).aspx
         */
         function getMSPointer(){
             var pointer;
 
             //IE >= 11 & rest of browsers
             if(window.PointerEvent){
                 pointer = { down: 'pointerdown', move: 'pointermove'};
             }
 
             //IE < 11
             else{
                 pointer = { down: 'MSPointerDown', move: 'MSPointerMove'};
             }
 
             return pointer;
         }
 
         /**
         * Gets the pageX and pageY properties depending on the browser.
         * https://github.com/alvarotrigo/fullPage.js/issues/194#issuecomment-34069854
         */
         function getEventsPage(e){
             var events = [];
 
             events.y = (typeof e.pageY !== 'undefined' && (e.pageY || e.pageX) ? e.pageY : e.touches[0].pageY);
             events.x = (typeof e.pageX !== 'undefined' && (e.pageY || e.pageX) ? e.pageX : e.touches[0].pageX);
 
             //in touch devices with scroll bar, e.pageY is detected, but we have to deal with touch events. #1008
             if(isTouch && isReallyTouch(e) && (options.scrollBar || !options.autoScrolling)){
                 events.y = e.touches[0].pageY;
                 events.x = e.touches[0].pageX;
             }
 
             return events;
         }
 
         /**
         * Slides silently (with no animation) the active slider to the given slide.
         * @param noCallback {bool} true or defined -> no callbacks
         */
         function silentLandscapeScroll(activeSlide, noCallbacks){
             setScrollingSpeed (0, 'internal');
 
             if(typeof noCallbacks !== 'undefined'){
                 //preventing firing callbacks afterSlideLoad etc.
                 isResizing = true;
             }
 
             landscapeScroll(activeSlide.closest(SLIDES_WRAPPER_SEL), activeSlide);
 
             if(typeof noCallbacks !== 'undefined'){
                 isResizing = false;
             }
 
             setScrollingSpeed(originals.scrollingSpeed, 'internal');
         }
 
         /**
         * Scrolls silently (with no animation) the page to the given Y position.
         */
         function silentScroll(top){
             // The first section can have a negative value in iOS 10. Not quite sure why: -0.0142822265625
             // that's why we round it to 0.
             var roundedTop = Math.round(top);
 
             if (options.css3 && options.autoScrolling && !options.scrollBar){
                 var translate3d = 'translate3d(0px, -' + roundedTop + 'px, 0px)';
                 transformContainer(translate3d, false);
             }
             else if(options.autoScrolling && !options.scrollBar){
                 container.css('top', -roundedTop);
             }
             else{
                 $htmlBody.scrollTop(roundedTop);
             }
         }
 
         /**
         * Returns the cross-browser transform string.
         */
         function getTransforms(translate3d){
             return {
                 '-webkit-transform': translate3d,
                 '-moz-transform': translate3d,
                 '-ms-transform':translate3d,
                 'transform': translate3d
             };
         }
 
         /**
         * Allowing or disallowing the mouse/swipe scroll in a given direction. (not for keyboard)
         * @type  m (mouse) or k (keyboard)
         */
         function setIsScrollAllowed(value, direction, type){
             //up, down, left, right
             if(direction !== 'all'){
                 isScrollAllowed[type][direction] = value;
             }
 
             //all directions?
             else{
                 $.each(Object.keys(isScrollAllowed[type]), function(index, key){
                     isScrollAllowed[type][key] = value;
                 });
             }
         }
 
         /*
         * Destroys fullpage.js plugin events and optinally its html markup and styles
         */
         function destroy(all){
             setAutoScrolling(false, 'internal');
             setAllowScrolling(false);
             setKeyboardScrolling(false);
             container.addClass(DESTROYED);
 
             clearTimeout(afterSlideLoadsId);
             clearTimeout(afterSectionLoadsId);
             clearTimeout(resizeId);
             clearTimeout(scrollId);
             clearTimeout(scrollId2);
 
             $window
                 .off('scroll', scrollHandler)
                 .off('hashchange', hashChangeHandler)
                 .off('resize', resizeHandler);
 
             $document
                 .off('keydown', keydownHandler)
                 .off('keyup', keyUpHandler)
                 .off('click touchstart', SECTION_NAV_SEL + ' a')
                 .off('mouseenter', SECTION_NAV_SEL + ' li')
                 .off('mouseleave', SECTION_NAV_SEL + ' li')
                 .off('click touchstart', SLIDES_NAV_LINK_SEL)
                 .off('mouseover', options.normalScrollElements)
                 .off('mouseout', options.normalScrollElements);
 
             $(SECTION_SEL)
                 .off('click touchstart', SLIDES_ARROW_SEL);
 
             clearTimeout(afterSlideLoadsId);
             clearTimeout(afterSectionLoadsId);
 
             //lets make a mess!
             if(all){
                 destroyStructure();
             }
         }
 
         /*
         * Removes inline styles added by fullpage.js
         */
         function destroyStructure(){
             //reseting the `top` or `translate` properties to 0
             silentScroll(0);
 
             //loading all the lazy load content
             container.find('img[data-src], source[data-src], audio[data-src], iframe[data-src]').each(function(){
                 setSrc($(this), 'src');
             });
 
             container.find('img[data-srcset]').each(function(){
                 setSrc($(this), 'srcset');
             });
 
             $(SECTION_NAV_SEL + ', ' + SLIDES_NAV_SEL +  ', ' + SLIDES_ARROW_SEL).remove();
 
             //removing inline styles
             $(SECTION_SEL).css( {
                 'height': '',
                 'background-color' : '',
                 'padding': ''
             });
 
             $(SLIDE_SEL).css( {
                 'width': ''
             });
 
             container.css({
                 'height': '',
                 'position': '',
                 '-ms-touch-action': '',
                 'touch-action': ''
             });
 
             $htmlBody.css({
                 'overflow': '',
                 'height': ''
             });
 
             // remove .fp-enabled class
             $('html').removeClass(ENABLED);
 
             // remove .fp-responsive class
             $body.removeClass(RESPONSIVE);
 
             // remove all of the .fp-viewing- classes
             $.each($body.get(0).className.split(/\s+/), function (index, className) {
                 if (className.indexOf(VIEWING_PREFIX) === 0) {
                     $body.removeClass(className);
                 }
             });
 
             //removing added classes
             $(SECTION_SEL + ', ' + SLIDE_SEL).each(function(){
                 if(options.scrollOverflowHandler){
                     options.scrollOverflowHandler.remove($(this));
                 }
                 $(this).removeClass(TABLE + ' ' + ACTIVE);
                 $(this).attr('style', $(this).data('fp-styles'));
             });
 
             removeAnimation(container);
 
             //Unwrapping content
             container.find(TABLE_CELL_SEL + ', ' + SLIDES_CONTAINER_SEL + ', ' + SLIDES_WRAPPER_SEL).each(function(){
                 //unwrap not being use in case there's no child element inside and its just text
                 $(this).replaceWith(this.childNodes);
             });
 
             //removing the applied transition from the fullpage wrapper
             container.css({
                 '-webkit-transition': 'none',
                 'transition': 'none'
             });
 
             //scrolling the page to the top with no animation
             $htmlBody.scrollTop(0);
 
             //removing selectors
             var usedSelectors = [SECTION, SLIDE, SLIDES_CONTAINER];
             $.each(usedSelectors, function(index, value){
                 $('.' + value).removeClass(value);
             });
         }
 
         /*
         * Sets the state for a variable with multiple states (original, and temporal)
         * Some variables such as `autoScrolling` or `recordHistory` might change automatically its state when using `responsive` or `autoScrolling:false`.
         * This function is used to keep track of both states, the original and the temporal one.
         * If type is not 'internal', then we assume the user is globally changing the variable.
         */
         function setVariableState(variable, value, type){
             options[variable] = value;
             if(type !== 'internal'){
                 originals[variable] = value;
             }
         }
 
         /**
         * Displays warnings
         */
         function displayWarnings(){
             var extensions = ['fadingEffect', 'continuousHorizontal', 'scrollHorizontally', 'interlockedSlides', 'resetSliders', 'responsiveSlides', 'offsetSections', 'dragAndMove', 'scrollOverflowReset', 'parallax'];
             if($('html').hasClass(ENABLED)){
                 showError('error', 'Fullpage.js can only be initialized once and you are doing it multiple times!');
                 return;
             }
 
             // Disable mutually exclusive settings
             if (options.continuousVertical &&
                 (options.loopTop || options.loopBottom)) {
                 options.continuousVertical = false;
                 showError('warn', 'Option `loopTop/loopBottom` is mutually exclusive with `continuousVertical`; `continuousVertical` disabled');
             }
 
             if(options.scrollBar && options.scrollOverflow){
                 showError('warn', 'Option `scrollBar` is mutually exclusive with `scrollOverflow`. Sections with scrollOverflow might not work well in Firefox');
             }
 
             if(options.continuousVertical && (options.scrollBar || !options.autoScrolling)){
                 options.continuousVertical = false;
                 showError('warn', 'Scroll bars (`scrollBar:true` or `autoScrolling:false`) are mutually exclusive with `continuousVertical`; `continuousVertical` disabled');
             }
 
             if(options.scrollOverflow && !options.scrollOverflowHandler){
                 options.scrollOverflow = false;
                 showError('error', 'The option `scrollOverflow:true` requires the file `scrolloverflow.min.js`. Please include it before fullPage.js.');
             }
 
             //using extensions? Wrong file!
             $.each(extensions, function(index, extension){
                 //is the option set to true?
                 if(options[extension]){
                     showError('warn', 'fullpage.js extensions require jquery.fullpage.extensions.min.js file instead of the usual jquery.fullpage.js. Requested: '+ extension);
                 }
             });
 
             //anchors can not have the same value as any element ID or NAME
             $.each(options.anchors, function(index, name){
 
                 //case insensitive selectors (http://stackoverflow.com/a/19465187/1081396)
                 var nameAttr = $document.find('[name]').filter(function() {
                     return $(this).attr('name') && $(this).attr('name').toLowerCase() == name.toLowerCase();
                 });
 
                 var idAttr = $document.find('[id]').filter(function() {
                     return $(this).attr('id') && $(this).attr('id').toLowerCase() == name.toLowerCase();
                 });
 
                 if(idAttr.length || nameAttr.length ){
                     showError('error', 'data-anchor tags can not have the same value as any `id` element on the site (or `name` element for IE).');
                     idAttr.length && showError('error', '"' + name + '" is is being used by another element `id` property');
                     nameAttr.length && showError('error', '"' + name + '" is is being used by another element `name` property');
                 }
             });
         }
 
         /**
         * Shows a message in the console of the given type.
         */
         function showError(type, text){
             console && console[type] && console[type]('fullPage: ' + text);
         }
 
     }; //end of $.fn.fullpage
 });
 
 
 //------------------------------------------
 //------------------------------------------
 var clsProduct_comparison = (() => {
     //PARAMATERS
     var arrProduct = [
         {
             // "id": 1,
             "product_name": "sl3800",
             "url": "#shopify-section-sl3800-info",
             "goto": ".product800-detail",
             "price": "449.99",
             "kind": "S-LINE",
             "typecolor": [
                 {
                     "typecolor": "BlackWhite",
                     "namecolor": "Black White",
                     "urlImg": "https://cdn.shopify.com/s/files/1/1759/4609/t/73/assets/fe800-SL3800-Black-White.png"
 
                 },
                 {
                     "typecolor": "CarbonBlack",
                     "namecolor": "Carbon Black",
                     "urlImg": "https://cdn.shopify.com/s/files/1/1759/4609/t/73/assets/fe800-SL3800-Carbon-Black.png"
 
                 }, {
                     "typecolor": "MidnightBlue",
                     "namecolor": "Midnight Blue",
                     "urlImg": "https://cdn.shopify.com/s/files/1/1759/4609/t/73/assets/fe800-SL3800-Midnight-Blue.png"
 
                 }
                 , {
                     "typecolor": "MidnightGreen",
                     "namecolor": "Midnight Green",
                     "urlImg": "https://cdn.shopify.com/s/files/1/1759/4609/t/73/assets/fe800-SL3800-Midnight-Green.png"
 
                 },
                 {
                     "typecolor": "MidnightPurple",
                     "namecolor": "Midnight Purple",
                     "urlImg": "https://cdn.shopify.com/s/files/1/1759/4609/t/73/assets/fe800-SL3800-Midnight-Purple.png"
 
                 },
                 {
                     "typecolor": "BurgundyRed",
                     "namecolor": "Burgundy Red",
                     "urlImg": "https://cdn.shopify.com/s/files/1/1759/4609/t/73/assets/fe800-SL3800-Burgundy-Red.png"
 
                 }
             ]
         },
         {
             // "id": 2,
             "product_name": "sl5800",
             "url": "#shopify-section-sl5800-info",
             "goto": ".product800-detail",
             "price": "449.99",
             "kind": "S-LINE",
             "typecolor": [
                 {
                     "typecolor": "BlackWhite",
                     "namecolor": "Black White",
                     "urlImg": "https://cdn.shopify.com/s/files/1/1759/4609/t/73/assets/fe800-SL5800-Black-White.png"
 
                 },
                 {
                     "typecolor": "CarbonBlack",
                     "namecolor": "Carbon Black",
                     "urlImg": "https://cdn.shopify.com/s/files/1/1759/4609/t/73/assets/fe800-SL5800-Carbon-Black.png"
 
                 }, {
                     "typecolor": "MidnightBlue",
                     "namecolor": "Midnight Blue",
                     "urlImg": "https://cdn.shopify.com/s/files/1/1759/4609/t/73/assets/fe800-SL5800-Midnight-Blue.png"
 
                 }
                 , {
                     "typecolor": "MidnightGreen",
                     "namecolor": "Midnight Green",
                     "urlImg": "https://cdn.shopify.com/s/files/1/1759/4609/t/73/assets/fe800-SL5800-Midnight-Green.png"
 
                 },
                 {
                     "typecolor": "MidnightPurple",
                     "namecolor": "Midnight Purple",
                     "urlImg": "https://cdn.shopify.com/s/files/1/1759/4609/t/73/assets/fe800-SL5800-Midnight-Purple.png"
 
                 },
                 {
                     "typecolor": "BurgundyRed",
                     "namecolor": "Burgundy Red",
                     "urlImg": "https://cdn.shopify.com/s/files/1/1759/4609/t/73/assets/fe800-SL5800-Burgundy-Red.png"
 
                 }
             ]
         },
         {
             // "id": 3,
             "product_name": "pl4800",
             "url": "#shopify-section-pl4800-info",
             "goto": ".product800-detail",
             "price": "449.99",
             "kind": "P-LINE",
             "typecolor": [
                 {
                     "typecolor": "BlackWhite",
                     "namecolor": "Black White",
                     "urlImg": "https://cdn.shopify.com/s/files/1/1759/4609/t/73/assets/fe800-PL4800-Black-White.png"
 
                 },
                 {
                     "typecolor": "CarbonBlack",
                     "namecolor": "Carbon Black",
                     "urlImg": "https://cdn.shopify.com/s/files/1/1759/4609/t/73/assets/fe800-PL4800-Carbon-Black.png"
 
                 }, {
                     "typecolor": "MidnightBlue",
                     "namecolor": "Midnight Blue",
                     "urlImg": "https://cdn.shopify.com/s/files/1/1759/4609/t/73/assets/fe800-PL4800-Midnight-Blue.png"
 
                 }
                 , {
                     "typecolor": "MidnightGreen",
                     "namecolor": "Midnight Green",
                     "urlImg": "https://cdn.shopify.com/s/files/1/1759/4609/t/73/assets/fe800-PL4800-Midnight-Green.png"
 
                 },
                 {
                     "typecolor": "MidnightPurple",
                     "namecolor": "Midnight Purple",
                     "urlImg": "https://cdn.shopify.com/s/files/1/1759/4609/t/73/assets/fe800-PL4800-Midnight-Purple.png"
 
                 },
                 {
                     "typecolor": "BurgundyRed",
                     "namecolor": "Burgundy Red",
                     "urlImg": "https://cdn.shopify.com/s/files/1/1759/4609/t/73/assets/fe800-PL4800-Burgundy-Red.png"
 
                 }
             ]
         },
         {
             // "id": 4,
             "product_name": "pl6800",
             "url": "#shopify-section-pl6800-info",
             "goto": ".product800-detail",
             "price": "449.99",
             "kind": "P-LINE",
             "typecolor": [
                 {
                     "typecolor": "BlackWhite",
                     "namecolor": "Black White",
                     "urlImg": "https://cdn.shopify.com/s/files/1/1759/4609/t/73/assets/fe800-PL6800-Black-White.png"
 
                 },
                 {
                     "typecolor": "CarbonBlack",
                     "namecolor": "Carbon Black",
                     "urlImg": "https://cdn.shopify.com/s/files/1/1759/4609/t/73/assets/fe800-PL6800-Carbon-Black.png"
 
                 }, {
                     "typecolor": "MidnightBlue",
                     "namecolor": "Midnight Blue",
                     "urlImg": "https://cdn.shopify.com/s/files/1/1759/4609/t/73/assets/fe800-PL6800-Midnight-Blue.png"
 
                 }
                 , {
                     "typecolor": "MidnightGreen",
                     "namecolor": "Midnight Green",
                     "urlImg": "https://cdn.shopify.com/s/files/1/1759/4609/t/73/assets/fe800-PL6800-Midnight-Green.png"
 
                 },
                 {
                     "typecolor": "MidnightPurple",
                     "namecolor": "Midnight Purple",
                     "urlImg": "https://cdn.shopify.com/s/files/1/1759/4609/t/73/assets/fe800-PL6800-Midnight-Purple.png"
 
                 },
                 {
                     "typecolor": "BurgundyRed",
                     "namecolor": "Burgundy Red",
                     "urlImg": "https://cdn.shopify.com/s/files/1/1759/4609/t/73/assets/fe800-PL6800-Burgundy-Red.png"
 
                 }
             ]
         },
 
     ]
 
     //INIT
     function init() {
 
         Collapsible()
         gotoSlider()
         setHighlight()
 
     }
 
     ////////////////////////////
     //EVENTS
 
 
     ////////////////////////////
     //FUNCTION
     Collapsible = () => {
 
         // check has attr fe800-product-detail
         if (typeof $('.page-fe800').attr('fe800-product-detail') !== 'undefined' && $('.page-fe800').attr('fe800-product-detail') !== false) {
             $('#fe800_title_comparison').html('Comparison Chart')
             createSticky()
 
         } else {
             var toggle_flag = 0;
             $("#fe800_title_comparison").click((e) => {
                 e.preventDefault()
 
                 // handle arrow svg
                 $("#product_comparison-content").slideToggle(500)
                 if (toggle_flag == 0) {
                     //code for slide down
                     toggle_flag = 1;
                     $('#fe800_title_comparison').attr('expand', '1')
                 } else {
                     //code for slide up
                     toggle_flag = 0;
                     $('#fe800_title_comparison').attr('expand', '0')
                 }
                 createSticky()
 
             })
 
         }
 
     }
 
 
     setHighlight = () => {
 
         var attrProDe = $('.page-fe800').attr('fe800-product-detail')
         if (typeof attrProDe !== 'undefined' && attrProDe !== false) {
 
             for (var i = 0; i < arrProduct.length; i++) {
                 if (attrProDe == arrProduct[i].product_name) {
                     // console.log("arrProduct.product_name[i]", arrProduct[i].product_name)
                     $('.row-comparison .row-item:nth-child(' + (i + 2) + ')').addClass('highlight')
                     $('.row-comparison .row-item:nth-child(' + (i + 2) + ')').children().addClass('js-gotoidelement')
                     $('.row-btn.highlight a.btn-viewmode').removeAttr("href").removeAttr("target").attr('goto', arrProduct[i].goto)
                     break;
 
                 }
             }
 
         }
     }
 
 
     /////////////////////////////////////
     createSticky = () => {
         var positionTop = $('.listproduct-js').offset().top
 
 
         $(window).scroll(function (e) {
 
             var scroll = $(window).scrollTop();
             var h1 = parseInt($('#fe800_title_comparison').css('padding-bottom'));
             var h2 = $('.main-header ').height();
             var h3 = $('.quickview-footer').height();
 
             // console.log("(h3 + h2 + h1", h3 + h2 + h1)
             // console.log(positionTop, "=>", scroll)
 
             if (scroll >= (positionTop - 160)) {
                 $('.listproduct-js').css('top', 80);
             }
 
             else {
                 $('.listproduct-js').css('top', 0);
             }
         });
 
     }
 
     gotoSlider = () => {
         //1 click vo DOT trand 3dx = valwidth*number
         var valwidth = $('.index-reviews__swiper-slide').width();
 
         $('.dot').click(function (e) {
             e.preventDefault();
             $('.dot').removeClass('active');
             $(this).addClass('active');
 
             var numSlider = parseInt($(this).attr('numSlider'))
 
             let swiperwrapper = $('.fe800-index-reviews__swiper .swiper-wrapper');
 
             let translate3D = 'translate3d(-' + valwidth * numSlider + 'px, 0px, 0px)';
 
             // console.log(translate3D);
 
             swiperwrapper.css({
                 '-webkit-transform': translate3D,
                 '-ms-transform': translate3D,
                 'transform': translate3D,
             });
 
         });
 
     }
 
 
     let touchstartX = 0
     let touchendX = 0
 
     document.addEventListener('touchstart', e => {
         touchstartX = e.changedTouches[0].screenX
     })
 
     document.addEventListener('touchend', e => {
         touchendX = e.changedTouches[0].screenX
         checkDirection()
     })
 
 
     function checkDirection() {
         if (touchendX < touchstartX) {
             activedot()
             // alert('swiped right!')
         }
         else {
             activedot()
             // alert('swiped left!')
         }
     }
     function activedot() {
         var id_group_color = $(".index-reviews__swiper-slide.swiper-slide.swiper-slide-active").attr("index");
         var curent_dot = $('[numSlider=' + id_group_color + ']')
         $('.dot').removeClass('active');
         if (curent_dot.hasClass('active')) return;
         curent_dot.addClass('active');
 
     }
 
     ////////////////////////////
     //RETURN
     return {
         init: init
     }
 
 
 })()
 
 ////////////////////////////////////
 //run with setinteval
 
 $(() => {
     clsProduct_comparison.init()
 })
 
 
 //------------------------------------------
 //------------------------------------------
 var clsMenuQuickview = (function () {
     //PARAMATERS
     var arrProduct = [
         {
             "id": "7024401154159",
             "temp": "",
             "product_name": "sl3800",
             "url": "#shopify-section-sl3800-info",
             "goto": ".product800-detail",
             "price": "449.99",
             "kind": "S-Line",
             "typecolor": window.shopData.arrProduct.typecolor_7024401154159
         },
         {
             "id": "7024816291951",
             "temp": "sl5800",
             "product_name": "sl5800",
             "url": "#shopify-section-sl5800-info",
             "goto": ".product800-detail",
             "price": "449.99",
             "kind": "S-Line",
             "typecolor": window.shopData.arrProduct.typecolor_7024816291951
         },
         {
             "id": "7025941348463",
             "temp": "",
             "product_name": "pl4800",
             "url": "#shopify-section-pl4800-info",
             "goto": ".product800-detail",
             "price": "449.99",
             "kind": "P-Line",
             "typecolor": window.shopData.arrProduct.typecolor_7025941348463
         },
         {
             "id": "7025941446767",
             "temp": "",
             "product_name": "pl6800",
             "url": "#shopify-section-pl6800-info",
             "goto": ".product800-detail",
             "price": "449.99",
             "kind": "P-Line",
             "typecolor": window.shopData.arrProduct.typecolor_7025941446767
         },
 
     ]
 
 
     //INIT
     function init() {
         if ($('.block-menuquickview').length == 0) return;
         events()
 
         // neu page product detail
         if (typeof $('.page-fe800').attr('fe800-product-detail') !== 'undefined' && $('.page-fe800').attr('fe800-product-detail') !== false) {
             setValIndex()
 
         }
     }
 
     ////////////////////////////
     //EVENTS
     function events() {
 
 
         var h = window.innerHeight * 2.5 / 4;
         // console.log(h,window.innerHeight)
         $('.block-menuquickview .inner').css({ "maxHeight": +h + "px" });
 
 
         $('.js-viewmoreallproduct').click(function (e) {
             e.preventDefault();
             $("body").toggleClass("quickview-footer-open")
             expand();
         });
 
 
         $('.to-top').click(function (e) {
             hide();
 
             var goto = parseInt($(this).attr('goto'))
             clsScrollbarSignatures.goto(1)
             e.preventDefault();
             return false;
         });
 
         $('.js-gotoidelement').click(function (e) {
             hide();
 
             var goto = $(this).attr('goto');
             clsScrollbarSignatures.gotoidelement(goto)
             e.preventDefault();
             return false;
         });
     }
 
 
     ////////////////////////////
     //FUNCTION
 
     function expand() {
         var expand = parseInt($('.block-menuquickview').attr('expand'));
 
         if (expand == 1) {
             hide()
         } else {
             show()
         }
     }
 
 
     function hide() {
         $('body').css('overflow', 'inherit');
         $('.block-menuquickview').attr('expand', '0');
         $(".block-menuquickview .menucontent").stop(true, false).animate({ bottom: 0 }, 200);
     }
 
     function show() {
         $('body').css('overflow', 'hidden');
         $('.block-menuquickview').attr('expand', '1');
 
 
         if (typeof $('.page-fe800').attr('fe800-product-detail') !== 'undefined' && $('.page-fe800').attr('fe800-product-detail') !== false) {
             var valueheight = $('.block-menuquickview .inner').height() + 168
         } else {
             var valueheight = $('.block-menuquickview .inner').height() + 118
         }
 
         $(".block-menuquickview .menucontent").stop(true, false).animate({ bottom: -valueheight }, 500);
     }
 
 
     function hidetoplayvideo() {
         $('.block-menuquickview').attr('expand', '0');
     }
 
     function setValIndex() {
 
         var attrProDe = $('.page-fe800').attr('fe800-product-detail')
 
         if (attrProDe == "sl5800" || attrProDe == "pl4800") {
             $('.block-menuquickview .inner .col.col-intro li:first-child').html('Color & RGB LED Kit options')
         }
         for (var i = 0; i < arrProduct.length; i++) {
             if (attrProDe == arrProduct[i].product_name) {
                 $('.block-menuquickview .col-product .js-popups[popip="lumbar"]').attr("popip", "lumbar" + arrProduct[i].product_name)
                 $('.block-menuquickview .col-product .js-popups[popip="seat"]').attr("popip", "seat" + arrProduct[i].product_name)
                 $('.block-menuquickview .col-product .js-popups[popip="rgb"]').attr("popip", "rgb" + arrProduct[i].temp)
 
                 // $('.block-menuquickview .col-product .info .custom_product_price').attr("data-product-id", arrProduct[i].id)
 
                 $('.block-menuquickview .col-intro .intro-inner .label-js').html(arrProduct[i].product_name)
                 $('.block-menuquickview .quickview-footer-group .vertagear-container span').html(`/ ${arrProduct[i].kind} / <span>${arrProduct[i].product_name}</span>`)
 
                 for (var j = 0; j < arrProduct[i].typecolor.length; j++) {
                     if ($('.col-product img').attr('typecolor') == arrProduct[i].typecolor[j].typecolor) {
                         $('.col-product img[typecolor]').attr("src", arrProduct[i].typecolor[j].urlImg);
                     }
 
                 }
 
                 break;
 
             }
         }
 
 
     }
 
 
 
     ////////////////////////////
     //RETURN
     return {
         hide: hide,
         init: init
     }
 
 
 })();
 
 ////////////////////////////////////
 //run with setinteval
 
 $(function () {
     clsMenuQuickview.init();
 });
 
 
 //------------------------------------------
 //------------------------------------------
 var clsScrollbarSignatures = (function () {
     //PARAMATERS
     var setting = {
         scrollstatus: '',
         timetowait: 500,
         heightofmenu: 60,
         heightofmenufull: 140,
         destination: {
             current: 0,
             startdetect: 3,
             enddetect: 6,
         },
         autoScrolling: false
     }
 
 
     var objsignatures = {
         first: '.fe800-signatures',
         last: '.fe800-signatures',
     }
 
     //// đặt lại id  signatures_1(objsignatures.first) theo  product detail
     var attrProDe = $('.page-fe800').attr('fe800-product-detail')
     // check fe800-product-detail tồn tại
     if (typeof attrProDe !== 'undefined' && attrProDe !== false) {
 
         objsignatures.first = '#shopify-section-fe800-signatures_1_' + attrProDe
 
         // console.log("ID", objsignatures,objsignatures.first)
     }
 
     //INIT
     function init() {
         detectdevices();
         detectbrowsers();
         detectos();
 
         blocks_init();
 
         if ($('#fullpage').length == 0) return;
 
         if (!isMobile && browsername != 'Safari') {
             event_scroll();
             fullpage_init();
             header_addbackground();
         }
 
     }
 
 
     ////////////////////////////
     // HEADER
     function header_addbackground() {
         $().addClass('')
         $('.main-header').append('<div class="bganimation"><div>');
     }
 
     ////////////////////////////
     // DETECT
 
     let valueTopToDetect = 300
     var lastScrollTop = 0;
 
     function event_scroll() {
         //////////////////////
         //FOR NORMAL
         //if(osname == 'Mac' && browsername == 'Chrome'){
 
         $(window).scroll(function () {
             scroll_normal();
         });
 
         //////////////////////
         //FOR SILENCE
         var stringdetect = 'wheel'; // 'mousewheel scroll wheel DOMMouseScroll touchstart touchmove MozMousePixelScroll'
         /* if(browsername = 'Firefox') {
             stringdetect = 'DOMMouseScroll MozMousePixelScroll';
         } */
 
         var lastChange = +new Date();
         $(window).bind('wheel', function (event) {
             var t = $(window).scrollTop();
             //console.log(setting.autoScrolling, setting.autoScrolling, $('body').attr('video'))
 
             // Detect up or dow
             //console.log(event.originalEvent.wheelDelta)
             if (event.originalEvent.wheelDelta >= 0) {//up
 
                 $('body').attr('wheel', 'up')
                 setting.scrollstatus = 'up'
 
                 if (!setting.autoScrolling) {
                    if ($('body').attr('video') != "play") {
                        $(".main-header").css({ top: "0" })
                        if(t > 80){
                            $('.block-menuquickview').css({ 'height': 60, 'opacity': 1, 'overflow': 'inherit' });
                        }else{
                            $('.block-menuquickview').css({ 'height': 0, 'opacity': 0, 'overflow': 'hidden' });
                        }
                    } else {
                        setting.scrollstatus = 'down';
                        if(!$('body').hasClass('quickview-footer-open')){
                            $('.block-menuquickview').css({ 'height': 0, 'opacity': 0, 'overflow': 'hidden' });
                        }
                        console.log(6628)
                    }
                 }
 
             } else {//down
                 $('body').attr('wheel', 'down')
                 setting.scrollstatus = 'down'
 
                 if (!setting.autoScrolling) {
                    if ($('body').attr('video') != "play" && !$('body').hasClass('quickview-footer-open')) {
                        $('.block-menuquickview').css({ 'height': 0, 'opacity': 0, 'overflow': 'inherit' });
                        // $(".main-header").css({ top: "-100%" })
                        console.log(6640)
                    }
                 }
 
             }
 
             if (clsPopups.getshow()) return;
 
             //clsMenuQuickview.hide();
 
             settimetowait(event);
             //console.log('setting.timetowait', setting.timetowait);
             scroll_silence(event.originalEvent.wheelDelta);
         });
 
     }
 
     function scroll_normal() {
         if ($('.block-menuquickview').attr('expand') == '1') return;
         //console.log('1111111111', lastScrollTop, setting.destination.current)
         var t = $(window).scrollTop();
 
         if (!goto_running) {
 
             //// CAN KIEM TRA SCROLL UP OR DOWN CHINH XAC ?????
             if (t < lastScrollTop && setting.destination.current >= (setting.destination.enddetect + 1)) { // up
                 var pos7 = $(objsignatures.last).last().next().offset();// detect for number 7
                 var newpos7 = pos7.top - t
 
 
                 if (newpos7 > ($(window).height() * .5)) {
                     settimerunning();
                     setdetect_up()
                 }
             }
             else if (t > lastScrollTop && setting.destination.current <= setting.destination.startdetect) { // down
 
                 var pos = $(objsignatures.first).first().offset();// detect for number 3
                 var newpos = pos.top - ($(window).height() + t)
 
                 if (newpos <= -($(window).height() * .6)) {
                     settimerunning();
                     setdetect_down()
                 }
             }
         }
 
 
         lastScrollTop = t;
     }
 
     function scroll_silence(delta) {
         if ($('.block-menuquickview').attr('expand') == '1') return;
 
         // scroll này detect khi BLOCKS signature FIXED
         if (!setting.autoScrolling || setdetect_running || goto_running) return;
         setdetect_setrunning();
 
         var objsignaturesitem = $('.fp-section:eq(' + (setting.destination.current - 1) + ') .signatures-item');
         //console.log(objsignaturesitem.attr('id'))
 
         // kiểm tra nếu là 4blocks signatures
         if (setting.destination.current >= setting.destination.startdetect && setting.destination.current <= setting.destination.enddetect) {
             var isactive = objsignaturesitem.hasClass('active');
             //console.log(setting, isactive)
 
             // up + block 3
             if (!isactive && delta >= 0 && setting.destination.current <= setting.destination.startdetect) {
 
                 clearsfullscreen();
                 console.log(6702)
 
                 return false;
             }
 
 
             // down + block 6
             if (delta < 0 && setting.destination.current >= setting.destination.enddetect && isactive) {
                $.fn.fullpage.moveTo(setting.destination.enddetect + 1);
                console.log('down + block')
                blocks_hide(); // hide all

                clearsfullscreen();
                 return false;
             }
 
             //////////////////////
             // has class active
             if (isactive) {
                 //console.log('isactive', delta, setting.destination.current)
 
                 // up
                 if (delta >= 0 && setting.destination.current >= setting.destination.startdetect) {
                     /* $.fn.fullpage.moveTo(setting.destination.current - 1);
 
                     // don't need wait scrolling
                     setdetect_running = null; */
                     $('.main-header').css({ top: '0'})
                     console.log(6728)
                 }
                 // down
                 else {
                     $.fn.fullpage.moveTo(setting.destination.current + 1);
                     console.log(6601)
                 }
 
                 blocks_hide() // hide all
             }
             //////////////////////
             // no class active
             else {
                 //up
                 if (delta >= 0) {
                     $.fn.fullpage.moveTo(setting.destination.current - 1);
                     blocks_hide() // hide all
                     console.log(6729)
                 }
                 //down
                 else {
                     var keepallow = videoallowautoplay;
                     $('.fp-section:eq(' + (setting.destination.current - 1) + ') .signatures-item .signatures-video').trigger('click');// trigger to click
                     videoallowautoplay = keepallow;
                    var tl = gsap.timeline();
 
                    tl.set('.main-header', { top: 0 })
                        .to('.main-header', { duration: .2,top: '-100%'})
                     console.log(6740);
                 }
 
             }
         }
     }
 
 
     ////////////////////////////
     // FULLPAGE
 
     function fullpage_init() {
         // set paras
         setting.destination.startdetect = $(objsignatures.first).first().index() + 1;
         setting.destination.enddetect = $(objsignatures.last).last().index() + 1;
 
         //console.log(setting)
 
         // check home video
         if ($('.block-video').length == 0) {
             $('body').attr('fullpage', '2');
         } else {
             $('body').attr('fullpage', '1');
         }
 
         // set fullscreenn
         $('#fullpage').fullpage({
             //options here
             css3: true,
             easingcss3: 'linear',
             scrollingSpeed: 300,
             autoScrolling: false,
             fitToSection: false,
             scrollOverflow: false,
             sectionSelector: '.shopify-section',
 
             //continuousVertical:true,
             //scrollBar:true,
             //normalScrollElements: '#element1, #element2',
             onLeave: function (origin, destination, direction) {
                 if (!setting.autoScrolling || goto_running) return;
 
             },
             afterLoad: function (anchorLink, index) {
                 setting.destination.current = index
             }
         });
     }
 
     ////////////////////////////
     // DETECT
     var setdetect_running = null;
     function setdetect_setrunning() {
         clearTimeout(setdetect_running);
 
         setdetect_running = setTimeout(() => {
             setdetect_running = null;
         }, setting.timetowait);
     }
 
     function setdetect_up() {
         setdetect_run(setting.destination.enddetect)
     }
 
     function setdetect_down() {
        $(".main-header").css({ top: "-100%" });
         setdetect_run(setting.destination.startdetect)
     }
 
     function setdetect_run(numbermove) {
         if (setdetect_running) return;
         setdetect_setrunning()
 
         var t = $(window).scrollTop();
 
         setAutoScrolling(true)
         gsap.set('#fullpage', { x: 0, z: 0.0001, y: -(t) })
 
         var newtop = t;
         if (numbermove == setting.destination.startdetect) {
             newtop = $(objsignatures.first).first().position().top
 
         } else if (numbermove == setting.destination.enddetect) {
             newtop = $(objsignatures.last).last().position().top
         }
 
         //$('body').attr('scroll','fixed')
 
         var tl = gsap.timeline({
             onComplete: function () {
                 $.fn.fullpage.moveTo(numbermove);
                 console.log('numbermove',setting.destination.startdetect)
             }
         });
 
         if ($('body').attr('wheel') == "up") {
             gsap.set('.block-menuquickview', { height: 60, opacity: 1 })
             tl.to('#fullpage', { duration: .1, top: setting.heightofmenufull, x: 0, z: 0.0001, y: -(newtop), ease: "none" })
         } else {
             tl.to('#fullpage', { duration: .1, x: 0, z: 0.0001, y: -(newtop), ease: "none" })
         }
 
 
 
     }
 
     function getMatrix(element) {
         const values = element.style.transform.split(/\w+\(|\);?/);
         const transform = values[1].split(/,\s?/g).map(numStr => parseInt(numStr));
         //console.log(transform)
 
         return {
             x: transform[0],
             y: transform[1],
             z: transform[2]
         };
     }
 
 
     function clearsfullscreen() {
         var matrix = getMatrix(document.getElementById('fullpage'));
 
         
        setAutoScrolling(false);

        if (setting.scrollstatus == 'up') {
            $(window).scrollTop(Math.abs(matrix.y) - setting.heightofmenufull);
        } else {
            $(window).scrollTop(Math.abs(matrix.y) - setting.heightofmenu);
        }
            
            
        console.log($(window).scrollTop(),Math.abs(matrix.y))
        gsap.set('#fullpage', { top: 0 })
     }
 
 
     function setAutoScrolling(value) {
         if (value) {
             $.fn.fullpage.setAllowScrolling(false);
         }
 
         $.fn.fullpage.setAutoScrolling(value);
         setting.autoScrolling = value;
     }
     ////////////////////////////
     //FUNCTION
     var goto_running = false;
     var goto_timing = null;
 
     var arrBlocks = {
         '1': '.block-video',
         '2': '.campagin-review',
         '3': '#signatures-3',
         '11': '.rgb-popup',
         '12': '.moreproduct-features',
         '13': '.wps_in_comfort',
         '14': '.product_color',
         '15': '.series_collection',
         '16': '.product800-detail',
         '17': '.section-specifications',
         '18': '.product_comparison',
         '19': '.section-review',
     }
 
     function goto(elementid) {
 
         goto_running = true;
         if (setting.autoScrolling) clearsfullscreen();
 
         //console.log(arrBlocks[elementid], $(arrBlocks[elementid]).offset().top, $(window).scrollTop())
         setTimeout(() => {
             $("html, body").animate({ scrollTop: $(arrBlocks[elementid]).offset().top - setting.heightofmenu }, 600, function () {
                 goto_running = false;
             });
         }, 200);
 
 
         return false;
     }
 
     function gotoidelement(elementid) {
 
         goto_running = true;
         if (setting.autoScrolling) clearsfullscreen();
 
         //console.log(elementid, $(elementid).offset().top, $(window).scrollTop())
         setTimeout(() => {
             $("html, body").animate({ scrollTop: $(elementid).offset().top - setting.heightofmenu }, 600, function () {
                 goto_running = false;
             });
             $('.block-menuquickview').css({ 'height': 0, 'overflow': 'hidden' });
         }, 200);
 
 
         return false;
     }
 
     function settimerunning() {
         goto_running = true;
 
         goto_timing = setTimeout(() => {
             clearTimeout(goto_timing);
             goto_running = false;
         }, 100);
     }
 
 
     ////////////////////////////
     //DETECT MOBILE
     var isMobile = false;
     function detectdevices() {
         isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
         if (isMobile) {
             $('body').attr('device', 'Mobile')
         }
 
     }
 
     var browsername = '';
     function detectbrowsers() {
 
         if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
             browsername = 'Opera';
         }
         else if (navigator.userAgent.indexOf("Chrome") != -1) {
             browsername = 'Chrome';
         }
         else if (navigator.userAgent.indexOf("Safari") != -1) {
             browsername = 'Safari';
         }
         else if (navigator.userAgent.indexOf("Firefox") != -1) {
             browsername = 'Firefox';
         }
         else if ((navigator.userAgent.indexOf("MSIE") != -1) || (!!document.documentMode == true)) {
             browsername = 'IE';
         }
         else {
             browsername = 'unknown';
         }
 
         $('body').attr('browser', browsername)
     }
 
     var osname = 'Others';
     function detectos() {
 
         if (navigator.platform.indexOf('Mac') > -1) {
             osname = 'Mac';
         }
         else if (navigator.platform.indexOf('Win') > -1) {
             osname = 'Win';
         }
 
         $('body').attr('os', osname)
     }
 
 
 
     function settimetowait(e) {
         //setting.timetowait = 500;
         //console.log(e.originalEvent.wheelDeltaY, e.originalEvent.deltaY)
 
         if (e.originalEvent.wheelDeltaY) {
             if (e.originalEvent.wheelDeltaY === (e.originalEvent.deltaY * -3)) {
                 setting.timetowait = 1000
             }
         }
         else if (e.originalEvent.deltaMode === 0) {
             setting.timetowait = 500
         }
 
     }
 
     ////////////////////////////
     //BLOCKS Signatures
     var timeoutblockshow = null;
 
     function blocks_init() {
         if ($('.signatures-item').length == 0) return;
 
         if ($('body').attr('device') == 'Mobile') {
             blocks_events_mobile();
         } else {
             blocks_events();
         }
     }
 
     function blocks_events() {
         $('.signatures-visual').click(function (e) {
             e.preventDefault();
             if ($(this).parent().hasClass('active')) {
                 blocks_hide()
 
             } else {
                 blocks_show($(this).parent())
             }
         });
 
         $('.signatures-video').click(function (e) {
 
             e.preventDefault();
             if ($(this).parent().hasClass('active')) {
                 blocks_hide()
 
             } else {
                 blocks_show($(this).parent())
             }
         });
     }
 
     function blocks_events_mobile() {
         const videos = document.querySelectorAll(".signatures-item video.video-mobile"); // Select ALL the Videos
         const observer = new IntersectionObserver((entries) => {
             entries.forEach((entry) => {
                 if (!entry.isIntersecting) {
                     entry.target.pause(); // Pause the TARGET video
                 } else {
                     entry.target.play(); // Play the TARGET video
                 }
             });
         }, { threshold: 1 });
         for (const video of videos) observer.observe(video); // Observe EACH video
 
     }
 
     function blocks_hide() {
         // hide the banner + text
         gsap.set('#fullpage', { ease: "none" })
 
         gsap.set('.main-header', { backgroundColor: '#fff' })
         gsap.set('.main-header .bganimation', { height: 0 })
 
         if ($('body').attr('wheel') == "up") {
            gsap.set('.main-header', { top: '0' })
            gsap.set('.block-menuquickview', { height: 60, opacity: 1, ease: "none" })
            gsap.to('#fullpage', { duration: .1, top: setting.heightofmenufull, ease: "none" })
         }else{
            gsap.set('.main-header', { top: '-100%' })
            gsap.set('.block-menuquickview', { height: 0, opacity: 0, ease: "none" })
         }
 
 
         //clsMenuQuickview.hide();
         $('.signatures-item').removeClass('active');
         $('.signatures-item video.video-desktop').trigger('pause');
         $('body').attr('video', 'pause');
 
 
         goto_running = false;
     }
 
     function blocks_show($this) {
         goto_running = true;
 
         // 1. animation để đống TEXT + Banners
         // 2. dong viewallproduct
         // 3. transparent thang HEADER 
         var tl = gsap.timeline({
             onComplete: function () {
                 // code here onComplete
                 $('body').attr('video', 'play');
                 goto_running = false;
             }
         });
 
 
         if ($('.block-menuquickview').height == 0) {
             tl
                 .set('.main-header .bganimation', { height: '100%' })
                 .set('.main-header', { backgroundColor: 'rgba(255, 255, 255, 0)' })
                 .to('#fullpage', { duration: .2, top: 0, ease: "none" })
                 .to('.main-header .bganimation', { duration: .2, height: 0 })
         } else {
             tl
                 .set('.main-header .bganimation', { height: '100%' })
                //  .set('.main-header', { backgroundColor: 'rgba(0, 0, 0, 0)' })
                 .to('#fullpage', { duration: .2, top: 0, ease: "none" })
                 .to('.block-menuquickview', { duration: .2, height: 0, opacity: 0, ease: "none" })
                 .to('.main-header .bganimation', { duration: .2, height: 0 })
         }
 
 
 
 
 
         //clsMenuQuickview.hide();
         $this.addClass('active');
 
         var objvideo = $this.find('video.video-desktop')
         objvideo[0].play();
 
         if (videoallowautoplay) {
             objvideo[0].muted = true;
         }
     }
 
     ////////////////////////////
     //RETURN
     return {
         init: init,
         gotoidelement: gotoidelement,
         goto: goto
     }
 })();
 
 ////////////////////////////////////
 //run with setinteval
 
 $(function () {
     clsScrollbarSignatures.init();
 });
 
 
 
 
 //------------------------------------------
 //------------------------------------------
 var clsPopups = (function () {
     //PARAMATERS
     var setting = {
         root: '.fe800-popup',
 
         isShow: false
     }
 
     //INIT
     function init() {
         if ($(setting.root).length == 0) return;
         events_ajax();
         contents_events();
         rgb_init();
         contents_open();
     }
 
     function events_ajax() {
         $(' .js-popups').click(function (e) {
             if (setting.isShow) return;
             e.preventDefault();
 
             $(".fe800-popup").attr("loading-popup", 1);
             gsap.set('.fe800-popup', { backgroundColor: 'rgba(0, 0, 0, 1)' })
 
             var popup = $(this).attr('popip')
 
             var urlajax = window.product == null ? 'https://www.vertagear.com/?sections=fe800-popup-' + popup + '-modal' : 'https://www.vertagear.com/products/'+window.product.handle+'?sections=fe800-popup-' + popup + '-modal'
 
             $.get(urlajax, function (data, status) {
                 var resulthtml = null
 
                 if (window.location.hostname == 'localhost') {
                     resulthtml = data;
                 }
                 else {
                     resulthtml = data['fe800-popup-' + popup + '-modal'];
                 }
 
                 try {
 
                     /* var customDiv = $(resulthtml);
                     document.querySelector('.popup-inner').attachShadow({mode: 'open'}).innerHTML(customDiv) */
 
                     $(setting.root + ' .popup-inner').html(resulthtml);
 
                     $(setting.root).imagesLoaded()
                         .always(function (instance) {
                             contents_open()
                         })
                         .done(function (instance) {
                             contents_open()
 
                         })
 
                 } catch (error) {
 
                 }
             });
 
             show();
         });
 
 
         $(setting.root).on("click", ".js-popup-close,.close-btn, .popup-background", function () {
             hide()
         });
 
 
         $(window).bind('mousewheel scroll wheel DOMMouseScroll touchstart touchmove MozMousePixelScroll', function (e) {
             e.stopPropagation();
         });
 
         $(document).keyup(function (e) {
             //console.log('keyup', e.which)
             if (e.which == 27) {// esc
                 clsCampagin_review.hide();
                 hide();
             }
         });
     }
 
     ////////////////////////////
     //FUNCTION
     function show() {
         setting.isShow = true;
         $('body').attr('popip', 'show');
 
 
 
         var tl = gsap.timeline({
             onComplete: function () {
                 //$(".fe800-popup").attr("loading-popup", 0);
             }
         });
 
         tl.set(setting.root + ' .popup-inner', { opacity: 0 })
             .set(setting.root, { display: 'block', opacity: 1, top: '100vh' })
             .to(setting.root, { duration: .3, opacity: 1, top: 0, ease: "none" })
 
 
     }
 
     function hide() {
         isContentOpen = false;
         setting.isShow = false;
 
         var tl = gsap.timeline({
             onComplete: function () {
                 $('body').attr('popip', 'hide');
                 $(setting.root + ' .popup-inner').html('');
                 gsap.set(setting.root, { display: 'none' })
 
                 swipercontent = null;
             }
         });
 
         tl.to(setting.root, { duration: .3, top: '100vh', opacity: 0, ease: "none" })
 
     }
 
     function getshow() {
         return setting.isShow;
     }
 
 
     ////////////////////////////
     //CONTENTS POPUPS
     var swipercontent = null;
 
     var isContentOpen = false;
     function contents_events() {
         // $(setting.root).on('click', '.desc', function () {
         //     if ($(this).hasClass('show')) {
         //         $(this).removeClass('show')
         //     } else {
         //         $(this).addClass('show')
         //     }
         // });
 
 
         $(setting.root).on('click', '.popup', function (e) {
             e.stopPropagation();
         });
 
         $(setting.root).on('click', '.videodetectpercent', function () {
             var statusvideo = $(this).attr('video');
 
             if (statusvideo == 'play') {
                 contents_videos_stop($(this));
                 $(this).addClass('notautoplay');
             } else {
                 contents_videos_play($(this));
 
             }
         });
 
         //console.log('.sticky.fixed',$(setting.root).find('.sticky.fixed').length )
 
 
         if ($('body').attr('device') != 'Mobile' && $(setting.root).find('.sticky.fixed').length == 0) {
             $(setting.root).bind('wheel', function (event) {
 
                 if (event.originalEvent.wheelDelta < 0 && isContentOpen) {//godown
                     if (!$(setting.root).hasClass('allowscroll')) {
                         $(setting.root + ' .sticky').addClass('fixed');
 
                         setTimeout(() => {
                             $(setting.root).addClass('allowscroll')
                             swipercontent ? swipercontent.mousewheel.enable() : false;
                         }, 300);
                     }
                 } else {
                     //var t = $(setting.root + " .popup-inner .popup").scrollTop();
                     if (swipercontent) {
                         var activeIndex = swipercontent.activeIndex;
 
                         if ($(setting.root).hasClass('allowscroll') && activeIndex == 0) {
                             $(setting.root).removeClass('allowscroll')
                             $(setting.root + ' .sticky').removeClass('fixed');
                             swipercontent.mousewheel.disable()
                         }
                     } else {
                         var t = $(setting.root + " .popup-inner .popup").scrollTop();
 
                         if ($(setting.root).hasClass('allowscroll') && t == 0) {
                             $(setting.root).removeClass('allowscroll')
                             $(setting.root + ' .sticky').removeClass('fixed');
                         }
                     }
                 }
             });
         } else {
             $(setting.root).addClass('allowscroll')
         }
 
     }
 
     function contents_setview() {
         if (!swipercontent) {
             contents_percentforsetview()
         }
     }
 
     function contents_swiperforsetview() {
         $(setting.root + ' .swiper-slide').each(function (index, element) {
             var activeIndex = swipercontent.activeIndex;
 
             if (activeIndex == index) {
                 contents_videos_play($(element))
             } else {
                 contents_videos_stop($(element))
             }
         });
     }
 
     function contents_percentforsetview() {
         var withinViewportArray = $('.videodetectpercent').percentWithinViewport();
 
         $.each(withinViewportArray, function (index) {
             var myPercVisible = parseInt($(this).attr('data-percent-viewport'));
             //console.log('myPercVisible', myPercVisible)
 
             if (myPercVisible > 60 && !$(this).hasClass('notautoplay')) {
                 contents_videos_play($(this))
             } else {
                 contents_videos_stop($(this))
             }
         });
     }
 
     function contents_open() {
         isContentOpen = true;
         var tl = gsap.timeline();
 
         tl.to(setting.root + ' .popup-inner', { delay: .4, duration: .2, opacity: 1 })
             .to(setting.root, { duration: .2, backgroundColor: 'rgba(0, 0, 0, 0.5)' })
 
 
         $(setting.root + " .popup-inner .popup").unbind("scroll");
         $(setting.root + " .popup-inner .popup").scroll(function () {
             contents_setview()
         });
 
         contents_setview();
         contents_setswiperfullpage();
         contents_setswipersnormal();
         contents_clickviewalltext();
     }
 
     function contents_clickviewalltext() {
         if ($('body').attr('device') == 'Mobile') {
             
             $('.see-more').click(function () {
                 console.log($(this).siblings('.see-less').length)
                 if ($(this).siblings('.see-less').length > 0) {
                     $(this).hide();
                     $(this).siblings('.see-less').show();
                 }
             })
 
             $('.see-less').click(function () {
                 $(this).hide();
                 $(this).siblings('.see-more').show();
             })
         }
     }
 
     function contents_setswiperfullpage() {
         if ($('body').attr('device') != 'Mobile') {
             //set scroll
             var t = $(setting.root + " .popup-inner .popup").scrollTop();
             if (t == 0) {
                 $(setting.root).removeClass('allowscroll')
                 $(setting.root + ' .sticky').removeClass('fixed');
             }
 
             if ($(setting.root + ' .swiperfullpage').length > 0) {
                 swipercontent = new Swiper(setting.root + ' .swiperfullpage', {
                     // Optional parameters
                     slidesPerView: "auto",
                     autoHeight: true,
                     direction: 'vertical',
                     mousewheel: {
                         releaseOnEdges: true,
                     },
                 });
 
                 swipercontent.on('slideChange', function () {
                     contents_swiperforsetview()
 
                 });
 
                 swipercontent.mousewheel.disable()
                 contents_swiperforsetview();
             } else {
                 swipercontent = null;
             }
         }
     }
 
     function contents_setswipersnormal() {
         if ($('#swiperfearure').length > 0) {
             new Swiper('#swiperfearure', {
                 spaceBetween: 10,
                 slidesPerView: 1,
                 pagination: {
                     enabled: true,
                     el: ".swiperfearure-pagination",
                     type: 'custom',
                     clickable: true,
                     renderCustom: function (swiper, current, total) {
                         var out = ''
                         for (i = 1; i < total + 1; i++) {
                             if (i == current) {
                                 out = out + '<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex=' + i + ' role="button" aria-label="Go to slide ' + i + 1 + '"></span>';
                             }
                             else {
                                 out = out + '<span class="swiper-pagination-bullet" tabindex=' + i + ' role="button" aria-label="Go to slide ' + i + 1 + '"></span>';
                             }
                         };
                         return out;
                     },
                 },
                 navigation: {
                     enabled: false,
                 },
                 breakpoints: {
                     1024: {
                         slidesPerView: 3.5,
                         navigation: {
                             enabled: true,
                             nextEl: ".swiperfearure-next",
                             prevEl: ".swiperfearure-prev",
                         },
                     },
                 },
             });
 
             if ($('body').attr('device') == 'Mobile') {
 
                 $('#swiperfearure .see-more').click(function () {
                     $(this).parent().addClass('active');
                     $(this).siblings('.desc').find('.see-less').css('display', 'inline-block');
                     $(this).hide();
                 })
 
                 $('#swiperfearure .see-less').click(function () {
                     console.log('123123123', $(this).parent().parent())
                     $(this).parent().parent().removeClass('active');
                     $(this).parent().siblings('.see-more').css('display', 'inline-block');
                     $(this).hide();
                 })
             }
         }
 
         if ($('#swiperreview').length > 0) {
             new Swiper('#swiperreview', {
                 spaceBetween: 10,
                 slidesPerView: 1,
                 navigation: {
                    enable: true,
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                 pagination: {
                     enabled: true,
                     el: ".swiperreview-pagination",
                     type: 'custom',
                     clickable: true,
                     renderCustom: function (swiper, current, total) {
                         var out = ''
                         for (i = 1; i < total + 1; i++) {
                             if (i == current) {
                                 out = out + '<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex=' + i + ' role="button" aria-label="Go to slide ' + i + 1 + '"></span>';
                             }
                             else {
                                 out = out + '<span class="swiper-pagination-bullet" tabindex=' + i + ' role="button" aria-label="Go to slide ' + i + 1 + '"></span>';
                             }
                         };
                         return out;
                     },
                 },
                 breakpoints: {
                     1024: {
                         spaceBetween: 90,
                         slidesPerView: 3,
                     },
                 },
             });
         }
 
         if ($('#swipercarouselgallery').length > 0) {
             new Swiper('#swipercarouselgallery', {
                 spaceBetween: 40,
                 slidesPerView: 1,
                 autoplay: {
                     delay: 3000
                 },
                 navigation: {
                     enabled: false,
                 },
                 breakpoints: {
                     1024: {
                         spaceBetween: 40,
                         slidesPerView: 2.5,
                         navigation: {
                             enabled: true,
                             nextEl: ".swipercarouselgallery-next",
                             prevEl: ".swipercarouselgallery-prev",
                         },
                     },
                 },
             });
         }
 
         if ($('#swipercontrols').length > 0) {
             new Swiper('#swipercontrols', {
                 spaceBetween: 0,
                 slidesPerView: 1,
                 pagination: {
                     enabled: true,
                     el: ".swipercontrols-pagination",
                     type: 'custom',
                     clickable: true,
                     renderCustom: function (swiper, current, total) {
                         var out = ''
                         for (i = 1; i < total + 1; i++) {
                             if (i == current) {
                                 out = out + '<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex=' + i + ' role="button" aria-label="Go to slide ' + i + 1 + '"></span>';
                             }
                             else {
                                 out = out + '<span class="swiper-pagination-bullet" tabindex=' + i + ' role="button" aria-label="Go to slide ' + i + 1 + '"></span>';
                             }
                         };
                         return out;
                     },
                 },
                 breakpoints: {
                     1024: {
                         spaceBetween: 0,
                         slidesPerView: 2,
                     },
                 },
             });
         }
     }
 
     function contents_videos_stop($this) {
         $this.attr('video', 'pause');
         $this.find('.play-btn').show();
 
         //console.log('leng',$this.find('video').length)
         $this.find('video').each(function () {
             $(this).get(0).pause();
         });
 
         /* if ($this.find('video').length > 1) {
             var idvideo = $('body').attr('device') == 'Mobile' ? '.video-mobile' : '.video-desktop';
             //$this.find(idvideo).trigger('pause');
             
             
         } else {
             $this.find('video').trigger('pause');
         } */
     }
 
     function contents_videos_play($this) {
         $this.removeClass('notautoplay');
         $this.attr('video', 'play');
         $this.find('.play-btn').hide();
 
         if ($this.find('video').length > 1) {
             var idvideo = $('body').attr('device') == 'Mobile' ? '.video-mobile' : '.video-desktop';
             $this.find(idvideo).trigger('play');
 
             if (videoallowautoplay && $this.find(idvideo)[0]) {
                 $this.find(idvideo)[0].muted = true;
             }
         } else {
             $this.find('video').trigger('play');
 
             if (videoallowautoplay && $this.find(idvideo)[0]) {
                 $this.find('video')[0].muted = true;
             }
         }
     }
 
     ////////////////////////////
     //functions
 
     var ldRgbLightUpBtnSrc = window.shopData.ldRgbLightUpBtnSrc
     var ldRgbLightUpBlueBtnSrc = window.shopData.ldRgbLightUpBlueBtnSrc
     var ldRgbLightUpMainImgSrc = window.shopData.ldRgbLightUpMainImgSrc
 
     var objtextfeatures = [
         { url: '#ldRgbCarouselFeature', title: 'Sync Your Game <br class="mb-hide" /> and Audio', desc: 'Blast or destroy, bass or highs—those around you will vibe to the sounds of your gameplay and music through your lights. The party starts with your every move.' },
         { url: '#ldRgbLightLogo', title: 'Light Up  Your Logo <br class="mb-hide" />', desc: `Don't ever let yourself be obscured. Even as darkness descends, shine a spotlight on what you're all about like never before. This RGB kit enhances not only your gaming but also you.` },
         { url: '#ldRgbApps', title: 'Simple Controls via <br class="mb-hide" /> SignalRGB', desc: 'Easily control your lighting experience with the critically acclaimed SignalRGB software. Everything you need is just a click away.' }
     ]
 
     var objimagefeatures = window.shopData.objimagefeatures
 
     function rgb_init() {
         $(setting.root).on("click", ".f800-featurescontents .nam-feature__action-wrapper", function () {
             var $index = $(this).index();
             $('.nam-feature__action-wrapper').removeClass('active');
             $(this).addClass('active');
 
             $('.feature__bg').css('display', 'none')
             $('.feature__bg' + ($index + 1)).css('display', 'block')
 
             //console.log('.feature__bg' + ($index+1))
 
             $('#namFeatureTitleDesk').html(objtextfeatures[$index].title)
             $('#namFeatureDescDesk').html(objtextfeatures[$index].desc)
         });
 
         $(setting.root).on("click", ".light-logo__selection__btns img", function () {
             $(".light-logo__selection__btns img").each(function (index, element) {
                 // element == this
                 $(element).attr('src', ldRgbLightUpBtnSrc[index])
             });
 
             var rootindex = $(this).index();
             $(this).attr('src', ldRgbLightUpBlueBtnSrc[rootindex])
             $('#lightLogoImg').attr('src', ldRgbLightUpMainImgSrc[rootindex])
         });
 
         if ($('body').attr('device') == 'Mobile') {
             $(setting.root).on("click", ".f800-featurescontents .nam-feature__action__switch__btn", function () {
                 var $index = $(this).index();
                 console.log($index, objimagefeatures[$index].image, objtextfeatures[$index].url);
                 $('.nam-feature__action__switch__btn').removeClass('nam-product-main-btn').addClass('nam-product-sec-btn');
                 $(this).removeClass('nam-product-sec-btn').addClass('nam-product-main-btn');
 
                 $('#namFeatureImg').attr('src', objimagefeatures[$index].image)
                 $('#ldRgbExploreBtn').attr('href', objtextfeatures[$index].url)
                 $('#namFeatureTitle').html(objtextfeatures[$index].title)
                 $('#namFeatureDesc').html(objtextfeatures[$index].desc)
             });
         }
     }
 
     ////////////////////////////
     //functions
 
     function getshow() {
         return setting.isShow;
 
     }
 
 
 
 
     ////////////////////////////
     //RETURN
     return {
         init: init,
         hide: hide,
         getshow: getshow
     }
 
 })();
 
 ////////////////////////////////////
 //run with setinteval
 
 $(function () {
     clsPopups.init();
 });
 
 
 //------------------------------------------
 //------------------------------------------
 var videoallowautoplay = false
 
 var clsHeroVideo = (function () {
     //PARAMATERS
     var timeout_video = null
 
     //INIT
     function init() {
         detectdevices()
 
         if ($('.block-video').length == 0) return;
 
         if (!isMobile) {
             add_observer();
         }
 
         events();
         play();
         change_videoMobile();
     }
 
     function events() {
         $(document).click(function (e) {
             videoallowautoplay = true;
         });
 
         if ($('body').attr('device') != 'Mobile') {
             Xclose();
 
             $('.js-playvideo').click(function (e) {
                 videoallowautoplay = true;
                 e.preventDefault();
                 play();
                 // console.log("play")
 
             });
 
             $('.js-pausevideo').click(function (e) {
                 videoallowautoplay = true;
                 e.preventDefault();
                 pause();
                 // console.log("pause")
                 PopupShow();
             });
         }
         else {
             $('.js-pausevideo').click(function (e) {
                 var video = $('.block-video #videohero_mobile')[0];
                 if (video.requestFullscreen) {
                     video.requestFullscreen();
                 } else if (video.webkitRequestFullscreen) { /* Safari */
                     video.webkitRequestFullscreen();
                 } else if (video.msRequestFullscreen) { /* IE11 */
                     video.msRequestFullscreen();
                 }
                 video.muted = true;
                 if (video.pause) {
                     video.play();
                 }
             });
         }
 
 
     }
 
     ////////////////////////////
     //FUNCTION
     function play() {
         clearTimeout(timeout_video);
 
         if (!isMobile) {
             gsap.to('.main-header', { duration: .1, backgroundColor: 'rgba(255, 255, 255, 0)', ease: "none" })
         }
 
 
         $('body').attr('video', 'play');
         //clsMenuQuickview.hide();
         $('.block-video').attr('video', 'play');
         //$('.block-video video')[0].play();
         $('.block-video video').trigger('play');
 
         $('.block-menuquickview').css({'height':0, 'overflow':'hidden'});
 
         if (videoallowautoplay) {
             $('.block-video video')[0].muted = false;
         }
     }
 
     function pause() {
         if ($('body').attr('video') != 'play') return;
         gsap.to('.main-header', { duration: .1, backgroundColor: 'rgba(255, 255, 255, 1)', ease: "none" })
 
 
         //clsMenuQuickview.hide();
 
         $('body').attr('video', 'pause');
         $('.block-video').attr('video', 'pause');
         $('.block-video video').trigger('pause');
     }
 
     function PopupShow() {
 
         gsap.set('.popup-hero-banner', { y: 500 });
         gsap.to('.popup-hero-banner', { duration: .25, y: 0, display: 'flex', ease: "none" });
         $('.popup-hero-banner video').trigger('play');
 
 
     }
 
     function Xclose() {
 
         $(document).keyup(function (e) {
             //console.log('keyup', e.which)
             if (e.which == 27) {// esc
                 gsap.to('.popup-hero-banner', { duration: .25, y: 500, display: 'none', ease: "none" })
                 $('.popup-hero-banner video').trigger('pause');
                 if ($('.popup-hero-banner').css('display') != 'none') {
                     play();
                 }
             }
         });
 
         $('.popup-hero-banner .xclose-js').click(function (e) {
             e.preventDefault();
             $('.popup-hero-banner video').trigger('pause');
             gsap.to('.popup-hero-banner', { duration: .25, y: 500, display: 'none', ease: "none" })
             play();
         });
 
 
 
 
 
 
     }
 
     function add_observer() {
 
         $(window).scroll(function () {
             //var t = $(window).scrollTop();
 
 
             var pos = $(".block-video").get(0).getBoundingClientRect();
             var t = Math.abs(pos.y)
 
             if (t > 100 && t <= $(window).height()) {
                 pause();
             } else if (t <= 100) {
                 play();
             }
         });
     }
 
     function change_videoMobile() {
         if ($('body').attr('device') == 'Mobile') {
             var video = $('.full-image-intro__bg video source');
             var videopopup = $('.popup-hero-banner .videoWrapper video source');
             video.attr('data-src', 'https://cdn.shopify.com/videos/c/o/v/18fe82fe9bd64c8b9e76eef754551d1a.mp4');
             videopopup.attr('data-src', 'https://cdn.shopify.com/videos/c/o/v/18fe82fe9bd64c8b9e76eef754551d1a.mp4');
         }
     }
 
     ////////////////////////////
     //DETECT MOBILE
     var isMobile = false;
     function detectdevices() {
         isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
         if (isMobile) {
             $('body').attr('device', 'Mobile')
         }
 
     }
 
 
     ////////////////////////////
     //RETURN
     return {
         init: init
     }
 
 
 })();
 
 ////////////////////////////////////
 //run with setinteval
 $(function () {
     clsHeroVideo.init();
 });
 
 
 //------------------------------------------
 //------------------------------------------
 var clsCampagin_review = (function () {
     //PARAMATERS
     var setting = {
         root: '#popup-reviews',
         isShow: false
     }
 
     //INIT
     function init() {
         // if ($('.campagin-review').length == 0) return;
         events()
     }
 
     ////////////////////////////
     //EVENTS
     function events() {
         var run_first = false;
 
 
         if ($('body').attr('device') != 'Mobile') {
             $('.index-signature__swiper-arrow.swiper-arrow.-next').click(function () {
                 var width_body = $('body').width();
                 if (width_body > 769) {
                     $(this).addClass('swiper-button-disabled');
                 }
 
                 if (run_first) return;
 
                 if (width_body > 1920 || $('body').attr('browser') == "Firefox") {
                     var witdth = $('#shopify-section-index-signature').width();
                     var tl = gsap.timeline({ onComplete: function () { run_first = true; } });
 
                     tl.set('.index-signature__main-inner .swiper-wrapper', { x: 0 })
                     tl.to('.index-signature__main-inner .swiper-wrapper', { duration: .5, x: -witdth, ease: "none" })
                 }
             });
         }
 
         $('.fe800-reviews-js').click(function () {
             show()
             return;
         })
         $(".custom-okeReviews-reviewsTab").click(function () {
             show()
             return;
         })
 
         $('.js-reviews-close').click(function () {
             hide();
         })
 
         getTotalReview();
     }
 
 
     ////////////////////////////
     //FUNCTION
     function star_rating() {
         var point = $('.point').text().trim();
         var star = '.campagin-review-recent .point .okeReviews-starRating-indicator-layer--foreground';
         const starTotal = 5;
         const starPercentage = (point / starTotal) * 100;
         const starPercentageRounded = `${((starPercentage / 10) * 10)}%`;
         document.querySelector(star).style.width = starPercentageRounded;
     }
 
     function star_reset() {
         var star = '.campagin-review-recent .point .okeReviews-starRating-indicator-layer--foreground';
         const starPercentageRounded = '20%';
         document.querySelector(star).style.width = starPercentageRounded;
     }
 
     function show() {
         setting.isShow = true;
         $('body').attr('popip', 'show');
 
 
         var tl = gsap.timeline();
 
         tl.set(setting.root + ' .reviews-inner', { opacity: 0, y: 500 })
             .set(setting.root, { display: 'block', opacity: 0, y: 500 })
             .to(setting.root, { duration: .3, opacity: 1, y: 0 })
             .to(setting.root + ' .reviews-inner', { duration: .2, opacity: 1, y: 0, ease: "none" })
     }
 
     function hide() {
         setting.isShow = false;
 
         var tl = gsap.timeline({
             onComplete: function () {
                 $('body').attr('popip', 'hide');
             }
         });
 
         tl.to(setting.root + ' .reviews-inner', { duration: .2, opacity: 0, y: 500, ease: "none" })
             .set(setting.root, { display: 'none' })
 
     }
 
     function getTotalReview() {
 
 
         $(window).load(function () {
             //console.log('page is loaded');
             setTimeout(function () {
                 var total = $('.reviews-inner .okeReviews-reviewsAggregate-summary-total').text();
 
                 if (total) {
                     $('.sub-rating').html(`Average customer rating <br /> (${total})`)
                 }
             }, 1500);
 
         });
     }
 
 
 
 
     ////////////////////////////
     //RETURN
     return {
         init: init,
         hide: hide
     }
 
 
 })();
 
 ////////////////////////////////////
 //run with setinteval
 
 $(function () {
     clsCampagin_review.init();
 });
 
 
 //------------------------------------------
 //------------------------------------------
 var clsWPS_in_comfort = (function () {
     //PARAMATERS
 
     //INIT
     function init() {
 
 
         detectdevices()
         // console.log(isMobile)
 
         if (!isMobile) {
             events()
 
         }
 
         customwper()
 
     }
 
     ////////////////////////////
     //EVENTS
     function events() {
         $('.wps_in_comfort .item').hover(function () {
             // over
             $('.item').removeClass('active');
             $(this).addClass('active');
         }, function () {
             // out
         }
         );
     }
 
     function customwper() {
  //  Initialize Swiper
         if ($('body').attr('device') == 'Mobile') {
             let swiper = new Swiper(".mySwiper-js", {
                 pagination: {
                     el: ".swiper-pagination-js",
                     clickable: true,
                 },
             });
         }
        
 
     }
 
 
 
 
 
     ////////////////////////////
     //FUNCTION
 
     ////////////////////////////
     //DETECT MOBILE
     var isMobile = false;
     function detectdevices() {
         isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
         if (isMobile) {
             $('body').attr('device', 'Mobile')
         }
 
     }
 
 
 
 
     ////////////////////////////
     //RETURN
     return {
         init: init
     }
 
 
 })();
 
 ////////////////////////////////////
 //run with setinteval
 
 $(function () {
     clsWPS_in_comfort.init();
 });
 
 
 //------------------------------------------
 //------------------------------------------
 var clsProductReview = (function () {
     //PARAMATERS
     var arrReviewsPage = {
         "SL3800": {
             "shopifyID": "shopify-7024401154159",
         },
         "SL5800": {
             "shopifyID": "shopify-7024816291951",
         },
         "PL4800": {
             "shopifyID": "shopify-7025941348463",
         },
         "PL6800": {
             "shopifyID": "shopify-7025941446767",
         },
     }
 
     //INIT
     function init() {
         if ($('.section-review').length == 0) return;
         start_tag();
         events()
     }
 
     ////////////////////////////
     //EVENTS
     function events() {
         // active_Tag();
         postIdReviewData();
     }
 
 
     ////////////////////////////
     //FUNCTION 
     function postIdReviewData() {
         var attrProDe = $('.page-fe800').attr('fe800-product-detail').toUpperCase();
         var newReviews = $('.fe800-reviews-js .okeReviews-reviewsSummary-ratingCount span')[0].outerText.replace('Reviews', "");
 
         // console.log('1111111111111111111', newReviews, attrProDe)
         if (typeof attrProDe === 'undefined' && attrProDe === false) return;
         $('.reviews-data').attr('data-oke-reviews-product-id', arrReviewsPage[attrProDe].shopifyID)
 
         if ($('body').attr('device') == 'Mobile' && $('.layoutv1').length <= 0) {
             $('.fe800-reviews-js .okeReviews-reviewsSummary-ratingCount span').html(newReviews);
 
         }
 
 
         // productdetail layout version1
         var newReviewsDesktop = $('.fe800-reviews-js .okeReviews-reviewsSummary-ratingCount span')[0].outerText.replace('Reviews', "Customer Reviews");
         var newReviewsMobile = $('.fe800-reviews-js .okeReviews-reviewsSummary-ratingCount span')[0].outerText.replace('Reviews', "Reviews");
         
         if ($('.productdetail-topbar').length == 0) return;
         var newReviewsTopbarMobile = $('.productdetail-topbar .fe800-reviews-js .okeReviews-reviewsSummary-ratingCount span')[0].outerText.replace('Reviews', "Customer Reviews");
 
         if ($('body').attr('device') == 'Mobile') {
             $('.layoutv1 .fe800-reviews-js .okeReviews-reviewsSummary-ratingCount span').html(newReviewsMobile);
             $('.layoutv1 .productdetail-topbar .fe800-reviews-js .okeReviews-reviewsSummary-ratingCount span').html(newReviewsTopbarMobile);
         } else {
             $('.layoutv1 .fe800-reviews-js .okeReviews-reviewsSummary-ratingCount span').html(newReviewsDesktop);
         }
 
 
     }
 
     var running = false;
     function active_Tag() {
 
         $('.tag').click(function () {
             if (running || $(this).hasClass('active')) return;
 
             running = true;
             var tag = $(this).attr('tag');
             $('.tag').removeClass('active');
             $(this).addClass('active');
             hide_ContenTag();
             show_ContenTag(tag);
         })
     }
 
     function hide_ContenTag() {
         $('.content-tag').removeClass('active');
         setTimeout(() => {
             $('.content-tag').hide();
         }, 300);
     }
 
     function show_ContenTag(tag) {
         setTimeout(() => {
             $('#' + tag).show();
         }, 300);
         setTimeout(() => {
             $('#' + tag).addClass('active');
         }, 400);
 
         running = false;
     }
 
     function start_tag() {
         $('.content-tag').hide();
         $('#tag1').show();
     }
 
 
 
     ////////////////////////////
     //RETURN
     return {
         init: init,
     }
 
 
 })();
 
 ////////////////////////////////////
 //run with setinteval
 
 $(function () {
     clsProductReview.init();
 });
 
 
 //------------------------------------------
 //------------------------------------------
 var clsSeries_collection = (() => {
     //PARAMATERS
     var arrProduct = [
         {
             "product_name": "sl3800",
             "url": "#shopify-section-sl3800-info",
 
         },
         {
             "product_name": "sl5800",
             "url": "#shopify-section-sl5800-info"
         },
         {
             "product_name": "pl4800",
             "url": "#shopify-section-pl4800-info"
         },
         {
             "product_name": "pl6800",
             "url": "#shopify-section-pl6800-info"
         },
 
     ]
     //INIT
     function init() {
         viewExpland()
         hiddenPrd()
 
        //  if ($('body').attr('device') == 'Mobile') {
        //      $('.nam-product__rgb-option__add-to-chair-text').html("Add to cart")
        //  }
 
         //
     }
 
     ////////////////////////////
     //EVENTS
 
 
 
     ////////////////////////////
     //FUNCTION
 
 
     viewExpland = () => {
 
         $('.fe800-btn-seemore-js').click(function (e) {
             e.preventDefault();
 
             if ($('.series_collection-item-detail').hasClass('control-expand')) {
                 $('.series_collection-item-detail').removeClass('control-expand');
                 $('.fe800-btn-seemore-js').not(this).show();
                 $('.fe800-btn-seeless-js').not(this).hide();
             }
 
             $(this).siblings('.series_collection-item-detail').addClass('control-expand');
             $(this).hide();
             $(this).siblings('.fe800-btn-seeless-js').show();
         });
 
         $('.fe800-btn-seeless-js').click(function (e) {
             e.preventDefault();
 
             $(this).siblings('.series_collection-item-detail').removeClass('control-expand');
             $(this).hide();
             $('.fe800-btn-seemore-js').show();
 
         });
 
 
     }
 
     hiddenPrd = () => {
 
         var attrProDe = $('.page-fe800').attr('fe800-product-detail')
         if (typeof attrProDe !== 'undefined' && attrProDe !== false) {
 
             for (var i = 0; i < arrProduct.length; i++) {
                 if (attrProDe == arrProduct[i].product_name) {
                     // console.log("arrProduct.product_name[i]", arrProduct[i].product_name, ('.series_collection-inner .series_collection-item:nth-child(' + (i + 2) + ')'))
                     $('.series_collection-inner .series_collection-item:nth-child(' + (i + 1) + ')').hide()
                     break;
 
                 }
             }
 
 
 
         }
     }
 
 
 
 
     ////////////////////////////
     //RETURN
     return {
         init: init
     }
 
 
 })()
 
 ////////////////////////////////////
 //run with setinteval
 
 $(() => {
     clsSeries_collection.init()
 })
 
 
 //------------------------------------------
 /*******************************************************
  * Copyright (C) 2021 Zakeke
  *
  * This file is part of Zakeke.
  *
  * Zakeke can not be copied and/or distributed without the express
  * permission of Zakeke
  *******************************************************/
 function zakekeDesigner(config) {
     function toShopifyPrice(price) {
         return price.toFixed(2) * 100;
     }
 
     function isInsideShopney() {
         return (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.zakekeAddToCartHandler)
             || (window.Android && window.Android.zakekeAddToCart);
     }
 
     function shopneyAddToCart(productId, variantId) {
         if (window.Android) {
             window.Android.zakekeAddToCart(productId, variantId);
         } else {
             window.webkit.messageHandlers.zakekeAddToCartHandler.postMessage('{"product_id":' + productId + ', "variant_id":' + variantId + '}');
         }
     }
 
     function shopneyAddToCartMultiple(products) {
         const productsJson = JSON.stringify(products);
         if (window.Android) {
             window.Android.zakekeMultipleAddToCart(productsJson);
         } else {
             window.webkit.messageHandlers.zakekeMultipleAddToCartHandler.postMessage(productsJson);
         }
     }
 
     function getShopLocale() {
         if (window.zakekeShopLocales) {
             return window.zakekeShopLocales.find(c => c.iso_code === config.locale || c.iso_code.split('-')[0] === config.locale || c.iso_code.split('-')[0] === config.locale.split('-')[0]);
         }
     }
 
     function localizeAddToCartFormAction(form) {
         const shopLocale = getShopLocale();
 
         if (shopLocale && !shopLocale.primary) {
             form.action = form.action.replace('/cart/add', shopLocale.root_url + '/cart/add');
         }
     }
 
     function buildDirectDownloadUrl(design) {
         const zipUrl = new URL(config.zakekeUrl + 'integration/shopify/download');
         zipUrl.searchParams.append('designDocID', design);
         zipUrl.searchParams.append('code', window.zakekeCustomerId || getVisitorCode());
         return zipUrl.toString();
     }
 
     function postprocessProperties(properties, context) {
         if (!window.zakekePostprocessProperties) {
             return Promise.resolve(properties);
         }
 
         return Promise.resolve(window.zakekePostprocessProperties(properties, Object.assign({}, context, {
             price: customizationPrice
         })));
     }
 
     function isOptismiticEnabled() {
         return customizationPrice === 0 && config.customizationStrategy === 1;
     }
 
     function toShopifyPreviews(previews) {
         return previews.reduce((acc, preview, idx) => acc + preview.url + '#' + preview.sideName + ((idx + 1) === previews.length ? '' : ','), '');
     }
 
     function getZakekePricingData() {
         return window.zakekePricingData;
     }
 
     function enableClientPreviews(iframeUrls) {
         iframeUrls.customizerLargeUrl = iframeUrls.customizerLargeUrl + '&isClientPreviewsEnabled=1';
         iframeUrls.customizerSmallUrl = iframeUrls.customizerSmallUrl + '&isClientPreviewsEnabled=1';
     }
     
     function checkStartImage(iframeUrls) {
         try {
             const hashSearch = Object.fromEntries(new URLSearchParams(window.location.hash.substring(1)));
             if (!hashSearch.startImageUrl) {
                 return;
             }
 
             const customizerLargeUrlSearch = new URLSearchParams(iframeUrls.customizerLargeUrl);
             const customizerSmallUrlSearch = new URLSearchParams(iframeUrls.customizerSmallUrl);
 
             customizerLargeUrlSearch.set('startImageUrl', hashSearch.startImageUrl);
             customizerSmallUrlSearch.set('startImageUrl', hashSearch.startImageUrl);
 
             iframeUrls.customizerLargeUrl = iframeUrls.customizerLargeUrl.split('?')[0] + '?' + customizerLargeUrlSearch.toString();
             iframeUrls.customizerSmallUrl = iframeUrls.customizerSmallUrl.split('?')[0] + '?' + customizerSmallUrlSearch.toString();
         } catch (e) {
             console.error(e);
         }
     }
 
     function findVariant(variantID) {
         const variant = config.product.variants.find(x => x.id == variantID);
 
         if (variant == null) {
             throw new Error(`Unable to find variant: ${variantID}`);
         }
 
         return variant;
     }
 
     function exactMatchVariant(color) {
         const currentVariant = findVariant(config.variantId);
 
         const options = [1, 2, 3].map(i => {
             const colorForOption = color.find(c => c.Id == i);
 
             if (colorForOption) {
                 return colorForOption.Value.Id;
             }
 
             return currentVariant[`option${i}`]
         });
 
         return config.product.variants.find(v => options.every((c, i) => v[`option${i + 1}`] === c));
     }
 
     function matchVariant(color) {
         return exactMatchVariant(color) || findVariant(config.variantId);
     }
 
     function isInStock(variant, quantity) {
         return variant.inventory_management === null
             || variant.inventory_policy === 'continue'
             || variant.inventory_quantity >= quantity;
     }
 
     function calculateZakekePrice(price, zakekePercentPrice, zakekePrice) {
         let finalPrice = zakekePrice;
 
         if (zakekePercentPrice) {
             finalPrice += price * (zakekePercentPrice / 100);
         }
 
         return finalPrice;
     }
 
     function calculateZakekeUnitPrice(zakekePrice, zakekePricingModel, qty) {
         if (zakekePrice === 0) {
             return zakekePrice;
         }
 
         return zakekePrice / qty;
     }
 
     function calculatePrice(price, zakekeLinePrice, quantity) {
         return (price * quantity) + zakekeLinePrice;
     }
 
     function productData(color, zakekeOptions) {
         const variant = window.zakekeNotExactMatchVariant ? matchVariant(JSON.parse(color)) : exactMatchVariant(JSON.parse(color));
 
         if (!variant) {
             iframe.contentWindow.postMessage({
                 data: {
                     color: color,
                     isOutOfStock: true,
                     finalPrice: 0
                 },
                 zakekeMessageType: 'DesignChange'
             }, '*');
 
             return;
         }
 
         const zakekePrice = calculateZakekePrice(
             variant.price,
             zakekeOptions['zakeke-percent-price'],
             zakekeOptions['zakeke-price']
         );
 
         customizationPrice = calculateZakekeUnitPrice(
             zakekePrice,
             zakekeOptions['zakeke-pricing-model'],
             config.quantity
         );
 
         iframe.contentWindow.postMessage({
             data: {
                 color: color,
                 isOutOfStock: !isInStock(variant, config.quantity),
                 finalPrice: (config.priceHide || window.zakekePriceHideOnlyFrontend) ? 0 : calculatePrice(variant.price, zakekePrice, config.quantity)
             },
             zakekeMessageType: 'DesignChange'
         }, '*');
     }
 
     function productPrice(data) {
         const variant = matchVariant(data.attributes);
 
         const zakekePrice = calculateZakekePrice(
             variant.price,
             data.percentPrice,
             Number.isNaN(data.price) ? 0 : data.price
         );
 
         customizationPriceMultiple = calculateZakekeUnitPrice(zakekePrice, data.pricingModel, data.quantity);
 
         iframe.contentWindow.postMessage({
             data: {
                 promiseId: data.promiseId,
                 isOutOfStock: !isInStock(variant, data.quantity),
                 finalPrice: calculatePrice(variant.price, zakekePrice, data.quantity)
             },
             zakekeMessageType: 'ProductPrice'
         }, '*');
     }
 
     function productAttributes(data) {
         const attributes = config.product.options.map(option => ({
                 id: option.position.toString(),
                 label: option.name,
                 values: option.values.map(val => ({
                         id: val,
                         label: val
                     })
                 )
             })
         );
         const variants = config.product.variants.map(variant =>
             [1, 2, 3].filter(i => variant[`option${i}`]).map(i => ({
                     Id: i.toString(),
                     Value: {
                         Id: variant[`option${i}`]
                     }
                 })
             )
         );
         iframe.contentWindow.postMessage({
             data: Object.assign({}, data, {
                 attributes,
                 variants
             }),
             zakekeMessageType: 'ProductAttributes'
         }, '*');
     }
 
     function getCart() {
         return fetch('/cart.json?t=${new Date().getTime()}').then(res => res.json()).then(data => console.log(123));
     }
 
     function ajaxAddToCart(items) {
         return fetch('/cart/add.json', {
             method: 'POST',
             headers: {
                 'Accept': 'application/json',
                 'Content-Type': 'application/json'
             },
             body: JSON.stringify({items})
         });
     }
 
     function ajaxRemoveFromCart(cartItem) {
         return fetch('/cart/change.json', {
             method: 'POST',
             headers: {
                 'Accept': 'application/json',
                 'Content-Type': 'application/json'
             },
             body: JSON.stringify({
                 id: cartItem.key,
                 quantity: 0
             })
         });
     }
 
     function checkProduct(product) {
         return new Promise(resolve => {
             fetch(`/products/${product.handle}.json?t=${new Date().getTime()}`, {
                 credentials: 'same-origin'
             }).then(res => {
                 if (res.ok) {
                     resolve(product);
                 } else {
                     setTimeout(() => resolve(checkProduct(product)), 300);
                 }
             });
         });
     }
 
     function createProduct(designID, variantID, includeTags, excludeCustomizationPrice, qty) {
         return fetch(config.zakekeApiUrl + 'shopify/designs', {
             headers: ({
                 'Accept': 'application/json',
                 'Content-Type': 'application/json',
                 'Authorization': 'Bearer ' + config.token
             }),
             method: 'POST',
             mode: 'cors',
             body: JSON.stringify({
                 docID: designID,
                 variantID,
                 includeTags,
                 excludeCustomizationPrice,
                 uniqueSku: window.zakekeUniqueSku || false,
                 qty
             })
         })
             .then(res => res.json())
             .then(product => ({
                     productID: product.productID,
                     variantID: product.variantID,
                     handle: product.handle,
                     quantity: qty
                 })
             ).then(checkProduct);
     }
 
     function addToCartMultiple(data) {
         var properties = config.properties;
         properties['_bulkCustomization'] = data.designID;
 
         if (data.previews && data.previews.length > 0) {
             properties['_previews'] = toShopifyPreviews(data.previews);
         }
 
         if (config.directDownload) {
             properties['_zakekeZip'] = buildDirectDownloadUrl(data.designID);
         }
 
         if (config.productAdvancedProcessing || isOptismiticEnabled()) {
             properties.customization = data.designID;
 
             if (customizationPriceMultiple && getZakekePricingData()) {
                 properties['_configurationPrice'] = toShopifyPrice(customizationPriceMultiple)
             }
         }
 
         const totalQty = data.attributesSelection.reduce((acc, selection) => acc + selection.quantity, 0);
 
         return Promise.all(data.attributesSelection.map(selection => ({
             variantID: matchVariant(selection.attributes).id,
             quantity: selection.quantity
         })).map(function (selection) {
             if ((config.productAdvancedProcessing || isOptismiticEnabled()) && !isInsideShopney()) {
                 return Promise.resolve(selection);
             } else {
                 return createProduct(data.designID, selection.variantID, window.zakekeIncludeTags, config.priceHide, totalQty);
             }
         })).then(function (products) {
             if (isInsideShopney()) {
                 return shopneyAddToCartMultiple(products.map((product, i) => ({
                     product_id: product.productID,
                     variant_id: product.variantID,
                     quantity: data.attributesSelection[i].quantity
                 })));
             }
 
             if (config.showFileNames && data.fileNames) {
                 for (const fileName of data.fileNames) {
                     properties[`_zakekeFileForSide${fileName.sideName}`] = fileName.fileName;
                 }
             }
 
             return postprocessProperties(Object.keys(properties, {
                 design: data.designID
             }).length > 0 ? properties : undefined).then(updatedProperties => ajaxAddToCart(products.map((product, i) =>
                 ({
                     id: product.variantID,
                     handle: product.handle,
                     quantity: data.attributesSelection[i].quantity,
                     properties: updatedProperties
                 })
             )));
         }).then(function () {
             if (!isInsideShopney()) {
                 if (window.zakekeAfterAddToCart) {
                     window.zakekeAfterAddToCart();
                 } else {
                     window.location.href = getCartUrl();
                 }
             }
         });
     }
 
     function addToCart(designID, variantID, quantity, properties, fileNames) {
         const form = document.getElementById('zakeke-addtocart');
         localizeAddToCartFormAction(form);
 
         const formInputId = form.querySelector('input[name="id"]');
         formInputId.value = variantID;
 
         let formInputQty = form.querySelector('input[name="quantity"]');
         if (!formInputQty) {
             formInputQty = document.createElement('input');
             formInputQty.type = 'hidden';
             formInputQty.name = 'quantity';
             form.appendChild(formInputQty);
         }
         formInputQty.value = quantity;
 
         const formType = document.createElement('INPUT');
         formType.type = 'hidden';
         formType.name = 'form_type';
         formType.value = 'product';
         form.appendChild(formType);
 
         if (config.directDownload) {
             properties['_zakekeZip'] = buildDirectDownloadUrl(designID);
         }
         
         if (config.showFileNames && fileNames) {
             for (const fileName of fileNames) {
                 properties[`_zakekeFileForSide${fileName.sideName}`] = fileName.fileName;
             }
         }
 
         postprocessProperties(properties, {
             design: designID
         }).then(properties => {
             if (properties != null) {
                 if (config.productAdvancedProcessing && customizationPrice && getZakekePricingData()) {
                     properties['_configurationPrice'] = toShopifyPrice(customizationPrice)
                 }
 
                 Object.keys(properties).map(property => {
                     const input = document.createElement('INPUT');
                     input.type = 'hidden';
                     input.name = `properties[${property}]`;
                     input.value = properties[property];
                     return input;
                 }).forEach(input => form.appendChild(input));
             }
 
             if (window.zakekeBeforeAddToCart) {
                 window.zakekeBeforeAddToCart(designID, {
                     quantity
                 }).then(_ => {
                     console.log('1111111111 - window.zakekeBeforeAddToCart')
                     clsProductsDetails.zakeke_closepopup()
                     //form.submit()
 
                 });
             } else {
                 console.log('222222222 - addToCart', properties)
                 clsProductsDetails.logo_setproperties(properties)
 
                 //form.submit();
             }
         });
     }
 
     function addToCartContext(color, designID, quantity, previews, fileNames) {
         const variantID = matchVariant(JSON.parse(color)).id;
 
         if (config.productAdvancedProcessing || isOptismiticEnabled()) {
             const properties = {
                 customization: designID
             };
 
             if (previews) {
                 properties['_previews'] = toShopifyPreviews(previews);
             }
 
             if (window.zakekeAddToCart) {
                 window.zakekeAddToCart(designID, variantID, quantity, properties);
             } else {
                 addToCart(designID, variantID, quantity, properties, fileNames);
             }
         } else {
             if (previews) {
                 additionalCartProperties['_previews'] = toShopifyPreviews(previews);
             }
             iframe.contentWindow.postMessage({
                 data: {
                     productID: config.product.id,
                     variantID: variantID,
                     includeTags: window.zakekeIncludeTags || false,
                     additionalTags: window.zakekeAdditionalTags || [],
                     excludeCustomizationPrice: config.priceHide || false,
                     uniqueSku: window.zakekeUniqueSku || false
                 },
                 zakekeMessageType: 'AddToCartContext'
             }, '*');
         }
     }
 
     function getCartUrl() {
         const shopLocale = getShopLocale();
         const url = '/cart';
         if (shopLocale && !shopLocale.primary) {
             return shopLocale.root_url + url;
         }
 
         return url;
     }
     
     function beforeUpdateCart(design, cartItems) {
         if (window.zakekeBeforeCartUpdate) {
             return window.zakekeBeforeCartUpdate(design, cartItems);
         } else {
             return Promise.resolve(cartItems);
         }
     }
 
     function updateCart(design, previews) {
         return getCart().then(cart => {
             const price = toShopifyPrice(customizationPrice).toString();
             const cartItems = cart.items.filter(item =>
                 item.properties
                 && (item.properties['customization'] === design || item.properties['_customization'] === design)
                 && (item.properties['_configurationPrice'] !== price
                     || item.properties['_previews'] !== toShopifyPreviews(previews))
             );
 
             return Promise.all(cartItems.map(item => postprocessProperties(Object.assign({}, item.properties, {
                 '_configurationPrice': price,
                 '_previews': toShopifyPreviews(previews)
             }), {
                 design
             }))).then(updatedCartItemsProperties => {
                 const updatedCartItems = updatedCartItemsProperties.map((properties, itemIndex) => {
                     const cartItem = {
                         id: cartItems[itemIndex].id,
                         properties,
                         quantity: cartItems[itemIndex].quantity
                     };
                     
                     if (cartItems[itemIndex].selling_plan_allocation) {
                         cartItem.selling_plan = cartItems[itemIndex].selling_plan_allocation.selling_plan.id;
                     }
                     
                     return cartItem;
                 });
 
                 return beforeUpdateCart(design, updatedCartItems).then(ajaxAddToCart).then(() =>
                     Promise.all((cartItems.map(ajaxRemoveFromCart)))
                 ).then(() => {
                     window.location.href = getCartUrl();
                 });
             });
         });
     }
 
     function updateZakekeConfig() {
         if (isInsideShopney()) {
             config.productAdvancedProcessing = false;
         } else {
             config.productAdvancedProcessing = config.productAdvancedProcessing ? config.productAdvancedProcessing : window.zakekeProductAdvancedProcessing;
         }
 
         if (config.productAdvancedProcessing) {
             if (!window.zakekePricingData || !window.zakekePricingData.variantId) {
                 config.priceHide = true;
             }
         }
 
         if (window.zakekePriceHide) {
             config.priceHide = window.zakekePriceHide;
         }
     }
 
     function getVisitorCode() {
         const id = Math.random().toString(36).substring(7);
         if (window.localStorage) {
             return localStorage["zakekeGuest"] = localStorage["zakekeGuest"] || id;
         } else {
             return id;
         }
     }
 
     function getIframeUrl() {
         let iframeRequest = Object.assign({}, config);
         if (window.zakekeCustomerId) {
             iframeRequest.c = window.zakekeCustomerId;
         } else {
             iframeRequest.v = getVisitorCode();
         }
 
         return fetch(config.zakekeApiUrl + 'shopify/customizer/iframe', {
             method: 'POST',
             headers: {
                 'Accept': 'application/json',
                 'Content-Type': 'application/json'
             },
             body: JSON.stringify(iframeRequest)
         }).then(res => res.json());
     }
 
     function createIframe() {
         const iframe = document.createElement('IFRAME');
         iframe.id = 'zakeke-frame';
         iframe.src = 'about:blank';
         iframe.allowfullscreen = true;
         iframe.setAttribute('data-hj-allow-iframe', '');
         return iframe;
     }
 
     var customizationPrice = 0,
         customizationPriceMultiple = 0,
         container = document.getElementById('zakeke-container'),
         iframe = createIframe(),
         additionalCartProperties = {};
 
     updateZakekeConfig();
 
     container.appendChild(iframe);
 
     window.addEventListener('message', function (event) {
         if (event.origin !== config.zakekeUrl.slice(0, -1)) {
             return;
         }
 
         if (event.data.zakekeMessageType === 'AddToCart') {
             if (window.zakekeAddToCart) {
                 window.zakekeAddToCart(event.data.data.handle, event.data.data.productID, event.data.data.variantID,
                     event.data.data.quantity, additionalCartProperties);
             } else if (isInsideShopney()) {
                 shopneyAddToCart(event.data.data.productID, event.data.data.variantID);
             } else {
                 addToCart(event.data.data.designID, event.data.data.variantID, event.data.data.quantity, additionalCartProperties, event.data.data.fileNames);
             }
         } else if (event.data.zakekeMessageType === 'AddToCartContext') {
             if (config.design) {
                 updateCart(config.design, event.data.data.previews);
             } else {
                 if (window.fbq) {
                     window.fbq('track', 'AddToCart', {
                         content_name: config.product.title,
                         content_ids: [config.product.id.toString()],
                         content_type: 'product'
                     });
                 }
 
                 addToCartContext(event.data.data.colorID, event.data.data.designID, event.data.data.quantity, event.data.data.previews, event.data.data.fileNames);
             }
         } else if (event.data.zakekeMessageType === 'AddToCartMultiple') {
             addToCartMultiple(event.data.data);
         } else if (event.data.zakekeMessageType === 'DesignChange') {
             productData(event.data.design.color, {
                 'zakeke-price': event.data.design.price || 0,
                 'zakeke-percent-price': event.data.design.percentPrice || 0,
                 'zakeke-pricing-model': event.data.design.pricingModel || 'advanced'
             });
         } else if (event.data.zakekeMessageType === 'ProductAttributes') {
             productAttributes(event.data.data);
         } else if (event.data.zakekeMessageType === 'ProductPrice') {
             productPrice(event.data.data);
         }
     }, false);
 
     function postProcessIframeUrl(iframeUrl) {
         if (window.zakekePostProcessIframeUrl) {
             return window.zakekePostProcessIframeUrl(iframeUrl);
         }
 
         return iframeUrl;
     }
 
     function setIframeUrl(iframeUrls) {
         if (config.productAdvancedProcessing || window.zakekeForceClientPreviews) {
             enableClientPreviews(iframeUrls);
         }
         
         checkStartImage(iframeUrls);
 
         if (window.zakekeAddToCartText) {
             iframeUrls.customizerLargeUrl = iframeUrls.customizerLargeUrl + '&cartButtonText=' + encodeURIComponent(window.zakekeAddToCartText);
             iframeUrls.customizerSmallUrl = iframeUrls.customizerSmallUrl + '&cartButtonText=' + encodeURIComponent(window.zakekeAddToCartText);
         }
 
         const zakekeBaseUrl = window.location.href.split('?')[0];
         iframeUrls.customizerLargeUrl = iframeUrls.customizerLargeUrl + '&shareUrlPrefix=' + encodeURIComponent(zakekeBaseUrl);
         iframeUrls.customizerSmallUrl = iframeUrls.customizerSmallUrl + '&shareUrlPrefix=' + encodeURIComponent(zakekeBaseUrl);
 
         iframe.style.background = 'none';
 
         if (window.matchMedia('(min-width: 769px)').matches) {
             iframe.src = postProcessIframeUrl(iframeUrls.customizerLargeUrl);
         } else {
             if (!window.location.pathname.includes('/pages/')) {
                 document.body.appendChild(container);
             }
             iframe.src = postProcessIframeUrl(iframeUrls.customizerSmallUrl);
 
             if (navigator.userAgent.match(/instagram/i) && navigator.userAgent.match(/iPhone/i)) {
                 const difference = window.screen.height - window.innerHeight;
                 iframe.style.paddingBottom = difference + 'px';
             }
         }
     }
 
     function getShopifyProduct(shopifyProduct) {
         if (window.zakekePostProcessShopifyProduct) {
             return window.zakekePostProcessShopifyProduct(shopifyProduct);
         }
 
         return Promise.resolve(shopifyProduct);
     }
 
     getIframeUrl().then(res => {
         config.token = res.token;
         config.variantId = res.variantId;
 
         return getShopifyProduct(res.product).then(product => {
             config.product = product;
             setIframeUrl(res);
         });
     });
 }
 